const Library_mobile_th = {
  "processor": [
    {
      "contentType": "OTHER_PROCESSORS",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ [cpuDisplay]"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHER_PROCESSORS_A",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ [cpuDisplay]"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "FALLBACK_PROCESSOR",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "เช่นเดียวกับสมอง โปรเซสเซอร์ของคุณควบคุมสิ่งที่พีซีของคุณทำ ซึ่งหมายความว่า วิดีโอที่คุณดู เกมที่คุณเล่น เว็บไซต์ที่คุณเข้าไป ล้วนเริ่มต้นด้วยโปรเซสเซอร์ของคุณ",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "โปรเซสเซอร์คือสมองของพีซี"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHER_OLD_PROCESSORS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_title": "ประสิทธิภาพและความคุ้มค่า",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "titleArray": [
                  {
                    "tr_title": "",
                    "tr_pretitle": "โปรเซสเซอร์ Intel® Pentium® Silver",
                    "tr_subtitle": "ควบคุมโลกดิจิตอลของคุณด้วยสมรรถนะในการเข้าถึงไฟล์จากเว็บ ทำงานมัลติทาสก์ได้ง่ายๆ โดยการสลับไปมาระหว่างโปรแกรมอย่างง่ายดาย และทำงานให้เสร็จได้มากขึ้นโดยใช้เวลาน้อยลง",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Pentium® Silver"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "โปรเซสเซอร์ Intel® Pentium® Gold",
                    "tr_subtitle": "ยกระดับประสิทธิภาพการทำงาน - เสริมประสิทธิภาพเพื่อขับเคลื่อนการทำงานผ่านวันที่ต้องใช้การประมวลผลสูงสุด การเรียกดูเว็บไซต์ที่ง่ายดายยิ่งขึ้น - โหลดหน้าเว็บที่มีสื่อมากมายขึ้นมาได้อย่างรวดเร็วเพื่อช่วยให้สำรวจได้มากขึ้น และใช้เวลารอน้อยลง",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Pentium® Gold"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "โปรเซสเซอร์ Intel® Celeron®",
                    "tr_subtitle": "ประสิทธิภาพที่ช่วยยกระดับการทำงานและความบันเทิงของคุณ เพลิดเพลินกับภาพยนตร์และวิดีโอบนเว็บด้วยความละเอียดที่น่าทึ่ง ใช้เวลาในการทำงานมากขึ้นและเสียเวลารอน้อยลง",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Celeron®"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "โปรเซสเซอร์ Intel® Pentium®",
                    "tr_subtitle": "ออกแบบมาเพื่อความบันเทิง การสตรีมวิดีโอ และการทำงานที่ยอดเยี่ยม เพลิดเพลินกับภาพยนตร์และวิดีโอบนเว็บด้วยความละเอียดที่น่าทึ่ง ใช้เวลาในการทำงานมากขึ้นและเสียเวลารอน้อยลง",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Pentium®"
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CELERON_2.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_2.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_INSIDE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/intel_inside/intel_inside_processor_badge.svg",
                "tileBG": "assets/images/intel_inside/intel_inside_home_tile.svg",
                "detailBGUrl": "assets/images/intel_inside/panel1_bg.svg",
                "tr_subtitle": "ประสิทธิภาพที่คุณต้องการ พร้อมความคุ้มค่าที่โดนใจ",
                "tr_title": "โปรเซสเซอร์ Intel®",
                "panelType1": "header-IconTop",
                "panelType2": "intel-inside-image-panel",
                "titleArray": [
                  {
                    "tr_title": "",
                    "tr_pretitle": "ความคุ้มค่าในแบบของตัวเอง",
                    "tr_subtitle": "โปรเซสเซอร์ Intel® สามารถรับมือได้กับแทบทุกงานที่คุณต้องการในราคาที่คุณจ่ายไหว นำทางจากซอฟต์แวร์หนึ่งไปยังอีกซอฟต์แวร์หนึ่งได้ง่าย หรือเต็มอิ่มไปกับกราฟิกคุณภาพสูงที่มีประสิทธิภาพแน่นอน",
                    "imageUrl": "assets/images/intel_inside/panel2_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "เชื่อมต่ออย่างแนบแน่น มั่นคง",
                    "tr_subtitle": "คุณภาพของวิดีโอที่มีชีวิตชีวายิ่งกว่า ความคมชัดของเสียงที่เต็มอิ่มยิ่งขึ้น และการเชื่อมต่ออินเทอร์เน็ตที่เร็วกว่าเกือบ 3 เท่า ช่วยให้คุณมั่นใจได้ถึงการทำงานร่วมกันในทุกหนแห่งที่คุณต้องการ<sup>26</sup>",
                    "imageUrl": "assets/images/intel_inside/panel3_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "แตกต่างอย่างชัดเจน",
                    "tr_subtitle": "ตั้งแต่การดูหนังแบบมาราธอนในตอนเช้าไปจนถึงการปรับแต่งในนาทีสุดท้าย โปรเซสเซอร์ Intel® จะเพิ่มระยะเวลาการใช้งานแบตเตอรี่ของอุปกรณ์ของคุณเพื่อประสบการณ์อันแสนดื่มด่ำอย่างไม่มีสะดุดอย่างแท้จริง",
                    "imageUrl": "assets/images/intel_inside/panel4_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "imageUrl": "assets/images/intel_inside/panel5_bg.svg",
                    "tr_pretitle": "สภาพแวดล้อมไหน ก็พร้อมให้เรียนรู้",
                    "tr_subtitle": "เรียกใช้เครื่องมือการเรียนรู้แบบออนไลน์หลายๆ อย่างได้อย่างง่ายดายจากทุกแห่งในบ้านของคุณ"
                  },
                  {
                    "tr_title": "",
                    "imageUrl": "assets/images/intel_inside/panel5_bg.svg",
                    "tr_pretitle": "เรียนรู้ได้อย่างอิสระ ตามสไตล์คุณ",
                    "tr_subtitle": "ศึกษาบทเรียนต่างๆ ได้ทุกที่คุณต้องการ พร้อมกับการใช้งานเครื่องมือการเรียนรู้ผ่านสื่ออิเล็กทรอนิกส์ที่หลากหลายไปในเวลาเดียวกัน"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CELERON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CELERON_3.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "สัมผัสขุมพลังที่รองรับทั้งความบันเทิงและการทำงานที่สอดรับกับงบประมาณและตรงตามไลฟ์สไตล์ของคุณ",
                "tr_title": "ประสิทธิภาพ Intel สำหรับงบประมาณทุกระดับ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel® Celeron®",
                "processorCompare": {
                  "tr_title": "ค้นหาระดับประสิทธิภาพและความคุ้มค่าที่ใช่สำ&#xfeff;ห&#xfeff;รั&#xfeff;บ&#xfeff;คุ&#xfeff;ณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CELERON_3.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Celeron®"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ท่องเว็บไซต์ได้อย่างรวดเร็ว",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "สลับการใช้งานระหว่างโปรแกรมได้อย่างง่ายดาย",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมทั่วไป",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมวิดีโอ 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การตัดต่อภาพถ่ายและวิดีโอทำได้ง่ายมาก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การทำงานที่รวดเร็วด้วยประสิทธิภาพอัจฉริยะ",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "7GEN_BELOW_PROCESSOR",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/[cup_badge].svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "genType": "7Gen",
                    "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ [cpu_fam] เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;7"
                  },
                  {
                    "genType": "6Gen",
                    "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ [cpu_fam] เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;6"
                  },
                  {
                    "genType": "5Gen",
                    "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ [cpu_fam] เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;5"
                  },
                  {
                    "genType": "4Gen",
                    "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ [cpu_fam] เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;4"
                  },
                  {
                    "genType": "3Gen",
                    "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ [cpu_fam] เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;3"
                  },
                  {
                    "genType": "2Gen",
                    "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ [cpu_fam] เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;2"
                  },
                  {
                    "genType": "1Gen",
                    "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ [cpu_fam] เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;1"
                  }
                ],
                "processorCompare": {
                  "tr_title": "",
                  "background": "",
                  "tr_tableHead": [
                    "แนะนำสำหรับ:",
                    "<span><img src=></span>",
                    "<span><img src=></span>"
                  ],
                  "tabletr": [
                    {
                      "tr_row": "",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_6.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i3 เจนเนอเรชั่น 8",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 สร้างขึ้นเพื่อให้คุณก้าวทันโลกแ&#65279;ห่&#65279;ง&#65279;ดิ&#65279;จิ&#65279;ทั&#65279;ล เ&#65279;ป็&#65279;น&#65279;โ&#65279;ป&#65279;ร&#65279;เ&#65279;ซ&#65279;ส&#65279;เ&#65279;ซ&#65279;อ&#65279;ร์ที่มีความเร็วและสมรรถนะสูง ช่วยให้คุณสามารถทำ&#65279;ง&#65279;า&#65279;นบนพีซีได้อย่างราบรื่นต&#65279;า&#65279;ม&#65279;ต้&#65279;อ&#65279;ง&#65279;ก&#65279;า&#65279;ร",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "ประสิทธิภาพที่หลากหลายตอบสนองอายุการใช้งานแบตเตอรี่ที่ยาวนานเพื่อให้คุณไปได้ทุกที่",
                "tr_title": "ใช้งานได้ตลอดทั้งวัน",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "processorCompare": {
                  "tr_title": "ค้นหาระดับประสิทธิภาพของเ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 <br/>ที่&#65279;เ&#65279;ห&#65279;ม&#65279;า&#65279;ะ&#65279;ส&#65279;ม",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i3"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การสตรีมภาพยนตร์แบบ 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเชื่อมต่อที่รวดเร็วและน่าเชื่อถือ",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การมาสก์ภาพถ่ายและฟิลเตอร์วิดีโอ",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกมด้วยความละเอียด 1080p เพื่ออัตราเฟรมที่&#65279;ไ&#65279;ม่&#65279;มี&#65279;ส&#65279;ะ&#65279;ดุ&#65279;ด",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เหมาะสำหรับการทำงานกับไฟล์ขนาดใหญ่และโปรแกรมสร้างสรรค์",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "สับเปลี่ยนจากการสตรีมภาพยนตร์ไปเป็นการสร้างงานนำเสนอได้อย่างง่ายดาย โดยที่เครื่องยังมีประสิทธิภาพอีกล้นเหลือ",
                "tr_title": "ใช้งานได้ตลอดทั้งวัน",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "สำหรับผู้ที่ต้องเดินทางตลอดเวลา แล็ปท็อปเครื่องนี้ได้รับการออกแบบมาเพื่อคุณโดยเฉพาะ",
                "tr_title": "พบกับอีกระดับของแ&#65279;ล็&#65279;ป&#65279;ท็&#65279;อ&#65279;ปอั&#65279;น&#65279;ล้ำ&#65279;ส&#65279;มั&#65279;ย",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ i3 เจนเนอเรชั่น 11 ออกแบบมาสำหรับพีซีแบบพกพาโดยเฉพาะ ให้คุณทำสิ่งต่างๆ ได้มากขึ้นในทุกๆ ที่",
                "tr_title": "ใช้ประโยชน์จากแล็ปท็อปเครื่องใหม่ของคุณได้มากขึ้น",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i3 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "เมื่อทั้งครอบครัวของคุณมองหาเดสก์ท็อปพีซีเครื่องหนึ่งที่รองรับทุกสิ่ง คุณต้องการพลังและความอเนกประสงค์ของโปรเซสเซอร์ Intel® Core™ i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_title": "พร้อมสำหรับทุกสิ่งด้วยประสิทธิภาพที่ไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i3 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_6.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 สร้างขึ้นเพื่อให้คุณก้าวทันโลกแ&#65279;ห่&#65279;ง&#65279;ดิ&#65279;จิ&#65279;ทั&#65279;ล เ&#65279;ป็&#65279;น&#65279;โ&#65279;ป&#65279;ร&#65279;เ&#65279;ซ&#65279;ส&#65279;เ&#65279;ซ&#65279;อ&#65279;ร์ที่มีความเร็วและสมรรถนะสูง ช่วยให้คุณสามารถทำ&#65279;ง&#65279;า&#65279;นบนพีซีได้อย่างราบรื่นต&#65279;า&#65279;ม&#65279;ต้&#65279;อ&#65279;ง&#65279;ก&#65279;า&#65279;ร",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "เล่นเกมและ VR ได้อย่างราบรื่นบนเกมที่ใช้ทรัพยากรมากที่สุด",
                "tr_title": "การเล่นเกมที่จริงจังเ&#65279;ริ่&#65279;ม&#65279;ที่&#65279;นี่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกม สตรีม และบันทึกได้อย่างเต็มที่",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 ที่ดีที่สุดสำหรับการเล่นเกม",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.5 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 4 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "ทำงานหลากหลายโปรแกรมได้อย่างง่ายดาย เพื่อให้คุณพร้อมสำหรับทุกความท้าทาย ไม่ว่าจะอยู่ที่ใดก็ตาม",
                "tr_title": "การมัลติทาสกิ้งได้ทุกที่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "processorCompare": {
                  "tr_title": "ค้นหาระดับประสิทธิภาพของเ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 <br/>ที่&#65279;เ&#65279;ห&#65279;ม&#65279;า&#65279;ะ&#65279;ส&#65279;ม",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i3"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การสตรีมภาพยนตร์แบบ 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเชื่อมต่อที่รวดเร็วและน่าเชื่อถือ",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การมาสก์ภาพถ่ายและฟิลเตอร์วิดีโอ",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกมด้วยความละเอียด 1080p เพื่ออัตราเฟรมที่&#65279;ไ&#65279;ม่&#65279;มี&#65279;ส&#65279;ะ&#65279;ดุ&#65279;ด",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เหมาะสำหรับการทำงานกับไฟล์ขนาดใหญ่และโปรแกรมสร้างสรรค์",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "ยกระดับทุกอย่างที่คุณทำ ไม่ว่าจะเป็นความบันเทิง การผลิตงาน หรือการสร้างคอนเทนต์",
                "tr_title": "อัปเกรดให้เป็นพีซีที่ทรงพลังมากขึ้น",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "สำหรับผู้ที่ต้องเดินทางตลอดเวลา แล็ปท็อปเครื่องนี้ได้รับการออกแบบมาเพื่อคุณโดยเฉพาะ",
                "tr_title": "พบกับอีกระดับของแ&#65279;ล็&#65279;ป&#65279;ท็&#65279;อ&#65279;ปอั&#65279;น&#65279;ล้ำ&#65279;ส&#65279;มั&#65279;ย",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "สร้างมาเพื่อการสตรีมและการเล่นเกมระดับ AAA อย่างราบรื่น",
                "tr_title": "เล่นสนุกตามใจสั่ง",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA อย่างราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีม",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมและการบันทึก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสร้างคอนเทนต์ขั้นสูง",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ประสิทธิภาพการเล่นเกมสูงสุด",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "ปลดล็อคและสามารถโอเวอร์คล็อกได้<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.5 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "สร้างมาเพื่อการสตรีมและการเล่นเกมระดับ AAA อย่างราบรื่น",
                "tr_title": "เล่นสนุกตามใจสั่ง",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA อย่างราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีม",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมและการบันทึก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสร้างคอนเทนต์ขั้นสูง",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ประสิทธิภาพการเล่นเกมสูงสุด",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "ปลดล็อคและสามารถโอเวอร์คล็อกได้<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.8 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 10 <br/>เธรด: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "ทำงานหลากหลายโปรแกรมได้อย่างง่ายดาย เพื่อให้คุณพร้อมสำหรับทุกความท้าทาย ไม่ว่าจะอยู่ที่ใดก็ตาม",
                "tr_title": "การมัลติทาสกิ้งได้ทุกที่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 10"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ i5 เจนเนอเรชั่น 11 นำประสบการณ์การแสดงผลภาพที่มีสีสันสดใสและทำงานได้อย่างหลากหลายมารวมกันไว้ในพีซีที่เบาและบางที่สุด",
                "tr_title": "พลังของแล็ปท็อปอันน่&#65279;า&#65279;ทึ่&#65279;ง",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/standard/i5_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "เมื่อทั้งครอบครัวของคุณมองหาเดสก์ท็อปพีซีเครื่องหนึ่งที่รองรับทุกสิ่ง คุณต้องการพลังและความอเนกประสงค์ของโปรเซสเซอร์ Intel® Core™ i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_title": "พร้อมสำหรับทุกสิ่งด้วยประสิทธิภาพที่ไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/standard/i5_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ i5 เ&#xfeff;จ&#xfeff;น&#xfeff;เ&#xfeff;น&#xfeff;อ&#xfeff;เ&#xfeff;ร&#xfeff;ชั่&#xfeff;น&nbsp;11 นำ&#xfeff;ป&#xfeff;ร&#xfeff;ะ&#xfeff;ส&#xfeff;บ&#xfeff;ก&#xfeff;า&#xfeff;ร&#xfeff;ณ์การแสดงผลภาพที่มีสีสันสดใสและทำ&#xfeff;ง&#xfeff;า&#xfeff;น&#xfeff;ไ&#xfeff;ด้&#xfeff;อ&#xfeff;ย่&#xfeff;า&#xfeff;ง&#xfeff;ห&#xfeff;ล&#xfeff;า&#xfeff;ก&#xfeff;ห&#xfeff;ล&#xfeff;า&#xfeff;ย&#xfeff;ม&#xfeff;า&#xfeff;ร&#xfeff;ว&#xfeff;ม&#xfeff;กั&#xfeff;นไว้ในแล็ปท็อปที่บางและเบา",
                "tr_title": "พลังของแล็ปท็อปอันน่&#65279;า&#65279;ทึ่&#65279;ง",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 11"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_6.svg",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 สร้างขึ้นเพื่อให้คุณก้าวทันโลกแ&#65279;ห่&#65279;ง&#65279;ดิ&#65279;จิ&#65279;ทั&#65279;ล เ&#65279;ป็&#65279;น&#65279;โ&#65279;ป&#65279;ร&#65279;เ&#65279;ซ&#65279;ส&#65279;เ&#65279;ซ&#65279;อ&#65279;ร์ที่มีความเร็วและสมรรถนะสูง ช่วยให้คุณสามารถทำ&#65279;ง&#65279;า&#65279;นบนพีซีได้อย่างราบรื่นต&#65279;า&#65279;ม&#65279;ต้&#65279;อ&#65279;ง&#65279;ก&#65279;า&#65279;ร",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "FPS มากกว่าสูงสุด 32% ขณะเล่นเกม สตรีม และบันทึก เมื่อเทียบกับพีซีอายุ 3 ปี<sup>3</sup>",
                "tr_title": "พลังสำหรับการแบ่งปันช่วงเวลาการเล่นเกมที่ยอดเยี่ยมที่สุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_7.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกม สตรีม และบันทึกได้อย่างเต็มที่",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 ที่ดีที่สุดสำหรับการเล่นเกม",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.5 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 4 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "โน้ตบุ๊คที่ออกแบบมาเพื่อประสิทธิภาพ อีกทั้งยังสวยงาม บางเบาและเต็มเปี่ยมไปด้วยพลัง เพื่อการสร้างสรรค์ เชื่อมต่อ และสตรีม",
                "tr_title": "ประสิทธิภาพขั้นสูงในทุกๆ ที่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "processorCompare": {
                  "tr_title": "ค้นหาระดับประสิทธิภาพของเ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 <br/>ที่&#65279;เ&#65279;ห&#65279;ม&#65279;า&#65279;ะ&#65279;ส&#65279;ม",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i3"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การสตรีมภาพยนตร์แบบ 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเชื่อมต่อที่รวดเร็วและน่าเชื่อถือ",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การมาสก์ภาพถ่ายและฟิลเตอร์วิดีโอ",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกมด้วยความละเอียด 1080p เพื่ออัตราเฟรมที่&#65279;ไ&#65279;ม่&#65279;มี&#65279;ส&#65279;ะ&#65279;ดุ&#65279;ด",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เหมาะสำหรับการทำงานกับไฟล์ขนาดใหญ่และโปรแกรมสร้างสรรค์",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "ประสิทธิภาพขั้นสูงยกระดับทุกสิ่งที่คุณทำให้ก้าวล้ำไปอีกขั้น",
                "tr_title": "ขุมพลังที่พร้อมสำหรับทุกอย่าง",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "สำหรับผู้ที่ต้องเดินทางตลอดเวลา แล็ปท็อปเครื่องนี้ได้รับการออกแบบมาเพื่อคุณโดยเฉพาะ",
                "tr_title": "พบกับอีกระดับของแ&#65279;ล็&#65279;ป&#65279;ท็&#65279;อ&#65279;ปอั&#65279;น&#65279;ล้ำ&#65279;ส&#65279;มั&#65279;ย",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "เล่นเกม สตรีม และบันทึกอย่างเหนือชั้น",
                "tr_title": "เติมพลังโลกแห่งเกม",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA อย่างราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีม",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมและการบันทึก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสร้างคอนเทนต์ขั้นสูง",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ประสิทธิภาพการเล่นเกมสูงสุด",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "ปลดล็อคและสามารถโอเวอร์คล็อกได้<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.5 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "เล่นเกม สตรีม และบันทึกอย่างเหนือชั้น",
                "tr_title": "เติมพลังโลกแห่งเกม",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA อย่างราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีม",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมและการบันทึก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสร้างคอนเทนต์ขั้นสูง",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ประสิทธิภาพการเล่นเกมสูงสุด",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "ปลดล็อคและสามารถโอเวอร์คล็อกได้<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.8 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 10 <br/>เธรด: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "อุปกรณ์ที่โฉบเฉี่ยวและออกแบบมาเพื่อเน้นประสิทธิภาพ ส่งผลต่อวิธีการสร้างสรรค์ เชื่อมต่อ และสตรีมของคุณได้อย่างมหาศาล",
                "tr_title": "ประสิทธิภาพระดับพรีเมียมสำหรับทุกๆ ที่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 10"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ i7 เจนเนอเรชั่น 11 มาพร้อมการสร้างคอนเทนต์ขั้นสูง การเล่นเกมที่ราบรื่น และความบันเทิงที่เหนือระดับในพีซีแบบพกพาที่บางเฉียบ",
                "tr_title": "ประสิทธิภาพแล็ปท็อปที่ไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/standard/i7_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "การสร้างเดสก์ท็อปพีซีให้พร้อมใช้งานกับทุกสิ่งที่บ้านของคุณจำเป็นต้องใช้ประสิทธิภาพไร้ขีดจำกัดของโปรเซสเซอร์ Intel® Core™ i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_title": "ทำงาน เรียนรู้ เล่น อย่างไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/standard/i7_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11 มาพร้อมการสร้างค&#65279;อ&#65279;น&#65279;เ&#65279;ท&#65279;น&#65279;ต์&#65279;ขั้&#65279;น&#65279;สู&#65279;ง การเล่นเกมที่ราบรื่น แ&#65279;ล&#65279;ะ&#65279;ค&#65279;ว&#65279;า&#65279;ม&#65279;บั&#65279;น&#65279;เ&#65279;ทิ&#65279;งที่เหนือระดับในแล็ปท็อปที่บางและเบา",
                "tr_title": "ประสิทธิภาพแล็ปท็อปที่ไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 11"
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "การสร้างเดสก์ท็อปพีซีให้พร้อมใช้งานกับทุกสิ่งที่บ้านของคุณจำเป็นต้องใช้ประสิทธิภาพไร้ขีดจำกัดของโปรเซสเซอร์ Intel® Core™ i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_title": "สร้างสรรค์อย่างไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 11"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_1195G7",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "มาพร้อมการสร้างคอนเทนต์ขั้นสูง การเล่นเกมที่ราบรื่น และความบันเทิงที่เหนือระดับในแล็ปท็อปที่บางและเบา โปรเซสเซอร์ Intel® Core™ i7 เจนเนอเรชั่น 11 นี้ดียิ่งกว่าที่เคย",
                "tr_title": "ประสิทธิภาพแล็ปท็อปที่ไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 11"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 สร้างขึ้นเพื่อให้คุณก้าวทันโลกแ&#65279;ห่&#65279;ง&#65279;ดิ&#65279;จิ&#65279;ทั&#65279;ล เ&#65279;ป็&#65279;น&#65279;โ&#65279;ป&#65279;ร&#65279;เ&#65279;ซ&#65279;ส&#65279;เ&#65279;ซ&#65279;อ&#65279;ร์ที่มีความเร็วและสมรรถนะสูง ช่วยให้คุณสามารถทำ&#65279;ง&#65279;า&#65279;นบนพีซีได้อย่างราบรื่นต&#65279;า&#65279;ม&#65279;ต้&#65279;อ&#65279;ง&#65279;ก&#65279;า&#65279;ร",
                "tr_title": "ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "FPS มากกว่าสูงสุด 41% ขณะเล่นเกม สตรีม และบันทึก เมื่อเทียบกับพีซีอายุ 3 ปี<sup>4</sup>",
                "tr_title": "นักเล่นเกมอยากได้ Intel® Core™ i9 จัดให้",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกม สตรีม และบันทึกได้อย่างเต็มที่",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 ที่ดีที่สุดสำหรับการเล่นเกม",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.5 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 4 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_8",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ปลุกความสามารถที่ซ้อนเร้นด้วยประสบการณ์การเล่นเกมสุดล้ำ",
                "tr_title": "ขับเคี่ยวกันถึงขีดสุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA อย่างราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีม",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมและการบันทึก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสร้างคอนเทนต์ขั้นสูง",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ประสิทธิภาพการเล่นเกมสูงสุด",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "ปลดล็อคและสามารถโอเวอร์คล็อกได้<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.5 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ปลุกความสามารถที่ซ้อนเร้นด้วยประสบการณ์การเล่นเกมสุดล้ำ",
                "tr_title": "ขับเคี่ยวกันถึงขีดสุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA อย่างราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีม",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมและการบันทึก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสร้างคอนเทนต์ขั้นสูง",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ประสิทธิภาพการเล่นเกมสูงสุด",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "ปลดล็อคและสามารถโอเวอร์คล็อกได้<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.8 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 10 <br/>เธรด: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ปลุกความสามารถที่ซ้อนเร้นด้วยประสบการณ์ใช้งานสุดล้ำเพื่อนักสร้างสรรค์โดยเฉพาะ",
                "tr_title": "สร้างสรรค์ถึงขีดสุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/EVO_I5_5.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ ที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i5 เจนเนอเรชั่น 11 และกราฟิก Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> มอบความเร็วและประสิทธิภาพชั้นยอดให้แก่คุณ ทั้งหมดนี้ในดีไซน์ที่บางและเบา",
                "tr_title": "ยกระดับขุมพลังสำหรับวิวัฒนาการแล็ปท็อป",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/evo/11gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/EVO_I7.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i7-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ ที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ i7 เจนเนอเรชั่น 11 และกราฟิก Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> ให้คุณได้รับความเร็วและประสิทธิภาพขั้นสูงเพื่อประสบการณ์การใช้งานแบบพกพาระดับพรีเมียม",
                "tr_title": "ขุมพลังขั้นสูงเพื่อแล็ปท็อปที่ก้าวล้ำไปอีกขั้น",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/evo/11gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "PENTIUM_SILVER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "เพลิดเพลินกับประสิทธิภาพ การรับชมสื่อ และประสบการณ์การเชื่อมต่อที่ลงตัว ในราคาที่คุ้มค่าอย่างน่าทึ่ง",
                "tr_title": "ประสิทธิภาพและก&#65279;า&#65279;ร&#65279;เ&#65279;ชื่&#65279;อ&#65279;ม&#65279;ต่&#65279;อ ที่คุ้มค่าอ&#65279;ย่&#65279;า&#65279;ง&#65279;น่&#65279;า&#65279;ทึ่&#65279;ง",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel® Pentium® Silver",
                "processorCompare": {
                  "tr_title": "ค้นหาระดับประสิทธิภาพและความคุ้มค่าที่ใช่สำ&#xfeff;ห&#xfeff;รั&#xfeff;บ&#xfeff;คุ&#xfeff;ณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Pentium® Silver"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ท่องเว็บไซต์ได้อย่างรวดเร็ว",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "สลับการใช้งานระหว่างโปรแกรมได้อย่างง่ายดาย",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมทั่วไป",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมวิดีโอ 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การตัดต่อภาพถ่ายและวิดีโอทำได้ง่ายมาก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การทำงานที่รวดเร็วด้วยประสิทธิภาพอัจฉริยะ",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "PENTIUM_GOLD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "เพลิดเพลินไปกับมัลติทาสกิ้งที่ราบรื่น การแก้ไขภาพถ่ายและตัดต่อวิดีโอทั่วไป รับชมวิดีโอ 4K และกราฟิกที่สดใส ในราคาที่คุ้มค่าอย่างน่าทึ่ง",
                "tr_title": "ประสิทธิภาพที่น่าประทับใจ สำหรับการทำงานและความบันเทิง",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel® Pentium® Gold",
                "processorCompare": {
                  "tr_title": "ค้นหาระดับประสิทธิภาพและความคุ้มค่าที่ใช่สำ&#xfeff;ห&#xfeff;รั&#xfeff;บ&#xfeff;คุ&#xfeff;ณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Pentium® Silver"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ท่องเว็บไซต์ได้อย่างรวดเร็ว",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "สลับการใช้งานระหว่างโปรแกรมได้อย่างง่ายดาย",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมทั่วไป",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมวิดีโอ 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การตัดต่อภาพถ่ายและวิดีโอทำได้ง่ายมาก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การทำงานที่รวดเร็วด้วยประสิทธิภาพอัจฉริยะ",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "การเล่นเกมระดับ AAA และระยะเวลาการใช้งานแบตเตอรี่ที่ยาวนานในพีซีที่เหมาะกับการพกพา คุณจึงสามารถเล่นเกมได้อย่างเต็มที่",
                "tr_title": "เต็มที่ทุกการใช้งาน",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": true
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": false
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ INTEL® CORE™ สำหรับการเล่นเกมที่เหมาะกับการพกพาเป็นพิเศษ",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i5&#8209;11300H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i7&#8209;11370H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i7‑11375H Special Edition เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>4.4 GHz</span>",
                      "tr_td2_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>4.8 GHz</span>",
                      "tr_td3_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>5.0 GHz</span>"
                    },
                    {
                      "tr_td1_title": "4 คอร์/8 เธรด",
                      "tr_td2_title": "4 คอร์/8 เธรด",
                      "tr_td3_title": "4 คอร์/8 เธรด"
                    },
                    {
                      "tr_td1_title": "เทคโนโลยี Intel® Turbo Boost",
                      "tr_td2_title": "เทคโนโลยี Intel® Turbo Boost",
                      "tr_td3_title": "เทคโนโลยี Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8 MB Intel® Smart Cache",
                      "tr_td2_title": "12 MB Intel® Smart Cache",
                      "tr_td3_title": "12 MB Intel® Smart Cache"
                    },
                    {
                      "tr_td1_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "การเล่นเกมระดับ AAA 1080p ที่มี FPS สูง พร้อมการตั้งค่าระดับสูง อีกทั้งประสิทธิภาพขณะไม่เสียบปลั๊กที่ยอดเยี่ยม ทั้งหมดนี้ในพีซีที่พกพาสะดวกเป็นพิเศษ",
                "tr_title": "ได้ครบ จบทุกความต้องการ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": true
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": false
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ INTEL® CORE™ สำหรับการเล่นเกมที่เหมาะกับการพกพาเป็นพิเศษ",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i5&#8209;11300H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i7&#8209;11370H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i7‑11375H Special Edition เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>4.4 GHz</span>",
                      "tr_td2_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>4.8 GHz</span>",
                      "tr_td3_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>5.0 GHz</span>"
                    },
                    {
                      "tr_td1_title": "4 คอร์/8 เธรด",
                      "tr_td2_title": "4 คอร์/8 เธรด",
                      "tr_td3_title": "4 คอร์/8 เธรด"
                    },
                    {
                      "tr_td1_title": "เทคโนโลยี Intel® Turbo Boost",
                      "tr_td2_title": "เทคโนโลยี Intel® Turbo Boost",
                      "tr_td3_title": "เทคโนโลยี Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8 MB Intel® Smart Cache",
                      "tr_td2_title": "12 MB Intel® Smart Cache",
                      "tr_td3_title": "12 MB Intel® Smart Cache"
                    },
                    {
                      "tr_td1_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_SPECIAL_EDITION_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาสูงสุด 5.0 GHz ช่วยให้คุณเหนือไปอีกขั้น และพีซีที่พกพาสะดวกเป็นพิเศษที่พร้อมไปกับคุณในทุกๆ ที่",
                "tr_title": "ทรงพลังแต่บางเบา",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 Special&nbsp;Edition เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_spcl_edition_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i7 Special Edition",
                      "tr_badgeSubTitle": "",
                      "active": true
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ INTEL® CORE™ สำหรับการเล่นเกมที่เหมาะกับการพกพาเป็นพิเศษ",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i5&#8209;11300H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i7&#8209;11370H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i7‑11375H Special Edition เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>4.4 GHz</span>",
                      "tr_td2_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>4.8 GHz</span>",
                      "tr_td3_title": "ความเร็วสัญญาณนาฬิกาสูงสุด <span class='style_badge'>5.0 GHz</span>"
                    },
                    {
                      "tr_td1_title": "4 คอร์/8 เธรด",
                      "tr_td2_title": "4 คอร์/8 เธรด",
                      "tr_td3_title": "4 คอร์/8 เธรด"
                    },
                    {
                      "tr_td1_title": "เทคโนโลยี Intel® Turbo Boost",
                      "tr_td2_title": "เทคโนโลยี Intel® Turbo Boost",
                      "tr_td3_title": "เทคโนโลยี Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8 MB Intel® Smart Cache",
                      "tr_td2_title": "12 MB Intel® Smart Cache",
                      "tr_td3_title": "12 MB Intel® Smart Cache"
                    },
                    {
                      "tr_td1_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ i7 Special Edition เจนเนอเรชั่น 11 มอบการสร้างคอนเทนต์ขั้นสูง การเล่นเกมที่ราบรื่น และความบันเทิงระดับใหม่ในพีซีที่พกพาสะดวก",
                "tr_title": "ประสิทธิภาพแล็ปท็อปที่ไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 Special&nbsp;Edition เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ Intel® Core™ i7 Special Edition เ&#xfeff;จ&#xfeff;น&#xfeff;เ&#xfeff;น&#xfeff;อ&#xfeff;เ&#xfeff;ร&#xfeff;ชั่&#xfeff;น 11"
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "โปรเซสเซอร์ Intel® Core™ i7 Special Edition เจนเนอเรชั่น 11 มอบการสร้างคอนเทนต์ขั้นสูง การเล่นเกมที่ราบรื่น และความบันเทิงระดับใหม่ในพีซีที่พกพาสะดวก",
                "tr_title": "ประสิทธิภาพแล็ปท็อปที่ไร้ขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 Special&nbsp;Edition เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ Intel® Core™ i7 Special Edition เ&#xfeff;จ&#xfeff;น&#xfeff;เ&#xfeff;น&#xfeff;อ&#xfeff;เ&#xfeff;ร&#xfeff;ชั่&#xfeff;น 11",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_spcl_edition_gaming_tile.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i7 Special Edition",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูงสามารถทำงานร่วมกันได้อย่างลงตัวเพื่อให้ได้ประโยชน์มากขึ้นจากการเล่นเกมแบบแข่งขันและการสร้างคอนเทนต์ที่ซับซ้อน",
                "tr_title": "ขุมพลังสุดแรง ที่มาพร้อมความเสถียร",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "ความสมดุลที่เหมาะสมของความเร็วสัญญาณนาฬิกาและป&#65279;ร&#65279;ะ&#65279;สิ&#65279;ท&#65279;ธิ&#65279;ภ&#65279;า&#65279;พคอร์จะทำให้คุณเล่นเกมได้ดียิ่งขึ้น ไม่ว่าจะเป็นก&#65279;า&#65279;ร&#65279;เ&#65279;ล่&#65279;น&#65279;แ&#65279;บ&#65279;บแข่งขันด้วย FPS ที่สูงหรือประสบการณ์การเล่นเกม AAA&nbsp;อั&#65279;น&#65279;น่&#65279;าตื่นตาตื่นใจ",
                "tr_title": "พลังสู่ชัยชนะ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "เล่น บันทึก และสตรีมพร้อมกันบนเกมที่ต้องการประสิทธิภาพขั้นสูงด้วย FPS ระดับสูง และสลับมาทำงานมัลติทาสกิ้งอันหนักหน่วงได้อย่างง่ายดาย",
                "tr_title": "พลังทะลุขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูงสามารถทำงานร่วมกันได้อย่างลงตัวเพื่อให้ได้ประโยชน์มากขึ้นจากการเล่นเกมแบบแข่งขันและการสร้างคอนเทนต์ที่ซับซ้อน",
                "tr_title": "ขุมพลังสุดแรง ที่มาพร้อมความเสถียร",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_HYBRID",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "สับเปลี่ยนจากการสตรีมภาพยนตร์ไปเป็นการสร้างงานนำเสนอได้อย่างง่ายดาย โดยที่เครื่องยังมีประสิทธิภาพอีกล้นเหลือ",
                "tr_title": "ใช้งานได้ตลอดทั้งวัน",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid",
                "tr_subTitle2": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid"
              }
            },
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "ประสิทธิภาพที่หลากหลายตอบสนองอายุการใช้งานแบตเตอรี่ที่ยาวนานเพื่อให้คุณไปได้ทุกที่",
                "tr_title": "ใช้งานได้ตลอดทั้งวัน",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid",
                "tr_subTitle2": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_HYBRID",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "ทำงานหลากหลายโปรแกรมได้อย่างง่ายดาย เพื่อให้คุณพร้อมสำหรับทุกความท้าทาย ไม่ว่าจะอยู่ที่ใดก็ตาม",
                "tr_title": "การมัลติทาสกิ้งได้ทุกที่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid",
                "tr_subTitle2": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid"
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "ยกระดับทุกอย่างที่คุณทำ ไม่ว่าจะเป็นความบันเทิง การผลิตงาน หรือการสร้างคอนเทนต์",
                "tr_title": "อัปเกรดให้เป็นพีซีที่ทรงพลังมากขึ้น",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid",
                "tr_subTitle2": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_H45",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ประสิทธิภาพการเล่นเกมระดับเ&#65279;ด&#65279;ส&#65279;ก์&#65279;ท็&#65279;อ&#65279;ปผสานความสะดวกแบบพ&#65279;ก&#65279;พ&#65279;า ไม่ว่าจะเป็นการเล่นแบบแ&#65279;ข่&#65279;ง&#65279;ขั&#65279;นด้วย FPS สูงหรือป&#65279;ร&#65279;ะ&#65279;ส&#65279;บ&#65279;ก&#65279;า&#65279;ร&#65279;ณ์การเล่นเกมระดับ AAA อันน่าตื่&#65279;น&#65279;ต&#65279;า&#65279;ตื่&#65279;น&#65279;ใ&#65279;จ",
                "tr_title": "พลังสู่ชัยชนะ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ประสิทธิภาพการเล่นเกมระดับเ&#65279;ด&#65279;ส&#65279;ก์&#65279;ท็&#65279;อ&#65279;ปผสานความสะดวกแบบพ&#65279;ก&#65279;พ&#65279;า ไม่ว่าจะเป็นการเล่นแบบแ&#65279;ข่&#65279;ง&#65279;ขั&#65279;นด้วย FPS สูงหรือป&#65279;ร&#65279;ะ&#65279;ส&#65279;บ&#65279;ก&#65279;า&#65279;ร&#65279;ณ์การเล่นเกมระดับ AAA อันน่าตื่&#65279;น&#65279;ต&#65279;า&#65279;ตื่&#65279;น&#65279;ใ&#65279;จ",
                "tr_title": "พลังสู่ชัยชนะ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_H45",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "แล็ปท็อปที่สามารถเล่น บันทึก และสตรีมพร้อมกันด้วย FPS ที่สูงและสลับเวิร์คโหลดมัลติทาสกิ้งอันหนักหน่วงได้อย่างง่ายดาย",
                "tr_title": "พลังทะลุขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "แล็ปท็อปที่สามารถเล่น บันทึก และสตรีมพร้อมกันด้วย FPS ที่สูงและสลับเวิร์คโหลดมัลติทาสกิ้งอันหนักหน่วงได้อย่างง่ายดาย",
                "tr_title": "พลังทะลุขีดจำกัด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H45_PERFORMANCE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูง สามารถทำงานร่วมกันได้อย่างลงตัว เพื่อความเร็วและแรงสำหรับการเล่นเกมแข่งขันและการสร้างคอนเทนต์ที่ซับซ้อน ไม่ว่าคุณจะใช้งานที่ไหนก็ตาม",
                "tr_title": "ขุมพลังสุดแรง ที่มาพร้อมความเสถียร",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูง สามารถทำงานร่วมกันได้อย่างลงตัว เพื่อความเร็วและแรงสำหรับการเล่นเกมแข่งขันและการสร้างคอนเทนต์ที่ซับซ้อน ไม่ว่าคุณจะใช้งานที่ไหนก็ตาม",
                "tr_title": "ขุมพลังสุดแรง ที่มาพร้อมความเสถียร",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H45_ENTHUSIAST",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็ว จำนวนคอร์ที่สูงและประสิทธิภาพที่ได้รับการปลดล็อค สามารถทำงานร่วมกันได้อย่างลงตัว เพื่อความเร็วและแรงสำหรับการเล่นเกมแข่งขันและการสร้างคอนเทนต์ที่ซับซ้อน ไม่ว่าคุณจะใช้งานที่ไหนก็ตาม",
                "tr_title": "ปลดล็อคขุมพลัง พร้อมการใช้งานทรงประสิทธิภาพ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็ว จำนวนคอร์ที่สูงและประสิทธิภาพที่ได้รับการปลดล็อค สามารถทำงานร่วมกันได้อย่างลงตัว เพื่อความเร็วและแรงสำหรับการเล่นเกมแข่งขันและการสร้างคอนเทนต์ที่ซับซ้อน ไม่ว่าคุณจะใช้งานที่ไหนก็ตาม",
                "tr_title": "ปลดล็อคขุมพลัง พร้อมการใช้งานทรงประสิทธิภาพ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_11",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูงสามารถทำงานร่วมกันได้อย่างลงตัวเพื่อให้ได้ประโยชน์มากขึ้นจากการเล่นเกมแบบแข่งขันและการสร้างคอนเทนต์ที่ซับซ้อน",
                "tr_title": "ขุมพลังสุดแรง ที่มาพร้อมความเสถียร",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge_laptop_11gen.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูงสามารถทำงานร่วมกันได้อย่างลงตัวเพื่อความเร็วและแรงสำหรับการสร้างคอนเทนต์ที่ซับซ้อน ไม่ว่าคุณจะใช้พีซีที่ไหนก็ตาม",
                "tr_title": "ขุมพลังสุดแรง ที่มาพร้อมความเสถียร",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 11",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูงสามารถทำงานร่วมกันได้อย่างลงตัวเพื่อความเร็วและแรงสำหรับการสร้างคอนเทนต์ที่ซับซ้อน",
                "tr_title": "ขุมพลังสุดแรง ที่มาพร้อมความเสถียร",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 11",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_10",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ปลุกความสามารถที่ซ้อนเร้นด้วยประสบการณ์การเล่นเกมสุดล้ำ",
                "tr_title": "ขับเคี่ยวกันถึงขีดสุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock_blue.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA อย่างราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีม",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมและการบันทึก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสร้างคอนเทนต์ขั้นสูง",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ประสิทธิภาพการเล่นเกมสูงสุด",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "ปลดล็อคและสามารถโอเวอร์คล็อกได้<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.5 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ปลุกความสามารถที่ซ้อนเร้นด้วยประสบการณ์การเล่นเกมสุดล้ำ",
                "tr_title": "ขับเคี่ยวกันถึงขีดสุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock_blue.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10 ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA อย่างราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีม",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสตรีมและการบันทึก",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การสร้างคอนเทนต์ขั้นสูง",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ประสิทธิภาพการเล่นเกมสูงสุด",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "ปลดล็อคและสามารถโอเวอร์คล็อกได้<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.8 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.1 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 10 <br/>เธรด: 20</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "สำหรับผู้ที่ต้องเดินทางตลอดเวลา แล็ปท็อปเครื่องนี้ได้รับการออกแบบมาเพื่อคุณโดยเฉพาะ",
                "tr_title": "พบกับอีกระดับของแ&#65279;ล็&#65279;ป&#65279;ท็&#65279;อ&#65279;ปอั&#65279;น&#65279;ล้ำ&#65279;ส&#65279;มั&#65279;ย",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_11_UNLOCKED",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูงสามารถทำงานร่วมกันได้อย่างลงตัวเพื่อให้ได้ประโยชน์มากขึ้นจากการเล่นเกมแบบแข่งขันและการสร้างคอนเทนต์ที่ซับซ้อน",
                "tr_title": "ปลดล็อคขุมพลัง พร้อมการใช้งานทรงประสิทธิภาพ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 11",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge_laptop_11gen.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็ว จำนวนคอร์ที่สูง และประสิทธิภาพแบบปลดล็อคสามารถทำงานร่วมกันได้อย่างลงตัวเพื่อความเร็วและแรงสำหรับการสร้างคอนเทนต์ที่ซับซ้อน ไม่ว่าคุณจะใช้พีซีที่ไหนก็ตาม",
                "tr_title": "ปลดล็อคขุมพลัง พร้อมการใช้งานทรงประสิทธิภาพ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 11",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ความเร็วสัญญาณนาฬิกาที่รวดเร็วและจำนวนคอร์ที่สูงสามารถทำงานร่วมกันได้อย่างลงตัวเพื่อความเร็วและแรงสำหรับการสร้างคอนเทนต์ที่ซับซ้อน",
                "tr_title": "ปลดล็อคขุมพลัง พร้อมการใช้งานทรงประสิทธิภาพ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 11",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "การเล่นเกมและ VR ลื่นไหลกับรายการเกมที่ใช้ทรัพยากรมากที่สุด",
                "tr_title": "การเล่นเกมที่จริงจังเ&#65279;ริ่&#65279;ม&#65279;ที่&#65279;นี่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกม สตรีม และบันทึกได้อย่างเต็มที่",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 ที่ดีที่สุดสำหรับการเล่นเกม",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 4 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.6 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5&nbsp;GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.6 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.9 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5&nbsp;GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "FPS มากกว่าสูงสุด 32% <br/><span class='tr_subtitle_font'>ขณะเล่น สตรีม และบันทึกเกม เมื่อเทียบกับพีซีอายุ 3 ปี<sup>3</sup></span>",
                "tr_title": "พลังสำหรับการแบ่งปันช่วงเวลาการเล่นเกมที่ยอดเยี่ยมที่สุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกม สตรีม และบันทึกได้อย่างเต็มที่",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 ที่ดีที่สุดสำหรับการเล่นเกม",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 4 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.6 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5&nbsp;GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.6 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.9 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5&nbsp;GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "FPS มากกว่าสูงสุด 41% <br/><span class='tr_subtitle_font'>ขณะเล่น สตรีม และบันทึกเกม เมื่อเทียบกับพีซีอายุ 3 ปี<sup>4</sup></span>",
                "tr_title": "นักเล่นเกมอยากได้ Intel® Core™ i9 จัดให้",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;9",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>เธรด</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>คอร์</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>สูงสุด <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>GHz</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] MB <br/></span><span class='subtitle_font'>แคช</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "ปลดล็อคต่อไปได้",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ค้นหาโปรเซสเซอร์ Intel® Core™ ที่เหมาะกับการเล่นเกมของคุณ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "โปรเซสเซอร์ Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "การเล่นเกม AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "การเล่นเกมเพื่อการแข่งขัน",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "เล่นเกม สตรีม และบันทึกได้อย่างเต็มที่",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 9 ที่ดีที่สุดสำหรับการเล่นเกม",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.3 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 4 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.6 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5&nbsp;GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.6 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 6 <br/>เธรด: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 4.9 GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>ความเร็วสัญญาณนาฬิกา<sup>2</sup>: สูงสุด 5&nbsp;GHz</span>",
                      "tr_subTitle": "<span class='small_font'>คอร์: 8 <br/>เธรด: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_K_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "เพื่อยุคใหม่แห่งการเล่นเกม",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 12"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 12"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 12"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_HX_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "เล่นเกมและลุยงานในเครื่องเดียว",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 12"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 12"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เชื่อถือได้เมื่อคุณต้องการมากที่สุด",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i3 เจนเนอเรชั่น 12",
                "bannerImgUrl": "assets/images/12th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เพิ่มขึ้นในส่วนที่จำเป็นที่สุด",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 12",
                "bannerImgUrl": "assets/images/12th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เพิ่มขึ้นในส่วนที่จำเป็นที่สุด",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 12",
                "bannerImgUrl": "assets/images/12th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพเหนือระดับในส่วนที่คุณต้องการมากที่สุด",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 12",
                "bannerImgUrl": "assets/images/12th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพเหนือระดับในส่วนที่คุณต้องการมากที่สุด",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 12",
                "bannerImgUrl": "assets/images/12th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/EVO_I5_12GEN.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ มอบประสิทธิภาพ ความอัจฉริยะในตัวที่ให้คุณแชทวิดีโอได้อย่างมั่นใจ อินเทอร์เน็ตที่เร็วขึ้น แบตเตอรี่ที่ใช้งานได้ยาวนาน และอื่นๆ อีกมากมาย",
                "tr_title": "ประสิทธิภาพที่เพิ่มขึ้นในส่วนที่จำเป็นที่สุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 12",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/EVO_I7_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/evo_processor_i7_gen12.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ มอบประสิทธิภาพ ความอัจฉริยะในตัวที่ให้คุณแชทวิดีโอได้อย่างมั่นใจ อินเทอร์เน็ตที่เร็วขึ้น แบตเตอรี่ที่ใช้งานได้ยาวนาน และอื่นๆ อีกมากมาย",
                "tr_title": "ประสิทธิภาพเหนือระดับในส่วนที่คุณต้องการมากที่สุด",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 12",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I9_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/EVO_I9_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/evo_processor_i9_gen12.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ มอบประสิทธิภาพ ความอัจฉริยะในตัวที่ให้คุณแชทวิดีโอได้อย่างมั่นใจ อินเทอร์เน็ตที่เร็วขึ้น แบตเตอรี่ที่ใช้งานได้ยาวนาน และอื่นๆ อีกมากมาย",
                "tr_title": "ประสิทธิภาพเต็มขีดสุดในแล็ปท็อประดับพรีเมียม",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 12",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i9-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "พร้อมเทคโนโลยี Intel®&nbsp;Turbo&nbsp;Boost&nbsp;2.0 สู&#65279;ง&#65279;สุ&#65279;ด&nbsp;[max_turbo_frequency]&nbsp;GHz",
                "tr_title": "สร้างมาเพื่อธุรกิจ",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 12",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ลดเสียงรบกวนและเบลอภาพพื้นหลังของคุณ",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพอัตโนมัติเพื่อให้คุณทุ่มเทในสิ่งที่คุณทำอยู่ได้อย่างเต็มที่",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "สัมผัสประสบการณ์การโทรผ่านเว็บที่มีคุณภาพสูงและราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "การรักษาความปลอดภัยในระดับฮาร์ดแวร์ตั้งแต่แกะกล่อง",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "มอบความสามารถในการจัดการอุปกรณ์จากระยะไกล",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพ Wi-Fi ของคุณให้ดีที่สุดโดยอัตโนมัติ<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "เพิ่มประสิทธิภาพผ่านแอปที่ขับเคลื่อนด้วยข้อมูล",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ทำงานเต็มประสิทธิผลด้วยประสิทธิภาพที่ดียิ่งขึ้น",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "พร้อมเทคโนโลยี Intel®&nbsp;Turbo&nbsp;Boost&nbsp;2.0 สู&#65279;ง&#65279;สุ&#65279;ด&nbsp;[max_turbo_frequency]&nbsp;GHz",
                "tr_title": "ทำงานเต็มประสิทธิภาพ ให้คุณโฟกัสกับธุรกิจของคุณอย่างเต็มที่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 12",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ลดเสียงรบกวนและเบลอภาพพื้นหลังของคุณ",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพอัตโนมัติเพื่อให้คุณทุ่มเทในสิ่งที่คุณทำอยู่ได้อย่างเต็มที่",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "สัมผัสประสบการณ์การโทรผ่านเว็บที่มีคุณภาพสูงและราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "การรักษาความปลอดภัยในระดับฮาร์ดแวร์ตั้งแต่แกะกล่อง",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "มอบความสามารถในการจัดการอุปกรณ์จากระยะไกล",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพ Wi-Fi ของคุณให้ดีที่สุดโดยอัตโนมัติ<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "เพิ่มประสิทธิภาพผ่านแอปที่ขับเคลื่อนด้วยข้อมูล",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ทำงานเต็มประสิทธิผลด้วยประสิทธิภาพที่ดียิ่งขึ้น",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "พร้อมเทคโนโลยี Intel®&nbsp;Turbo&nbsp;Boost&nbsp;2.0 สู&#65279;ง&#65279;สุ&#65279;ด&nbsp;[max_turbo_frequency]&nbsp;GHz",
                "tr_title": "ให้ธุรกิจของคุณเติบโตอย่างรวดเร็ว",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 12",
                "processorTileBadgeUrl": "assets/images/standard/VPRO12_i9.svg",
                "processorCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ลดเสียงรบกวนและเบลอภาพพื้นหลังของคุณ",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพอัตโนมัติเพื่อให้คุณทุ่มเทในสิ่งที่คุณทำอยู่ได้อย่างเต็มที่",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "สัมผัสประสบการณ์การโทรผ่านเว็บที่มีคุณภาพสูงและราบรื่น",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "การรักษาความปลอดภัยในระดับฮาร์ดแวร์ตั้งแต่แกะกล่อง",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "มอบความสามารถในการจัดการอุปกรณ์จากระยะไกล",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพ Wi-Fi ของคุณให้ดีที่สุดโดยอัตโนมัติ<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "เพิ่มประสิทธิภาพผ่านแอปที่ขับเคลื่อนด้วยข้อมูล",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "ทำงานเต็มประสิทธิผลด้วยประสิทธิภาพที่ดียิ่งขึ้น",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เชื่อถือได้ซึ่งเน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/13th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพในการใช้งานจริงที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 13",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพในการใช้งานจริงที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 13",
                "bannerImgUrl": "assets/images/creator/13thgeni5processor.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่ทรงพลังที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 13",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่ทรงพลังที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 13",
                "bannerImgUrl": "assets/images/creator/13thgeni7processor.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เหนือชั้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 13",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/EVO_I5_12GEN.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "เชื่อมต่อกับโทรศัพท์ที่คุณใช้งานได้อย่างราบรื่น<sup>24</sup> เลือก Wi-Fi ที่ดีที่สุดได้อย่างอัจฉริยะและชาร์จเร็วด้วยแบตเตอรี่ที่ใช้งานได้ยาวนาน",
                "tr_title": "ยกระดับประสิทธิภาพที่เ&#xfeff;ห&#xfeff;นื&#xfeff;อ&#xfeff;ชั้&#xfeff;น สู่&#xfeff;ก&#xfeff;า&#xfeff;ร&#xfeff;ทำ&#xfeff;สิ่&#xfeff;ง&#xfeff;ต่&#xfeff;า&#xfeff;ง&#xfeff;ๆไ&#xfeff;ด้&#xfeff;ม&#xfeff;า&#xfeff;ก&#xfeff;ขึ้&#xfeff;น&#xfeff;ใ&#xfeff;น&#xfeff;ทุ&#xfeff;ก&#xfeff;ที่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 13",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/EVO_I7_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "เชื่อมต่อกับโทรศัพท์ที่คุณใช้งานได้อย่างราบรื่น<sup>24</sup> เลือก Wi-Fi ที่ดีที่สุดได้อย่างอัจฉริยะและชาร์จเร็วด้วยแบตเตอรี่ที่ใช้งานได้ยาวนาน",
                "tr_title": "ยกระดับประสิทธิภาพที่เหนือชั้น ให้พีซีของคุณทำสิ่งต่างๆ ได้มากขึ้นไปพร้อมกัน",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 13",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I9_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/EVO_I9_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "เชื่อมต่อกับโทรศัพท์ที่คุณใช้งานได้อย่างราบรื่น<sup>24</sup> เลือก Wi-Fi ที่ดีที่สุดได้อย่างอัจฉริยะและชาร์จเร็วด้วยแบตเตอรี่ที่ใช้งานได้ยาวนาน",
                "tr_title": "ยกระดับประสิทธิภาพที่เหนือชั้นเพื่อทำงานที่ใช้สมรรถนะสูงได้อย่างรวดเร็ว",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 13",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i9-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_13TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เหนือชั้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 13",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 13",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 13",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_ABOVE13TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เหนือชั้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ i9",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เชื่อถือได้ซึ่งเน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ i3",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/13th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพในการใช้งานจริงที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่ทรงพลังที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_14TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เหนือชั้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ i9",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่เชื่อถือได้ซึ่งเน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;3",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/14th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพในการใช้งานจริงที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;5",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ 5",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่ทรงพลังที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;7",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ 7",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ประสิทธิภาพที่ทรงพลังที่เน้นการทำสิ่งต่างๆ ได้มากขึ้น",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_14_1.svg",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ 9",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/intel_core_9_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_14_1.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ 9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_1ST_GEN_ULTRA_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "เล่นเกมได้อย่างเต็มที่",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 5",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_5_h_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 7",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_7_h_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 9",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_9_h_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores",
                    "tr_badgeSubTitle1": "[l_core] LPE-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores",
                    "tr_badgeSubTitle1": "[l_thread] บน LPE-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ Ultra 5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ Ultra 7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                      "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ Ultra 9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tr_title": "เล่นเกมได้อย่างเต็มที่",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tr_title": "เล่นเกมได้อย่างเต็มที่",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tr_title": "เล่นเกมได้อย่างเต็มที่",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tr_title": "เล่นเกมได้อย่างเต็มที่",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tr_title": "เล่นเกมได้อย่างเต็มที่",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tr_title": "เล่นเกมได้อย่างเต็มที่",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "ธุรกิจขนาดเล็กควรได้รับโซลูชันธุรกิจที่ยิ่งใหญ่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i5 เจนเนอเรชั่น 13",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ลดเสียงรบกวนและเบลอภาพพื้นหลังของคุณ",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพอัตโนมัติเพื่อให้คุณทุ่มเทในสิ่งที่คุณทำอยู่ได้อย่างเต็มที่",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "สัมผัสประสบการณ์การโทรผ่านเว็บที่มีคุณภาพสูงและราบรื่น",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "รับการปกป้องจากระบบรักษาความปลอดภัยในระดับฮาร์ดแวร์ตั้งแต่แกะกล่อง",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "ช่วยปกป้องอุปกรณ์และข้อมูลจากการโจมตีแบบปลอมแปลงทางกายภาพ",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "ธุรกิจขนาดเล็กควรได้รับโซลูชันธุรกิจที่ยิ่งใหญ่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i7 เจนเนอเรชั่น 13",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ลดเสียงรบกวนและเบลอภาพพื้นหลังของคุณ",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพอัตโนมัติเพื่อให้คุณทุ่มเทในสิ่งที่คุณทำอยู่ได้อย่างเต็มที่",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "สัมผัสประสบการณ์การโทรผ่านเว็บที่มีคุณภาพสูงและราบรื่น",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "รับการปกป้องจากระบบรักษาความปลอดภัยในระดับฮาร์ดแวร์ตั้งแต่แกะกล่อง",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "ช่วยปกป้องอุปกรณ์และข้อมูลจากการโจมตีแบบปลอมแปลงทางกายภาพ",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "ธุรกิจขนาดเล็กควรได้รับโซลูชันธุรกิจที่ยิ่งใหญ่",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i9 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;13",
                "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ i9 เจนเนอเรชั่น 13",
                "processorTileBadgeUrl": "assets/images/standard/VPRO12_i9.svg",
                "processorCompare": {
                  "tr_title": "โปรเซสเซอร์นี้เปรียบเทียบได้กับอะไร",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "ลดเสียงรบกวนและเบลอภาพพื้นหลังของคุณ",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "ปรับประสิทธิภาพอัตโนมัติเพื่อให้คุณทุ่มเทในสิ่งที่คุณทำอยู่ได้อย่างเต็มที่",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "สัมผัสประสบการณ์การโทรผ่านเว็บที่มีคุณภาพสูงและราบรื่น",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "รับการปกป้องจากระบบรักษาความปลอดภัยในระดับฮาร์ดแวร์ตั้งแต่แกะกล่อง",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "ช่วยปกป้องอุปกรณ์และข้อมูลจากการโจมตีแบบปลอมแปลงทางกายภาพ",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_RPL_MTL_vPro",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/vPro_ultra_badge.png",
                "tileBG": "",
                "bannerImgUrl": "assets/images/INTEL_VPRO_ULTRA.png",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "ปลดล็อกประสบการณ์ AI ใหม่ให้กับธุรกิจ",
                "tr_title": "พร้อมรับทุกความท้าทาย ด้วยพลังจากโปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;[XX] และ Intel&nbsp;vPro®",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra [XX]",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_1.png",
                    "tr_badgeTitle": "ยกระดับธุรกิจของคุณด้วย AI PC จาก Intel",
                    "tr_badgeSubTitle": "พีซีอันทรงพลังที่สร้างประสบการณ์ชั้นยอดคือหัวใจสำคั&#xfeff;ญ&#xfeff;ข&#xfeff;อ&#xfeff;งป&#xfeff;ร&#xfeff;ะ&#xfeff;สิ&#xfeff;ท&#xfeff;ธิภาพในการทำงานของธุรกิจ Intel vPro® ช่&#xfeff;ว&#xfeff;ย&#xfeff;ใ&#xfeff;ห้พ&#xfeff;นั&#xfeff;ก&#xfeff;ง&#xfeff;า&#xfeff;นทำเวิร์คโหลดและแอปพลิเคชั่นต่างๆ ได้&#xfeff;อ&#xfeff;ย่&#xfeff;า&#xfeff;ง&#xfeff;มีป&#xfeff;ร&#xfeff;ะ&#xfeff;สิ&#xfeff;ท&#xfeff;ธิ&#xfeff;ภาพและศักยภาพการทำงานมากยิ่งขึ้น ซึ่งเป็&#xfeff;น&#xfeff;ผ&#xfeff;ล&#xfeff;ม&#xfeff;าจ&#xfeff;า&#xfeff;ก&#xfeff;ส&#xfeff;ถ&#xfeff;าปัตยกรรมใหม่ที่ให้ประสิทธิภาพด้านการ&#xfeff;ป&#xfeff;ร&#xfeff;ะ&#xfeff;ห&#xfeff;ยั&#xfeff;ดพ&#xfeff;ลั&#xfeff;ง&#xfeff;ง&#xfeff;า&#xfeff;นอย่างเหนือชั้นสำหรับเวิร์คโหลดทางธุรกิจ&#xfeff;ต่&#xfeff;า&#xfeff;ง&#xfeff;ๆ&nbsp;ที่ซั&#xfeff;บ&#xfeff;ซ้&#xfeff;อ&#xfeff;น โดยสถาปัตยกรรมนี้จะส่งงานที่ใช่ไปยังก&#xfeff;ล&#xfeff;ไ&#xfeff;ก&#xfeff;ที่เ&#xfeff;ห&#xfeff;ม&#xfeff;า&#xfeff;ะ&#xfeff;ส&#xfeff;มในเวลาที่เหมาะเจาะ",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_2.png",
                    "tr_badgeTitle": "คุณสมบัติ<wbr>รั&#xfeff;ก&#xfeff;ษ&#xfeff;า&#xfeff;ค&#xfeff;ว&#xfeff;า&#xfeff;มป&#xfeff;ล&#xfeff;อ&#xfeff;ด&#xfeff;ภั&#xfeff;ยแบบหลา&#xfeff;ย&#xfeff;ชั้&#xfeff;น&#xfeff;ที่พ&#xfeff;ร้&#xfeff;อ&#xfeff;ม&#xfeff;ทำ&#xfeff;งานตั้งแ&#xfeff;ต่&#xfeff;แ&#xfeff;ก&#xfeff;ะก&#xfeff;ล่&#xfeff;อ&#xfeff;ง",
                    "tr_badgeSubTitle": "ภัยคุกคามรูปแบบใหม่ๆ จำเป็นต้องมีแนวทางด้านการรักษาความปลอดภัยที่ครอบคลุม Intel vPro® ให้การปกป้องที่ระดับฮาร์ดแวร์และทั่วทั้งสแต็ก เพื่อการปกป้องธุรกิจของคุณที่ดียิ่งกว่า มาตรการรักษาความปลอดภัยที่พร้อมใช้งานและไม่เหมือนใครเหล่านี้ ซึ่งรวมไปถึงขีดความสามารถในการตรวจจับภัยคุกคามด้วย AI จะช่วยปกป้องผู้ใช้งาน ข้อมูล และธุรกิจข&#xfeff;อ&#xfeff;ง&#xfeff;คุ&#xfeff;ณ",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_3.png",
                    "tr_badgeTitle": "เครื่องมือในตัวที่จะช่วยให้ผู้ใช้ทำงานอย่างต่อเนื่องได้จากแทบทุกที่",
                    "tr_badgeSubTitle": "มีสำนักงานอยู่ทุกที่และพีซีเองก็เช่นกัน Intel vPro® ให้ขีดความสามารถในการจัดการด้วยฮาร์ดแวร์สมัยใหม่เพื่อช่วยลดภาระด้านการจัดการกลุ่มพีซีให้กับธุรกิจต่างๆ ลดความซับซ้อนในการสนับสนุน และยกระดับประสบการณ์ใช้งานของผู้ใช้งานจริง ซึ่งทำทั้งหมดนี้ได้โดยที่ปฏิบัติตามแนวทางการประมวลผลที่ยั่งยืนไปพร้อมกัน",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_5.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ก้าวล้ำเหนือพีซีไปอีกขั้น ด้วย AI PC",
                "tr_subtitle1": "ขับเคลื่อนด้วยโปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA (ซีรีส์&nbsp;2)",
                "tr_subtitle2": "ทุกสิ่งเป็นไปได้ด้วย Intel AI PC ของคุณ",
                "tr_subtitle": "โมบายล์โปรเซสเซอร์ที่มีประสิทธิภาพสูงและปลอดภัยที่สุดของ Intel<sup>39</sup>",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;5 (ซีรีส์&nbsp;2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>สร้างสรรค์ได้มากขึ้น</span> ด้วยเครื่องมือ AI ที่ให้คุณสร้างสรรค์ได้เร็วขึ้น"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>มีประสิทธิภาพมากขึ้น</span> ด้วยผู้ช่วย AI ที่ช่วยให้คุณประหยัดเวลา"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>ปลอดภัยมากขึ้น</span> ด้วยการปกป้องข้อมูลในเครื่อง"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_7.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ก้าวล้ำเหนือพีซีไปอีกขั้น ด้วย AI PC",
                "tr_subtitle1": "ขับเคลื่อนด้วยโปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA (ซีรีส์&nbsp;2)",
                "tr_subtitle2": "ทุกสิ่งเป็นไปได้ด้วย Intel AI PC ของคุณ",
                "tr_subtitle": "โมบายล์โปรเซสเซอร์ที่มีประสิทธิภาพสูงและปลอดภัยที่สุดของ Intel<sup>39</sup>",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;7 (ซีรีส์&nbsp;2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>สร้างสรรค์ได้มากขึ้น</span> ด้วยเครื่องมือ AI ที่ให้คุณสร้างสรรค์ได้เร็วขึ้น"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>มีประสิทธิภาพมากขึ้น</span> ด้วยผู้ช่วย AI ที่ช่วยให้คุณประหยัดเวลา"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>ปลอดภัยมากขึ้น</span> ด้วยการปกป้องข้อมูลในเครื่อง"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_9.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ก้าวล้ำเหนือพีซีไปอีกขั้น ด้วย AI PC",
                "tr_subtitle1": "ขับเคลื่อนด้วยโปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA (ซีรีส์&nbsp;2)",
                "tr_subtitle2": "ทุกสิ่งเป็นไปได้ด้วย Intel AI PC ของคุณ",
                "tr_subtitle": "โมบายล์โปรเซสเซอร์ที่มีประสิทธิภาพสูงและปลอดภัยที่สุดของ Intel<sup>39</sup>",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 9 (ซีรีส์ 2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>สร้างสรรค์ได้มากขึ้น</span> ด้วยเครื่องมือ AI ที่ให้คุณสร้างสรรค์ได้เร็วขึ้น"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>มีประสิทธิภาพมากขึ้น</span> ด้วยผู้ช่วย AI ที่ช่วยให้คุณประหยัดเวลา"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>ปลอดภัยมากขึ้น</span> ด้วยการปกป้องข้อมูลในเครื่อง"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_5.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ก้าวล้ำเหนือพีซีไปอีกขั้น ด้วย AI PC",
                "tr_subtitle1": "ขับเคลื่อนด้วยโปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA (ซีรีส์&nbsp;2)",
                "tr_subtitle2": "ทุกสิ่งเป็นไปได้ด้วย Intel AI PC ของคุณ",
                "tr_subtitle": "โมบายล์โปรเซสเซอร์ที่มีประสิทธิภาพสูงและปลอดภัยที่สุดของ Intel<sup>39</sup>",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;5 (ซีรีส์&nbsp;2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_7.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ก้าวล้ำเหนือพีซีไปอีกขั้น ด้วย AI PC",
                "tr_subtitle1": "ขับเคลื่อนด้วยโปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA (ซีรีส์&nbsp;2)",
                "tr_subtitle2": "ทุกสิ่งเป็นไปได้ด้วย Intel AI PC ของคุณ",
                "tr_subtitle": "โมบายล์โปรเซสเซอร์ที่มีประสิทธิภาพสูงและปลอดภัยที่สุดของ Intel<sup>39</sup>",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;7 (ซีรีส์&nbsp;2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_9.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ก้าวล้ำเหนือพีซีไปอีกขั้น ด้วย AI PC",
                "tr_subtitle1": "ขับเคลื่อนด้วยโปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA (ซีรีส์&nbsp;2)",
                "tr_subtitle2": "ทุกสิ่งเป็นไปได้ด้วย Intel AI PC ของคุณ",
                "tr_subtitle": "โมบายล์โปรเซสเซอร์ที่มีประสิทธิภาพสูงและปลอดภัยที่สุดของ Intel<sup>39</sup>",
                "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 9 (ซีรีส์ 2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "สร้างมาเพื่อเกม พร้อมลุยทุกสถานการณ์",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 5",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_5_tile_badge.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 7",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_7_tile_badge.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 9",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_9_tile_badge.svg"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores",
                    "tr_badgeSubTitle1": "[l_core] LPE-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores",
                    "tr_badgeSubTitle1": "[l_thread] บน LPE-cores"
                  }
                ],
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/processor/arl_panel1.png",
                    "tr_title": "ปลดล็อกประสิทธิภาพที่&#xfeff;ดี&#xfeff;เ&#xfeff;ยี่&#xfeff;ย&#xfeff;ม&#xfeff;สำ&#xfeff;ห&#xfeff;รั&#xfeff;บก&#xfeff;า&#xfeff;ร&#xfeff;เ&#xfeff;ล่&#xfeff;น&#xfeff;เ&#xfeff;ก&#xfeff;ม",
                    "tr_subtitle": "รับประสิทธิภาพระดับตำนานสำหรับก&#xfeff;า&#xfeff;ร&#xfeff;เ&#xfeff;ล่&#xfeff;น&#xfeff;เ&#xfeff;ก&#xfeff;ม&#xfeff;ด้&#xfeff;ว&#xfeff;ย&#xfeff;ค&#xfeff;อ&#xfeff;ร์&#xfeff;ที่&#xfeff;พั&#xfeff;ฒ&#xfeff;น&#xfeff;าขึ้นใหม่ที่มอบการเล่นเกมที่ลื่นไหลตอบสนองไ&#xfeff;ด้&#xfeff;ดี&#xfeff;เ&#xfeff;ป็&#xfeff;น&#xfeff;พิ&#xfeff;เ&#xfeff;ศ&#xfeff;ษ <br/><br/>ความถี่สูงสุด <span class ='expandable_highlight'>[XX] GHz</span> พร้อมด้วย Intel® Thermal Velocity Boost",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel2.png",
                    "tr_title": "เพิ่มประสิทธิภาพการทำงานให้ถึงขั้นสูงสุด",
                    "tr_subtitle": "รับประสิทธิภาพสูงแบบ Ultra ด้วยโปรเซสเซอร์ Intel®&nbsp;Core™ Ultra ที่ปรับปรุงทั้งประสิทธิภาพและการใช้พลังงานอ&#xfeff;ย่&#xfeff;า&#xfeff;งคุ้&#xfeff;ม&#xfeff;ค่&#xfeff;าเพื่อให้แล็ปท็อปของคุณทำงานได้เย็นขึ้น เงียบขึ้นแ&#xfeff;ล&#xfeff;ะ&#xfeff;เ&#xfeff;ร็&#xfeff;ว&#xfeff;ขึ้&#xfeff;น <br><br/>ประสิทธิภาพมัลติเธรดเพิ่มขึ้นมากกว่า <span class ='expandable_highlight'>10+%</span> <br><br/>ใช้พลังงานลดลงสูงสุด <span class ='expandable_highlight'>30%</span>",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel3.png",
                    "tr_title": "เตรียมพร้อมสำหรับอนาคต<wbr>ด้วยการอ&#xfeff;อ&#xfeff;ฟ&#xfeff;โ&#xfeff;ห&#xfeff;ล&#xfeff;ดเกม<wbr>และสตรีม",
                    "tr_subtitle": "ปลดล็อกประสิทธิภาพการสตรีมและการเล่นเกมที่ดีขึ้นด้วย AI PC ที่ใช้โปรเซสเซอร์ Intel® Core™ Ultra<br><br/><strong>ถ่ายโอนงาน AI ไปยัง NPU:</strong><br><br/><span class ='expandable_highlight'>การลบพื้นหลัง</span><br><br/><span class ='expandable_highlight'>การเพิ่มประสิทธิภาพเสียง</span><br><br/><span class ='expandable_highlight'>การจัดเฟรมอัตโนมัติ</span><br><br/><strong>ตัวเร่งความเร็ว AI สามตัว: CPU, GPU, NPU</strong> ด้วยตัวเร่งความเร็ว AI ทั้ง CPU, GPU และ NPU ที่ติดตั้งอยู่ในโปรเซสเซอร์ ทำให้โปรเซสเซอร์ Intel® Core™ Ultra สามารถจัดการเวิร์กโหลด AI ได้อย่างรวดเร็ว",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4.png",
                    "tr_title": "ปรับปรุงการเชื่อมต่อของคุณ",
                    "tr_subtitle": "ด้วยเลน PCIe 5.0 ที่มากขึ้น เทคโนโลยี Thunderbolt™ 5.0  และ Wi-Fi 7 ที่พร้อมใช้งาน ทำให้เดสก์ท็อปโปรเซสเซอร์ Intel® Core™ Ultra  ช่วยให้คุณเชื่อมต่อได้ง่ายกว่าที่เคย <br><br/><strong>รองรับเทคโนโลยี Thunderbolt™ 5 </strong>​ <br><br/>ถ่ายโอนได้สูงถึง <span class ='expandable_highlight'>120 Gbps</span> สำหรบการบันทึก การตัดต่อ หรือการแชร์ไฟล์ แบนด์วิดท์ข้อมูลมากกว่า Thunderbolt™ <br><br/><span class ='expandable_highlight'>2 เท่า</span>​",
                    "align": "right"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "สร้างสรรค์มากขึ้น<br>มีประสิทธิภาพมากขึ้น<br>ปลอดภัยมากขึ้น",
                "tr_subtitle": "มีเวลาให้กับสิ่งที่คุณรักมากขึ้น",
                "bannerImgUrl": "assets/images/processor/arl_std_banner_desktop.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;5 (ซีรีส์&nbsp;2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (ซีรีส์&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;7 (ซีรีส์&nbsp;2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (ซีรีส์&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel® Core™ Ultra 9 (ซีรีส์ 2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (ซีรีส์&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1_desktop.png",
                    "tr_title": "ลดเวลาการทำงานให้เสร็จเร็วขึ้น ได้รวดเร็ว",
                    "tr_subtitle": "ให้คุณเหลือเวลามากขึ้นด้วยการช่วยเหลือของ AI จัดระเบียบปฏิทินของคุณ วางแผนการเดินทาง สรุปเนื้อหาการประชุมทันที สร้างงานนำเสนออย่างง่ายดาย และอื่น ๆ",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2_desktop.png",
                    "tr_title": "เล่นเกมโปรดของคุณ แบบไร้กังวล",
                    "tr_subtitle": "ไร้ปัญหาด้านประสิทธิภาพหรือความเข้ากันได้ขณะเล่นเกม เล่นเกมระดับ AAA ยอดนิยมได้อย่างราบรื่น คุณจึงสามารถเล่นเกมและสตรีมได้อย่างมั่นใจ",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3_desktop.png",
                    "tr_title": "สร้างสรรค์สิ่งที่คุณรัก อย่างง่ายดาย",
                    "tr_subtitle": "ให้คุณทำทุกอย่างที่ต้องการได้รวดเร็วและง่ายดายขึ้นด้วยเครื่องมือสร้างสรรค์งานที่เร่งความเร็วด้วย AI<br><br>ครอบตัดภาพ เปลี่ยนพื้นหลัง และเพิ่มเอฟเฟ็กต์ได้อย่างรวดเร็ว ปรับปรุงวิดีโอได้ในไม่กี่คลิก แม้แต่ปรับแต่งสร้างงานศิลปะจากข้อความสั้นๆ",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel4_desktop.png",
                    "tr_title": "อุ่นใจมากขึ้น ไ&#xfeff;ด้&#xfeff;ต&#xfeff;ล&#xfeff;อ&#xfeff;ด&#xfeff;เ&#xfeff;ว&#xfeff;ล&#xfeff;า",
                    "tr_subtitle": "มั่นใจได้เมื่อรู้ว่าคุณมีระบบการป้องกันในตัวที่ช่วยให้ข้อมูลของคุณปลอดภัยและเป็นส่วนตัวมากขึ้น<br><br>นอกจากนี้ แอปรักษาความปลอดภัยที่ใช้ AI ยังช่วยตรวจจับเสียงปลอมในวิดีโอได้ทันที และช่วยปกป้องข้อมูลที่ละเอียดอ่อนที่จัดเก็บไว้ในพีซีของคุณ",
                    "align": "left"
                  }
                ]
              }
            },
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "สร้างสรรค์มากขึ้น<br>มีประสิทธิภาพมากขึ้น<br>ปลอดภัยมากขึ้น",
                "tr_subtitle": "มีเวลาให้กับสิ่งที่คุณรักมากขึ้น",
                "bannerImgUrl": "assets/images/processor/arl_std_banner.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;5 (ซีรีส์&nbsp;2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (ซีรีส์&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;7 (ซีรีส์&nbsp;2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (ซีรีส์&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel® Core™ Ultra 9 (ซีรีส์ 2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (ซีรีส์&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1.png",
                    "tr_title": "ลดเวลาการทำงานให้เสร็จเร็วขึ้น ได้รวดเร็ว",
                    "tr_subtitle": "ให้คุณเหลือเวลามากขึ้นด้วยการช่วยเหลือของ AI จัดระเบียบปฏิทินของคุณ วางแผนการเดินทาง สรุปเนื้อหาการประชุมทันที สร้างงานนำเสนออย่างง่ายดาย และอื่น ๆ",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2.png",
                    "tr_title": "สร้างสรรค์สิ่งที่คุณรัก อย่างง่ายดาย",
                    "tr_subtitle": "ให้คุณทำทุกอย่างที่ต้องการได้รวดเร็วและง่ายดายขึ้นด้วยเครื่องมือสร้างสรรค์งานที่เร่งความเร็วด้วย AI<br><br>ครอบตัดภาพ เปลี่ยนพื้นหลัง และเพิ่มเอฟเฟ็กต์ได้อย่างรวดเร็ว ปรับปรุงวิดีโอได้ในไม่กี่คลิก แม้แต่ปรับแต่งสร้างงานศิลปะจากข้อความสั้นๆ",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3.png",
                    "tr_title": "เล่นเกมโปรดของคุณ แบบไร้กังวล",
                    "tr_subtitle": "ไร้ปัญหาด้านประสิทธิภาพหรือความเข้ากันได้ขณะเล่นเกม เล่นเกมระดับ AAA ยอดนิยมได้อย่างราบรื่น คุณจึงสามารถเล่นเกมและสตรีมได้อย่างมั่นใจ<br><br>นอกจากนี้ คุณยังจะได้สัมผัสกับประสบการณ์การเล่นเกมที่ราบรื่นยิ่งขึ้นในระหว่างเดินทางและระยะเวลาในการเล่นที่นานขึ้นแม้ไม่ได้เสียบปลั๊ก ด้วยกราฟิก Intel® Arc™ ในตัว<sup>57</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel4.png",
                    "tr_title": "ลืมที่ชาร์จไปได้เลย ตลอดวัน<sup>55</sup>",
                    "tr_subtitle": "ทำทุกอย่างที่คุณชอบขณะเดินทางด้วยระยะเวลาการใช้งานแบตเตอรี่สูงสุด <strong>20 ชั่วโมง<sup>55,56</sup></strong>",
                    "align": "centre"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel5.png",
                    "tr_title": "อุ่นใจมากขึ้น ไ&#xfeff;ด้&#xfeff;ต&#xfeff;ล&#xfeff;อ&#xfeff;ด&#xfeff;เ&#xfeff;ว&#xfeff;ล&#xfeff;า",
                    "tr_subtitle": "มั่นใจได้เมื่อรู้ว่าคุณมีระบบการป้องกันในตัวที่ช่วยให้ข้อมูลของคุณปลอดภัยและเป็นส่วนตัวมากขึ้น<br><br>นอกจากนี้ แอปรักษาความปลอดภัยที่ใช้ AI ยังช่วยตรวจจับเสียงปลอมในวิดีโอได้ทันที และช่วยปกป้องข้อมูลที่ละเอียดอ่อนที่จัดเก็บไว้ในพีซีของคุณ",
                    "align": "left"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "EVO",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "สร้างสรรค์มากขึ้น<br>มีประสิทธิภาพมากขึ้น<br>ปลอดภัยมากขึ้น",
                "tr_subtitle": "มีเวลาให้กับสิ่งที่คุณรักมากขึ้น",
                "bannerImgUrl": "assets/images/processor/arl_std_banner.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "panelType2": "evo-content-tile-panel",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;5 (ซีรีส์&nbsp;2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (ซีรีส์&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;7 (ซีรีส์&nbsp;2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (ซีรีส์&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "โปรเซสเซอร์ Intel® Core™ Ultra 9 (ซีรีส์ 2)",
                    "tr_badgeSubTitle1": "โปรเซสเซอร์ INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (ซีรีส์&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1.png",
                    "tr_title": "ลดเวลาการทำงานให้เสร็จเร็วขึ้น ได้รวดเร็ว",
                    "tr_subtitle": "ให้คุณเหลือเวลามากขึ้นด้วยการช่วยเหลือของ AI จัดระเบียบปฏิทินของคุณ วางแผนการเดินทาง สรุปเนื้อหาการประชุมทันที สร้างงานนำเสนออย่างง่ายดาย และอื่น ๆ",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2.png",
                    "tr_title": "สร้างสรรค์สิ่งที่คุณรัก อย่างง่ายดาย",
                    "tr_subtitle": "ให้คุณทำทุกอย่างที่ต้องการได้รวดเร็วและง่ายดายขึ้นด้วยเครื่องมือสร้างสรรค์งานที่เร่งความเร็วด้วย AI<br><br>ครอบตัดภาพ เปลี่ยนพื้นหลัง และเพิ่มเอฟเฟ็กต์ได้อย่างรวดเร็ว ปรับปรุงวิดีโอได้ในไม่กี่คลิก แม้แต่ปรับแต่งสร้างงานศิลปะจากข้อความสั้นๆ",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3.png",
                    "tr_title": "เล่นเกมโปรดของคุณ แบบไร้กังวล",
                    "tr_subtitle": "ไร้ปัญหาด้านประสิทธิภาพหรือความเข้ากันได้ขณะเล่นเกม เล่นเกมระดับ AAA ยอดนิยมได้อย่างราบรื่น คุณจึงสามารถเล่นเกมและสตรีมได้อย่างมั่นใจ<br><br>นอกจากนี้ คุณยังจะได้สัมผัสกับประสบการณ์การเล่นเกมที่ราบรื่นยิ่งขึ้นในระหว่างเดินทางและระยะเวลาในการเล่นที่นานขึ้นแม้ไม่ได้เสียบปลั๊ก ด้วยกราฟิก Intel® Arc™ ในตัว<sup>57</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel5.png",
                    "tr_title": "อุ่นใจมากขึ้น ไ&#xfeff;ด้&#xfeff;ต&#xfeff;ล&#xfeff;อ&#xfeff;ด&#xfeff;เ&#xfeff;ว&#xfeff;ล&#xfeff;า",
                    "tr_subtitle": "มั่นใจได้เมื่อรู้ว่าคุณมีระบบการป้องกันในตัวที่ช่วยให้ข้อมูลของคุณปลอดภัยและเป็นส่วนตัวมากขึ้น<br><br>นอกจากนี้ แอปรักษาความปลอดภัยที่ใช้ AI ยังช่วยตรวจจับเสียงปลอมในวิดีโอได้ทันที และช่วยปกป้องข้อมูลที่ละเอียดอ่อนที่จัดเก็บไว้ในพีซีของคุณ",
                    "align": "left"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Intel® Evo™ AI PC",
                    "tr_subtitle": "สัมผัสความสุดยอดของโปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;Ultra"
                  },
                  {
                    "tr_title": "ออกแบบเพื่อประสบการณ์ใช้งาน AI สำหรับวันนี้และในอนาคต",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "มีให้เลือกหลายสี ขนาด และมีทั้งแบบหน้าจอสัมผัสหรือรูปลักษณ์การออกแบบ 2-in-1",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "เอนจิน AI แบบเฉพาะจะเร่งประสิทธิภาพของทุกสิ่งที่คุณทำ",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "พร้อมใช้งานทันทีด้วยฮาร์ดแวร์และซอฟต์แวร์ที่คุณรู้จัก",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "ทำงานได้เงียบและไม่ร้อนด้วยแบตเตอรี่ที่ใช้งานได้ตลอดทั้งวัน",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "การปกป้องในตัวทำให้ข้อมูลมีความปลอดภัย",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "ซิงค์กับโทรศัพท์หรือแท็บเล็ตใดก็ได้<sup>54</sup>",
                    "tr_subtitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE_LAPTOP",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "โปรเซสเซอร์",
                "tr_title": "ก้าวสู่ยุคใหม่ของการเล่นเกม",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 5",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_5_tile_badge_laptop.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 7",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_7_tile_badge_laptop.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "โปรเซสเซอร์ Intel® Core™ Ultra 9",
                    "tr_gen_core_title_uppercase": "โปรเซสเซอร์ INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_9_tile_badge_laptop.svg"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>คอร์</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores",
                    "tr_badgeSubTitle1": "[l_core] LPE-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>เธรด</span></span>",
                    "tr_badgePreTitle": "[p_thread] บน Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] บน Efficient-cores",
                    "tr_badgeSubTitle1": "[l_thread] บน LPE-cores"
                  }
                ],
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/processor/arl_panel1_laptop.png",
                    "tr_title": "ปลดล็อกประสิทธิภาพที่&#xfeff;ดี&#xfeff;เ&#xfeff;ยี่&#xfeff;ย&#xfeff;ม&#xfeff;สำ&#xfeff;ห&#xfeff;รั&#xfeff;บก&#xfeff;า&#xfeff;ร&#xfeff;เ&#xfeff;ล่&#xfeff;น&#xfeff;เ&#xfeff;ก&#xfeff;ม",
                    "tr_subtitle": "รับประสิทธิภาพระดับตำนานสำหรับการเล่นเกมด้วยคอร์ที่พัฒนาขึ้นใหม่ ที่มอบการเล่นเกมที่ลื่นไหลตอบสนองได้ดีเป็นพิเศษ <br/><br/>เพิ่มประสิทธิภาพให้เกมคลาสสิกได้ในคลิกเดียว เพื่อรับการอัปเดตอย่างต่อเนื่องสำหรับ Intel® Application Optimization<sup>48</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4.png",
                    "tr_title": "ใช้พลังงานได้อย่างเ&#xfeff;ต็&#xfeff;ม&#xfeff;ป&#xfeff;ร&#xfeff;ะ&#xfeff;สิ&#xfeff;ท&#xfeff;ธิ&#xfeff;ภ&#xfeff;า&#xfeff;พ",
                    "tr_subtitle": "ทำสิ่งต่างๆ ได้มากขึ้นโดยใช้พลังงานน้อยลง – รับประสิทธิภาพการเล่นเกมที่ดีขึ้น เล่นได้นานขึ้น โดยไม่ต้องเสียบปลั๊ก <br><br/>รับประสิทธิภาพสูงแบบ Ultra ด้วยโปรเซสเซอร์ Intel®&nbsp;Core™ Ultra ที่ปรับปรุงทั้งประสิทธิภาพและการใช้พลังงานอ&#xfeff;ย่&#xfeff;า&#xfeff;งคุ้&#xfeff;ม&#xfeff;ค่&#xfeff;าเพื่อให้แล็ปท็อปของคุณทำงานได้เย็นขึ้น เงียบขึ้นแ&#xfeff;ล&#xfeff;ะ&#xfeff;เ&#xfeff;ร็&#xfeff;ว&#xfeff;ขึ้&#xfeff;น",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel3.png",
                    "tr_title": "เตรียมพร้อมสำหรับอนาคตด้วย AI",
                    "tr_subtitle": "ทำงาน AI บนอุปกรณ์ได้เร็วขึ้นด้วย AI PC ที่ขับเคลื่อนด้วยโปรเซสเซอร์ <span class ='expandable_highlight'>Intel® Core™ Ultra</span> ตั้งแต่งานด้านการออฟโหลดเกมและการสตรีมไปจนถึงการสร้างสรรค์ภาพและเสียง ใช้ประโยชน์สูงสุดจากพีซี AI ของคุณ ตัวเร่ง AI สามตัวภายในโปรเซสเซอร์ช่วยดูแลข้อมูลของคุณให้เป็นส่วนตัวและเข้าถึงง่าย<sup>41</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4_laptop.png",
                    "tr_title": "มัลติเธรดดิ้งสำหรับเ&#xfeff;ม&#xfeff;ก้&#xfeff;า&#xfeff;ท&#xfeff;า&#xfeff;ส&#xfeff;กิ้&#xfeff;ง",
                    "tr_subtitle": "เข้าถึงประสิทธิภาพการทำงานในระดับที่ไม่เคยพบมาก่อนด้วยคอร์ที่ได้รับการอัปเกรดเป็นพิเศษเพื่อพาการสตรีม การเล่นเกม และการสร้างคอนเทนต์ของคุณสูงขึ้นไปอีกระดับ <br><br/>ประสิทธิภาพของมัลติเธรดดิ้งที่มากขึ้นทำให้คุณสามารถทำงานแบบมัลติทาสกิ้งหรือแม้แต่เมก้าทาสกิ้งได้โดยมีการสะดุดน้อยมาก",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel5_laptop.png",
                    "tr_title": "ปรับปรุงการเชื่อมต่อของคุณ",
                    "tr_subtitle": "ไม่ต้องหงุดหงิดกับการเชื่อมต่อที่ล่าช้าอีกต่อไป ด้วย Intel® Wi-Fi 7 และ Intel® Wi-Fi 6E ที่มีในตัว<sup>49</sup> <br><br/>หมดปัญหาเรื่องสายเคเบิลหลายเส้นด้วยเทคโนโลยี Thunderbolt™ รุ่นล่าสุด พอร์ตบนแล็ปท็อปที่เร็วที่สุด <sup>50</sup> สำหรับเชื่อมต่ออุปกรณ์ต่อพ่วงทั้งหมดของคุณ รวมถึงกล้อง จอมอนิเตอร์ และไดรฟ์จัดเก็บข้อมูล<sup>51</sup>​",
                    "align": "left"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "ให้คุณทำงานได้เร็วขึ้น ทรงพลังขึ้น",
                  "tr_pretitle": "Intel® Core™ Ultra [XX] ซีรีส์&nbsp;3",
                  "tr_subtitle": "นี่แหละพลังของ Intel Inside®",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel1.png",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_series3.svg",
                  "badgeUrl1": "assets/images/badges/copilot_plus_ptl.svg"
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "ไม่ใช่แค่พีซีเครื่องหนึ่ง<br/>แต่นี่คือพีซีของคุณ",
                  "tr_subtitle": "โลกของคุณอยู่บนแล็ปท็อปของคุณ นี่จึงเป็นเหตุผลที่แล็ปท็อปที่ขับเคลื่อนด้วย<span class='processor_bold'>โปรเซสเซอร์ Intel® Core™ Ultra ซี&#xfeff;รี&#xfeff;ส์ 3</span> มีทุกอย่างที่คุณต้องการสำหรับทุกกิจกรรมของคุณ:",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel2.png",
                  "titleArray": [
                    {
                      "tr_title": "ทำงาน เล่น และจบทุกการ<br>สร้างสรรค์ด้วยการชาร์จ<br>เพียงครั้งเดียว"
                    },
                    {
                      "tr_title": "ประสิทธิภาพที่ทรงพลังและพกพาได้ง่ายดุจเงาตามตัว"
                    },
                    {
                      "tr_title": "เล่นเกมและใช้แอปโปรดได้อย่างราบรื่น"
                    }
                  ],
                  "badgeIcons": [
                    {
                      "tr_badgeTitle": "ทำงาน เล่น และจบทุกการ<br>สร้างสรรค์ด้วยการชาร์จ<br>เพียงครั้งเดียว",
                      "imgUrl": "assets/images/proc_ptl_battery.svg"
                    },
                    {
                      "tr_badgeTitle": "ประสิทธิภาพที่สร้างขึ้นเพื่อตอบสนองความต้องการของคุณ",
                      "imgUrl": "assets/images/proc_ptl_performance.svg"
                    },
                    {
                      "tr_badgeTitle": "เล่นเกมได้ภาพค&#xfeff;ม&#xfeff;ชั&#xfeff;ด มี&#xfeff;ประสิทธิภาพสู&#xfeff;ง&#xfeff;เ&#xfeff;ยี่&#xfeff;ย&#xfeff;ม",
                      "imgUrl": "assets/images/proc_ptl_gaming.svg"
                    },
                    {
                      "tr_badgeTitle": "AI ที่สร้างมา<br/>เพื่อช่วยคุณ",
                      "imgUrl": "assets/images/proc_ptl_aiExperience.svg"
                    },
                    {
                      "tr_badgeTitle": "กราฟิกที่ปลุกทุกจินตนาการให้มีชีวิต",
                      "imgUrl": "assets/images/proc_ptl_graphics.svg"
                    },
                    {
                      "tr_badgeTitle": "รันแอปและเกมที่เครื่องอื่นๆ ทำ&#xfeff;ไ&#xfeff;ม่&#xfeff;ไ&#xfeff;ด้",
                      "imgUrl": "assets/images/proc_ptl_compatibility.svg"
                    },
                    {
                      "tr_badgeTitle": "งานออกแบบที่สะท้อนสไตล์ของคุณ",
                      "imgUrl": "assets/images/proc_ptl_design.svg"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "ประสบการณ์แล็ปท็อป<br/>โดยรวมที่ดีที่สุด<sup>1</sup>",
                  "tr_subtitle": "แล็ปท็อป Intel® Evo™ Edition ทุกเครื่องที่บางและเบา ได้ผ่านการตรวจสอบเพื่อมอบประสบการณ์ระดับพรีเมียมที่พร้อมใช้งานเสมอ เร็วเสมอ และสร้างมาเพื่อตอบทุกโจทย์ที่คุณต้องการ",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel3.svg",
                  "badgeUrl": "assets/images/badges/evo_ultra_ptl.svg",
                  "titleArray": [
                    {
                      "tr_title": "ประสิทธิภาพที่พร้อมไปกับคุณทุกที่"
                    },
                    {
                      "tr_title": "ระยะเวลาการใช้งานแบตเตอรี่ที่ตอบโจทย์ในชีวิตจริง"
                    },
                    {
                      "tr_title": "การชาร์จไฟที่รวดเร็ว"
                    },
                    {
                      "tr_title": "ปลุกการทำงานได้ทันที"
                    },
                    {
                      "tr_title": "และอื่นๆ อีกมากมาย"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel4.svg",
                  "tr_subtitle": "ผลลัพธ์ของแต่ละระบบอาจแตกต่างกันอย่างมากขึ้นอยู่กับการกำหนดค่า การใช้งาน และปัจจัยอื่น ๆ เรียนรู้เพิ่มเติมที่ www.Intel.com/PerformanceIndex<br/><br/>คุณสมบัติ AI อาจต้องมีการซื้อซอฟต์แวร์ สมัครใช้งาน หรือเปิดใช้งานโดยผู้ให้บริการซอฟต์แวร์หรือแพลตฟอร์ม หรืออาจมีการกำหนดค่าแบบเฉพาะหรือข้อกำหนดเกี่ยวกับการทำงานที่เข้ากันได้ ข้อได้เปรียบด้านความหน่วงของข้อมูล ต้นทุน และความเป็นส่วนตัว อ้างอิงถึงแอป AI ที่ไม่ได้อยู่บนคลาวด์ เรียนรู้เพิ่มเติมที่ intel.com/AIPC<br/><br/>ไม่มีผลิตภัณฑ์หรือส่วนประกอบใดที่จะปลอดภัยอย่างสมบูรณ์แบบ<br/><br/>ค่าใช้จ่ายและผลลัพธ์ของคุณอาจแตกต่างกันไป<br/><br/>เทคโนโลยี Intel อาจต้องใช้ฮาร์ดแวร์ที่รองรับ ซอฟต์แวร์ที่เฉพาะเจาะจง หรือการเปิดใช้บริการ<br/><br/>© Intel Corporation Intel, โลโก้ Intel และเครื่องหมาย Intel อื่นๆ เป็นเครื่องหมายการค้าของ Intel Corporation หรือบริษัทสาขา ชื่อและตราสินค้าอื่นอาจถูกอ้างกรรมสิทธิ์โดยบุคคลอื่น"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL_12XE",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_pretitle": "<span class='processor_bold'>โปรเซสเซอร์ Intel® Core™ Ultra [XX] </span>ที่มีกราฟิก Intel® <span class='processor_bold'>Arc™ ในตัว</span>",
                  "tr_title": "ไอเดียที่ยิ่งใหญ่ ไม่จำเป็นต้องใช้พีซีเครื่องใหญ่",
                  "tr_subtitle": "",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel1.png",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                  "badgeUrl1": "assets/images/arc-badge.svg",
                  "titleArray": [
                    {
                      "tr_title": "กราฟิกระดับสตูดิโอ ในดีไซน์บางเฉียบสุดพรีเมียม"
                    },
                    {
                      "tr_title": "เร็ว เงียบ พร้อมทำงานทันทีเมื่อมีไอเดีย"
                    },
                    {
                      "tr_title": "ระยะเวลาการใช้งานแบตเตอรี่ที่ทรงพลังไม่แพ้ความคิดสร้างสรรค์ของคุณ"
                    }
                  ],
                  "tr_subtitle2": "ผลลัพธ์ของแต่ละระบบอาจแตกต่างกันอย่างมากขึ้นอยู่กับการกำหนดค่า การใช้งาน และปัจจัยอื่นๆ เรียนรู้เพิ่มเติมที่ www.Intel.com/PerformanceIndex © Intel Corporation"
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "ไม่ใช่แค่พีซีเครื่องหนึ่ง<br/>แต่นี่คือพีซีของคุณ",
                  "tr_subtitle": "โลกของคุณอยู่บนแล็ปท็อปของคุณ นี่จึงเป็นเหตุผลที่แล็ปท็อปที่ขับเคลื่อนด้วย<span class='processor_bold'>โปรเซสเซอร์ Intel® Core™ Ultra ซี&#xfeff;รี&#xfeff;ส์ 3</span> มีทุกอย่างที่คุณต้องการสำหรับทุกกิจกรรมของคุณ:",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel2.png",
                  "titleArray": [
                    {
                      "tr_title": "ทำงาน เล่น และจบทุกการ<br>สร้างสรรค์ด้วยการชาร์จ<br>เพียงครั้งเดียว"
                    },
                    {
                      "tr_title": "ประสิทธิภาพที่ทรงพลังและพกพาได้ง่ายดุจเงาตามตัว"
                    },
                    {
                      "tr_title": "เล่นเกมและใช้แอปโปรดได้อย่างราบรื่น"
                    }
                  ],
                  "badgeIcons": [
                    {
                      "tr_badgeTitle": "ทำงาน เล่น และจบทุกการ<br>สร้างสรรค์ด้วยการชาร์จ<br>เพียงครั้งเดียว",
                      "imgUrl": "assets/images/proc_ptl_battery.svg"
                    },
                    {
                      "tr_badgeTitle": "ในที่สุด แบตเตอรี่ก็<br/>ไม่อาจหยุดยั้งพลังแห่งความคิดสร้างสรรค์ของคุณแล้ว",
                      "imgUrl": "assets/images/proc_ptl_performance.svg"
                    },
                    {
                      "tr_badgeTitle": "กลางวันสร้างสรรค์<br/>กลางคืนเล่นเกม",
                      "imgUrl": "assets/images/proc_ptl_gaming.svg"
                    },
                    {
                      "tr_badgeTitle": "AI ที่สร้างมา<br/>เพื่อช่วยคุณ",
                      "imgUrl": "assets/images/proc_ptl_aiExperience.svg"
                    },
                    {
                      "tr_badgeTitle": "กราฟิกที่ถ่ายทอดจินตนาการของคุณออกมาอย่างสมจริง",
                      "imgUrl": "assets/images/proc_ptl_graphics.svg"
                    },
                    {
                      "tr_badgeTitle": "รันแอปและเกมที่เครื่องอื่นๆ ทำ&#xfeff;ไ&#xfeff;ม่&#xfeff;ไ&#xfeff;ด้",
                      "imgUrl": "assets/images/proc_ptl_compatibility.svg"
                    },
                    {
                      "tr_badgeTitle": "งานออกแบบที่สะท้อนสไตล์ของคุณ",
                      "imgUrl": "assets/images/proc_ptl_design.svg"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel4.svg",
                  "tr_subtitle": "ผลลัพธ์ของแต่ละระบบอาจแตกต่างกันอย่างมากขึ้นอยู่กับการกำหนดค่า การใช้งาน และปัจจัยอื่นๆ เรียนรู้เพิ่มเติมที่ www.Intel.com/PerformanceIndex<br/><br/> คุณสมบัติ AI อาจต้องมีการซื้อซอฟต์แวร์ สมัครใช้งาน หรือเปิดใช้งานโดยผู้ให้บริการซอฟต์แวร์หรือแพลตฟอร์ม หรืออาจมีการกำหนดค่าแบบเฉพาะหรือข้อกำหนดเกี่ยวกับการทำงานที่เข้ากันได้ ข้อได้เปรียบด้านความหน่วงของข้อมูล ต้นทุน และความเป็นส่วนตัว อ้างอิงถึงแอป AI ที่ไม่ได้อยู่บนคลาวด์ เรียนรู้เพิ่มเติมที่ intel.com/AIPC<br/><br/> ไม่มีผลิตภัณฑ์หรือส่วนประกอบใดที่จะปลอดภัยอย่างสมบูรณ์แบบ<br/><br/> ค่าใช้จ่ายและผลลัพธ์ของคุณอาจแตกต่างกันไป<br/><br/> เทคโนโลยี Intel อาจต้องใช้ฮาร์ดแวร์ที่รองรับ ซอฟต์แวร์ที่เฉพาะเจาะจง หรือการเปิดใช้บริการ<br/><br/> © Intel Corporation Intel, โลโก้ Intel และเครื่องหมาย Intel อื่นๆ เป็นเครื่องหมายการค้าของ Intel Corporation หรือบริษัทสาขา ชื่อและตราสินค้าอื่นอาจถูกอ้างกรรมสิทธิ์โดยบุคคลอื่น"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "graphics": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_tileTitle1": "กร&#xfeff;า&#xfeff;ฟิ&#xfeff;กแ&#xfeff;บ&#xfeff;บ&#xfeff;แ&#xfeff;ยก",
                "tr_title": "หน่วยประมวลผลกราฟิกคืออะไร",
                "tr_pretitle": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "หน่วยประมวลผลกราฟิกหรือ GPU สร้างภาพที่คุณเห็นบนหน้าจอ",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/graphic-integrated-GPU-badge.png",
                    "tr_badgeTitle": "GPU ในตัว",
                    "tr_badgeSubTitle": "GPU แบบรวมใช้ RAM เหมือนกับส่วนอื่นๆ ของคอมพิวเตอร์ จึงทำให้ประหยัดพลังงานได้มากขึ้น",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics-discrete-GPU-badge.svg",
                    "tr_badgeTitle": "การ์ดจอแยก",
                    "tr_badgeSubTitle": "GPU ประเภทนี้ทรงพลังมากที่สุด เพราะมี RAM ของตัวเอง และทรัพยากรอื่นๆ ที่ใช้สำหรับการสร้างกราฟิกที่โดดเด่นโดยเฉพาะ",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphic-hybrid-GPU-badge.png",
                    "tr_badgeTitle": "GPU ไฮบริด",
                    "tr_badgeSubTitle": "GPU ประเภทนี้ทรงพลังมากที่สุด เพราะมี RAM ของตัวเอง และทรัพยากรอื่นๆ ที่ใช้สำหรับการสร้างกราฟิกที่โดดเด่นโดยเฉพาะ",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/video-editing.png",
                    "tr_badgeTitle": "การตัดต่อภาพถ่ายและวิดีโอที่ไหลลื่น",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/binge-4k.svg",
                    "tr_badgeTitle": "รับชมวิดีโอ 4K",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/games.svg",
                    "tr_badgeTitle": "เล่นเกมยอดฮิตด้วยรายละเอียดอันน่าทึ่ง",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics_dual_gpus.svg",
                    "tr_badgeTitle": "การ์ดจอคู่",
                    "tr_badgeSubTitle": "สำหรับบางระบบ ที่มีการใช้กราฟิก Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> สามารถใช้ประโยชน์ได้จากทั้งการ์ดจอบนโปรเซสเซอร์และการ์ดจอแยก เพื่อกระจายเวิร์คโหลดด้านกราฟิก",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphic-integrated-GPU-badge.png",
                    "tr_badgeTitle": "GPU ในตัว",
                    "tr_badgeSubTitle": "GPU แบบในตัวรวมอยู่ในชิปเดียวกันกับโปรเซสเซอร์หลักหรือ CPU GPU ชนิดนี้ใช้ RAM และทรัพยากรอื่นๆ เหมือนกับชิ้นส่วนอื่นของคอมพิวเตอร์ จึงประหยัดพลังงานมากกว่า และรองรับอุปกรณ์ที่บางและเบากว่า",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics-discrete-GPU-badge.svg",
                    "tr_badgeTitle": "GPU เฉพาะ",
                    "tr_badgeSubTitle": "GPU ประเภทนี้ทรงพลังมากที่สุด เพราะมี RAM ของตัวเอง และทรัพยากรอื่นๆ ที่ใช้สำหรับการสร้างกราฟิกที่โดดเด่นโดยเฉพาะ",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "",
                "tr_pretitle": "",
                "tr_subtitle": "",
                "panelType1": "",
                "panelType2": "gaming-graphics",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "มาตรฐาน",
                    "tr_badgeSubTitle": "VRAM สูงสุด 4&nbsp;GB",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "ที่เข้าแข่งขัน",
                    "tr_badgeSubTitle": "VRAM สูงสุด 8&nbsp;GB",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "พิเศษ",
                    "tr_badgeSubTitle": "VRAM มากกว่า 8&nbsp;GB",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "พลังด้านกราฟิกขั้นสูง",
                "tr_pretitle": "[graphic_display]",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "การประมวลผลกราฟิกที่ทรงพลังที่สุดต้องอาศัยการ์ดกราฟิกที่เน้นการสร้างสรรค์ภาพที่สวยงาม คมชัดและภาพเคลื่อนไหวที่ลื่นไหลเป็นพิเศษ",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_PLUS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "กราฟิกที่สวยงามและมีชีวิตชีวาในตัว",
                "tr_pretitle": "กราฟิก Intel® Iris® Plus",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "กราฟิก Intel® Iris® Plus ให้คุณดื่มด่ำไปกับวิดีโอ 4K HDR และการเล่นเกมแบบ Full HD โดยไม่ต้องใช้การ์ดกราฟิกเพิ่ม",
                "badgeUrl": "assets/images/badges/intel-IRIS-plus.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_GRAPHICS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "ภาพอันน่าทึ่ง ประสิทธิภาพที่ได้มาง่&#xfeff;า&#xfeff;ย&nbsp;ๆ",
                "tr_pretitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "กราฟิก Intel® ให้ประสิทธิภาพกราฟิกแบบรวมที่พลิกโฉมวงการเพื่อการรองรับการออกแบบสุดลื่นไหลสำหรับนักสร้างสรรค์และประสบการณ์การเล่นเกมที่สมบูรณ์แบบ",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_PRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "กราฟิก Intel® Iris® Pro",
                "tr_pretitle": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "UHD_FEATURING_IRIS_XE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "กราฟิก UHD Intel® มาพร้อมสถาปัตยกรรม X<sup class='small_text_sup_xe'>e</sup>",
                "tr_pretitle": "ประสบการณ์ภาพที่สมจริง",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "",
                "tr_text1": "สัมผัสการตัดต่อภาพถ่ายและวิดีโอที่ไหลลื่น รับชมวิดีโอ 4K หรือเล่นเกมยอดฮิตด้วยรายละเอียดอันน่าทึ่ง",
                "tr_photo_text": "การตัดต่อภาพถ่ายและวิดีโอที่ไหลลื่น",
                "tr_video_text": "รับชมวิดีโอ 4K",
                "tr_game_text": "เล่นเกมยอดฮิตด้วยรายละเอียดอันน่าทึ่ง",
                "badgeUrl": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "มากกว่าภาพสวยๆ",
                "tr_subtitle": "ด้วยการทำงานร่วมกันอย่างใกล้ชิดกับโปรเซสเซอร์ (หรือ CPU) การ์ดกราฟิก (หรือ GPU) จะเป็นตัวกำหนดว่าเกมของคุณจะทำงานและแสดงผลอย่างไร VRAM หรือ Video RAM ซึ่งใช้กับการแสดงผลกราฟิกโดยเฉพาะ เป็นวิธีที่รวดเร็วในการระบุว่า GPU ของคุณอยู่ในระดับใด",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[XX] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_UHD_630",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "สำหรับกราฟิกเกมขั้นสูง",
                "tr_subtitle": "การประมวลผลกราฟิกที่ทรงพลังมากที่สุดต้องอาศัยการ์ดกราฟิกแบบแยกที่มุ่งเน้นเฉพาะการสร้างสรรค์ภาพที่สวยงาม คมชัด และภาพเคลื่อนไหวที่ลื่นไหล",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[XX] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "Intel_UHD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "สำหรับกราฟิกเกมขั้นสูง",
                "tr_subtitle": "การประมวลผลกราฟิกที่ทรงพลังมากที่สุดต้องอาศัยการ์ดกราฟิกแบบแยกที่มุ่งเน้นเฉพาะการสร้างสรรค์ภาพที่สวยงาม คมชัด และภาพเคลื่อนไหวที่ลื่นไหล",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[XX] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "มากกว่าภาพสวยๆ",
                "tr_subtitle": "ด้วยการทำงานร่วมกันอย่างใกล้ชิดกับโปรเซสเซอร์ (หรือ CPU) การ์ดกราฟิก (หรือ GPU) จะเป็นตัวกำหนดว่าเกมของคุณจะทำงานและแสดงผลอย่างไร VRAM หรือ Video RAM ซึ่งใช้กับการแสดงผลกราฟิกโดยเฉพาะ เป็นวิธีที่รวดเร็วในการระบุว่า GPU ของคุณอยู่ในระดับใด",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[XX] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHERS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "พลังด้านกราฟิกขั้นสูง",
                "tr_pretitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "การประมวลผลกราฟิกที่ทรงพลังที่สุดต้องอาศัยการ์ดกราฟิกที่เน้นการสร้างสรรค์ภาพที่สวยงาม คมชัดและภาพเคลื่อนไหวที่ลื่นไหลเป็นพิเศษ",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "[graphic_display]",
                "tr_pretitle": "สำหรับกราฟิกเกมขั้นสูง",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_subtitle": "การประมวลผลกราฟิกที่ทรงพลังที่สุดต้องอาศัยการ์ดกราฟิกที่เน้นการสร้างสรรค์ภาพที่สวยงาม คมชัดและภาพเคลื่อนไหวที่ลื่นไหลเป็นพิเศษ",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[XX] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ],
                "titleArray": [
                  {
                    "detailPageName": "LESS_THAN_0",
                    "tr_subtitle": "การประมวลผลกราฟิกที่ทรงพลังมากที่สุดต้องอาศัยการ์ดกราฟิกแบบแยกที่มุ่งเน้นเฉพาะการสร้างสรรค์ภาพที่สวยงาม คมชัด และภาพเคลื่อนไหวที่ลื่นไหล",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "0_TO_4",
                    "tr_subtitle": "มอบพลังกราฟิกที่มากมาย ตอบสนองความต้องการขั้นต่ำของเกม",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "4_TO_8",
                    "tr_subtitle": "สำหรับผู้เล่นระดับสูงกว่า ซึ่งต้องการเล่นเกมระดับการแข่งขัน",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "GREATER_THAN_8",
                    "tr_subtitle": "สำหรับนักเล่นเกมขั้นสูง ซึ่งใช้พีซีสำหรับการสร้างเนื้อหาอย่างหนักหน่วง",
                    "tr_title": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_HD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "วิดีโอที่มีชีวิตชีวาและก&#65279;า&#65279;ร&#65279;เ&#65279;ล่&#65279;น&#65279;เ&#65279;&#65279;ก&#65279;มที่สุดดื่มด่ำ",
                "tr_pretitle": "[graphic_display]",
                "tr_subtitle": "ใช้ประโยชน์สูงสุดจากหน้าจอความละเอียดสูงของคุณ ด้วยกราฟิก HD Intel® และเพลิดเพลินกับประสบการณ์มัลติมีเดียที่เต็มอิ่ม และการประมวลผลกราฟิกแบบในตัว",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_UHD_620",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "พลังขับเคลื่อนเพื่อวิดีโอและภาพสีสันสดใส",
                "tr_pretitle": "[graphic_display]",
                "tr_subtitle": "รายละเอียดสีที่ได้รับมีความสดใสและคมชัดมากขึ้นจากวิดีโอที่คุณสตรีมและภาพถ่าย",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_XE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "การสร้างและการเล่นเกมชั้&#65279;น&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tr_pretitle": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "กราฟิก Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> นำประสิทธิภาพกราฟิกระดับพลิกโฉมวงการมาสู่พีซีแบบบางและเบา ไม่ว่าจะเป็นความบันเทิงแบบสมจริง การสร้างคอนเทนต์ขั้นสูง ไปจนถึงการเล่นเกมเมนสตรีม",
                "badgeUrl": "assets/images/badges/intel-iris-xe.svg"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_pretitle": "สำหรับกราฟิกเกมขั้นสูง",
                "tr_title": "กราฟิก Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/intel-iris-xe.svg",
                "tr_subtitle": "การประมวลผลกราฟิกที่ทรงพลังมากที่สุดต้องอาศัยการ์ดกราฟิกแบบแยกที่มุ่งเน้นเฉพาะการสร้างสรรค์ภาพที่สวยงาม คมชัด และภาพเคลื่อนไหวที่ลื่นไหล",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[x] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_XE_MAX",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "ปลดปล่อยพลังค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;คิ&#xfeff;ด&#xfeff;ส&#xfeff;ร้&#xfeff;า&#xfeff;ง&#xfeff;ส&#xfeff;ร&#xfeff;ร&#xfeff;ค์ของคุณ",
                "tr_pretitle": "กราฟิก Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> MAX",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "ให้งานสร้างสรรค์พรั่งพรูและดื่มด่ำไปกับการเล่นเกมหลากหลายรูปแบบ ด้วยการผนึกกำลังระหว่างการ์ดจอบนโปรเซสเซอร์และเทคโนโลยีของการ์ดจอแบบแยกจาก Intel®",
                "badgeUrl": "assets/images/badges/intel-iris-xe-max.svg"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "tr_title": "กราฟิก Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> MAX",
                "tr_pretitle": "สำหรับกราฟิกเกมขั้นสูง",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/intel-iris-xe-max.svg",
                "tr_subtitle": "การประมวลผลกราฟิกที่ทรงพลังมากที่สุดต้องอาศัยการ์ดกราฟิกแบบแยกที่มุ่งเน้นเฉพาะการสร้างสรรค์ภาพที่สวยงาม คมชัด และภาพเคลื่อนไหวที่ลื่นไหล",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[x] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_tileTitle": "กราฟิก",
                "tr_title": "การแสดงผลแบบในตัวที่สวยงาม",
                "tr_subtitle": "เพลิดเพลินกับเกม ภาพยนตร์ และวิดีโอบนเว็บ<BR/>ด้วยรายละเอียดและความชัดเจนที่ยอดเยี่ยม",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "ARC_GRAPHICS",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "กราฟิก",
                "badgeUrl": "assets/images/arc-badge.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/arc_graphics/fallback_arc_graphics.svg",
                "tr_subtitle": "",
                "panelType1": "header-BadgeIconTop-arc",
                "panelType2": "",
                "tr_title": ""
              }
            }
          ],
          "factTagTypes": [
            {
              "factTagType": "Arc_Graphics_Panel_Content",
              "navText": [
                {
                  "specName": "Arc_Graphics_Badge_Icon",
                  "specDetails": {
                    "targetURL": "badgeIconUrl",
                    "tr_specTitle": "",
                    "tr_specText": ""
                  }
                },
                {
                  "specName": "Graphics_Boost_Workflow",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "กราฟิก",
                    "tr_specText": "เพิ่มประสิทธิภาพเวิร์กโฟลว์ของคุณ"
                  }
                },
                {
                  "specName": "Graphics_Supercharge_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "กราฟิก",
                    "tr_specText": "เสริมพลังการเล่นเกมของคุณ"
                  }
                },
                {
                  "specName": "Graphics_Supercharge_Gaming_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "กราฟิก",
                    "tr_specText": "เสริมพลังการเล่นเกมของคุณ"
                  }
                },
                {
                  "specName": "Graphics_Level_Up_Your_Game",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "กราฟิก",
                    "tr_specText": "ยกระดับเกมข&#xfeff;อ&#xfeff;ง&#xfeff;คุ&#xfeff;ณ"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel2.png",
                    "tr_specTitle": "ปลดปล่อยพลังค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;คิ&#xfeff;ด&#xfeff;ส&#xfeff;ร้&#xfeff;า&#xfeff;ง&#xfeff;ส&#xfeff;ร&#xfeff;ร&#xfeff;ค์ของคุณ",
                    "tr_specText": "เร่งประสิทธิภาพการทำงานของคุณได้ทุกที่ด้วยความสามารถของสื่อที่ครอบคลุมที่สุด เช่น <strong>การเข้ารหัสฮาร์ดแวร์ AV1 ครั้งแรกของอุตสาหกรรม</strong> และการสร้างเนื้อหาที่เร่งด้วย AI<sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A380_panel2.png",
                    "tr_specTitle": "ปลดปล่อยพลังค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;คิ&#xfeff;ด&#xfeff;ส&#xfeff;ร้&#xfeff;า&#xfeff;ง&#xfeff;ส&#xfeff;ร&#xfeff;ร&#xfeff;ค์ของคุณ",
                    "tr_specText": "เร่งประสิทธิภาพการทำงานของคุณด้วยความสามารถของสื่อที่ครอบคลุมที่สุด เช่น <strong>การเข้ารหัสฮาร์ดแวร์ AV1 ครั้งแรกของอุตสาหกรรม</strong> และการสร้างเนื้อหาที่เร่งด้วย AI<sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A730M_panel3.png",
                    "tr_specTitle": "ปลดปล่อยพลังค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;คิ&#xfeff;ด&#xfeff;ส&#xfeff;ร้&#xfeff;า&#xfeff;ง&#xfeff;ส&#xfeff;ร&#xfeff;ร&#xfeff;ค์ของคุณ",
                    "tr_specText": "สัมผัสกับการสร้างเนื้อหาที่เร่งความเร็วด้วย <strong>AI ที่ล้ำสมัยด้วยการเข้ารหัสฮาร์ดแวร์ AV1 ครั้งแรกของอุตสาหกรรม</strong> และ<strong>เอ็นจิ้นมีเดีย X<sup>e</sup> ขั้นสูง</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel3.png",
                    "tr_specTitle": "ปลดปล่อยพลังค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;คิ&#xfeff;ด&#xfeff;ส&#xfeff;ร้&#xfeff;า&#xfeff;ง&#xfeff;ส&#xfeff;ร&#xfeff;ร&#xfeff;ค์ของคุณ",
                    "tr_specText": "สัมผัสกับการสร้างเนื้อหาที่เร่งความเร็วด้วย <strong>AI ที่ล้ำสมัยด้วยการเข้ารหัสฮาร์ดแวร์ AV1 ครั้งแรกของอุตสาหกรรม</strong> และ<strong>เอ็นจิ้นมีเดีย X<sup>e</sup> ขั้นสูง</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine_12",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel3.png",
                    "tr_specTitle": "ปลดปล่อยพลังค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;คิ&#xfeff;ด&#xfeff;ส&#xfeff;ร้&#xfeff;า&#xfeff;ง&#xfeff;ส&#xfeff;ร&#xfeff;ร&#xfeff;ค์ของคุณ",
                    "tr_specText": "สัมผัสกับการสร้างเนื้อหาที่เร่งความเร็วด้วย <strong>AI ที่ล้ำสมัยด้วยการเข้ารหัสฮาร์ดแวร์ AV1 ครั้งแรกของอุตสาหกรรม</strong> และ<strong>เอ็นจิ้นมีเดีย X<sup>e</sup> ขั้นสูง</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Portability_Meets_Performance",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel3.png",
                    "tr_specTitle": "ค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;ส&#xfeff;ะ&#xfeff;ด&#xfeff;ว&#xfeff;ก<br>ในการพ&#xfeff;ก&#xfeff;พ&#xfeff;าผสานกับ<br>ป&#xfeff;ร&#xfeff;ะ&#xfeff;สิ&#xfeff;ท&#xfeff;ธิ&#xfeff;ภ&#xfeff;า&#xfeff;พ",
                    "tr_specText": "เล่นเกมใหม่ล่าสุดได้ในทุกๆ ที่ สัมผัสกับประสิทธิภาพและพลังที่เต็มเปี่ยมตอบโจทย์การเล่มเกมยุคใหม่ <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>เทคโนโลยีการอั&#xfeff;ป&#xfeff;ส&#xfeff;เ&#xfeff;ก&#xfeff;ลที่ปรับปรุงโดย Intel® AI เพื่อประสิทธิภาพที่มากขึ้นและการเล่นเกมที่ลื่นไหล <br/><br/>การสนับสนุน <strong>DirectX* 12 Ultimate:  </strong>นำคุณสู่อีกระดับของการเล่นเกมที่สมจริงด้วยเทคโนโลยีกราฟิก เช่น Ray Tracing และ Variable Rate Shading"
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel4.png",
                    "tr_specTitle": "ควบคุมเกมได้อย่างใจต้องการ",
                    "tr_specText": "<strong>ศูนย์ควบคุม Intel® Arc™</strong> ช่วยให้คุณปรับแต่งประสบการณ์ของคุณด้วยเลย์เอาท์ที่ใช้งานง่ายและทันสมัย รับการอัปเดตไดรเวอร์ที่ไร้รอยต่อ เพิ่มประสิทธิภาพให้เกมของคุณ และอื่นๆ"
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A310_panel4.png",
                    "tr_specTitle": "ควบคุมเกมได้อย่างใจต้องการ",
                    "tr_specText": "<strong>ศูนย์ควบคุม Intel® Arc™</strong> ช่วยให้คุณปรับแต่งประสบการณ์ของคุณด้วยเลย์เอาท์ที่ใช้งานง่ายและทันสมัย รับการอัปเดตไดรเวอร์ที่ไร้รอยต่อ เพิ่มประสิทธิภาพให้เกมของคุณ และอื่นๆ"
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games_1",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A730M_panel4.png",
                    "tr_specTitle": "ควบคุมเกมได้อย่างใจต้องการ",
                    "tr_specText": "รับการอัปเดตไดรเวอร์แบบไร้รอยต่อ และปรับเน้นประสิทธิภาพเกมโปรดมากมายของคุณด้วยซอฟต์แวร์<strong>ศูนย์ควบคุม Intel® Arc™</strong>"
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_Desktop2",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A310_newPanel5.png",
                    "tr_specTitle": "ใช้ประโยชน์จากแพลตฟอร์ม INTEL® ของคุณ",
                    "tr_specText": "จับคู่กับโปรเซสเซอร์ Intel® Core™ ที่เข้ากันได้เพื่อปลดปล่อย<strong>เทคโนโลยี Intel® Deep Link</strong> เพื่อยกระดับประสบการณ์การสร้างสรรค์ การเล่นเกม และการสตรีมของคุณ"
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_A580",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_newPanel5.png",
                    "tr_specTitle": "เสริมสร้างระบบ INTEL® ของคุณ",
                    "tr_specText": "จับคู่กับโปรเซสเซอร์ Intel® Core™ ที่เข้ากันได้เพื่อปลดปล่อย<strong>เทคโนโลยี Intel® Deep Link</strong> เพื่อยกระดับประสบการณ์การสร้างสรรค์ การเล่นเกม และการสตรีมของคุณ"
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel5.png",
                    "tr_specTitle": "ใช้ประโยชน์จากแพลตฟอร์ม INTEL® ของคุณ",
                    "tr_specText": "จับคู่กับโปรเซสเซอร์ Intel® Core™ ที่เข้ากันได้เพื่อปลดปล่อย<strong>เทคโนโลยี Intel® Deep Link</strong> เพื่อยกระดับประสบการณ์การสร้างสรรค์ การเล่นเกม และการสตรีมของคุณ"
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_newPanel5.png",
                    "tr_specTitle": "ใช้ประโยชน์จากแพลตฟอร์ม INTEL® ของคุณ",
                    "tr_specText": "จับคู่กับโปรเซสเซอร์ Intel® Core™ ที่เข้ากันได้เพื่อปลดปล่อย<strong>เทคโนโลยี Intel® Deep Link</strong> เพื่อยกระดับประสบการณ์การสร้างสรรค์ การเล่นเกม และการสตรีมของคุณ"
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_System",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_newPanel5.png",
                    "tr_specTitle": "เสริมสร้างระบบ INTEL® ของคุณ",
                    "tr_specText": "จับคู่กับโปรเซสเซอร์ Intel® Core™ ที่เข้ากันได้เพื่อปลดปล่อย<strong>เทคโนโลยี Intel® Deep Link</strong> เพื่อยกระดับประสบการณ์การสร้างสรรค์ การเล่นเกม และการสตรีมของคุณ"
                  }
                },
                {
                  "specName": "Take_Center_Stage",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_panel4.png",
                    "tr_specTitle": "รับบทบาทสำคัญ",
                    "tr_specText": "ออกอากาศได้อย่างราบรื่นด้วยเทคโนโลยีการสตรีมที่ได้จากซอฟต์แวร์<strong>ศูนย์ควบคุม Intel® Arc™</strong>"
                  }
                },
                {
                  "specName": "Take_Center_Stage_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel4.png",
                    "tr_specTitle": "รับบทบาทสำคัญ",
                    "tr_specText": "ออกอากาศได้อย่างราบรื่นด้วยเทคโนโลยีการสตรีมที่ได้จากซอฟต์แวร์<strong>ศูนย์ควบคุม Intel® Arc™</strong>"
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A750_panel2.png",
                    "tr_specTitle": "สัมผัสการเล่นเกมประสิทธิภาพสูงที่สมจริง",
                    "tr_specText": "ประสิทธิภาพที่ดีที่สุดต้องมาก่อนด้วยเกม AAA ระดับล่าสุดที่ความละเอียดสูงและอัตราการรี&#xfeff;เ&#xfeff;ฟ&#xfeff;ร&#xfeff;ช&#xfeff;สู&#xfeff;ง <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>เทคโนโลยีการอั&#xfeff;ป&#xfeff;ส&#xfeff;เ&#xfeff;ก&#xfeff;ลที่ปรับปรุงโดย Intel® AI เพื่อประสิทธิภาพที่มากขึ้นและการเล่นเกมที่ลื่นไหล <br/><br/>การสนับสนุน <strong>DirectX* 12 Ultimate:  </strong>นำคุณสู่อีกระดับของการเล่นเกมที่สมจริงด้วยเทคโนโลยีกราฟิก เช่น Ray Tracing และ Variable Rate Shading"
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel2.png",
                    "tr_specTitle": "สัมผัสการเล่นเกมประสิทธิภาพสูงที่สมจริง",
                    "tr_specText": "ประสิทธิภาพที่ดีที่สุดต้องมาก่อนด้วยเกม AAA ระดับล่าสุดที่ความละเอียดสูงและอัตราการรี&#xfeff;เ&#xfeff;ฟ&#xfeff;ร&#xfeff;ช&#xfeff;สู&#xfeff;ง <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>เทคโนโลยีการอั&#xfeff;ป&#xfeff;ส&#xfeff;เ&#xfeff;ก&#xfeff;ลที่ปรับปรุงโดย Intel® AI เพื่อประสิทธิภาพที่มากขึ้นและการเล่นเกมที่ลื่นไหล <br/><br/>การสนับสนุน <strong>DirectX* 12 Ultimate:  </strong>นำคุณสู่อีกระดับของการเล่นเกมที่สมจริงด้วยเทคโนโลยีกราฟิก เช่น Ray Tracing และ Variable Rate Shading"
                  }
                },
                {
                  "specName": "Give_Your_Games_A_Boost",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A380_panel3.png",
                    "tr_specTitle": "เพิ่มประสิทธิภาพให้เกมของคุณ",
                    "tr_specText": "ยกระดับประสบการณ์การเล่นเกมของคุณไปอีกขั้นด้วย: <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>เทคโนโลยีการอั&#xfeff;ป&#xfeff;ส&#xfeff;เ&#xfeff;ก&#xfeff;ลที่ปรับปรุงโดย Intel® AI เพื่อประสิทธิภาพที่มากขึ้นและการเล่นเกมที่ลื่นไหล <br/><br/>การสนับสนุน <strong>DirectX* 12 Ultimate:  </strong>นำคุณสู่อีกระดับของการเล่นเกมที่สมจริงด้วยเทคโนโลยีกราฟิก เช่น Ray Tracing และ Variable Rate Shading"
                  }
                },
                {
                  "specName": "Experience_Advanced_Fast_Paced_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_panel2.png",
                    "tr_specTitle": "สัมผัสประสบการณ์การเล่นเกมที่ฉับไวขั้นสูง",
                    "tr_specText": "เพลิดเพลินกับการเล่นเกมระดับ AAA ยอดนิยมมากมายอย่างไหลลื่น และการเล่นเกมด้วยอัตรารีเฟรชสูง ตั้งแต่เกมยิงแบบอีสปอร์ตสุดระทึก กระทั่งเกม RTS สุดฮิตที่ฉับไว <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>เทคโนโลยีการอั&#xfeff;ป&#xfeff;ส&#xfeff;เ&#xfeff;ก&#xfeff;ลที่ปรับปรุงโดย Intel® AI เพื่อประสิทธิภาพที่มากขึ้นและการเล่นเกมที่ลื่นไหล <br/><br/>การสนับสนุน <strong>DirectX* 12 Ultimate:  </strong>นำคุณสู่อีกระดับของการเล่นเกมที่สมจริงด้วยเทคโนโลยีกราฟิก เช่น Ray Tracing และ Variable Rate Shading"
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A750_panel2.png",
                    "tr_specTitle": "สัมผัสการเล่นเกมประสิทธิภาพสูงที่สมจริง",
                    "tr_specText": "ประสิทธิภาพที่ดีที่สุดต้องมาก่อนด้วยเกม AAA ระดับล่าสุดที่ความละเอียดสูงและอัตราการรี&#xfeff;เ&#xfeff;ฟ&#xfeff;ร&#xfeff;ช&#xfeff;สู&#xfeff;ง <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>เทคโนโลยีการอั&#xfeff;ป&#xfeff;ส&#xfeff;เ&#xfeff;ก&#xfeff;ลที่ปรับปรุงโดย Intel® AI เพื่อประสิทธิภาพที่มากขึ้นและการเล่นเกมที่ลื่นไหล <br/><br/>การสนับสนุน <strong>DirectX* 12 Ultimate:  </strong>นำคุณสู่อีกระดับของการเล่นเกมที่สมจริงด้วยเทคโนโลยีกราฟิก เช่น Ray Tracing และ Variable Rate Shading"
                  }
                },
                {
                  "specName": "Graphics_Universe",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "กราฟิก",
                    "tr_specText": "จักรวาลกราฟิกที่เปิดกว้างสำหรับทุกคน"
                  }
                },
                {
                  "specName": "Accelerate_Your_Frames",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel2.png",
                    "tr_specTitle": "เร่งเฟรมของคุณ เร่งเกมของคุณ",
                    "tr_specText": "เทคโนโลยี Intel® X<sup class='small_text_sup_xe'>e</sup> Super Sampling (X<sup class='small_text_sup_xe'>e</sup>SS) ยกระดับการเล่นเกมของคุณขึ้นไปอีกขั้นด้วยการอัปสเกลที่ยกระดับด้วย AI เพื่อประสิทธิภาพสูงสุดพร้อมความเที่ยงตรงของภาพสูง X<sup class='small_text_sup_xe'>e</sup>SS ได้รับการปรับให้เหมาะสมกับผลิตภัณฑ์กราฟิก Intel® Arc™ เพื่อให้คุณสามารถใช้ประโยชน์สูงสุดจากการเร่งความเร็วฮาร์ดแวร์ Intel® X<sup class='small_text_sup_xe'>e</sup> Matrix Extensions (Intel® XMX)"
                  }
                },
                {
                  "specName": "Ultimate_Visuals_Are_Here",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel3.png",
                    "tr_specTitle": "ภาพสวยสุดยอดมาแล้ว",
                    "tr_specText": "ด้วยการรองรับ DirectX* 12 Ultimate ในกราฟิก Intel® Arc™ ทุกรุ่นอย่างเต็มรูปแบบ คุณจะได้ดื่มด่ำไปกับก&#xfeff;า&#xfeff;ร&#xfeff;เ&#xfeff;ล่&#xfeff;น&#xfeff;เ&#xfeff;ก&#xfeff;มอันน่&#xfeff;า&#xfeff;ทึ่&#xfeff;งที่เต็มอิ่มสมจริงจากเทคโนโลยีด้านกราฟิกล่าสุดอย่าง Ray&nbsp;Tracing, Variable Rate Shading, Mesh Shading และ Sampler Feedback ซึ่งเป็นรากฐานของก&#xfeff;า&#xfeff;ร&#xfeff;เ&#xfeff;ล่&#xfeff;น&#xfeff;เ&#xfeff;ก&#xfeff;มในเ&#xfeff;จ&#xfeff;น&#xfeff;เ&#xfeff;น&#xfeff;อ&#xfeff;เ&#xfeff;ร&#xfeff;ชั่&#xfeff;นถัดไป"
                  }
                },
                {
                  "specName": "Seamless_Photos_And_Videos",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel4.png",
                    "tr_specTitle": "การสร้างสรรค์รูปภาพ วิดีโอ และสื่ออย่างไม่มีสะดุด",
                    "tr_specText": "ปลดปล่อยจินตนาการของคุณและดึงดูดผู้ชมด้วยการสร้างคอนเทนต์ดิจิทัลที่สมบูรณ์แบบโดยใช้มีเดียเอนจินขั้นสูงที่เสริมด้วย AI และเร่งความเร็วด้วยเทคโนโลยี Intel® สร้างคอนเทนต์ที่น่าทึ่ง ซึ่งขับเคลื่อนด้วยกราฟิกที่รองรับรูปแบบสื่อชั้นนำในปัจจุบันทั้งหมด ขณะเดียวกันก็รักษาความทันสมัยด้วยความสามารถในการเข้ารหัสวิดีโอ AV1 ขั้นสูงสุด"
                  }
                },
                {
                  "specName": "Experience_Cutting_Edge",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel5.png",
                    "tr_specTitle": "สัมผัสประสบการณ์การเล่นเกมและการสร้างสรรค์ด้วย AI อันล้ำสมัย",
                    "tr_specText": "กราฟิก Intel® Arc™ จะปลดล็อกขีดความสามารถด้าน AI อันทรงพลัง ตั้งแต่การสร้างสรรค์ขั้นสูงไปจนถึงการเล่นเกมที่เต็มอิ่มสมจริง ใช้ประโยชน์สูงสุดจากซอฟต์แวร์การสร้างสรรค์ขั้นสูงในปัจจุบัน รวมถึงการสร้างข้อความเป็นรูปภาพและการตัดต่อวิดีโอที่เร่งความเร็วด้วย AI นอกจากนี้คุณยังสามารถเพลิดเพลินกับการเล่นเกมที่มีความละเอียดสูงผ่านการอัปสเกล X<sup class='small_text_sup_xe'>e</sup>SS ที่เร่งความเร็วด้วย AI"
                  }
                },
                {
                  "specName": "Professional_Graphics",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc_pro_badge.png",
                    "tr_specTitle": "กราฟิก",
                    "tr_specText": "กราฟิกระดับมืออาชีพเริ่มที่นี่"
                  }
                },
                {
                  "specName": "Designers_And_Engineers",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel2.png",
                    "tr_specTitle": "เหมาะสำหรับนักสร้างสรรค์ นักออกแบบ และวิศวกรที่ต้องเดินทางไปมา",
                    "tr_specText": "กราฟิก Intel® Arc™ Pro ในตัวที่มีอยู่ในโปรเซสเซอร์ Intel® Core™ Ultra H-ซีรีส์บางรุ่นให้ประสิทธิภาพกราฟิกที่ดีขึ้นถึง 2 เท่า พร้อมกับการรองรับผู้จัดจำหน่ายซอฟต์แวร์อิสระ (ISV) เพื่อให้ได้ความน่าเชื่อถือที่เพิ่มขึ้น และให้การเร่งความเร็วฮาร์ดแวร์ Ray Tracing และ AI อย่างมีประสิทธิภาพเพื่อการสร้างคอนเทนต์อันน่าทึ่งได้ในทุกที่<br/><br/><span class='expandable_heading'>การรองรับซอฟต์แวร์<br/></span><br/>Intel ทำงานอย่างใกล้ชิดร่วมกับบริษัทซอฟต์แวร์หลายร้อยบริษัทมานานหลายปี และประสบการณ์ที่ไม่มีใครเทียบได้นี้ฝังรวมอยู่ในการ์ดกราฟิก Intel® Arc™ Pro A-ซีรีส์ ของเรา ใบรับรองมีความสำคัญสำหรับเราเช่นเดียวกับคุณ"
                  }
                },
                {
                  "specName": "Making_Ai_Attainable",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel3.png",
                    "tr_specTitle": "ทำให้ AI กลายเป็นจริง",
                    "tr_specText": "กลุ่ม GPU นี้รวมเทคโนโลยีที่ดีเยี่ยมให้เลือกมากมาย รวมถึงการรองรับเครื่องมือ AI ที่เข้ากันได้ของคุณ พร้อมด้วยการเร่งความเร็ว AI แยกเฉพาะในตัวหากคุณต้องใช้"
                  }
                },
                {
                  "specName": "Ray_Tracing",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel3.png",
                    "tr_specTitle": "Ray Tracing โดยไม่ต้องจ่ายราคาพรีเมียม",
                    "tr_specText": "การ์ดกราฟิกต้องทำมากกว่าการฉายพิกเซลไปบนจอแสดงผล แต่ยังต้องเร่งสร้างภาพที่สวยงามด้วย เทคโนโลยีฮาร์ดแวร์ Ray Tracing ที่อยู่ในกราฟิก Intel® Arc™ Pro A-ซีรีส์ ช่วยให้ซอฟต์แวร์ที่ทำงานเข้ากันได้ของคุณสามารถสำรวจดูเวิร์กโฟลว์ระดับมืออาชีพใหม่ ๆ เหล่านี้ได้ โดยทั่วไปแล้ว Ray Tracing มักถูกมองว่ามีอยู่เฉพาะในกราฟิกราคาสูง แต่กลุ่มผลิตภัณฑ์กราฟิกระดับมืออาชีพรุ่นล่าสุดของ Intel นั้นแตกต่างออกไป"
                  }
                },
                {
                  "specName": "Immersive_Display",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel5.png",
                    "tr_specTitle": "การมอบขุมพลังให้กับนักสร้างสรรค์ด้วยจอแสดงผลที่เต็มอิ่มสมจริง",
                    "tr_specText": "ด้วยการรองรับ DirectX* 12 Ultimate ในกราฟิก Intel® Arc™ ทุกรุ่นอย่างเต็มรูปแบบ คุณจะได้ดื่มด่ำไปกับก&#xfeff;า&#xfeff;ร&#xfeff;เ&#xfeff;ล่&#xfeff;น&#xfeff;เ&#xfeff;ก&#xfeff;มอันน่&#xfeff;า&#xfeff;ทึ่&#xfeff;งที่เต็มอิ่มสมจริงจากเทคโนโลยีด้านกราฟิกล่าสุดอย่าง Ray&nbsp;Tracing, Variable Rate Shading, Mesh Shading และ Sampler Feedback ซึ่งเป็นรากฐานของก&#xfeff;า&#xfeff;ร&#xfeff;เ&#xfeff;ล่&#xfeff;น&#xfeff;เ&#xfeff;ก&#xfeff;มในเ&#xfeff;จ&#xfeff;น&#xfeff;เ&#xfeff;น&#xfeff;อ&#xfeff;เ&#xfeff;ร&#xfeff;ชั่&#xfeff;นถัดไป"
                  }
                },
                {
                  "specName": "Dynamically_Optimised_Images",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel6.png",
                    "tr_specTitle": "รูปภาพที่ปรับให้เหมาะสมแบบไดนามิก",
                    "tr_specText": "Dolby Vision* ช่วยเพิ่มความลึก ความคมชัดให้มากขึ้น และให้สีสันแก่จอแสดงผลที่รองรับการทำงานได้ดีขึ้น ด้วยฮาร์ดแวร์แบบแยกซึ่งทำหน้าที่ถอดรหัสบน Pro GPU Dolby Vision* ดึงศักยภาพของเทคโนโลยี HDR ออกมาได้อย่างเต็มที่ ด้วยการปรับคุณภาพของภาพให้เหมาะสมแบบไดนามิกตามการทำงานของอุปกรณ์จอแสดงผลและแพลตฟอร์มของคุณ เพื่อถ่ายทอดภาพอันน่าทึ่งได้ในทุก ๆ ครั้ง"
                  }
                },
                {
                  "specName": "Expertly_Verified_Software",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel2.png",
                    "tr_specTitle": "ซอฟต์แวร์ที่ต&#xfeff;ร&#xfeff;ว&#xfeff;จ&#xfeff;ส&#xfeff;อ&#xfeff;บโดยผู้&#xfeff;เ&#xfeff;ชี่&#xfeff;ย&#xfeff;ว&#xfeff;ช&#xfeff;า&#xfeff;ญ",
                    "tr_specText": "Intel ทำงานอย่างใกล้ชิดร่วมกับบริษัทซอฟต์แวร์หลายร้อยบริษัทมานานหลายปี และประสบการณ์ที่ไม่มีใครเทียบได้นี้ฝังรวมอยู่ในกลุ่มผลิตภัณฑ์กราฟิก Intel® Arc™ Pro A-ซีรีส์ ระดับมืออาชีพ ใบรับรองและใบประกาศเวิร์กโฟลว์ซอฟต์แวร์มีความสำคัญสำหรับเราเช่นเดียวกับคุณ"
                  }
                },
                {
                  "specName": "Ray_Tracing_Mobile",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel3.png",
                    "tr_specTitle": "Ray Tracing โดยไม่ต้องจ่ายราคาพรีเมียม",
                    "tr_specText": "การ์ดกราฟิกต้องทำมากกว่าการฉายพิกเซลไปบนจอแสดงผล แต่ยังต้องเร่งสร้างภาพที่สวยงามด้วย เทคโนโลยีฮาร์ดแวร์ Ray Tracing ที่อยู่ในกราฟิก Intel® Arc™ Pro A-ซีรีส์ ช่วยให้ซอฟต์แวร์ที่ทำงานเข้ากันได้ของคุณสามารถสำรวจดูเวิร์กโฟลว์ระดับมืออาชีพใหม่ ๆ เหล่านี้ได้ โดยทั่วไปแล้ว Ray Tracing มักถูกมองว่ามีอยู่เฉพาะในกราฟิกราคาสูง แต่กลุ่มผลิตภัณฑ์กราฟิกระดับมืออาชีพรุ่นล่าสุดของ Intel นั้นแตกต่างออกไป"
                  }
                },
                {
                  "specName": "Multiple_Large_Display",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel4.png",
                    "tr_specTitle": "หลายจอแสดงผลมีขนาดใหญ่พร้อม GPU โมบายล์เล็ก ๆ ชิ้นเดียว",
                    "tr_specText": "กราฟิก Intel® Arc™ Pro สำหรับแล็ปท็อปสามารถรองรับจอ<wbr>แ&#xfeff;ส&#xfeff;ด&#xfeff;ง&#xfeff;ผ&#xfeff;ลขนาดใหญ่พิเศษได้ถึงสี่จอเพื่อเพิ่มประสิทธิภาพเวิร์กโฟลว์ของคุณ อีกทั้งยังรองรับ High Dynamic Range (HDR) และนั่นคือทั้งหมดที่คุณใช้จัดระบบหลายจอแสดงผลได้ครบถ้วนสำหรับโซเชียลมีเดียทั้งที่บ้านและออฟฟิศ"
                  }
                },
                {
                  "specName": "Full_Memory_Bandwidth",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel5.png",
                    "tr_specTitle": "ศักยภาพแบนด์วิดธ์หน่วยความจำเต็ม",
                    "tr_specText": "แบนด์วิดธ์ของการ์ดกราฟิกของคุณในเวิร์กสเตชันเป็นสิ่งสำคัญที่ต้องพิจารณา หากทำพลาด คุณอาจทำให้เวิร์กโฟลว์ระดับมืออาชีพช้าลงได้ ด้วยเหตุนี้เราจึงทำให้ GPU Intel®&nbsp;Arc™&nbsp;Pro A&#8209;ซี&#xfeff;รี&#xfeff;ส์ สามารถรองรับ PCIe* 4.0 อันล้ำสมัยใหม่ได้ โดยไม่ส่งผลก&#xfeff;ร&#xfeff;ะ&#xfeff;ท&#xfeff;บต่อความเข้ากันได้กับรุ่นก่อนหน้า ความเร็วแบนด์วิดธ์สูงก็จะเสริมส่งหน่วยความจำกราฟิกเพิ่มขึ้นอีก ทำให้ซอฟต์แวร์ของคุณสามารถเข้าถึงข้อมูลของโครงการได้รวดเร็วยิ่งขึ้น"
                  }
                },
                {
                  "specName": "Breathe_Life",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel2.png",
                    "tr_specTitle": "เติมชีวิตใส่ให้ทุกเฟรม",
                    "tr_specText": "<span class='expandable_heading'>เร่งความเร็วด้วย AI ให้พลังโดย Intel<br/></span><br/>Intel® X<sup class='small_text_sup_xe'>e</sup>SS เป็นเทคโนโลยีการอัปสเกลที่ยกระดับด้วย AI ซึ่งเพิ่มประสิทธิภาพของคุณ โดยไม่ลดทอนความสวยงามของเฟรมใด ๆ คุณจึงสามารถสัมผัสกับการเล่นเกมของคุณได้ในเกมแบบควรจะเป็น"
                  }
                },
                {
                  "specName": "Real_Immersive",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel3.png",
                    "tr_specTitle": "ตอบสนองฉับไว<br/>สวยงาม<br/>สมจริงขั้นสุด",
                    "tr_specText": "โลกที่สมจริงยิ่งกว่ากำลังรออยู่ ด้วย Ray Tracing ในตัว คุณจะได้สัมผัสกับรายละเอียดทุกอย่าง ตั้งแต่แสงเงาและแสงสะท้อนที่สมจริงไปจนถึงแสงอันยอดเยี่ยม เรียกได้ว่าเป็นประสบการณ์การเล่นเกมแบบที่คุณจะไม่อยากพลาดไปเลย"
                  }
                },
                {
                  "specName": "Your_Best_Gameplay",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel4.png",
                    "tr_specTitle": "ถ่ายทอดสุดยอดการเล่นเกมของคุณ ออกไปอย่างสมบูรณ์แบบ",
                    "tr_specText": "ให้กลุ่มเป้าหมายของคุณได้สัมผัสกับการเล่นเกมอันสุดลื่นไหลอย่างที่พวกเขาต้องการ ด้วยขีดความสามารถในการเข้ารหัส AV1 ที่เร่งความเร็วด้วยฮาร์ดแวร์ของกราฟิก Intel® Arc™ ทุกคนจะหลงใหลไปกับทุกการเคลื่อนไหวของคุณ ภาพแสดงที่มีคุณภาพสูงขึ้นกับอัตราบิตเท่าเดิมช่วยให้คุณได้รับการสตรีมที่ดีที่สุดพร้อมประหยัดแบนด์วิดธ์"
                  }
                },
                {
                  "specName": "Welcome_All_Creators",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel5.png",
                    "tr_specTitle": "พร้อมสำหรับนักสร้างสรรค์ทุกคน",
                    "tr_specText": "ประสบการณ์ใช้งาน AI ใหม่และที่ดียิ่งขึ้นมาอยู่ที่ปลายนิ้วของคุณแล้ว ใช้เวลาไปกับการสร้างสรรค์ได้มากขึ้นพร้อมกับใช้เวลารอแอปพลิเคชันมากมายได้น้อยกว่าด้วยตัวเร่ง AI ขั้นสูงที่มาในกราฟิก Intel® Arc™ A-ซีรีส์<br/><br/>ยกระดับการสร้างสรรค์วิดีโอของคุณขึ้นไปอีกขั้นและก้าวเป็นผู้นำด้วยวิดีโอ AV1 คุณภาพสูงและประหยัดพื้นที่จัดเก็บ ซึ่งขับเคลื่อนด้วยขีดความสามารถของฮาร์ดแวร์ AV1 ขั้นสูงในกราฟิก Intel® Arc™"
                  }
                },
                {
                  "specName": "Graphics_Universe_B",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "เทคโนโลยีใหม่ กราฟิกยอด การเล่นเยี่ยม",
                    "tr_specText": "เล่น สร้าง รังสรรค์"
                  }
                },
                {
                  "specName": "Game_Ready",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel1.png",
                    "tr_specTitle": "เกมพร้อม ฟี&#xfeff;เ&#xfeff;จ&#xfeff;อ&#xfeff;ร์&#xfeff;เ&#xfeff;พี&#xfeff;ย&#xfeff;บ",
                    "tr_specText": "สนุกไปกับการเล่นเกมใหม่ล่าสุดอย่างมีประสิทธิภาพที่ความละเอียด <strong>1080p</strong> และ <strong>1440p</strong> ที่ผ่านการอัปสเกลด้วย AI และ Ray Tracing<br><br/> เพลิดเพลินไปกับประสิทธิภาพและคุณสมบัติที่คุณต้องการในราคาที่คุณพึงใจ",
                    "subSpecs": [
                      {
                        "tr_title": "ความละเอียด <br><strong>1440p</strong>"
                      }
                    ]
                  }
                },
                {
                  "specName": "Game_Changing_Modern_Tech",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel2.png",
                    "tr_specTitle": "เทคโนโลยีทันสมัย ที่&#xfeff;พ&#xfeff;ลิ&#xfeff;ก&#xfeff;โ&#xfeff;ฉ&#xfeff;ม&#xfeff;ว&#xfeff;ง&#xfeff;ก&#xfeff;า&#xfeff;ร",
                    "tr_specText": "เพิ่มประสิทธิภาพ เร่งการตอบสนอง และอีกมากมายด้วยเทคโนโลยีการเล่นเกมจากกราฟิก Intel® Arc™<br><br/> สนุกไปกับประสิทธิภาพที่เหนือชั้นและภาพอันสวยงามกับเกมมากกว่า 150 เกม ที่ยกระดับด้วย AI ผ่านเทคโนโลยี Intel® X<sup>e</sup> Super Sampling (X<sup>e</sup>SS)<br><br/> ปรับให้เกมของคุณเล่นได้ราบรื่นยิ่งขึ้นและตอบสนองได้มากขึ้นด้วยเทคโนโลยี Intel® X<sup>e</sup>SS Frame Generation และ Intel® X<sup>e</sup> Low Latency จาก Intel",
                    "subSpecs": [
                      {
                        "tr_title": "หน่วยความจำ <strong>10GB<br></strong>"
                      },
                      {
                        "tr_title": "<strong>มากกว่า 150<br></strong>เกม"
                      },
                      {
                        "tr_title": "<strong>Intel® X<sup>e</sup>SS<br></strong>"
                      }
                    ]
                  }
                },
                {
                  "specName": "Software_Releases",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel3.png",
                    "tr_specTitle": "ซอฟต์แวร์ทันสมัย ใหม่ล่าสุด",
                    "tr_specText": "อัปเดตซอฟต์แวร์เสมอ เพื่อประสบการณ์การเล่นเกมที่ดีขึ้นอย่างต่อเนื่อง"
                  }
                },
                {
                  "specName": "Creator_Toolkit",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel4.png",
                    "tr_specTitle": "ชุดเครื่องมืออรรถประโยชน์",
                    "tr_specText": "ประหยัดเวลาและเอ็กพอร์ตวิดีโออย่างรวดเร็วด้วยตัวแปลงรหัสคู่ที่รองร้บการเข้ารหัสพร้อมกัน สร้างสรรค์คอนเทนต์ที่พร้อมรองรับฟอร์แมตยอดนิยม และรวมถึง AV1 ที่ล้ำหน้า<br><br/> มีเดียเอนจิน Intel® X<sup>e</sup> ที่ทรงพลังช่วยให้คุณสร้างและแก้ไขคอนเทนต์ที่มีความละเอียดสูงได้อย่างรวดเร็ว"
                  }
                },
                {
                  "specName": "Explore_AI",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel5.png",
                    "tr_specTitle": "สร้างมาเพื่อก&#xfeff;า&#xfeff;ร&#xfeff;ใ&#xfeff;ช้&#xfeff;ง&#xfeff;า&#xfeff;น&nbsp;AI",
                    "tr_specText": "สร้างประสบการณ์ใช้งาน AI เช่น การสร้างภาพจากข้อความ และ AI แชทบอทได้โดยตรงบนพีซีของคุณ AI Playground แอปฟรีและเป็นส่วนตัวที่นำความสามารถ AI มารวมกันเพื่อสร้างประสบการณ์การใช้งานที่ง่าย<br><br/> เพลิดเพลินไปกับการเล่นเกมที่ดีขึ้น การสร้างสรรค์ได้อย่างรวดเร็ว และอีกมากมายด้วยเอนจิน AI เฉพาะทางที่ชื่อว่า Intel® Xe Matrix Extensions (Intel® XMX) ที่มีให้มาในกราฟิก Intel® Arc™",
                    "subSpecs": [
                      {
                        "tr_title": "<strong>144<br></strong>เอนจิน AI<br>Intel® XMX"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "os": [
    {
      "contentType": "WINDOWS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "header-IconTop",
                "badgeUrl": "",
                "tr_title": "ทุกสิ่งที่คุณต้องการเพื่อให้งานสำเร็จลุล่วง",
                "tr_pretitle": "Windows* 10",
                "tr_subtitle": "สมรรถนะอันทรงพลังในอุปกรณ์น้ำหนักเบา บาง และใช้งานได้ยาวนาน ที่คุณเป็นเจ้าของได้ ค้นพบสิ่งที่คุณต้องการ ทั้งแบตเตอรี่ยาวนาน หน้าจอสัมผัสอันสวยงาม* และโซลิดสเตตไดรฟ์ (SSD) ล่าสุด ได้ใน PC Windows",
                "tr_noteSection": "*ขึ้นอยู่กับฮาร์ดแวร์",
                "titleArray": [
                  {
                    "tr_title": "น้อยแต่มาก",
                    "tr_subtitle": "โดยทั่วไป PC ในปัจจุบันใช้พลังงานน้อยลง คุณจึงใช้งานแบตเตอรี่ได้นานกว่าที่เคย โดยเฉลี่ยแล้วจะเล่นวิดีโอได้นานกว่า 8 ชั่วโมง**",
                    "tr_noteSection": "**อายุเเบตเตอรี่จะเเตกต่างกันไปอย่างเห็นได้ชัดตามอุปกรณ์ การตั้งค่า การใช้งาน และปัจจัยอื่น ๆ"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "header-IconTopGaming",
                "tr_pretitle": "ทุกสิ่งที่คุณต้องการเพื่อให้งานสำเร็จลุล่วง",
                "tr_title": "Windows* 10",
                "tr_subtitle": "สมรรถนะอันทรงพลังในอุปกรณ์น้ำหนักเบา บาง และใช้งานได้ยาวนาน ที่คุณเป็นเจ้าของได้ ค้นพบสิ่งที่คุณต้องการ ทั้งแบตเตอรี่ยาวนาน หน้าจอสัมผัสอันสวยงาม* และโซลิดสเตตไดรฟ์ (SSD) ล่าสุด ได้ใน PC Windows",
                "tr_noteSection": "*ขึ้นอยู่กับฮาร์ดเเวร์",
                "titleArray": [
                  {
                    "tr_title": "น้อยแต่มาก",
                    "tr_subtitle": "โดยทั่วไป PC ในปัจจุบันใช้พลังงานน้อยลง คุณจึงใช้งานแบตเตอรี่ได้นานกว่าที่เคย โดยเฉลี่ยแล้วจะเล่นวิดีโอได้นานกว่า 8 ชั่วโมง**",
                    "tr_noteSection": "**อายุเเบตเตอรี่จะเเตกต่างกันไปอย่างเห็นได้ชัดตามอุปกรณ์ การตั้งค่า การใช้งาน และปัจจัยอื่น ๆ"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWSUWP",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "ปรับปรุงใหม่เพื่อความปลอดภัยและสมรรถนะ",
                "tr_pretitle": "Windows* 10 ในโหมด S  ",
                "tr_subtitle": "ขณะที่ใช้งาน Windows* 10 ในโหมด S คุณจะได้รับการปกป้องเพิ่มขึ้นอีกชั้นหนึ่ง ซึ่งจะช่วยให้คุณทำงาน เล่นสนุก และค้นหาสิ่งใหม่ๆ โดยมั่นใจได้ว่าอุปกรณ์ของคุณปลอดภัย"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ปรับปรุงใหม่เพื่อความปลอดภัยและสมรรถนะ",
                "tr_title": "Windows* 10 ในโหมด S  ",
                "tr_subtitle": "ขณะที่ใช้งาน Windows* 10 ในโหมด S คุณจะได้รับการปกป้องเพิ่มขึ้นอีกชั้นหนึ่ง ซึ่งจะช่วยให้คุณทำงาน เล่นสนุก และค้นหาสิ่งใหม่ๆ โดยมั่นใจได้ว่าอุปกรณ์ของคุณปลอดภัย"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWS_GENERIC",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "ทำสิ่งต่างๆ อันยอดเยี่ยม",
                "tr_pretitle": "Windows*",
                "tr_subtitle": "ประสิทธิภาพ ราคา และตัวเลือกมากมาย ตั้งแต่คอมพิวเตอร์ 2-in-1 ที่ล้ำสมัยไปจนถึงแล็ปท็อปที่บางและเบา หน้าจอสัมผัส คีย์บอร์ดแบบถอดได้ ไม่ว่าคุณจะมีงบหรือสไตล์แบบไหนก็สามารถหาพีซี Windows* ที่ลงตัวได้"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ทำสิ่งต่างๆ อันยอดเยี่ยม",
                "tr_title": "Windows*",
                "tr_subtitle": "ประสิทธิภาพ ราคา และตัวเลือกมากมาย ตั้งแต่คอมพิวเตอร์ 2-in-1 ที่ล้ำสมัยไปจนถึงแล็ปท็อปที่บางและเบา หน้าจอสัมผัส คีย์บอร์ดแบบถอดได้ ไม่ว่าคุณจะมีงบหรือสไตล์แบบไหนก็สามารถหาพีซี Windows* ที่ลงตัวได้"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "LINUX",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "",
                "tr_pretitle": "LINUX*",
                "tr_subtitle": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWS_11",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "image-only-panel",
                "panelType2": "header-IconTop",
                "badgeUrl": "",
                "tr_title": "",
                "tr_pretitle": "",
                "badgeIcons": [
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/1.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/2.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/3.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/4.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/5.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/6.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/7.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/8.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/9.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/10.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/11.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/12.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/13.png"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "memory": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_title": "คุณต้องการ RAM เท่าไหร่",
                "tr_subtitle": "",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "ทั่วไป - RAM 2 GB สูงสุด 8 GB",
                    "tr_badgeSubTitle": "เหมาะสำหรับผู้ที่ใช้พีซีสำหรับการประมวลผลคำและการท่องเว็บเป็นหลัก และมีแนวโน้มว่าจะเน้นใช้ทีละหนึ่งโปรแกรม"
                  },
                  {
                    "tr_badgeTitle": "ทรงพลัง - RAM 8 GB สูงสุด 16 GB",
                    "tr_badgeSubTitle": "ด้วย RAM ที่มากกว่า โปรแกรมของคุณจะรันได้เร็วกว่า และคุณจะสามารถรันหลายแอปพลิเคชันพร้อมกันได้มากกว่า"
                  },
                  {
                    "tr_badgeTitle": "ขั้นสูง - RAM มากกว่า 16 GB",
                    "tr_badgeSubTitle": "ถ้าคุณสนใจการเล่นเกม การแก้ไข ภาพถ่ายหรือตัดต่อวิดีโอ หรือการสร้างแบบจำลอง 3 มิติ คุณจะต้องการ RAM เพิ่มเพื่อรองรับโปรแกรมขั้นสูงเหล่านี้"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GOOD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "RAM [XX] GB สำหรับมั&#65279;ล&#65279;ติ&#65279;ท&#65279;า&#65279;ส&#65279;กิ้&#65279;งประจำวัน",
                "tr_subtitle": "หน่วยความจำของคุณจะช่วยให้โหลดและรันโปรแกรมพื้นฐานต่างๆ ได้อย่างราบรื่น เช่น โปรแกรมประมวลผลคำและการท่องเว็บ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class ='value'>[XX] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BETTER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "RAM [XX] GB สำหรับมั&#65279;ล&#65279;ติ&#65279;ท&#65279;า&#65279;ส&#65279;กิ้&#65279;งที่ทรงพลัง",
                "tr_subtitle": "ถ้าคุณใช้งานหลายโปรแกรมพร้อมกัน หน่วยความจำ [memory_total] GB ช่วยให้คุณสลับไปมาระหว่างโปรแกรมได้อย่างง่ายดาย",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class ='value'>[XX] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BEST",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "RAM [XX] GB สำหรับมั&#65279;ล&#65279;ติ&#65279;ท&#65279;า&#65279;ส&#65279;กิ้&#65279;งขั้นสูง",
                "tr_subtitle": "คุณจะมีหน่วยความจำเหลือเฟือสำหรับการรันโปรแกรมขั้นสูงหลายโปรแกรมในเวลาเดียวกัน โดยไม่ทำให้พีซีช้าลง",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class ='value'>[XX] GB<br/></span><span class='subtitle-value'>VRAM</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "หน่วยความจำ [Value1]&nbsp;GB = ห&#xfeff;น่&#xfeff;ว&#xfeff;ย&#xfeff;ค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;จำ Intel®&nbsp;Optane™ [Value2]&nbsp;GB + RAM&nbsp;[Value3]&nbsp;GB",
                "tr_subtitle": "การผสมผสานโซลูชันหน่วยความจำนี้จะทำให้คุณได้รับประสิทธิภาพของฮาร์ดไดรฟ์ที่เร่งความเร็วยิ่งขึ้นจากหน่วยความจำ Intel® Optane™ พร้อมทั้งการตอบสนองที่ดียิ่งขึ้นจาก RAM ของคุณ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>หน่วยความจำ<br/></span><span class='subtitle-value'>[XX] GB</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "tr_title": "ลดเวลาที่ใช้ในการรอคอย ทำ&#65279;สิ่&#65279;ง&#65279;ที่คุณชอบได้มากขึ้น",
                "tr_subtitle": "เมื่อหน่วยความจำ Intel® Optane™ ทำงานร่วมกับหน่วยความจำระบบของคุณ จะช่วยให้คุณเข้าถึงโปรแกรมที่ใช้งานบ่อยได้รวดเร็วขึ้น และโปรแกรมจะเปิดใช้งานและโหลดขึ้นทันทีที่คุณต้องการ",
                "tr_pretitle": "หน่วยความจำ Intel® Optane™ [XX] GB",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "titleArray": [
                  {
                    "tr_title": "หน่วยความจำทำอะไรให้กับพีซี"
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-optane-faster-content.png",
                    "tr_badgeTitle": "สร้างเนื้อหาได้รวดเร็วขึ้น",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-responsive-gaming.png",
                    "tr_badgeTitle": "เล่นเกมด้วยการตอบสนองที่เร็วกว่า",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-easier-multitasking.png",
                    "tr_badgeTitle": "ทำการมัลติทาสกิ้งได้ง่ายขึ้น",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-open-programs.png",
                    "tr_badgeTitle": "เปิดโปรแกรมได้เร็วกว่า",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "panelType2": "",
                "panelType1": "badgesAndHeadings-memory",
                "tr_title": "<span class='intelOptanMemoryTitle'>เร่งความเร็วให้กับเกมของคุณ</span>",
                "tr_pretitle": "หน่วยความจำ Intel® Optane™ [XX] GB",
                "tr_pretitle1": "หน่วยความจำ Intel® Optane™ [XX] GB ให้คุณเล่นเกมได้รวดเร็วขึ้น",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "เปิดเกมได้<br/><span class=\"optane-game\">เร็วขึ้นสูงสุด 98%</span><br/>จากไดรฟ์ข้อมูล ด้วยโปรเซสเซอร์ [optane_legal_processor_name] ที่ใช้หน่วยความจำ Intel® Optane™<sup>15</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "โหลดเลเวลได้รวดเร็วขึ้น<br/><span class=\"optane-game\">สูงสุด 4.1 เท่า</span><br/>จากไดรฟ์ข้อมูล ด้วยโปรเซสเซอร์ [optane_legal_processor_name] ที่ใช้หน่วยความจำ Intel® Optane™<sup>16</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            },
            {
              "deviceType": "DEFAULT_A",
              "details": {
                "tr_tileTitle": "หน่วยความจำ Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "panelType2": "",
                "panelType1": "badgesAndHeadings-memory",
                "tr_title": "<span class='intelOptanMemoryTitle'>เร่งความเร็วให้กับเกมของคุณ</span>",
                "tr_pretitle": "หน่วยความจำ Intel® Optane™ [XX] GB",
                "tr_pretitle1": "หน่วยความจำ Intel® Optane™ [XX] GB ให้คุณเล่นเกมได้รวดเร็วขึ้น",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "เปิดเกมได้<br/><span class=\"optane-game\">เร็วขึ้นสูงสุด 98%</span><br/>จากไดรฟ์ข้อมูล ด้วยโปรเซสเซอร์ [optane_legal_processor_name] ที่ใช้หน่วยความจำ Intel® Optane™<sup>15</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "โหลดเลเวลได้รวดเร็วขึ้น<br/><span class=\"optane-game\">สูงสุด 4.1 เท่า</span><br/>จากไดรฟ์ข้อมูล ด้วยโปรเซสเซอร์ [optane_legal_processor_name] ที่ใช้หน่วยความจำ Intel® Optane™<sup>16</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "หน่วยความจำ [Value1]&nbsp;GB = ห&#xfeff;น่&#xfeff;ว&#xfeff;ย&#xfeff;ค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;จำ Intel®&nbsp;Optane™ [Value2]&nbsp;GB + RAM&nbsp;[Value3]&nbsp;GB",
                "tr_subtitle": "การผสมผสานโซลูชันหน่วยความจำนี้จะทำให้คุณได้รับประสิทธิภาพของฮาร์ดไดรฟ์ที่เร่งความเร็วยิ่งขึ้นจากหน่วยความจำ Intel® Optane™ พร้อมทั้งการตอบสนองที่ดียิ่งขึ้นจาก RAM ของคุณ",
                "titleArray": [
                  {
                    "tr_title": "RAM [XX] GB สำหรับการมัลติทาสกิ้ง",
                    "tr_subtitle": "ถ้าคุณใช้งานหลายโปรแกรมพร้อมกัน หน่วยความจำ [memory_total] GB ช่วยให้คุณสลับไปมาระหว่างโปรแกรมได้อย่างง่ายดาย"
                  },
                  {
                    "tr_title": "สำหรับงานประจำวันทั่วไป",
                    "tr_subtitle": "หน่วยความจำของคุณจะช่วยให้โหลดและรันโปรแกรมพื้นฐานต่างๆ ได้อย่างราบรื่น เช่น โปรแกรมประมวลผลคำและการท่องเว็บ"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "DEFAULT",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_title": "RAM [XX] GB",
                "tr_pretitle": "รองรับมัลติทาสกิ้งได้มากขึ้น",
                "tr_subtitle": "RAM ช่วยให้โปรเซสเซอร์เข้าถึงไฟล์โปรแกรมได้ง่ายขึ้น ทำให้ CPU เข้าถึงไฟล์ได้เร็วขึ้นและทำงานหลายอย่างพร้อมกันได้รวดเร็วมากขึ้น",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "หน่วยความจำมาตรฐาน",
                    "tr_badgeSubTitle": "RAM สูงสุด 8 GB"
                  },
                  {
                    "tr_badgeTitle": "หน่วยความจำขั้นสูง",
                    "tr_badgeSubTitle": "RAM มากกว่า 8&nbsp;GB และสูงสุด 16&nbsp;GB"
                  },
                  {
                    "tr_badgeTitle": "หน่วยความจำระดับสุดยอด",
                    "tr_badgeSubTitle": "RAM มากกว่า 16&nbsp;GB"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GAMING_12TH_MEMORY",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_title": "[XX] GB สำหรับง&#xfeff;า&#xfeff;นมั&#xfeff;ล&#xfeff;ติ&#xfeff;ท&#xfeff;า&#xfeff;ส&#xfeff;กิ้&#xfeff;งเพิ่มขึ้น",
                "tr_pretitle": "รองรับมัลติทาสกิ้งได้มากขึ้น",
                "tr_subtitle": "RAM ช่วยให้โปรเซสเซอร์เข้าถึงไฟล์โปรแกรมได้ง่ายขึ้น ทำให้ CPU เข้าถึงไฟล์ได้เร็วขึ้นและทำงานหลายอย่างพร้อมกันได้รวดเร็วมากขึ้น",
                "gamingPanleType2": "gaming-panelType1",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "หน่วยความจำมาตรฐาน",
                    "tr_badgeSubTitle": "RAM สูงสุด 8 GB"
                  },
                  {
                    "tr_badgeTitle": "หน่วยความจำขั้นสูง",
                    "tr_badgeSubTitle": "RAM มากกว่า 8&nbsp;GB และสูงสุด 16&nbsp;GB"
                  },
                  {
                    "tr_badgeTitle": "หน่วยความจำระดับสุดยอด",
                    "tr_badgeSubTitle": "RAM มากกว่า 16&nbsp;GB"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "หน่วยความจำนี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "มาตรฐาน",
                      "tr_badgeSubTitle": "<span class='memory-value'>RAM <span class='ram_value'>8 GB</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "ขั้นสูง",
                      "tr_badgeSubTitle": "<span class='memory-value'>RAM <span class='ram_value'>16 GB</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "ระดับสูง",
                      "tr_badgeSubTitle": "<span class='memory-value'>RAM <span class='ram_value'>32 GB</span></span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STANDARD_COMMON_12TH_MEMORY",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "หน่วยความจำ",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_title": "หน่วยความจำนี้เปรียบเทียบได้กับอะไร",
                "tr_subtitle": "",
                "gamingPanleType2": "gaming-panelType1",
                "enhancementCompare": {
                  "tr_title": "หน่วยความจำนี้เปรียบเทียบได้กับอะไร",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "อุปกรณ์ปัจจุบัน",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "ทุกวัน",
                      "tr_badgeSubTitle": "<span class='memory-value'>RAM <span class='ram_value'>8 GB</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "ทรงพลัง",
                      "tr_badgeSubTitle": "<span class='memory-value'>RAM <span class='ram_value'>16 GB</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "ขั้นสูง",
                      "tr_badgeSubTitle": "<span class='memory-value'>RAM <span class='ram_value'>32 GB</span></span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ],
  "storage": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "อุปกรณ์จัดเก็บข้อมูล",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png",
                "tr_title": "พีซีของคุณจัดเก็บข้อมูลได้เท่าไหร่",
                "tr_subtitle": "คุณจะไม่ต้องเดา เพราะเราจะแสดงให้เห็นชัดๆ ว่าคุณจะสามารถจัดเก็บข้อมูลได้เท่าไหร่บ&#65279;น&#65279;พี&#65279;ซีเครื่องนี้",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/storage-songs-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>สร้างไลบรารีสำหรับ</span> <br/><span class=\"storage-standard\">[num_songs] เพลง<sup>†</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>†</sup>โดยเฉลี่ย 5 MB ต่อเพลง",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-game-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>สร้างไลบรารีสำหรับ</span><br/><span class=\"storage-standard\">[num_games] เกม<sup>†</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>†</sup>โดยเฉลี่ย 40 GB ต่อเกม",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-videos-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>ที่เก็บข้อมูลสำหรับ</span> <br/><span class=\"storage-standard\">[num_videos] วิดีโอ<sup>§</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>§</sup>โดยเฉลี่ย 5 GB ต่อวิดีโอ",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-photos-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>ถ่ายและจัดเก็บ</span><br/><span class=\"storage-standard\">[num_photos] ภาพ<sup>^</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>^</sup>โดยเฉลี่ย 4 MB ต่อภาพถ่าย",
                    "imgUrl": ""
                  }
                ],
                "titleArray": [
                  {
                    "storageType": "HDD",
                    "tr_pretitle": "[capacity] GB HDD"
                  },
                  {
                    "storageType": "SSD",
                    "tr_pretitle": "[capacity] GB SSD"
                  },
                  {
                    "storageType": "SSD_AND_HDD",
                    "tr_pretitle": ""
                  },
                  {
                    "storageType": "OPTANE",
                    "tr_pretitle": "หน่วยความจำ Intel® Optane™ [total_optane_memory] GB + SSD [convertedSSD] GB "
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "SSD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "อุปกรณ์จัดเก็บข้อมูล",
                "tileBG": "",
                "badgeUrl": "assets/images/std12storage.svg",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_preTitle": "ที่เก็บข้อมูล SSD [capacity] GB",
                "tr_preTitle1": "ที่เก็บข้อมูล SSD [capacity] TB",
                "titleArray": [
                  {
                    "detailPageName": "WIN10S_Storage",
                    "tr_subtitle": "พีซีเครื่องนี้มาพร้อมกับ SSD ที่มีอุปกรณ์จัดเก็บข้อมูลขนาด [capacity]&nbsp;GB นั่นหมายความว่าคุณจะสามารถบันทึกภาพถ่าย วิดีโอ และโปรแกรมได้มากมาย และเข้าถึงได้รวดเร็วยิ่งขึ้นเมื่อเทียบกับฮาร์ดดิสก์ไดรฟ์",
                    "tr_title": "พื้นที่สำหรับทุกสิ่งบนพีซีของคุณ"
                  },
                  {
                    "detailPageName": "WIN10S_Storage-1000",
                    "tr_subtitle": "พีซีเครื่องนี้มาพร้อมกับ SSD ที่มีอุปกรณ์จัดเก็บข้อมูลขนาด [capacity]&nbsp;TB นั่นหมายความว่าคุณจะสามารถบันทึกภาพถ่าย วิดีโอ และโปรแกรมได้มากมาย และเข้าถึงได้รวดเร็วยิ่งขึ้นเมื่อเทียบกับฮาร์ดดิสก์ไดรฟ์",
                    "tr_title": "อุปกรณ์นี้มีพื้นที่จัดเก็บข้อมูลที่&#65279;น่&#65279;า&#65279;ทึ่&#65279;ง"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] GB</span>",
                    "tr_badgeTitle1": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] TB</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "SSD",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "HDD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "อุปกรณ์จัดเก็บข้อมูล",
                "badgeUrl": "assets/images/std12storage.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgeAndHeadings",
                "tr_preTitle": "ที่เก็บข้อมูล HDD [capacity] GB",
                "tr_preTitle1": "ที่เก็บข้อมูล HDD [capacity] TB",
                "titleArray": [
                  {
                    "detailPageName": "WIN10S_Storage",
                    "tr_subtitle": "ฮาร์ดดิสก์ไดรฟ์เป็นตัวเลือกที่ดีสำหรับผู้ที่ต้องการปริมาณพื้นที่จัดเก็บข้อมูลขนาดใหญ่บนพีซีโดยตรง",
                    "tr_title": "พื้นที่สำหรับทุกสิ่งบนพีซีของคุณ"
                  },
                  {
                    "detailPageName": "WIN10S_Storage-1000",
                    "tr_subtitle": "ฮาร์ดดิสก์ไดรฟ์เป็นตัวเลือกที่ดีสำหรับผู้ที่ต้องการปริมาณพื้นที่จัดเก็บข้อมูลขนาดใหญ่บนพีซีโดยตรง",
                    "tr_title": "อุปกรณ์นี้มีพื้นที่จัดเก็บข้อมูลที่&#65279;น่&#65279;า&#65279;ทึ่&#65279;ง"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class ='value'>[capacity]<br/></span><span class='subtitle-value'>ที่เก็บข้อมูล</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "HDD",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "อุปกรณ์จัดเก็บข้อมูล",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "tr_title": "",
                "tr_pretitle": "พีซีของคุณจัดเก็บข้อมูลได้เท่าไหร่",
                "tr_subtitle": "คุณจะไม่ต้องเดา เพราะเราจะแสดงให้เห็นชัดๆ ว่าคุณจะสามารถจัดเก็บข้อมูลได้เท่าไหร่บ&#65279;น&#65279;พี&#65279;ซีเครื่องนี้",
                "titleArray": [
                  {
                    "tr_title": "HDD [XX]&nbsp;GB "
                  },
                  {
                    "tr_title": "SSD [XX]&nbsp;GB "
                  },
                  {
                    "tr_title": "Intel® SSD [total_capacity] GB เร่งความเร็วโดยห&#65279;น่&#65279;ว&#65279;ย&#65279;ค&#65279;ว&#65279;า&#65279;ม&#65279;จำ Intel® Optane™ [optane_memory_size] GB "
                  },
                  {
                    "tr_title": "Intel® SSD [total_capacity] TB ที่เร่งความเร็วด้วยห&#65279;น่&#65279;ว&#65279;ย&#65279;ค&#65279;ว&#65279;า&#65279;ม&#65279;จำ Intel® Optane™ [optane_memory_size] GB"
                  },
                  {
                    "tr_title": "SSD [convertedSSD] GB + HDD&nbsp;[convertedHDD]&nbsp;GB"
                  },
                  {
                    "tr_title": "SSD [convertedSSD] TB + HDD&nbsp;[convertedHDD]&nbsp;GB"
                  },
                  {
                    "tr_title": "SSD [convertedSSD] GB + HDD&nbsp;[convertedHDD]&nbsp;TB"
                  },
                  {
                    "tr_title": "SSD [convertedSSD] TB + HDD&nbsp;[convertedHDD]&nbsp;TB"
                  }
                ],
                "badgeIcons": [
                  {
                    "storageType": "GB",
                    "items": [
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] GB</span>",
                        "tr_badgeSubTitle": "SSD"
                      },
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] GB</span>",
                        "tr_badgeSubTitle": "HDD"
                      },
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] GB</span>",
                        "tr_badgeSubTitle": "<span class='subtitle-value'>SSD<br/><span class='storage-seperator'> +  </span><br/>HDD</span>"
                      }
                    ]
                  },
                  {
                    "storageType": "TB",
                    "items": [
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] TB</span>",
                        "tr_badgeSubTitle": "SSD"
                      },
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] TB</span>",
                        "tr_badgeSubTitle": "HDD"
                      },
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] TB</span>",
                        "tr_badgeSubTitle": "<span class='subtitle-value'>SSD<br/><span class='storage-seperator'> +  </span><br/>HDD</span>"
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "SSD_AND_HDD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "อุปกรณ์จัดเก็บข้อมูล",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12storage.svg",
                "tr_preTitle": "ที่เก็บข้อมูล SSD [convertedSSD] GB + HDD [convertedHDD] GB",
                "tr_preTitle1": "ที่เก็บข้อมูล SSD [convertedSSD] TB + HDD [convertedHDD] GB",
                "tr_preTitle2": "ที่เก็บข้อมูล SSD [convertedSSD] GB + HDD [convertedHDD] TB",
                "tr_preTitle3": "ที่เก็บข้อมูล SSD [convertedSSD] TB + HDD [convertedHDD] TB",
                "titleArray": [
                  {
                    "tr_title": "พื้นที่สำหรับทุกสิ่งบนพีซีของคุณ",
                    "tr_title1": "อุปกรณ์นี้มีพื้นที่จัดเก็บข้อมูลที่&#65279;น่&#65279;า&#65279;ทึ่&#65279;ง",
                    "tr_subtitle": "พีซีนี้มีไดรฟ์ Solid-State พร้อมพื้นที่จัดเก็บข้อมูลขนาด [convertedSSD]&nbsp;GB และฮาร์ดดิสก์ไดรฟ์ขนาด [convertedHDD]&nbsp;GB ซึ่งมอบทั้งความจุขนาดมหาศาลและประสิทธิภาพการจัดเก็บข้อมูลที่รวดเร็วแก่คุณ",
                    "tr_subtitle1": "พีซีนี้มีไดรฟ์ Solid-State พร้อมพื้นที่จัดเก็บข้อมูลขนาด [convertedSSD]&nbsp;TB และฮาร์ดดิสก์ไดรฟ์ขนาด [convertedHDD]&nbsp;GB ซึ่งมอบทั้งความจุขนาดมหาศาลและประสิทธิภาพการจัดเก็บข้อมูลที่รวดเร็วแก่คุณ",
                    "tr_subtitle2": "พีซีนี้มีไดรฟ์ Solid-State พร้อมพื้นที่จัดเก็บข้อมูลขนาด [convertedSSD]&nbsp;GB และฮาร์ดดิสก์ไดรฟ์ขนาด [convertedHDD]&nbsp;TB ซึ่งมอบทั้งความจุขนาดมหาศาลและประสิทธิภาพการจัดเก็บข้อมูลที่รวดเร็วแก่คุณ",
                    "tr_subtitle3": "พีซีนี้มีไดรฟ์ Solid-State พร้อมพื้นที่จัดเก็บข้อมูลขนาด [convertedSSD]&nbsp;TB และฮาร์ดดิสก์ไดรฟ์ขนาด [convertedHDD]&nbsp;TB ซึ่งมอบทั้งความจุขนาดมหาศาลและประสิทธิภาพการจัดเก็บข้อมูลที่รวดเร็วแก่คุณ"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] GB</span>",
                    "tr_badgeTitle1": "<span class='subtitle-value'>ที่เก็บข้อมูล</span><span class ='value'>[capacity] TB</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle-value'>SSD<br/><span class='storage-seperator'> +  </span><br/>HDD</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "อุปกรณ์จัดเก็บข้อมูล",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_storage.svg",
                "badgeUrl2": "assets/images/std12storage.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "เพิ่มความเร็วในการเข้าใช้ที่จัดเก็บข้อมูลขนาดใหญ่ซึ่งมีหน่วยควมจำ Intel® Optane™ ที่มี SSD",
                "tr_title": "ไร้ปัญหาสำหรับไฟล์ขนาดมหึมา",
                "tr_pretitle": "Intel® SSD [total_capacity] GB เร่งความเร็วโดยห&#65279;น่&#65279;ว&#65279;ย&#65279;ค&#65279;ว&#65279;า&#65279;ม&#65279;จำ Intel® Optane™ [optane_memory_size] GB ",
                "tr_pretitle1": "Intel® SSD [total_capacity] TB ที่เร่งความเร็วด้วยห&#65279;น่&#65279;ว&#65279;ย&#65279;ค&#65279;ว&#65279;า&#65279;ม&#65279;จำ Intel® Optane™ [optane_memory_size] GB",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "SSD",
                    "tr_badgeSubTitle": ""
                  }
                ],
                "titleArray": [
                  {
                    "tr_subtitle": "โซลูชันสำหรับที่จัดเก็บข้อมูลรุ่นใหม่นี้ถือเป็นหน่วยความจำรวมระหว่าง Intel® Optane™ และ SSD บนชิปตัวเดียว การทำงานของหน่วยความจำรุ่นนี้:",
                    "tr_title": "หน่วยความจำ INTEL®&nbsp;OPTANE™ ที่มี SSD<br/>คืออะไร"
                  }
                ],
                "panel2BadgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-frequency-badge.png",
                    "tr_badgeTitle": "เปิดไฟล์ที่คุณต้องการได้อย่างรวดเร็ว",
                    "tr_badgeSubTitle": "ระบบจะโหลดไฟล์และโปรแกรมที่ใช้งานบ่อยไว้ล่วงหน้า ช่วยให้คุณมีเวลาสร้างสรรค์งานได้มากขึ้นและลดเวลารอ",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/optane-memory-storage-badge.svg",
                    "tr_badgeTitle": "เพิ่มความเร็วสำหรับที่จัดเก็บข้อมูล",
                    "tr_badgeSubTitle": "คุณจะมีพื้นที่ว่างสำหรับไฟล์สื่อด้วย SSD สมรรถนะสูง",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-time-badge.png",
                    "tr_badgeTitle": "มีการตอบสนองที่รวดเร็วยิ่งขึ้น",
                    "tr_badgeSubTitle": "หน่วยความจำ Intel® Optane™ ที่มี SSD จะเรียนรู้วิธีการทำงานของคุณเพื่อทำให้พีซีมีประสิทธิภาพมากยิ่งขึ้น",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "อุปกรณ์จัดเก็บข้อมูล",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "เก็บสื่อทั้งหมดของคุณไว้ใกล้มือด้วยที่เก็บข้อมูลที่เหลือเฟือและไว้ใจได้",
                "tr_title": "พื้นที่สำหรับภาพถ่าย วิดีโอและเพลงของคุณทั้งหมด"
              }
            }
          ]
        }
      ]
    }
  ],
  "display": [
    {
      "contentType": "TOUCH_SCREEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การแสดงผล",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "",
                "tr_title": "[screenResolution] ล้านพิกเซลเพื่อการปัดและซูมที่น่าตื่นตาตื่นใจ",
                "tr_subtitle": "โต้ตอบกับพีซีของคุณเหมือนเป็นส&#65279;ม&#65279;า&#65279;ร์&#65279;ท&#65279;โ&#65279;ฟ&#65279;นด้วยการควบคุมที่ไม่ยุ่งยากแ&#65279;ล&#65279;ะ&#65279;ร&#65279;า&#65279;ย&#65279;ล&#65279;ะ&#65279;เอียดที่คมชัดสดใสยิ่งขึ้น",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[screenDiagonal]”<br/></span><span class='subtitle-value'>[screenResolutionType]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "ความละเอียด: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "พิกเซล: [screenResolution] ล้าน"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "จอแสดงผล [screenDiagonal]&nbsp;นิ้ว",
                    "tr_badgeSubTitle": "ความสูงหน้าจอ: [screenHeight] นิ้ว",
                    "tr_badgePreTitle": "ความกว้างหน้าจอ: [YY] นิ้ว"
                  },
                  {
                    "badgeUrl": "assets/images/display-touchscreen-badge.svg",
                    "tr_badgeTitle": "จอแสดงผลแบบสัมผัส",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "DISPLAY",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การแสดงผล",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "",
                "tr_title": "ดำดิ่งเข้าไปใน <br/>[screenResolution] ล้านพิกเซล",
                "tr_subtitle": "สิ่งที่สำคัญที่สุดคือพิกเซล พิกเซลที่มากกว่าจะทำให้ภาพของคุณชัดเจนและสดใสมากกว่า",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[screenDiagonal]”<br/></span><span class='subtitle-value'>[screenResolutionType]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "ความละเอียด: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "พิกเซล: [screenResolution] ล้าน"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "จอแสดงผล [screenDiagonal]&nbsp;นิ้ว",
                    "tr_badgeSubTitle": "ความสูงหน้าจอ: [screenHeight] นิ้ว",
                    "tr_badgePreTitle": "ความกว้างหน้าจอ: [YY] นิ้ว"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การแสดงผล",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/display-badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "badgesAndHeadings",
                "tr_title": "[screenDiagonal] นิ้ว <br/>[screenResolutionX] x [screenResolutionY]",
                "tr_pretitle": "หน้าต่างสู่โลกแห่งเกม",
                "tr_subtitle": "เหมือนกับกรณีของทีวี สิ่งที่คุณสนใจเป็นหลักสำหรับจ&#65279;อ&#65279;แ&#65279;ส&#65279;ด&#65279;งผลที่ใช้เล่นเกมก็คือ ขนาดและความละเอียด",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "ความละเอียด: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "พิกเซล: [screenResolution] ล้าน"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "จอแสดงผล [screenDiagonal]&nbsp;นิ้ว",
                    "tr_badgeSubTitle": "ความสูงหน้าจอ: [screenHeight] นิ้ว",
                    "tr_badgePreTitle": "ความกว้างหน้าจอ: [screenWidth] นิ้ว"
                  },
                  {
                    "badgeUrl": "assets/images/display-touchscreen-badge.svg",
                    "tr_badgeTitle": "จอแสดงผลแบบสัมผัส"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "4K",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การแสดงผล",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "4K",
                "tr_title": "อุปกรณ์นี้มีจอแสดงผลที่น่าประทับใจ",
                "tr_subtitle": "ด้วยจำนวนพิกเซลที่มากกว่า HD ถึงแปดเท่า วิดีโอและเกมของคุณจะให้ความคมชัดและสีสันในระดับที่ไม่เคยมีมาก่อน",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "4K",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "ความละเอียด: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "พิกเซล: [screenResolution] ล้าน"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "จอแสดงผล [screenDiagonal]&nbsp;นิ้ว",
                    "tr_badgeSubTitle": "ความสูงหน้าจอ: [screenHeight] นิ้ว",
                    "tr_badgePreTitle": "ความกว้างหน้าจอ: [YY] นิ้ว"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การแสดงผล",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "[screenResolution] ล้านพิกเซลให้คุณแตะ ปัด และสัมผัส",
                    "tr_subTitle": "ดูและโต้ตอบกับสิ่งต่างๆ ที่คุณชื่นชอบ ด้วยรายละเอียดที่คมชัดและสดใสขึ้น"
                  },
                  {
                    "tr_title": "[screenResolution] ล้านพิกเซลให้คุณยกระดับโลกดิจิทัลของคุณ",
                    "tr_subTitle": "สิ่งที่สำคัญที่สุดคือพิกเซล พิกเซลที่มากกว่าจะทำให้ภาพของคุณชัดเจนและสดใสมากกว่า"
                  },
                  {
                    "tr_title": "อุปกรณ์นี้มีจอแสดงผลที่น่าประทับใจ",
                    "tr_subTitle": "ด้วยจำนวนพิกเซลที่มากกว่า HD เกือบสี่เท่า วิดีโอและเกมของคุณจะมี<br/>ความคมชัดและสีสันในระดับใหม่"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "connectivity": [
    {
      "contentType": "VERSION_3",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การเชื่อมต่อ",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "เทคโนโลยี Thunderbolt™ 3 ให้คุณเชื่อมต่อแท่นชาร์จ จอแสดงผล หรืออุปกรณ์ข้อมูลใดๆ ได้อย่างรวดเร็วที่สุดและอเนกประสงค์ที่สุด",
                "tr_title": "หนึ่งพอร์ต จัดการเบ็ดเสร็จ",
                "tr_title1": "หนึ่งพอร์ต จัดการเบ็ดเสร็จ",
                "titleArray": [
                  {
                    "tr_title": "ฉันจะใช้ประโยชน์จากเทคโนโลยี Thunderbolt™ 3 อย่างไร",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เทคโนโลยี Thunderbolt™&nbsp;3"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-4k.png",
                    "tr_badgeTitle": "จอภาพ 4K",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เชื่อมต่อจอแสดงผลที่มีความละเอียด ความคมชัด และสีสันอันน่าทึ่ง"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-graphic.png",
                    "tr_badgeTitle": "การ์ดแสดงผลภายนอก",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "ทำให้พีซีของคุณทำงานด้านกราฟิกได้ดีขึ้นอย่างมากในทันที"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-networking.png",
                    "tr_badgeTitle": "เครือข่ายที่รวดเร็ว",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "มอบการเชื่อมต่อระหว่างเครื่องที่รวดเร็ว"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การเชื่อมต่อ",
                "detailBGUrl": "",
                "tr_subtitle": "เทคโนโลยี Thunderbolt™ 3 ถ่ายโอนข้อมูลด้วยอัตราความเร็วที่สูงกว่า USB ทั่วไป ช่วยให้คุณย้ายไฟล์ได้อย่างรวดเร็ว และเชื่อมต่ออุปกรณ์ต่อพ่วงได้อย่างรวดเร็วและง่ายดาย เช่น จอภาพหลายจอหรือการ์ดกราฟิกต่างๆ",
                "tr_title": "เทคโนโลยี Thunderbolt™&nbsp;3",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_pretitle": "ถ่ายโอนข้อมูลรวดเร็วมาก",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "USB* 2.0",
                    "tr_badgeSubTitle": "480 Mbps",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "USB* 3.0",
                    "tr_badgeSubTitle": "5 Gbps",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "เทคโนโลยี Thunderbolt™&nbsp;3",
                    "tr_badgeSubTitle": "40 Gbps",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_4",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การเชื่อมต่อ",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "<ul><li>หนึ่งพอร์ตและหนึ่งสายอเนกประสงค์สามารถรองรับอุปกรณ์เสริมที่คุณใช้งานบ่อยได้ทั้งหมด</li> <li>การชาร์จโน้ตบุ๊กที่เชื่อถือได้</li> <li>อุ่นใจกับการรับรองที่เพียบพร้อม</li></ul>",
                "tr_title": "การเชื่อมต่อสาย<br/>ที่อเนกประสงค์<br/>อย่างแท้จริง",
                "tr_title1": "การเชื่อมต่อสายที่อเนกประสงค์อย่างแท้จริง",
                "tr_noteSection": "<sup>†</sup>ขึ้นอยู่กับข้อกำหนดของข้อมูลจำเพาะขั้นต่ำ",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "tr_title": "ฉันจะใช้ประโยชน์จากเทคโนโลยี THUNDERBOLT™&nbsp;4&nbsp;ได้อย่างไร",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เทคโนโลยี Thunderbolt™&nbsp;4"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-create.png",
                    "tr_badgeTitle": "สร้าง",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เชื่อมต่อจอภาพภายนอกและอุปกรณ์จัดเก็บข้อมูลที่รวดเร็วเพื่อดูและแก้ไขรูปภาพและวิดีโอ"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "แท่นเชื่อมต่อ",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "จัดโต๊ะทำงานให้เรียบง่ายและเป็นระเบียบด้วยการเชื่อมต่อแล็ปท็อปของคุณเข้ากับอุปกรณ์เสริมทั้งหมดด้วยสายเพียงเส้นเดียว"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-game.png",
                    "tr_badgeTitle": "เกม",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เพิ่มความจุ SSD และ HDD ให้มากขึ้นด้วยความเร็วสูงสุด 3,000 MB ต่อวินาทีสำหรับจัดเก็บไลบรารีเกมและไฟล์มีเดีย"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "ประสิทธิภาพสูงสุด<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เร็วกว่า USB* 3.2 ถึง 4 เท่า <br/>เร็วกว่า HDMI* 2 ถึง 2 เท่า"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การเชื่อมต่อ",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "เพลิดเพลินไปกับประสิทธิภาพที่น่าทึ่งเช่นเดียวกันของเทคโนโลยี Thunderbolt™ 3 ด้วยความสามารถที่ยอดเยี่ยมกว่าที่ให้คุณเชื่อมต่อได้งา่ยดาย และใช้แท่น จอภาพ อุปกรณ์จัดเก็บข้อมูลที่รวดเร็ว Thunderbolt™ หรืออุปกรณ์เสริม USB*",
                "tr_title": "เทคโนโลยี Thunderbolt™&nbsp;4",
                "tr_pretitle": "การเชื่อมต่อสายที่อเนกประสงค์อย่างแท้จริง",
                "tr_noteSection": "<sup>†</sup>ขึ้นอยู่กับข้อกำหนดของข้อมูลจำเพาะขั้นต่ำ",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/thunderbolt-icon.png",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "สายอเนกประสงค์ Thunderbolt™ 4 สายเดียวสามารถแทนที่สายเคเบิล USB-C* ทั้งหมดของคุณเพื่อให้เลือกสายได้อย่างง่ายดายและรวดเร็ว"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "แท่นชาร์จเทคโนโลยี Thunderbolt™ 4 มาพร้อมพอร์ต Thunderbolt™ ถึง 4 พอร์ตเพิ่มความยืดหยุ่นในการเชื่อมต่ออุปกรณ์เสริมของคุณ"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "ประสิทธิภาพสูงสุด<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เร็วกว่า USB* 3.2 ถึง 4 เท่า <br/>เร็วกว่า HDMI* 2 ถึง 2 เท่า"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "EVO",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การเชื่อมต่อ",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "<ul><li>หนึ่งพอร์ตและหนึ่งสายอเนกประสงค์สามารถรองรับอุปกรณ์เสริมที่คุณใช้งานบ่อยได้ทั้งหมด</li> <li>การชาร์จโน้ตบุ๊กที่เชื่อถือได้</li> <li>อุ่นใจกับการรับรองที่เพียบพร้อม</li></ul>",
                "tr_title": "เปิดประสบการณ์แบบเต็มพิกัดกับอุปกรณ์เสริม Thunderbolt™",
                "tr_noteSection": "<sup>†</sup>ขึ้นอยู่กับข้อกำหนดของข้อมูลจำเพาะขั้นต่ำ",
                "badgeUrl": "assets/images/evo_thunderbolt4.png",
                "tileBG": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "tr_title": "ฉันจะใช้ประโยชน์จากเทคโนโลยี THUNDERBOLT™&nbsp;4&nbsp;ได้อย่างไร",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/thunderbolt-create.png",
                    "tr_badgeTitle": "สร้าง",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เชื่อมต่อจอภาพภายนอกและอุปกรณ์จัดเก็บข้อมูลที่รวดเร็วเพื่อดูและแก้ไขรูปภาพและวิดีโอ"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "แท่นเชื่อมต่อ",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "จัดโต๊ะทำงานให้เรียบง่ายและเป็นระเบียบด้วยการเชื่อมต่อแล็ปท็อปของคุณเข้ากับอุปกรณ์เสริมทั้งหมดด้วยสายเพียงเส้นเดียว"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-game.png",
                    "tr_badgeTitle": "เกม",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เพิ่มความจุ SSD และ HDD ให้มากขึ้นด้วยความเร็วสูงสุด 3,000 MB ต่อวินาทีสำหรับจัดเก็บไลบรารีเกมและไฟล์มีเดีย"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "ประสิทธิภาพสูงสุด<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "เร็วกว่า USB* 3.2 ถึง 4 เท่า <br/>เร็วกว่า HDMI* 2 ถึง 2 เท่า"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_5",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "การเชื่อมต่อ",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "gaming-panelType1",
                "tr_subtitle": "สัมผัสประโยชน์ของเทคโนโลยี Thunderbolt™ 5",
                "tr_title": "การเชื่อมต่อที่ง่ายดาย เชื่อถือได้ และรวดเร็วอย่างยิ่งยวดที่ทำได้ทุกอย่าง!",
                "tr_title1": "การเชื่อมต่อที่ง่ายดาย เชื่อถือได้ และรวดเร็วอย่างยิ่งยวดที่ทำได้ทุกอย่าง!",
                "tr_noteSection": "",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "imgUrl": "assets/images/unrivaled_icon.svg",
                    "tr_title": "ความเรียบง่ายอย่างไร้คู่แข่ง",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/reliable_icon.svg",
                    "tr_title": "การเชื่อมต่อที่เชื่อถือได้",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/performance_icon.svg",
                    "tr_title": "ประสิทธิภาพสูงสุด",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/compatibility_icon.svg",
                    "tr_title": "ความเข้ากันได้แบบครบวงจร",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "คอมพิวเตอร์ที่มีเทคโนโลยี THUNDERBOLT™ 5 ช่วยให้การถ่ายโอนข้อมูลเป็นไปอย่างรวดเร็วที่สุด",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "คอมพิวเตอร์ที่มีเทคโนโลยี THUNDERBOLT™ 5 ช่วยให้การถ่ายโอนข้อมูลเป็นไปอย่างรวดเร็วที่สุด",
                  "panelType2": "enhancement-compare",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "เทคโนโลยี Thunderbolt™ 5",
                      "tr_badgeSubTitle": "6,000Mbps"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "เทคโนโลยี Thunderbolt™&nbsp;4",
                      "tr_badgeSubTitle": "3,000Mbps"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "USB4*",
                      "tr_badgeSubTitle": "1,500Mbps"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "USB 3.2",
                      "tr_badgeSubTitle": "450Mbps"
                    }
                  ]
                },
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/thunderbolt_panel1.png",
                    "tr_title": "",
                    "tr_subtitle": "ใช้<strong> Thunderbolt™ Share</strong><br> เพื่อถ่ายโอนไฟล์และแชร์จอภาพ  จัดเก็บข้อมูล และทรัพยากรอื่น ๆ ได้อย่างง่ายดายด้วยความเร็วปานสายฟ้า<sup>53</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/thunderbolt_panel2.png",
                    "tr_title": "",
                    "tr_subtitle": "<strong>จัดพื้นที่ทำงานอย่างชาญฉลาดด้วยสายเคเบิลเพียงเส้นเดียวที่เชื่อมต่อกับแท่นเชื่อมต่อและอุปกรณ์เสริม</strong><br><br/>คอมพิวเตอร์ สายเคเบิล และอุปกรณ์เสริมได้รับการรับรองเพื่อให้มั่นใจว่าเป็น<span class ='expandable_bold_text'>โซลูชันครบวงจรที่เชื่อถือได้</span>",
                    "align": "right"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "wifi": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "badgeUrl": "",
                "tr_subtitle": "ประเภท Wi‑Fi ที่ใช้บ่อยที่สุด:",
                "tr_title": "เข้าใจมาตรฐาน Wi‑Fi",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 ช่วยให้ได้ความเร็วมากขึ้น แม้ในขณะที่มีผู้ใช้งานมากมายใช้สัญญาณเดียวกัน<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6 (Gig+)",
                    "tr_badgeSubTitle": "นวัตกรรม Wi-Fi ล่าสุดจาก Intel ให้คุณเชื่อมต่อได้เร็วกว่ากิกะบิต Wi-Fi แม้มีผู้ใช้งานจำนวนมากใช้สัญญาณเดียวกัน<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "Wi-Fi 6E เป็นความก้าวหน้าด้าน Wi-Fi ที่ยิ่งใหญ่ที่สุดในรอบ 20 ปี โดยเปิดช่องสัญญาณความเร็วสูงใหม่ เพื่อยกระดับประสิทธิภาพและความเสถียร พร้อมกับลดสิ่งรบกวนให้น้อยลง"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 ช่วยให้ได้ความเร็วมากขึ้น แม้ในขณะที่มีผู้ใช้งานมากมายใช้สัญญาณเดียวกัน<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/standard_wifi_killer_AX1675_badge.svg",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "ข้อดีทั้งหมดของ Wi-Fi 6E ผนวกด้วยกลไกการจัดระดับความสำคัญ Intel® Killer™ ซึ่งสลับแบนด์วิดธ์ไปให้เว็บไซต์และแอปพลิเคชันที่ต้องการใช้มากที่สุด"
                  },
                  {
                    "badgeUrl": "assets/images/Wi-fi-6E-badge.svg",
                    "tr_badgeTitle": "Wi‑Fi 6E",
                    "tr_badgeSubTitle": "ด้วยการแย่งสัญญาณกันน้อยลงในช่องสัญญาณความเร็วสูง คุณจะได้รับประสิทธิภาพและความเสถียรที่ดีขึ้น"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 ช่วยให้ได้ความเร็วมากขึ้น แม้ในขณะที่มีผู้ใช้งานมากมายใช้สัญญาณเดียวกัน<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 6 (Gig+)",
                    "tr_badgeSubTitle": "ด้วยสัญญาณรบกวนที่น้อยลงจาก Wi-Fi 6 และความสามารถแบบอัจฉริยะของกลไกการจัดระดับความสำคัญ Intel® Killer™ ประสบการณ์ออนไลน์ของคุณจะเร็วขึ้นและตอบสนองไวขึ้น⁶"
                  },
                  {
                    "badgeUrl": "assets/images/standard_generic_wifi.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "ด้วยการแย่งสัญญาณกันน้อยลงในช่องสัญญาณความเร็วสูง คุณจะได้รับประสิทธิภาพและความเสถียรที่ดีขึ้น"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-7-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 7 (5 Gig)",
                    "tr_badgeSubTitle": "ความเร็ว Wi-Fi สำหรับพีซีที่มากกว่า 5 Gbps พร้อมเวลาแฝงต่ำเป็นพิเศษที่สม่ำเสมอ - แชร์ไฟล์ได้ในไม่กี่วินาทีแทนที่จะนานหลายนาที"
                  },
                  {
                    "badgeUrl": "assets/images/killerwifi-7-badge.png",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 7",
                    "tr_badgeSubTitle": "Intel® Killer™ Wi-Fi 7 (5 Gig) เป็นเทคโนโลยีล่าสุดที่ให้ความน่าเชื่อถือ “สูงสุด” ความหน่วงต่ำ และความเร็วผ่านการเพิ่มประสิทธิภาพเครือข่ายบนพื้นฐาน AI"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 ช่วยให้ได้ความเร็วมากขึ้น แม้ในขณะที่มีผู้ใช้งานมากมายใช้สัญญาณเดียวกัน<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "Intel® Wi-Fi 6E (Gig+) เร่งความเร็วได้มากกว่า 1Gbps ด้วยความน่าเชื่อถือ และความหน่วงต่ำด้วยการใช้ช่องสัญญาณ 6GHz"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "ประสิทธิภาพ ความจุ และความเร็วที่ดีขึ้น เมื่อเทียบกับ Wi-Fi 5 บนเครือข่ายที่หนาแน่น"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_subtitle": "เชื่อมต่อได้ดีขึ้นด้วย Wi‑Fi [XX] และเพลิดเพลินไปกับอินเทอร์เน็ตที่มีความเร็วเพิ่มขึ้น<sup>†</sup> และเชื่อถือได้มากขึ้น",
                "tr_title": "ได้ทั้งระยะการทำงานที่ดีขึ้นและความเร็วที่เพิ่มขึ้น",
                "tr_noteSection": "<sup>†</sup>ความเร็วและ/หรือระยะเชื่อมต่อไร้สายที่แท้จริงอาจแตกต่างกันไป",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi [XX]"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "ในยุคของเกมแบบผู้เล่นหลายคนหรือเกมออนไลน์ การเชื่อมต่ออย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งมีความสำคัญมากขึ้นอย่างที่ไ&#65279;ม่&#65279;เ&#65279;ค&#65279;ย&#65279;มีมาก่อน นอกเหนือจากความเร็วแล้ว คุณยังต้องการสัญญาณไร้สายที่รักษาความเร็วดังกล่าวได้อย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งอีกด้วย",
                "tr_title": "[XX]",
                "tr_pretitle": "การเชื่อมต่อคือหัวใจสำคัญ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-6E-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "เชื่อมต่อกับเราเตอร์ Intel® Wi‑Fi 6 (Gig+) ไปยัง Wi‑Fi 6 พร้อมรองรับช่องสัญญาณ 160 MHz เพื่อให้สามารถเชื่อมต่อได้รวดเร็วขึ้นและเชื่อถือได้มากขึ้นสำหรับผู้ใช้งานจำนวนมากขึ้น",
                "tr_title": "ความเร็วเพิ่มขึ้นเกือบ 3 เท่าด้วย Intel® <span class='no-warp'>Wi-Fi 6 </span> (GIG+)<sup>†</sup>",
                "tr_noteSection": "<sup>†</sup>มากกว่า AC Wi‑Fi มาตรฐาน คุณสมบัติที่เลือกมาพร้อมกับ SKU บางรายการเท่านั้น ตรวจสอบรายละเอียดกับผู้ผลิต สำหรับข้อมูลเพิ่มเติมเกี่ยวกับ Wi‑Fi โปรดไปที่ intel.com/wifi6disclaimers"
              }
            },
            {
              "deviceType": "MODEL_AX101",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-6-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Intel® Wi-Fi 6 สองย่านความถี่ระดับเริ่มต้น รองรับประสิทธิภาพการทำงานที่ดีขึ้นเพื่อตอบโจทย์ความต้องการขั้นพื้นฐานด้านการเชื่อมต่อ เช่น อีเมลและการท่องอินเทอร์เน็ตบนเครือข่ายที่หนาแน่น<sup>9</sup>",
                "tr_title": "Essential Wi‑Fi",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "ในยุคของเกมแบบผู้เล่นหลายคนหรือเกมออนไลน์ การเชื่อมต่ออย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งมีความสำคัญมากขึ้นอย่างที่ไ&#65279;ม่&#65279;เ&#65279;ค&#65279;ย&#65279;มีมาก่อน นอกเหนือจากความเร็วแล้ว คุณยังต้องการสัญญาณไร้สายที่รักษาความเร็วดังกล่าวได้อย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งอีกด้วย",
                "tr_title": "[XX]",
                "tr_pretitle": "การเชื่อมต่อคือหัวใจสำคัญ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6E",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                "tr_subtitle": "การมีช่องสัญญาณ Wi‑Fi ใหม่เหล่านี้หมายความว่า คุณไม่จำเป็นต้องแบ่งปันแบ&#xfeff;น&#xfeff;ด์&#xfeff;วิ&#xfeff;ด&#xfeff;ท์กับอุปกรณ์รุ่นเก่าในละแวกบ้านคุณ ซึ่งทำให้คุณสตรีมได้อย่างราบรื่น ท่องเว็บได้อย่างรวดเร็ว และทำงานและเรียนรู้จากระยะไกลได้อย่างราบรื่น",
                "tr_title": "เชื่อมต่อได้โดยไม่ต้องไปแย่งชิงกับใคร",
                "tr_noteSection": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHERS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                "tr_subtitle": "เชื่อมต่อได้ดีขึ้นด้วย [XX] และเพลิดเพลินไปกับอินเทอร์เน็ตที่เร็วขึ้น<sup>†</sup> และเชื่อถือได้มากขึ้น",
                "tr_title": "ได้ทั้งระยะการทำงานที่ดีขึ้นและความเร็วที่เพิ่มขึ้น",
                "tr_noteSection": "<sup>†</sup>ความเร็วและ/หรือระยะเชื่อมต่อไร้สายที่แท้จริงอาจแตกต่างกันไป",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "ในยุคของเกมแบบผู้เล่นหลายคนหรือเกมออนไลน์ การเชื่อมต่ออย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งมีความสำคัญมากขึ้นอย่างที่ไ&#65279;ม่&#65279;เ&#65279;ค&#65279;ย&#65279;มีมาก่อน นอกเหนือจากความเร็วแล้ว คุณยังต้องการสัญญาณไร้สายที่รักษาความเร็วดังกล่าวได้อย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งอีกด้วย",
                "tr_title": "[graphic_display]",
                "tr_pretitle": "การเชื่อมต่อคือหัวใจสำคัญ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Wi‑Fi ในตัวที่เร็วสุดขีด",
                "tr_subtitle": "ถอดปลั๊กแต่สามารถเชื่อมต่อกับโลกออนไลน์ของคุณได้ตลอดเวลา"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6E_KILLER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1675_badge.svg",
                "tr_subtitle": "การเล่นเกมออนไลน์ได้รับการพัฒนาอย่างจริงจัง ด้วยเลนเฉพาะความเร็วสูง เพื่อลดการขัดจังหวะ และมาพร้อมกับกลไกการจัดลำดับความสำคัญ Intel® Killer™ ที่ช่วยให้การเล่นเกมกลายเป็นสิ่งสำคัญอันดับหนึ่งเสมอ",
                "tr_title": "ก้าวล้ำนำหน้าคู่แข่ง",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/[image_path].png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "การเล่นเกมออนไลน์ได้รับการพัฒนาอย่างจริงจัง ด้วยเลนเฉพาะความเร็วสูง เพื่อลดการขัดจังหวะ และมาพร้อมกับกลไกการจัดลำดับความสำคัญ Intel® Killer™ ที่ช่วยให้การเล่นเกมกลายเป็นสิ่งสำคัญอันดับหนึ่งเสมอ",
                "tr_title": "[XX]",
                "tr_pretitle": "ก้าวล้ำนำหน้าคู่แข่ง",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_6E",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/[image_path].png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "ด้วยเลนความเร็วสูงที่ให้มาเป็นพิเศษช่วยลดการรบกวน เน้นการเล่นเกมก่อนสิ่งอื่น นี่คือการเล่นเกมออนไลน์ที่ได้รับการอัปเกรดอย่างแท้จริง",
                "tr_title": "[XX]",
                "tr_pretitle": "ก้าวล้ำนำหน้าคู่แข่ง",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6_KILLER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                "tr_subtitle": "Intel® Killer™ Wi‑Fi จะเร่งความเร็วการรับส่งข้อมูลเครือข่ายโดยอัตโนมัติให้แอปพลิเคชันที่ต้องใช้มากที่สุด เพื่อให้วิดีโอที่คุณสตรีมมีรายละเอียดภาพคมชัดและมีบัฟเฟอร์น้อยลง",
                "tr_title": "วิธีเชื่อมต่อที่ทั้งเร็วและฉ&#xfeff;ล&#xfeff;า&#xfeff;ด&#xfeff;ก&#xfeff;ว่&#xfeff;า⁶",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "ในยุคของเกมแบบผู้เล่นหลายคนหรือเกมออนไลน์ การเชื่อมต่ออย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งมีความสำคัญมากขึ้นอย่างที่ไ&#65279;ม่&#65279;เ&#65279;ค&#65279;ย&#65279;มีมาก่อน นอกเหนือจากความเร็วแล้ว คุณยังต้องการสัญญาณไร้สายที่รักษาความเร็วดังกล่าวได้อย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งอีกด้วย",
                "tr_title": "[XX]",
                "tr_pretitle": "การเชื่อมต่อคือหัวใจสำคัญ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "KILLER_VERSION_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_subtitle": "เชื่อมต่อได้ดีขึ้นด้วย Wi-Fi 5 และเพลิดเพลินไปกับอินเทอร์เน็ตที่มีความเร็วเพิ่มขึ้น<sup>†</sup>และเชื่อถือได้มากขึ้น",
                "tr_title": "ได้ทั้งระยะการทำงานที่ดีขึ้นและความเร็วที่เพิ่มขึ้น",
                "tr_noteSection": "<sup>†</sup>ความเร็วและ/หรือระยะเชื่อมต่อไร้สายที่แท้จริงอาจแตกต่างกันไป",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "THIRDPARTY_6E",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "ในยุคของเกมแบบผู้เล่นหลายคนหรือเกมออนไลน์ การเชื่อมต่ออย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งมีความสำคัญมากขึ้นอย่างที่ไ&#65279;ม่&#65279;เ&#65279;ค&#65279;ย&#65279;มีมาก่อน นอกเหนือจากความเร็วแล้ว คุณยังต้องการสัญญาณไร้สายที่รักษาความเร็วดังกล่าวได้อย่างต่&#65279;อ&#65279;เ&#65279;นื่&#65279;อ&#65279;งอีกด้วย",
                "tr_title": "[XX]",
                "tr_pretitle": "ก้าวล้ำนำหน้าคู่แข่ง",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-7-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "คุณสมบัติ Wi-Fi 7 จะสร้างและยกระดับ Wi-Fi รุ่นก่อนหน้า ซึ่งจะหมายถึงไม่เพียงแต่ความเร็วมากขึ้น แต่ยังปรับปรุงการตอบสนองและความน่าเชื่อถืออย่างมากสำหรับประสบการณ์ของผู้บริโภคที่ดื่มด่ำและเทคโนโลยีในอนาคตอันซับซ้อน",
                "tr_title": "ระบบเครือข่ายพีซีที่เทียบเท่าการต่อสาย",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "คุณสมบัติ Wi-Fi 7 จะสร้างและยกระดับ Wi-Fi รุ่นก่อนหน้า ซึ่งจะหมายถึงไม่เพียงแต่ความเร็วมากขึ้น แต่ยังปรับปรุงการตอบสนองและความน่าเชื่อถืออย่างมากสำหรับประสบการณ์ของผู้บริโภคที่ดื่มด่ำและเทคโนโลยีในอนาคตอันซับซ้อน",
                "tr_title": "[XX]",
                "tr_pretitle": "พลิกโฉมประสบการณ์ใช้งานของผู้ใช้",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "KILLER_VERSION_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/killerwifi-7-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "",
                "tr_title": "ความเร็ว เวลาแฝง และความน่าเชื่อถือที่ปรับปรุงดีขึ้นผ่านการเพิ่มประสิทธิภาพเครือข่ายบนพื้นฐาน AI",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/killerwifi-7-badge.png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "ความเร็ว เวลาแฝง และความน่าเชื่อถือที่ปรับปรุงดีขึ้นผ่านการเพิ่มประสิทธิภาพเครือข่ายบนพื้นฐาน AI",
                "tr_title": "[XX]",
                "tr_pretitle": "การตอบสนองราวกับมีสาย",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "battery": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "แบตเตอรี่",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-power-icon.png",
                    "tr_badgeTitle": "มีวิธีวัดอย่างไร",
                    "tr_badgeSubTitle": "ผู้ผลิตส่วนใหญ่ระบุอายุการใช้งานแบตเตอรี่ของตนเป็นจำนวนชั่วโมง แม้ว่าการคำนวณนี้จะไม่ถูกต้อง 100% แต่น่าจะช่วยคุณเปรียบเทียบอายุการใช้งานแบตเตอรี่ของพีซีเครื่องหนึ่งกับอีกเครื่องได้"
                  }
                ],
                "tr_subtitle": "",
                "tr_title": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "แบตเตอรี่",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/battery-badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "สำหรับการเล่นเกมขณะเดินทาง",
                "tr_subtitle": "ด้วยพลังของแล็ปท็อปสำหรับเล่นเกมในปัจจุบัน ไม่มีเหตุผลที่คุณจะต้องนั่งติดโต๊ะอีกต่อไป ตอนนี้คุณสามารถพกพาเกมติดตัวไปได้ทุกที่",
                "tr_title": "อายุการใช้งานแบตเตอรี่ [Dynamic.battery.values.hours] ชั่วโมง"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BATTERYLIFE",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Intel® Core™ Ultra: ก้าวสู่มาตรฐานใหม่ของแบตเตอรี่แล็ปท็อป",
                "detailBGUrl": "assets/images/battery_life_bg.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "bannerImgUrl": "assets/images/battery_life_banner_img.svg",
                "tr_subtitle": "ก้าวสู่มาตรฐานใหม่ของแบตเตอรี่แล็ปท็อป",
                "tr_title": "โปรเซสเซอร์ Intel® Core™ Ultra 200V ซีรีส์",
                "tr_noteSection": "กล่าวถึงโปรเซสเซอร์ Intel® Core™ Ultra 200V ซีรีส์ในเดือนสิงหาคม 2025 โดยอ้างอิงสถาปัตยกรรมอันเป็นเอกลักษณ์และระยะเวลาการใช้งานแบตเตอรี่ที่น่าทึ่งของโปรเซสเซอร์รุ่นนี้ ซึ่งวัดบนแล็ปท็อปชั้นนำ<br/>ดูรายละเอียดได้ที่ www.Intel.com/PerformanceIndex<br/>ไม่มีผลิตภัณฑ์ใดที่จะปลอดภัยอย่างสมบูรณ์แบบ © Intel Corporation",
                "tileBG": "assets/images/batteryLifeTile_img.svg",
                "titleArray": [
                  {
                    "tr_title": "ทำสิ่งต่าง ๆ ได้มากขึ้นเพียงชาร์จครั้งเดียว",
                    "tr_subTitle": ""
                  },
                  {
                    "tr_title": "สัมผัสประสิทธิภาพเต็มพิกัด แม้ไม่เสียบปลั๊ก",
                    "tr_subTitle": ""
                  },
                  {
                    "tr_title": "สร้างทุกสิ่งที่จุดประกายในตัวคุณได้อย่างไร้ขีดจำกัด",
                    "tr_subTitle": ""
                  }
                ],
                "badgeUrl": "assets/images/badges/battery_life_badge.svg",
                "tr_badgeTitle": "นี่แหละพลังของ <span class='battery_highlight'>Intel Inside®</span>"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GOOD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "แบตเตอรี่",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "ถอดปลั๊กและใช้แอป เล่นเกม และฟังเพลงได้อย่างต่อเนื่องหลายชั่วโมง",
                "tr_title": "สตรีมได้ถึง [XX] ชั่วโมงด้วยการชาร์จเพียงครั้งเดียว<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>อิงตามอายุการใช้งานแบตเตอรี่ที่ผู้ผลิตพีซีระบุ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] ชั่วโมง",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BETTER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "แบตเตอรี่",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "ถอดปลั๊กและใช้แอป เล่นเกม และฟังเพลงได้อย่างต่อเนื่องหลายชั่วโมง",
                "tr_title": "ใช้งานขณะเดินทางได้นานถึง [Dynamic.battery.values.hours] ชั่วโมง<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>อิงตามอายุการใช้งานแบตเตอรี่ที่ผู้ผลิตพีซีระบุ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] ชั่วโมง",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BEST",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "แบตเตอรี่",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "ถอดปลั๊กและใช้แอป เล่นเกม และฟังเพลงได้อย่างต่อเนื่องหลายชั่วโมง",
                "tr_title": "ใช้งานได้นานตลอดวัน [Dynamic.battery.values.hours] ชั่วโมงด้วยการชาร์จเพียงครั้งเดียว<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>อิงตามอายุการใช้งานแบตเตอรี่ที่ผู้ผลิตพีซีระบุ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] ชั่วโมง",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "แบตเตอรี่",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/battery-badge.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "พีซีนี้ปรับประสิทธิภาพอายุการใช้งานแบตเตอรี่ของคุณให้ยาวนานขึ้นและให้อายุการใช้งานแบตเตอรี่ยาวนานอย่างน้อย 4 ชั่วโมงเมื่อชาร์จไฟ 30 นาที<sup>4</sup>",
                "tr_title": "พึ่งพาปลั๊กไฟน้อยลงด้วยระยะเวลาการใช้งานแบตเตอรี่ [Dynamic.battery.values.hours] ชั่วโมง<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>อิงตามอายุการใช้งานแบตเตอรี่ที่ผู้ผลิตพีซีระบุ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] ชั่วโมง",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "headerTabs": [
    {
      "tabName": "homepage",
      "headerDetails": {
        "tr_specTitle": "หน้าหลัก",
        "targetURL": "Home",
        "iconURL": "assets/images/home.svg"
      }
    },
    {
      "tabName": "why_this_pc",
      "headerDetails": {
        "tr_specTitle": "ทำไมต้องพีซีนี้",
        "targetURL": "WhyThisPC",
        "iconURL": "assets/images/whythispc.svg"
      }
    },
    {
      "tabName": "pc_specs",
      "headerDetails": {
        "tr_specTitle": "ดูข้อมูลจำเพาะทั้งหมด",
        "targetURL": "PcSpec",
        "iconURL": "assets/images/pcspecs.svg"
      }
    },
    {
      "tabName": "remote",
      "headerDetails": {
        "tr_specTitle": "ระยะไกล",
        "targetURL": "",
        "iconURL": "assets/images/Frame_3468.svg"
      }
    },
    {
      "tabName": "mobile",
      "headerDetails": {
        "tr_specTitle": "มือถือ",
        "targetURL": "",
        "iconURL": "assets/images/Frame_3468.svg"
      }
    },
    {
      "tabName": "legal",
      "headerDetails": {
        "tr_specTitle": "กฎหมาย",
        "tr_paragraph_array": [
          "ซอฟต์แวร์และเวิร์คโหลดที่ใช้ในการทดสอบประสิทธิภาพจะได้รับการปรับให้ได้ประสิทธิภาพสูงสุดเฉพาะสำหรับไมโครโปรเซสเซอร์ Intel® เท่านั้น การทดสอบประสิทธิภาพ เช่น SYSmark* และ MobileMark* ถูกประเมินโดยใช้ระบบคอมพิวเตอร์ ส่วนประกอบ และฟังก์ชันที่เฉพาะเจาะจง การเปลี่ยนแปลงปัจจัยอันใดอันหนึ่ง อาจส่งผลให้เกิดผลลัพธ์แตกต่างกัน คุณควรศึกษาข้อมูลอื่นๆ ร่วมกับการทดสอบประสิทธิภาพ เพื่อช่วยให้คุณประเมินผลประกอบการตัดสินใจซื้อได้อย่างรอบคอบ รวมถึงประสิทธิภาพของผลิตภัณฑ์ดังกล่าวเมื่อทำงานร่วมกับผลิตภัณฑ์อื่น หากต้องการข้อมูลเพิ่มเติมเกี่ยวกับประสิทธิภาพและผลการวัดประสิทธิภาพ โปรดไปที่ www.intel.com/benchmarks",
          "¹ผลิตภัณฑ์ Intel® Wi-Fi 6 (Gig+) รองรับช่องสัญญาณเสริม 160 MHz ช่วยเพิ่มความเร็วสูงสุดที่เป็นไปได้ในทางทฤษฎี (2402 Mbps) สำหรับผลิตภัณฑ์ 2x2 802.11ax PC Wi-Fi ทั่วไป ผลิตภัณฑ์ Intel® Wi-Fi 6 (Gig+) ระดับพรีเมียมให้ความเร็วสูงสุดตามทฤษฎี 2-4 เท่า เมื่อเทียบกับผลิตภัณฑ์ 2x2 (1201 Mbps) หรือ 1x1 (600 Mbps) 802.11ax PC Wi-Fi มาตรฐานซึ่งรองรับข้อกำหนดแบบบังคับของช่อง 80 MHz เท่านั้น",
          "²การแนะนำเพื่อจุดประสงค์ในการให้ข้อมูลเท่านั้น โปรดศึกษาแหล่งข้อมูลอื่นๆ ประกอบการตัดสินใจซื้อของคุณ",
          "³คุณสมบัติและคุณประโยชน์ของเทคโนโลยี Intel ขึ้นอยู่กับการกำหนดค่าระบบ และอาจจำเป็นต้องเปิดใช้งานฮาร์ดแวร์ ซอฟต์แวร์ และบริการ ประสิทธิภาพอาจแตกต่างกันขึ้นอยู่กับการกำหนดค่าของระบบ ไม่มีระบบคอมพิวเตอร์ใดที่จะปลอดภัยอย่างสมบูรณ์แบบ โปรดตรวจสอบกับผู้ผลิตระบบหรือผู้ค้าปลีก หรืออ่านข้อมูลเพิ่มเติมที่ intel.com",
          "⁴สำหรับระบบที่มีจอแสดงผล FHD เมื่อใช้ในการท่องเว็บแบบไร้สาย เมื่อปิดเครื่องจากการชัตดาวน์ของ OEM ตามค่าเริ่มต้น",
          "⁵เมื่อเทียบกับเทคโนโลยีการเชื่อมต่อ I/O อื่นๆ ของพีซี ซึ่งประกอบด้วย eSATA, USB, และ IEEE 1394* FireWire ประสิทธิภาพจะแตกต่างกันขึ้นอยู่กับฮาร์ดแวร์และซอฟต์แวร์เฉพาะที่ใช้ ต้องใช้งานกับอุปกรณ์ที่ใช้เทคโนโลยี Thunderbolt™",
          "⁶เร็วกว่าเกือบ 3 เท่า: 802.11ax 2x2 160 MHz ช่วยให้อัตราข้อมูลตามทฤษฎีสูงสุด 2402 Mbps เร็วกว่า 802.11ac 2x2 80 MHz (867 Mbps) Wi‑Fi มาตรฐานประมาณ 3 เท่า ตามที่ระบุไว้ในข้อมูลจำเพาะมาตรฐานไร้สาย IEEE 802.11* และต้องใช้เราเตอร์เครือข่ายไร้สาย 802.11ax ที่กำหนดค่าแบบเดียวกัน",
          "⁷ลดความหน่วงลง 75%: อิงตามข้อมูลการจำลอง Intel (79%) ของ 802.11ax ที่มีและที่ไม่มี OFDMA โดยใช้ไคลเอนต์ 9 เครื่อง การหน่วงเวลาโดยเฉลี่ยเมื่อไม่มี OFDMA อยู่ที่ 36ms และการหน่วงเวลาเฉลี่ยแบบ OFDMA ลดเหลือ 7.6ms การหน่วงเวลาที่ปรับปรุงดีขึ้นต้องใช้เราเตอร์ 802.11ax (Wi&#8209;Fi 6) และไคลเอนต์ทั้งหมดที่รองรับ OFDMA",
          "⁸อิงตามการเปรียบเทียบอัตราข้อมูลสูงสุดตามทฤษฎีในข้อมูลจำเพาะ 802.11, 2x2 160 MHz Wi‑Fi 6/6E (802.11ax) สามารถให้ 2402 Mbps เทียบกับ 2x2 80 MHz Wi‑Fi 5 (802.11ac) สามารถให้ 867 Mbps ซึ่งเท่ากับเร็วกว่า 2.8 เท่า",
          "⁹Wi‑Fi 6 ที่ดีที่สุดในระดับเดียวกัน: ผลิตภัณฑ์ Intel® Wi‑Fi 6 (Gig+) รองรับช่องเสริม 160 MHz จึงให้ความเร็วสูงสุดตามทฤษฎี (2402 Mbps) สำหรับผลิตภัณฑ์ 2x2 802.11ax PC Wi‑Fi ทั่วไป ผลิตภัณฑ์ Intel® Wi‑Fi 6 (Gig+) ระดับพรีเมียมให้ความเร็วสูงสุดตามทฤษฎี 2-4 เท่า เมื่อเทียบกับผลิตภัณฑ์ 2x2 (1201 Mbps) หรือ 1x1 (600 Mbps) 802.11ax PC Wi‑Fi มาตรฐานซึ่งรองรับข้อกำหนดแบบบังคับของช่องสัญญาณ 80 MHz เท่านั้น",
          "เฉพาะ SKU บางรุ่นเท่านั้น ฟังก์ชันการทำงานแตกต่างกันไปตามการออกแบบของ OEM สำหรับรายละเอียด ให้ตรวจสอบกับ OEM หรือผู้ค้าปลีก สำหรับข้อมูลเพิ่มเติมเกี่ยวกับ Wi‑Fi กรุณาไปที่ intel.com/wifi6disclaimers",
          "¹⁰เทคโนโลยี Thunderbolt™ 4 ที่ 40Gbps มอบโซลูชันแบบใช้สายต่อไปยังแท่นเชื่อมต่อ จอแสดงผลหรืออุปกรณ์ข้อมูลใดๆ ที่รวดเร็วที่สุด เรียบง่ายที่สุด และเชื่อถือได้มากที่สุด เมื่อเทียบกับเทคโนโลยีการเชื่อมต่อ I/O อื่นๆ ของพีซี รวมถึง eSATA*, USB* และ IEEE 1394* FireWire",
          "¹¹ต้องใช้เราเตอร์ที่มี 802.11ax ซึ่งรองรับ OFDMA และไคลเอนต์หลายตัวบนเครือข่ายที่มีการสนับสนุน AX ดีขึ้นในสภาพแวดล้อมที่หนักหน่วงจากคุณสมบัติ OFDMA ที่รองรับด้วยไคลเอนท์ 802.11ax และ APs 2 Gbps ตามข้อสันนิษฐาน 70% โดยประมาณของข้อมูลจำเพาะ IEEE 802.11* อัตราข้อมูลตามทฤษฎีสูงสุด 802.11ax 160 MHz 2402 Mbps",
          "¹²ตามที่วัดโดยการเปิดใช้งานเอกสารที่มีเวิร์คโหลดกิจกรรมพื้นหลัง โดยเปรียบเทียบระหว่างโปรเซสเซอร์ Intel® Core™ i7-8565U เจนเนอเรชั่น 8 (512GB TLC SSD) กับโปรเซสเซอร์ Intel® Core™ i7-8565U เจนเนอเรชั่น 8 (หน่วยความจำ Intel® Optane™ H10 32GB + 512GB พร้อมที่เก็บข้อมูลแบบ Solid State)",
          "¹³Intel® Thread Director มาพร้อมโปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 12 และช่วยให้ระบบปฏิบัติการแบ่งเวิร์คโหลดไปยังคอร์ที่เหมาะสมได้อย่างชาญฉลาดยิ่งขึ้น ผู้ใช้ไม่จำเป็นต้องดำเนินการใดๆ โปรดดูรายละเอียดที่ intel.com",
          "¹⁴ไม่มีให้มาในโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12 บางรุ่น สถาปัตยกรรมไฮบริดประสิทธิภาพสูงได้รวมสถาปัตยกรรมคอร์ระดับไมโครใหม่สองตัวเข้าด้วยกัน นั่นคือ Performance-cores (P-cores) และ Efficient-cores (E-cores) บนแผงวงจรโปรเซสเซอร์เดียว โปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12 บางรุ่น (โปรเซสเซอร์ Intel® Core™ i5 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;12 บางรุ่นและต่ำกว่า) ไม่มีสถาปัตยกรรมไฮบริดประสิทธิภาพสูง แต่จะมีเพียง P&#8209;cores เท่านั้น",
          "¹⁵ตรวจวัดโดยเวิร์กโหลดการเปิดเกม โดยเปรียบเทียบโปรเซสเซอร์ Intel® Core™ i7-8750H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8 (โมดูลหน่วยความจำ Intel® Optane™ ขนาด 32GB + Intel® SSD 256GB PCIe* + 1TB HDD) กับโปรเซสเซอร์ Intel® Core™ i7-8750H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8 (Intel® SSD 256GB PCIe* + 1TB HDD) เวิร์กโหลดการเปิดเกม - เวิร์กโหลดที่พัฒนาโดย Intel ซึ่งตรวจวัดเวลาที่ผ่านไปสำหรับการเปิดเกม Total War: WARHAMMER* II Build: 5577.0 และไปที่เมนูหลัก โดยปิดการใช้งานวิดีโอแนะนำ (เปิดเกม) การกำหนดค่าการเร่งความเร็วให้กับไดรฟ์ข้อมูลที่ใช้หน่วยความจำ Intel® Optane™: โปรเซสเซอร์ Intel® Core™ i7-8750H, PL1=45W TDP, 6C12T, เทอร์โบสูงสุด 4GHz บนระบบ OEM ก่อนการผลิต, กราฟิก: NVIDIA* GeForce* GTX 1070, หน่วยความจำ: 2x4GB DDR4, พื้นที่จัดเก็บข้อมูล: Intel® SSD Series 760p 256GB (PCle*) + 1TB HDD + หน่วยความจำ Intel® Optane™ ขนาด 32GB, ระบบปฏิบัติการ: Windows* 10 RS3 Build 1709, MCU 0x84; โปรเซสเซอร์ Intel® Core™ i7-8750H, PL1=45W TDP, 6C12T, เทอร์โบสูงสุด 4GHz บนระบบ OEM ก่อนการผลิต, กราฟิก: NVIDIA* GeForce* GTX 1070, หน่วยความจำ: 2x4GB DDR4, พื้นที่จัดเก็บข้อมูล: Intel® SSD Series 760p 256GB (PCIe*) + 1TB HDD, OS: Windows* 10 RS3 Build 1709, MCU 0x84",
          "¹⁶ ตรวจวัดโดยเวิร์กโหลดการโหลดเลเวลเกม โดยเปรียบเทียบโปรเซสเซอร์ Intel® Core™ i7-8750H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8 (โมดูลหน่วยความจำ Intel® Optane™ ขนาด 32GB) กับโปรเซสเซอร์ Intel® Core™ i7-8750H เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;8 (HDD เท่านั้น) เวิร์คโหลดการโหลดเลเวลเกม - เวิร์คโหลดที่พัฒนาโดย Intel ซึ่งตรวจวัดเวลาที่ผ่านไปจากเมนูหลักจนถึงการโหลดเลเวล (Level Load) เสร็จสิ้นบน Total War*: WARHAMMER* II Build: 5577.0 การกำหนดค่าการเร่งความเร็วให้กับไดรฟ์ข้อมูลที่ใช้หน่วยความจำ Intel® Optane™: โปรเซสเซอร์ Intel® Core™ i7-8750H, PL1=45W TDP, 6C12T, เทอร์โบสูงสุด 4GHz บนระบบ OEM ก่อนการผลิต, กราฟิก: NVIDIA* GeForce* GTX 1070, หน่วยความจำ: 2x4GB DDR4, พื้นที่จัดเก็บข้อมูล: Intel® SSD 760p 256GB (PCle*) + 1TB HDD + หน่วยความจำ Intel® Optane™ ขนาด 32GB, ระบบปฏิบัติการ: Windows* 10 RS3 Build 1709, MCU 0x84; โปรเซสเซอร์ Intel® Core™ i7-8750H, PL1=45W TDP, 6C12T, เทอร์โบสูงสุด 4GHz บนระบบ OEM ก่อนการผลิต, กราฟิก: NVIDIA* GeForce* GTX 1070, หน่วยความจำ: 2x4GB DDR4, ที่เก็บข้อมูล: Intel® SSD Series 760p 256GB (PCIe*) + 1TB HDD, OS: Windows* 10 RS3 Build 1709, MCU 0x84",
          "¹⁷บน Performance-cores ประสิทธิภาพจะแตกต่างกันไปตามการใช้งาน การกำหนดค่า และปัจจัยอื่นๆ เรียนรู้เพิ่มเติมได้ที่ www.intel.com/PerformanceIndex",
          "¹⁸การเปลี่ยนความเร็วสัญญาณนาฬิกาหรือแรงดันไฟฟ้าอาจก่อให้เกิดอันตรายหรือลดอายุการใช้งานของโปรเซสเซอร์และส่วนประกอบอื่นๆ ของระบบ และอาจลดความเสถียรและประสิทธิภาพของระบบ การรับประกันอาจเป็นโมฆะหากใช้งานโปรเซสเซอร์ไม่ตรงตามข้อกำหนดจำเพาะที่ระบุไว้ ตรวจสอบกับผู้ผลิตระบบและส่วนประกอบถ้าต้องการรายละเอียดเพิ่มเติม",
          "¹⁹ตามที่วัดโดยการรวมกันของความสามารถในการรักษาความปลอดภัยที่เหนือกว่าและต่ำกว่าระบบปฏิบัติการ การปกป้องแอปและข้อมูล และการป้องกันภัยคุกคามขั้นสูงสำหรับธุรกิจทุกขนาดของแพลตฟอร์ม Intel vPro® และแนวทางความปลอดภัยที่มาก่อนสิ่งอื่นใดของ Intel ในการออกแบบผลิตภัณฑ์ การผลิต และการสนับสนุน พีซีธุรกิจทั้งหมดที่สร้างขึ้นบนแพลตฟอร์ม Intel vPro® ผ่านการตรวจสอบตามข้อกำหนดที่เข้มงวด ซึ่งรวมถึงคุณสมบัติด้านความปลอดภัยแบบใช้ฮาร์ดแวร์ที่ไม่ซ้ำใคร ดูรายละเอียดที่ www.intel.com/PerformanceIndex (แพลตฟอร์ม) ไม่มีผลิตภัณฑ์หรือส่วนประกอบใดที่จะปลอดภัยอย่างสมบูรณ์แบบ",
          "²⁰Intel® Connectivity Performance Suite มีมาในระบบที่ใช้ Windows* เท่านั้น การทดสอบ Wi-Fi ของ Intel Over The Air (OTA) บนเครือข่ายที่หนาแน่น เทียบกับการไม่มีระบบการจัดระดับความสำคัญของการรับส่งข้อมูลแบบไร้สายของแอปพลิเคชันชอฟต์แวร์ ICPS และการสลับจุดเชื่อมต่อแบบอัจฉริยะ ดูรายละเอียดที่ www.intel.com/PerformanceIndex (การเชื่อมต่อ) ผลลัพธ์อาจแตกต่างออกไป",
          "²¹ตามที่เทียบกับโปรเซสเซอร์เจนเนอเรชั่นก่อนหน้า",
          "²²กราฟิก Intel® Arc™ เป็นการ์ดกราฟิกตระกูลแรกในตลาดที่รองรับการเข้ารหัส AV1 (ณ ไตรมาสที่ 1 ปี 2022) ดูรายละเอียดได้ที่ intel.com/performanceindex",
          "²³ตามที่วัดโดยคุณสมบัติเฉพาะของงานออกแบบ Intel® Evo™ ซึ่งได้รับการตรวจสอบแล้วว่าตรงตามเกณฑ์ประสบการณ์ผู้ใช้อุปกรณ์พกพาที่สำคัญ การทดสอบเมื่อเดือนกุมภาพันธ์ 2022",
          "²⁴ปัจจุบันโซลูชัน Intel® Unison™ มีให้เฉพาะบนงานออกแบบ Intel® Evo™ ที่อยู่ในเกณฑ์บนพีซีที่ใช้ Windows* และจะจับคู่กับโทรศัพท์ที่ใช้ Android หรือ iOS เท่านั้น ทุกอุปกรณ์จะต้องรันระบบปฏิบัติการในเวอร์ชันที่รองรับ",
          "²⁵ความเร็วสูงสุดของหน่วยความจำเชื่อมโยงกับการกำหนดค่า 1 DIMM ต่อช่อง (1DPC) การโหลด DIMM เพิ่มเติมในช่องใดๆ อาจส่งผลต่อความเร็วสูงสุดของหน่วยความจำ สูงสุด DDR5-5600 MT/s 1DPC UDIMM 1Rx8, 1Rx16 และ DDR5-5200 1Rx8, 1Rx16, 2Rx8 ในบาง SKU การกำหนดค่า 2DPC มอบความจุหน่วยความจำสูงสุด",
          "²⁶เทียบกับ Wi-Fi มาตรฐาน โปรดดูรายละเอียดที่ intel.com/performance-wireless ผลลัพธ์อาจแตกต่างออกไป",
          "²⁷ สถาปัตยกรรมไฮบริดเพื่อประสิทธิภาพผสมผสานสถาปัตยกรรมขนาดเล็กสองคอร์ ได้แก่ Performance-core (P-core) และ Efficient-core (E-core) บนไดย์โปรเซสเซอร์เดียวที่เปิดตัวครั้งแรกบนโปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 12 โปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 12 และใหม่กว่าบ&#xfeff;า&#xfeff;ง&#xfeff;รุ่นไม่มีสถาปัตยกรรมไฮบริดเพื่อประสิทธิภาพ โดยมีเฉพาะ P-core และมีขนาดแคชเท่ากับเจนเนอเรชั่นก่อนหน้า โปรดดู ark.intel.com สำหรับร&#xfeff;า&#xfeff;ย&#xfeff;ล&#xfeff;ะเอียด SKU",
          "²⁸Intel® Thread Director ที่ติดตั้งมาในฮาร์ดแวร์มีให้เฉพาะในการกำหนดค่าสถาปัตยกรรมไฮบริดเพื่อประสิทธิภาพของโปรเซสเซอร์ Intel® Core™ เ&#xfeff;จ&#xfeff;น&#xfeff;เ&#xfeff;น&#xfeff;อ&#xfeff;เ&#xfeff;ร&#xfeff;ชั่&#xfeff;น 12 หรือใหม่กว่าเท่านั้น และต้องเปิดใช้งานระบบปฏิบัติการ คุณสมบัติและฟังก์ชันใช้งานที่มีให้จะแตกต่างไปตามระบบปฏิบัติการ",
          "²⁹Intel® Thread Director ที่ติดตั้งมาในฮาร์ดแวร์มีให้เฉพาะในการกำหนดค่าสถาปัตยกรรมไฮบริดเพื่อประสิทธิภาพของโปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 12 และ 13 เท่านั้น และต้องเปิดใช้งานระบบปฏิบัติการ คุณสมบัติและฟังก์ชันใช้งานที่มีให้จะแตกต่างไปตามระบบปฏิบัติการ",
          "³⁰ตามที่วัดจากประสิทธิภาพของ Reference Validation Platform ของโมบายล์โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra (ซีรีส์ 2 - โค้ดเนม: Lunar Lake) เทียบกับโมบายล์โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra (ซีรีส์ 1 - โค้ดเนม: Meteor Lake) ใน 3DMark Time Spy ดูรายละเอียดที่ intel.com/performanceindex ผลลัพธ์อาจแตกต่างออกไป",
          "³¹พื้นหลังเบลอและการตรวจจับใบหน้ามีให้เฉพาะในระบบที่ใช้ Windows* เท่านั้น",
          "³²ผลิตภัณฑ์ Wi-Fi 7 สามารถเข้าถึงช่องสัญญาณ 320 MHz ใน 6 GHz และช่องสัญญาณ 160 MHz ใหม่ที่รวมกันใน 5 GHz พร้อมความสามารถในการเจาะหน่วยหลายทรัพยากรใหม่",
          "³³อิงตามข้อกำหนดมาตรฐานไร้สาย IEEE แ&#xfeff;ล&#xfeff;ะอั&#xfeff;ต&#xfeff;ร&#xfeff;า&#xfeff;ข้&#xfeff;อมูลทางทฤษฎีสูงสุดสำหรับกา&#xfeff;ร&#xfeff;ส&#xfeff;ต&#xfeff;รี&#xfeff;มอุ&#xfeff;ป&#xfeff;ก&#xfeff;ร&#xfeff;ณ์พร้อมกัน 2 ตัว",
          "³⁴การจำลองทางวิศวกรรมของ Intel สำ&#xfeff;ห&#xfeff;รั&#xfeff;บส&#xfeff;ภ&#xfeff;า&#xfeff;พ&#xfeff;แ&#xfeff;วดล้อมเครือข่ายที่ห&#xfeff;น&#xfeff;า&#xfeff;แ&#xfeff;น่&#xfeff;นร&#xfeff;ะ&#xfeff;บุว่&#xfeff;าส&#xfeff;า&#xfeff;ม&#xfeff;า&#xfeff;ร&#xfeff;ถลดเวลาแฝงได้อย่างมากด้วย&#xfeff;ค&#xfeff;ว&#xfeff;า&#xfeff;มส&#xfeff;า&#xfeff;ม&#xfeff;า&#xfeff;ร&#xfeff;ถการทำงาน Wi-Fi 7 แ&#xfeff;บ&#xfeff;บ Multi‑Link ใหม่",
          "³⁵การชาร์จขั้นต่ำจากระดับการปิดระบบตามค่าเริ่มต้นของ OEM ผลลัพธ์ของแต่ละระบบอาจแตกต่างกันไป ดูรายละเอียดได้ที่ intel.com/performance-evo",
          "³⁶เครือข่าย Wi-Fi 6 GHz ไม่สามารถใช้งานได้ในบางประเทศ/ภูมิภาค",
          "³⁷Windows* เท่านั้น",
          "³⁸การชาร์จจากระดับการปิดระบบตามค่าเริ่มต้นของ OEM หากต้องการข้อมูลเพิ่มเติมเกี่ยวกับประสิทธิภาพและผลการวัดประสิทธิภาพ โปรดไปที่ intel.com/Evo",
          "³⁹กล่าวถึงโมบายล์โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra (ซีรีส์&nbsp;2) โดยดูจากคุณสมบัติด้านการรักษาความปลอดภัยที่ขับเคลื่อนด้วยฮาร์ดแวร์ที่ไม่เหมือนใคร การเปรียบเทียบกับความสามารถของระบบปฏิบัติการด้านการรักษาความปลอดภัยสูงกว่าหรือต่ำกว่า และประสิทธิภาพที่น่าประทับใจแม้ว่าพลังงานจะต่อกว่าเมื่อเปรียบเทียบกับรุ่นก่อนหน้านี้ (เมื่อเดือนกันยายน 2024) ดูรายละเอียดที่ intel.com/performanceindex ผลลัพธ์อาจแตกต่างออกไป",
          "⁴⁰ซอฟต์แวร์แอปพลิเคชั่นที่แสดงไว้เพื่อวัตถุประสงค์ในการอธิบายเท่านั้น คุณสมบัติ AI อาจต้องให้มีการซื้อซอฟต์แวร์ การสมัครใช้งาน หรือการเปิดใช้งานเพิ่มเติมโดยผู้ให้บริการซอฟต์แวร์หรือแพลตฟอร์ม หรืออาจต้องมีการกำหนดค่าเฉพาะหรือข้อกำหนดการทำงานที่เข้ากันได้ ดูรายละเอียดที่ www.intel.com/PerformanceIndex ผลลัพธ์อาจแตกต่างออกไป © Intel Corporation",
          "⁴¹อาจมีการปรับเปลี่ยนหรือจำลองรูปภาพที่แสดงไว้ คุณสมบัติ AI อาจต้องให้มีการซื้อซอฟต์แวร์ การสมัครใช้งาน หรือการเปิดใช้งานเพิ่มเติมโดยผู้ให้บริการซอฟต์แวร์หรือแพลตฟอร์ม หรืออาจต้องมีการกำหนดค่าเฉพาะหรือข้อกำหนดการทำงานที่เข้ากันได้ ดูรายละเอียดที่ www.intel.com/AIPC",
          "⁴²ตัวอย่างได้รับการทยอยเปิดตัวในการอัปเดตล่าสุดเป็น Windows* 11 ในบางแห่งทั่วโลก เวลาที่พร้อมใช้งานจะแตกต่างกันไปตามอุปกรณ์และตลาด เรียนรู้เพิ่มเติมที่: aka.ms/WindowsAIFeatures © Intel Corporation",
          "⁴³ปัจจุบัน โซลูชัน Intel® Unison™ พร้อมให้บริการสำหรับงานออกแบบที่ตรงตามเกณฑ์ ดูรายละเอียดที่ www.intel.com/PerformanceIndex",
          "⁴⁴FPS ที่เพิ่มความละเอียดด้วย Intel® X<sup>e</sup>SS เทียบกับ FPS แบบเนทีฟตามที่วัดผลโดย Dying Light 2 Stay Human ที่ทำงานในโปรเซสเซอร์ Intel® Core™ Ultra 7 165H ดูรายละเอียดที่ www.intel.com/PerformanceIndex ผลลัพธ์อาจแตกต่างออกไป",
          "⁴⁵ตามที่วัดจากการใช้พลังงาน SoC ที่ต่ำกว่าของ Reference Validation Platform ของโมบายล์โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra (ซีรีส์ 2 - โค้ดเนม: Lunar Lake) เทียบกับ Reference Validation Platform ของโมบายล์โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra (ซีรีส์ 1 - โค้ดเนม: Meteor Lake) ใน YouTube* 4K 30FPS AV1 ดูรายละเอียดที่ intel.com/performanceindex ผลลัพธ์อาจแตกต่างออกไป",
          "⁴⁶ตามที่วัดประสิทธิภาพของแพลตฟอร์มการตรวจสอบยืนยันของโมบายล์โปรเซสเซอร์ Intel® Core™ Ultra (ซีรีส์ 2 — ชื่อรหัส: Lunar Lake) เทียบกับ Meteor Lake บน 3DMark* Time Spy ดูรายละเอียดที่ intel.com/performanceindex ผลลัพธ์อาจแตกต่างออกไป",
          "⁴⁷ตามที่วัดจากการใช้พลังงาน SoC ที่ต่ำกว่าของโมบายล์โปรเซสเซอร์ Intel® Core™ Ultra (ซีรีส์ 2 — ชื่อรหัส: Lunar Lake) ซึ่งแพลตฟอร์มการตรวจสอบยืนยันโดยอ้างอิงกับแพลตฟอร์มการตรวจสอบยืนยันโดยอ้างอิง Meteor Lake ใน YouTube* 4K 30FPS AV1 ดูรายละเอียดที่ intel.com/performanceindex ผลลัพธ์อาจแตกต่างออกไป",
          "⁴⁸Intel® Application Optimization เป็นนโยบายภายใน Intel® Dynamic Tuning Technology ที่ช่วยปรับประสิทธิภาพของเกมบางเกม โดยใช้การกำหนดค่าที่จำเป็นสำหรับโปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 14 บางรุ่น สำหรับข้อมูลเพิ่มเติมเกี่ยวกับ Intel® Application Optimization โปรดดูที่ <br/>www.intel.com/content/<br/>www/th/th/support/articles/<br/>000095419/processors.html",
          "⁴⁹การเชื่อมต่อ Wi-Fi ขึ้นอยู่กับความพร้อมใช้งานของแบนด์ การรองรับระบบปฏิบัติการ และความเข้ากันได้ของเราเตอร์ ดูรายละเอียดได้ที่ intel.com/performance-wireless ผลลัพธ์อาจแตกต่างออกไป",
          "⁵⁰ตั้งแต่เดือนเมษายน 2024 เมื่อเทียบกับเทคโนโลยีการเชื่อมต่อ I/O แบบสองทิศทางของไคลเอ็นต์อื่น อย่างเทคโนโลยี Thunderbolt™ 5, eSATA และ USB ต้องเชื่อมต่อผ่านอุปกรณ์เสริมเทคโนโลยี Thunderbolt™ 5 เพื่อให้สามารถเปิดใช้งานประสิทธิภาพแบบคู่ได้ ดูรายละเอียดได้ที่ intel.com/performance-wired ผลลัพธ์อาจแตกต่างออกไป",
          "⁵¹สำหรับรายละเอียดของเทคโนโลยี Thunderbolt™ 5 โปรดไปที่ intel.com/thunderbolt",
          "⁵²ประสิทธิภาพอิงจากข้อกำหนดเฉพาะขั้นต่ำ",
          "⁵³Thunderbolt™ Share เป็นโซลูชันซอฟต์แวร์เสริมที่ได้รับอนุญาตโดยผู้ผลิต และมีมาให้ในพีซีหรืออุปกรณ์ที่รองรับ Thunderbolt™ 5 เป็นบางรุ่น<br>การเชื่อมต่อที่รวดเร็วเมื่อเทียบกับเทคโนโลยีการเชื่อมต่อ I/O อื่น ๆ ของพีซี รวมถึง eSATA, USB และ IEEE 1394 FireWire ประสิทธิภาพจะแตกต่างกันขึ้นอยู่กับฮาร์ดแวร์และซอฟต์แวร์เฉพาะที่คุณใช้ ต้องใช้อุปกรณ์ที่รองรับ Thunderbolt™<br>Thunderbolt™ 4 และ Thunderbolt™ 5 มี DisplayPort ซึ่งสามารถเชื่อมต่อกับจอแสดงผลทั้งหมดที่มี DisplayPort และ mini-DisplayPort ได้ และอะแดปเตอร์สามารถเชื่อมต่อกับอิ&#xfeff;น&#xfeff;เ&#xfeff;ท&#xfeff;อ&#xfeff;ร์&#xfeff;เ&#xfeff;ฟ&#xfeff;ซจอแสดงผลสมัยใหม่อื่น ๆ ทั้งหมด รวมถึง HDMI, DVI และ VGA<br>แต่ละอุปกรณ์เสริมอาจให้ผลลัพธ์อาจแตกต่างออกไป พลังและประสิทธิภาพแตกต่างกันไปตามการใช้ การกำหนดค่า และปัจจัยอื่น ๆ และจะไม่รับประกันประสิทธิภาพของแต่ละอุปกรณ์เสริม",
          "⁵⁴อ้างอิงจากความเข้ากันได้ในวงกว้าง ตัวเลือกซอฟต์แวร์ที่หลากหลาย สถาปัตยกรรมที่เป็นเอกลักษณ์ และประสิทธิภาพที่น่าประทับใจของโปรเซสเซอร์ Intel® Core™ Ultra ที่ผสานรวมเพื่อมอบประสบการณ์ AI โดยรวมที่ดีที่สุด รวมถึงการเปรียบเทียบกับโปรเซสเซอร์ของคู่แข่ง (ณ เดือนสิงหาคม 2024)",
          "⁵⁵ระยะเวลาการใช้งานของแบตเตอรี่จะมีความแตกต่างกันอย่างมีนัยสำคัญตามการกำหนดค่า การใช้งาน และปัจจัยอื่น ๆ",
          "⁵⁶อ้างอิงถึงแล็ปท็อป Dell* XPS บางรุ่นที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ Ultra 7 268V โดยอิงจจาก UL Procyon* Battery Life Benchmark – คะแนนย่อยด้าน Office Productivity; ความละเอียดจอแสดงผล: 1920x1080 และขนาดแบตเตอรี่: 55Wh",
          "⁵⁷GPU Intel® Arc™ มีให้บนระบบที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ Ultra บางรุ่นเท่านั้น การกำหนดค่าระบบอื่น ๆ มาพร้อมกราฟิก Intel® ตรวจสอบกับ OEM หรือผู้ค้าปลีกเกี่ยวกับการกำหนดค่าระบบ",
          "⁵⁸© 2025 Take - Two Interactive Software, Inc. © 2025 Techland S.A. ©&nbsp;Intel Corporation แลกรับภายในวันที่ 15 กันยายน 2025 เป็นไปตามเงื่อนไข",
          "⁵⁹พีซีปลายทางจะต้องมีโปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;Ultra ที่ใช้งาน Windows* 11 Home หรือ Pro และเชื่อมต่อกับอินเทอร์เน็ต คุณต้องใช้ Laplink* PCmover* Express ฟรี ภายในวันที่ 28 กุมภาพันธ์ 2026",
          "⁶⁰อ้างอิงถึงประสิทธิภาพที่วัดจากเกณฑ์มาตรฐานยอดนิยมต่าง ๆ บนแล็ปท็อปที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ Ultra 200V ซีรีส์ เมื่อเทียบกับโปรเซสเซอร์ของคู่&#xfeff;แ&#xfeff;ข่&#xfeff;ง",
          "⁶¹อ้างอิงถึงผลลัพธ์ด้านประสิทธิภาพจากการทดสอบ ณ เดือนสิงหาคม 2024 ในเกมยอดนิยมต่าง ๆ บนแล็ปท็อปที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ Ultra 200V ซีรีส์ เมื่อเทียบกับโปรเซสเซอร์ของคู่แข่ง",
          "⁶²อ้างอิงถึงแล็ปท็อปที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ Ultra 200V ซีรีส์ ที่มีกราฟิก Intel® Arc™ ภายใน เมื่อเทียบกับตัวเลือกแล็ปท็อปแบบบางพิเศษอื่น ๆ ณ เดือนสิงหาคม 2024 โดยอิงจากประสิทธิภาพที่น่าประทับใจที่ได้จากการวัดประสิทธิภาพกราฟิก ประสิทธิภาพเกมการเล่น และประสิทธิภาพเกณฑ์มาตรฐาน AI กราฟิกที่แข็งแกร่ง รวมถึงการเปรียบเทียบกับโปรเซสเซอร์ของคู่แข่ง",
          "⁶³อ้างอิงถึงแล็ปท็อปที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ Ultra 200V ซีรีส์ โดยอิงจากประสิทธิภาพที่เหนือชั้นในการใช้งาน การวัดประสิทธิภาพ และเวิร์กโหลดที่หลากหลาย เมื่อเทียบกับโปรเซสเซอร์ของคู่แข่ง (ข้อมูล ณ เดือนสิงหาคม 2024) ต้องรับการอัปเดตฟรี เวลาอัปเดตแตกต่างกันไปตามอุปกรณ์และภูมิภาค ดูข้อมูลเพิ่มเติมที่ aka.ms/copilotpluspcs",
          "⁶⁴อ้างอิงถึงแล็ปท็อป Dell* XPS บางรุ่นที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ Ultra 7 268V โดยอิงจาก UL Procyon* Battery Life Benchmark – คะแนนย่อยด้าน Office Productivity; ความละเอียดจอแสดงผล: 1920x1080 และขนาดแบตเตอรี่: 55Wh สำหรับเชิงอรรถ 1-7 ดูรายละเอียดที่ intel.com/PerformanceIndex",
          "⁶⁵เมื่อเดือนมกราคม 2024 โดยอิงจากคุณสมบัติเฉพาะของงานออกแบบ Intel® Evo™ เช่น โปรเซสเซอร์ Intel® Core™ ประสิทธิภาพสูง ส่วนประกอบระดับพรีเมียม ความเข้ากันได้ที่ไม่มีใครเทียบ และโซลูชันการเชื่อมต่อล่าสุดในงานออกแบบที่ล้ำสมัย การออกแบบทั้งหมดภายใต้ตรา Intel® Evo™ ต้องตรงตามเกณฑ์ที่ต้องการเพื่อมอบประสบการณ์ที่ยอดเยี่ยมสำหรับผู้ใช้อุปกรณ์พกพา เช่น การตอบสนองและระยะเวลาการใช้งานแบตเตอรี่ ประสิทธิภาพของอุปกรณ์แต่ละเครื่องอาจแตกต่างกัน ดูรายละเอียดได้ที่ www.intel.com/performance-evo ไม่มีผลิตภัณฑ์หรือส่วนประกอบใดที่จะปลอดภัยอย่างสมบูรณ์แบบ ภาพแอปพลิเคชันซอฟต์แวร์มีจุดประสงค์เพื่อใช้เป็นภาพประกอบเท่านั้น คุณสมบัติ AI อาจต้องมีการซื้อซอฟต์แวร์ สมัครใช้งาน หรือเปิดใช้งาน หรืออาจมีข้อกำหนดเกี่ยวกับการกำหนดค่าหรือความเข้ากันได้ ประโยชน์ด้านความเป็นส่วนตัวของข้อมูลหมายความถึงแอป AI ที่ไม่ได้ทำงานบนคลาวด์ ดูรายละเอียดเพิ่มเติมที่ atintel.com/AIPC ผลลัพธ์อาจแตกต่างออกไป © Intel Corporation ชื่อและตราสินค้าอื่นอาจถูกอ้างกรรมสิทธิ์โดยบุคคลอื่น",
          "⁶⁶อิงตามระยะเวลาการใช้งานแบตเตอรี่จริงที่ตรวจสอบแล้วเมื่อใช้เวิร์กโฟลว์ทั่วไปในสภาพแวดล้อมที่สมจริงของการใช้งานในชีวิตประจำวันโดยเฉลี่ย ผลลัพธ์อาจแตกต่างออกไป ดูรายละเอียดได้ที่ intel.com/Performance-Evo © Intel Corp",
          "[ZhCn Only Legal Text General]",
          "[ZhCn Only Legal Text Point12]",
          "[ZhCn Only Legal Text Point13]",
          "Intel ไม่รับผิดชอบต่อราคาที่ไม่ถูกต้อง",
          "*ชื่อและแบรนด์อื่นๆ อาจเป็นทรัพย์สินของผู้อื่น",
          "ลิขสิทธิ์ 2022 INFLEXION GAMES เกม NIGHTINGALE, INFLEXION และการออกแบบที่เกี่ยวข้องและเครื่องหมายที่ประกอบกัน เป็นเครื่องหมายการค้าของ INFLEXION STUDIOS INC สงวนลิขสิทธิ์",
          "อาจต้องเปิดใช้งานฮาร์ดแวร์ ซอฟต์แวร์ หรือบริการเพื่อใช้งานเทคโนโลยี Intel ไม่มีผลิตภัณฑ์หรือส่วนประกอบใดที่จะปลอดภัยอย่างสมบูรณ์แบบ ค่าใช้จ่ายและผลลัพธ์ของคุณอาจแตกต่างกันไป ดูรายละเอียดเพิ่มเติมได้ที่ https://edc.intel.com/content/<br/>www/us/en/products/performance/<br/>benchmarks/wired/",
          "ผลลัพธ์และข้อมูลใดๆ โดย NERO* จัดเตรียมไว้ให้เพื่อความสะดวกและเพื่อใช้เป็นข้อมูลเท่านั้น Intel Corporation ไม่มีหน้าที่รับผิดชอบใดๆ จากการใช้เป็นตัวอย่าง ต่อความถูกต้องของแอป NERO* ผลลัพธ์และคะแนนประสิทธิภาพ หรือความหลากหลายที่อาจเกิดขึ้นได้จากเวอร์ชันอื่นๆ ของแอปที่มีให้ดาวน์โหลดบน www.nero.com หรือเว็บไซต์ของบุคคลที่สามรายอื่นๆ คะแนนการวัดประสิทธิภาพพีซีของ NERO* วัดโดยใช้ระบบคอมพิวเตอร์ ส่วนประกอบ ซอฟต์แวร์ การปฏิบัติการ และฟังก์ชันการทำงานเฉพาะ การเปลี่ยนแปลงปัจจัยอันใดอันหนึ่ง อาจส่งผลให้เกิดผลลัพธ์แตกต่างกัน คุณควรศึกษาข้อมูลอื่นๆ ร่วมกับการทดสอบประสิทธิภาพ เพื่อช่วยให้คุณประเมินผลประกอบการตัดสินใจซื้อได้อย่างรอบคอบ รวมถึงประสิทธิภาพของผลิตภัณฑ์ดังกล่าวเมื่อทำงานร่วมกับผลิตภัณฑ์อื่น",
          "แพลตฟอร์ม Intel vPro® ทุกเวอร์ชันจะต้องใช้โปรเซสเซอร์ Intel® Core™ ที่เข้าเกณฑ์, ระบบปฏิบัติการที่รองรับ, ซิลิคอน Intel® LAN และ/หรือ WLAN, การปรับปรุงเฟิร์มแวร์ ตลอดจนฮาร์ดแวร์กับซอฟต์แวร์อื่นๆ ที่จำเป็นในการมอบรูปแบบการใช้งานด้านการบริหารจัดการ คุณสมบัติการรักษาความปลอดภัย ประสิทธิภาพระบบและความเสถียรที่บ่งบอกถึงตัวแพลตฟอร์ม",
          "ประสิทธิภาพจะแตกต่างกันไปตามการใช้งาน การกำหนดค่า และปัจจัยอื่นๆ เรียนรู้เพิ่มเติมได้ที่ www.intel.com/PerformanceIndex",
          "Intel ไม่มีการควบคุมหรือตรวจสอบข้อมูลจากบุคคลที่สาม คุณควรศึกษาแหล่งข้อมูลอื่นๆ เพื่อประเมินความแม่นยำ",
          "© 2024 Ubisoft Entertainment*. All Rights Reserved. © Intel Corporation Intel, โลโก้ Intel และเครื่องหมาย Intel อื่น ๆ เป็นเครื่องหมายการค้าของ Intel Corporation หรือบริษัทสาขา *ชื่อและตราสินค้าอื่นอาจถูกอ้างกรรมสิทธิ์โดยบุคคลอื่น",
          "ไม่มีผลิตภัณฑ์หรือส่วนประกอบใดที่จะปลอดภัยอย่างสมบูรณ์แบบ",
          "ค่าใช้จ่ายและผลลัพธ์ของคุณอาจแตกต่างกันไป",
          "Intel, โลโก้ Intel, Intel Core, Intel Optane, Intel Iris, Thunderbolt และโลโก้ Thunderbolt เป็นเครื่องหมายการค้าของ Intel Corporation หรือบริษัทสาขา ชื่อและตราสินค้าอื่นอาจถูกอ้างกรรมสิทธิ์โดยบุคคลอื่น",
          "© Intel Corporation"
        ],
        "targetURL": "",
        "iconURL": ""
      }
    },
    {
      "tabName": "navigation",
      "navigationTabs": [
        {
          "tr_specTitle": "หน้าหลัก",
          "targetURL": "mob-content",
          "iconURL": "assets/images/nav-home.svg"
        },
        {
          "tr_specTitle": "สแกนเพื่อเปรียบเทียบ",
          "targetURL": "compare",
          "iconURL": ""
        },
        {
          "tr_specTitle": "กำลังมาแรง",
          "targetURL": "trending",
          "iconURL": "assets/images/trending.svg"
        }
      ]
    }
  ],
  "trending": [
    {
      "tr_specTitle": "ปลดล็อกประสบการณ์ AI ใหม่ด้วยโปรเซสเซอร์ Intel® Core™ Ultra",
      "targetURL": "assets/lang/[XX]/trending/Ultra_Processor_Video.mp4",
      "iconURL": "",
      "videoName": "Ultra_Processor_Video"
    },
    {
      "tr_specTitle": "ปลดล็อกประสบการณ์ AI ใหม่ด้วยโปรเซสเซอร์ Intel® Core™ Ultra",
      "targetURL": "assets/videos/trending/IPOS_AI_Video.mp4",
      "iconURL": "",
      "videoName": "IPOS_AI_Video"
    },
    {
      "tr_specTitle": "ปลดล็อกประสบการณ์ AI ใหม่ด้วยโปรเซสเซอร์ Intel® Core™ Ultra",
      "targetURL": "assets/lang/[XX]/trending/Ultra_Processor_Video_Panel2.mp4",
      "iconURL": "",
      "videoName": "Ultra_Processor_Video_Panel2"
    },
    {
      "tr_specTitle": "Stable Diffusion*: สร้างภาพจากข้อความ",
      "targetURL": "assets/lang/[XX]/trending/text_link.mp4",
      "iconURL": "",
      "videoName": "text_link"
    },
    {
      "tr_specTitle": "Adobe*: ตัดต่อภาพ",
      "targetURL": "assets/lang/[XX]/trending/photo_link.mp4",
      "iconURL": "",
      "videoName": "photo_link"
    },
    {
      "tr_specTitle": "Intel® X<sup>e</sup>SS : เพิ่มความละเอียดภาพ",
      "targetURL": "assets/lang/[XX]/trending/imgUpscaling_link.mp4",
      "iconURL": "",
      "videoName": "imgUpscaling_link"
    },
    {
      "tr_specTitle": "McAfee*: โปรแกรมตรวจจับ Deepfake",
      "targetURL": "assets/lang/[XX]/trending/Security_link.mp4",
      "iconURL": "",
      "videoName": "Security_link"
    },
    {
      "tr_specTitle": "Microsoft* Copilot",
      "targetURL": "assets/lang/[XX]/trending/copilot_link.mp4",
      "iconURL": "",
      "videoName": "copilot_link"
    },
    {
      "tr_specTitle": "เอฟเฟกต์สำหรับการทำงานร่วมกัน (Teams)",
      "targetURL": "assets/lang/[XX]/trending/Collaboration_link.mp4",
      "iconURL": "",
      "videoName": "Collaboration_link"
    },
    {
      "tr_specTitle": "IQIYI: การควบคุมด้วยท่าทาง",
      "targetURL": "assets/lang/[XX]/trending/Gesture_link.mp4",
      "iconURL": "",
      "videoName": "Gesture_link"
    },
    {
      "tr_specTitle": "เชื่อมต่อพีซีกับโทรศัพท์ของคุณ และดูการแจ้งเตือน สายโทรเข้าและข้อความ",
      "targetURL": "assets/videos/trending/unison_evo_mtl_ultra_processor_video.mp4",
      "iconURL": "",
      "videoName": "unison_evo_mtl_ultra_processor_video"
    },
    {
      "tr_specTitle": "กราฟิกที่สวยงามและมีชีวิตชีวาในตัว",
      "targetURL": "assets/videos/trending/intel_iris_plus_graphics.mp4",
      "iconURL": "",
      "videoName": "intel_iris_plus_graphics"
    },
    {
      "tr_specTitle": "Microsoft*: ใช้ชีวิตในแบบของคุณ",
      "targetURL": "assets/videos/trending/standard_home_detail_run_your_life_with_microsoft_365.mp4",
      "iconURL": "",
      "videoName": "standard_home_detail_run_your_life_with_microsoft_365"
    },
    {
      "tr_specTitle": "Microsoft*: ทุกสิ่งที่เป็นคุณ ทั้งหมดในพริบตา เพียงปัดแค่ครั้งเดียว",
      "targetURL": "assets/videos/trending/standard_home_detail_onedrive_in_microsoft_365.mp4",
      "iconURL": "",
      "videoName": "standard_home_detail_onedrive_in_microsoft_365"
    },
    {
      "tr_specTitle": "Xbox* Game Pass Ultimate",
      "targetURL": "assets/videos/trending/windows_10_home.mp4",
      "iconURL": "",
      "videoName": "windows_10_home"
    },
    {
      "tr_specTitle": "ให้โปรเซสเซอร์ของคุณทำงานได้เร็วขึ้นที่ความถี่สูงขึ้นด้วยการปรับแต่งระบบอย่างละเอียด",
      "targetURL": "assets/videos/trending/gaming_processor_detail_enthusiast _overclocking.mp4",
      "iconURL": "",
      "videoName": "gaming_processor_detail_enthusiast _overclocking"
    },
    {
      "tr_specTitle": "เพิ่มประสิทธิภาพระบบเดสก์ท็อปหรือแล็ปท็อปของคุณโดยไม่สูญเสียพื้นที่จัดเก็บข้อมูล",
      "targetURL": "assets/videos/trending/optane_memory.mp4",
      "iconURL": "",
      "videoName": "optane_memory"
    },
    {
      "tr_specTitle": "เพิ่มประสิทธิภาพระบบเดสก์ท็อปหรือแล็ปท็อปของคุณโดยไม่สูญเสียพื้นที่จัดเก็บข้อมูล",
      "targetURL": "assets/videos/trending/standard_detail_panel_memory_optanememory_optane-memory.mp4",
      "iconURL": "",
      "videoName": "standard_detail_panel_memory_optanememory_optane-memory"
    },
    {
      "tr_specTitle": "Samsung OLED: ให้ภาพสวยที่ถนอมสายตา",
      "targetURL": "assets/lang/[XX]/trending/Samsung_OLED.mp4",
      "iconURL": "",
      "videoName": "Samsung_OLED"
    },
    {
      "tr_specTitle": "ความเร็ว เวลาแฝง และความน่าเชื่อถือที่ปรับปรุงดีขึ้นผ่านการเพิ่มประสิทธิภาพเครือข่ายบนพื้นฐาน AI",
      "targetURL": "assets/videos/trending/standard__wifi_killer_7.mp4",
      "iconURL": "",
      "videoName": "standard__wifi_7_killer"
    },
    {
      "tr_specTitle": "ระบบเครือข่ายพีซีที่เทียบเท่าการต่อสาย",
      "targetURL": "assets/videos/trending/standard_wifi_7.mp4",
      "iconURL": "",
      "videoName": "standard_wifi_7"
    },
    {
      "tr_specTitle": "ระบบเครือข่ายพีซีที่เทียบเท่าการต่อสาย",
      "targetURL": "assets/videos/trending/wifi_7_desktop_video.mp4",
      "iconURL": "",
      "videoName": "wifi_7_desktop_video"
    },
    {
      "tr_specTitle": "ความเร็วเพิ่มขึ้นเกือบ 3 เท่าด้วย Intel® Wi-Fi 6 (Gig+)",
      "targetURL": "assets/lang/[XX]/trending/nongaming__wifi_6e.mp4",
      "iconURL": "",
      "videoName": "wifi_6e"
    },
    {
      "tr_specTitle": "เชื่อมต่อได้โดยไม่ต้องไปแย่งชิงกับใคร",
      "targetURL": "assets/videos/trending/standard_tile_wifi_intel_panel2_video.mp4",
      "iconURL": "",
      "videoName": "standard_tile_wifi_intel_panel2_video"
    },
    {
      "tr_specTitle": "การเชื่อมต่อสาย<br/>ที่อเนกประสงค์<br/>อย่างแท้จริง",
      "targetURL": "assets/videos/trending/standard_facttag_details_thunderbolt_version3.mp4",
      "iconURL": "",
      "videoName": "standard_facttag_details_thunderbolt_version3"
    },
    {
      "tr_specTitle": "เล่นอย่างมือโปร: ดูว่า Intel มอบพลังแก่การเล่นเกมและเกมเมอร์ได้อย่างไร",
      "targetURL": "assets/videos/trending/gaming_graphics_detail.mp4",
      "iconURL": "",
      "videoName": "gaming_graphics_detail"
    },
    {
      "tr_specTitle": "เล่นอย่างมือโปร: เป็นแชมป์ได้ด้วย Intel",
      "targetURL": "assets/videos/trending/gaming_detail_panel_influencer_video.mp4",
      "iconURL": "",
      "videoName": "gaming_detail_panel_influencer_video"
    }
  ],
  "uiText": {
    "tr_welcomePageTitle": "ยินดีต้อนรับ",
    "tr_welcomePagetrSubtitle": "ควบคุมพีซีนี้จากระยะไกลด้วยสมาร์ทโฟนของคุณ",
    "tr_welcomePagembSubtitle": "ยินดีต้อนรับ สำรวจข้อมูลจำเพาะของพีซีนี้บนส&#xfeff;ม&#xfeff;า&#xfeff;ร์&#xfeff;ท&#xfeff;โ&#xfeff;ฟ&#xfeff;นของคุณ",
    "tr_welcomePageBtnText": "เริ่มต้น",
    "tr_welcomePageText": "สำรวจและเปรียบเทียบรายละเอียดของพีซีนี้บนส&#65279;ม&#65279;า&#65279;ร์&#65279;ท&#65279;โ&#65279;ฟ&#65279;นของคุณ",
    "tr_scrollText": "สำรวจอุปกรณ์ที่อยู่ตรงหน้าของคุณ",
    "tr_toolTipTextc1": "ใช้ปุ่มเหล่านี้เพื่อนำทางไปยังหน้าต่างๆ บนอุปกรณ์ที่อยู่ตรงหน้าของคุณ",
    "tr_toolTipTextc2": "เมื่อแตะการ์ดด้านล่าง คุณจะถูกนำทางไปยังหน้ารายละเอียดข้อมูลจำเพาะของแต่ละอุปกรณ์",
    "tr_toolTipTextc3": "ใช้ปุ่มเหล่านี้เพื่อเลื่อนขึ้นหรือลงบนหน้าจอที่คุณกำลังใช้งาน",
    "tr_toolTipTextc4": "ปิดโหมดระยะไกลเพื่อดูข้อมูลจำเพาะอุปกรณ์บนสมาร์ทโฟนของคุณ",
    "tr_toolTipTextmb1": "แตะบนการ์ดเพื่อดูหน้าเนื้อหาโดยละเอียด",
    "tr_toolTipTextmb2": "แตะเพื่อดูข้อมูลสรุปเกี่ยวกับข้อมูลจำเพาะของอุปกรณ์ทั้งหมด",
    "tr_toolTipTextmb3": "แตะปุ่มเพื่อสแกนรหัส QR และเปรียบเทียบสูงสุด 4 อุปกรณ์",
    "tr_nextButton": "ต่อไป",
    "tr_prevButton": "ย้อนกลับ",
    "tr_gotItButton": "เข้าใจแล้ว",
    "tr_skipButton": "ข้าม",
    "tr_placeholderText": "*placeholder",
    "tr_processorHeading": "โปรเซสเซอร์",
    "tr_processorSubheading": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i7 เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;10",
    "tr_memorySubheading": "[XX] GB",
    "tr_storageSubheading": "หน่วยความจำ Intel® Optane™ [XX] GB + SSD [YY] GB",
    "tr_coachmarkProcessor": "โปรเซสเซอร์ XX",
    "tr_coachmarkGraphics": "กราฟิก [XX]",
    "tr_coachmarkMemory": "ค่าจำเพาะ",
    "tr_coachmarkOS": "[XX]",
    "tr_deviceName": "HP Envy 17T",
    "tr_price": "$ 999.95",
    "tr_compare": "เปรียบเทียบ",
    "tr_viewallspecs": "ดูข้อมูลจำเพาะทั้งหมด",
    "tr_operatingSystem": "ระบบปฏิบัติการ",
    "tr_AmdProcessorNonIntel": "โปรเซสเซอร์ AMD*",
    "tr_QualcommProcessorNonIntel": "โปรเซสเซอร์ Qualcomm*",
    "tr_GBText": "GB",
    "tr_remoteText": "ข้อมูลจำเพาะที่แสดงบนหน้าจอแล็ปท็อป",
    "tr_scanErrorText": "คุณสามารถสแกนได้สูงสุด 3&nbsp;อุปกรณ์พร้อมกัน โปรดลบอุปกรณ์อื่นที่นอกเหนือจากนี้",
    "tr_scanErrorText2": "คุณได้สแกนอุปกรณ์นี้แล้ว โ&#xfeff;ป&#xfeff;ร&#xfeff;ด&#xfeff;ส&#xfeff;แ&#xfeff;ก&#xfeff;น&#xfeff;อุ&#xfeff;ป&#xfeff;ก&#xfeff;ร&#xfeff;ณ์&#xfeff;เ&#xfeff;ค&#xfeff;รื่&#xfeff;อ&#xfeff;ง&#xfeff;อื่&#xfeff;น",
    "tr_scanMsg": "สแกนเพื่อเพิ่มอุปกรณ์",
    "tr_backToScan": "ย้อนกลับไปเปรียบเทียบ",
    "tr_scanToCompare": "สแกนเพื่อเปรียบเทียบ",
    "tr_compareDevice": "เปรียบเทียบอุปกรณ์",
    "tr_processorTitle": "โปรเซสเซอร์",
    "tr_graphicTitle": "กราฟิก",
    "tr_storageTitle": "อุปกรณ์จัดเก็บข้อมูล",
    "tr_displayTitle": "จอแสดงผล",
    "tr_batteryTitle": "แบตเตอรี่",
    "tr_memoryTitle": "หน่วยความจำ",
    "tr_wifiTitle": "Wi‑Fi",
    "tr_connectivityTitle": "การเชื่อมต่อ",
    "tr_priceTitle": "ราคา",
    "tr_operatingSystemTitle": "ระบบปฏิบัติการ",
    "tr_batteryHoursText": "[XX] ชั่วโมง",
    "tr_hrsText": "ชม.",
    "tr_touchscreeenText": "หน้าจอสัมผัส [screenDiagonal]” ",
    "tr_HDText": "HD",
    "tr_FHDText": "FHD",
    "tr_4KText": "4K",
    "tr_HDTochScreenText": "หน้าจอสัมผัส HD",
    "tr_FHDTouchScreenText": "หน้าจอสัมผัส FHD",
    "tr_4KTouchscreenText": "หน้าจอสัมผัส 4K",
    "tr_wifi_gigText": "(Gig+)",
    "tr_save": "บันทึก",
    "tr_device_comparison": "เอกสารการเปรียบเทียบอุปกรณ์ [dd]-[mm]-[yyyy]",
    "tr_Save_As_JPEG": "บันทึกเป็น JPEG",
    "tr_Save_As_PDF": "บันทึกเป็น PDF",
    "tr_Downloading_PDF": "กำลังดาวน์โหลด PDF",
    "tr_pdf_file": "[XXX].pdf",
    "tr_open": "เปิด",
    "tr_logo": "โลโก้",
    "tr_laptop_name": "ชื่อแล็ปท็อป",
    "tr_TBText": "TB",
    "tr_optaneMemoryTitle": "หน่วยความจำ Intel® Optane™",
    "tr_inchUnit": "นิ้ว",
    "tr_wifi1": "Wi‑Fi 1",
    "tr_wifi2": "Wi‑Fi 2",
    "tr_wifi3": "Wi‑Fi 3",
    "tr_wifi4": "Wi‑Fi 4",
    "tr_wifi5": "Wi‑Fi 5",
    "tr_wifi6": "Intel® Wi‑Fi 6 (Gig+)",
    "tr_wifi6Caps": "INTEL® WI‑FI 6 (GIG+)",
    "tr_wifi6e": "6E",
    "tr_wifi6eValue": "Wi‑Fi 6E",
    "tr_wifiXX": "Wi‑Fi [XX]",
    "tr_wifiXXCaps": "WI‑FI [XX]",
    "tr_wifi6E": "Intel® Wi‑Fi 6E (Gig+)",
    "tr_IntelOptaneMemory": "หน่วยความจำ INTEL® OPTANE™",
    "tr_Thunderbolt3": "เทคโนโลยี Thunderbolt™&nbsp;3",
    "tr_Thunderbolt4": "เทคโนโลยี Thunderbolt™&nbsp;4",
    "tr_Thunderbolt5": "เทคโนโลยี Thunderbolt™ 5",
    "tr_processorGraphicsCaps": "การ์ดจอบนโปรเซสเซอร์",
    "tr_processorGraphicsSmall": "การ์ดจอบนโปรเซสเซอร์",
    "tr_graphicsCardCaps": "กราฟิกแบบแยก",
    "tr_graphicsCardSmall": "กร&#xfeff;า&#xfeff;ฟิ&#xfeff;กแ&#xfeff;บ&#xfeff;บ&#xfeff;แ&#xfeff;ยก",
    "tr_processorTitleCamel": "โปรเซสเซอร์",
    "tr_graphicTitleCamel": "กราฟิก",
    "tr_storageTitleCamel": "อุปกรณ์จัดเก็บข้อมูล",
    "tr_displayTitleCamel": "การแสดงผล",
    "tr_batteryTitleCamel": "แบตเตอรี่",
    "tr_batteryLifeTitleCamel": "ระยะเวลาการใช้งานแบตเตอรี่",
    "tr_exceptionalBattery": "ระยะเวลาการใช้งานแบตเตอรี่ที่น่าทึ่ง",
    "tr_memoryTitleCamel": "หน่วยความจำ",
    "tr_connectivityTitleCamel": "การเ&#xfeff;ชื่&#xfeff;อ&#xfeff;ม&#xfeff;ต่&#xfeff;อ",
    "tr_priceTitleCamel": "ราคา",
    "tr_operatingSystemTitleCamel": "ระบบป&#xfeff;ฏิ&#xfeff;บั&#xfeff;ติ&#xfeff;ก&#xfeff;า&#xfeff;ร",
    "tr_viewallspecsCamel": "ดูข้อมูลจำเพาะทั้งหมด",
    "tr_displayText": "[screenDiagonal]”",
    "tr_displayTextResolution": "[screenDiagonal]” [screenResolutionType]",
    "tr_displayTextResolutionTouchscreen": "หน้าจอสัมผัส [screenDiagonal]” [screenResolutionType]",
    "tr_OS": "ระบบปฏิบัติการ",
    "tr_Chrome_OS": "Chrome* OS",
    "tr_PCSpecs_text": "สเปคพีซี",
    "tr_explorePC_text": "สำรวจทุกสิ่งเกี่ยวกับพีซีนี้",
    "tr_mtlPC_text": "สัมผัสความหมายที่แท้จริงของการ “ออกแบบมาเพื่อตอบโจทย์ทุกการใช้งาน”",
    "tr_optaneMemory": "หน่วยความจำ Intel®&nbsp;Optane™",
    "tr_displayText_Display": "จอแสดงผล [screenDiagonal]”",
    "tr_displayTextResolution_Display": "จอแสดงผล [screenResolutionType] [screenDiagonal]” ",
    "tr_displayTextResolutionTouchscreen_Display": "จอทัชสกรีน [screenResolutionType] [screenDiagonal]”",
    "tr_displayTextTouchscreeenText": "จอทัชสกรีน  [screenDiagonal]”",
    "tr_learnMoreLabel": "เรียนรู้เ&#65279;พิ่&#65279;ม&#65279;เ&#65279;ติ&#65279;ม",
    "tr_batteryHoursTextUpperCase": "[XX] ชั่วโมง",
    "tr_processorGraphicsIrisXe": "โปรเซสเซอร์ Intel® Core™ [cpu_fam] เจนเนอเรชั่น 11 และกราฟิก Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax": "โปรเซสเซอร์ Intel® Core™ [cpu_fam] เจนเนอเรชั่น 11 และกราฟิก Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> Max",
    "tr_Thunderbolt3UpperCase": "เทคโนโลยี THUNDERBOLT™&nbsp;3",
    "tr_Thunderbolt4UpperCase": "เทคโนโลยี THUNDERBOLT™&nbsp;4",
    "tr_Thunderbolt5UpperCase": "สัมผัสประโยชน์ของเทคโนโลยี Thunderbolt™ 5",
    "tr_processorWithArcGraphics": "โปรเซสเซอร์ INTEL® CORE™ [cpu_fam] เจนเนอเรชั่น 12 และกราฟิก INTEL® ARC™",
    "tr_processorGraphicsIrisXe12Gen": "โปรเซสเซอร์ INTEL® CORE™ [cpu_fam] เจนเนอเรชั่น 12 และกราฟิก INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax12Gen": "โปรเซสเซอร์ INTEL® CORE™ [cpu_fam] เจนเนอเรชั่น 12 และกราฟิก INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_samsung_oled": "Samsung OLED",
    "tr_oled": "OLED",
    "tr_processorWithArcGraphics13Gen": "โปรเซสเซอร์ INTEL® CORE™ [cpu_fam] เจนเนอเรชั่น 13 และกราฟิก INTEL® ARC™",
    "tr_processorGraphicsIrisXe13Gen": "โปรเซสเซอร์ INTEL® CORE™ [cpu_fam] เจนเนอเรชั่น 13 และกราฟิก INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax13Gen": "โปรเซสเซอร์ INTEL® CORE™ [cpu_fam] เจนเนอเรชั่น 13 และกราฟิก INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_ultra5": "Intel® Core™ Ultra 5",
    "tr_ultra7": "Intel® Core™ Ultra 7",
    "tr_ultra9": "Intel® Core™ Ultra 9",
    "tr_arcGraphicsBadgeToModelNameMapping": {
      "tr_A350M": "กราฟิก INTEL® ARC™ A350M",
      "tr_A370M": "กราฟิก INTEL® ARC™ A370M",
      "tr_A730M": "กราฟิก INTEL® ARC™ A730M",
      "tr_A770M": "กราฟิก INTEL® ARC™ A770M",
      "tr_A310": "กราฟิก INTEL® ARC™ A310",
      "tr_A380": "กราฟิก INTEL® ARC™ A380",
      "tr_A580": "กราฟิก INTEL® ARC™ A580",
      "tr_A750": "กราฟิก INTEL® ARC™ A750",
      "tr_A770": "กราฟิก INTEL® ARC™ A770"
    },
    "tr_memoryValue": "RAM [XX] GB",
    "tr_memoryWithOptaneDesc": "หน่วยความจำ [Value1]&nbsp;GB = ห&#xfeff;น่&#xfeff;ว&#xfeff;ย&#xfeff;ค&#xfeff;ว&#xfeff;า&#xfeff;ม&#xfeff;จำ Intel®&nbsp;Optane™ [Value2]&nbsp;GB + RAM&nbsp;[Value3]&nbsp;GB",
    "tr_textGBGB": "SSD [convertedSSD] GB + HDD&nbsp;[convertedHDD]&nbsp;GB",
    "tr_textGBTB": "SSD [convertedSSD] GB + HDD&nbsp;[convertedHDD]&nbsp;TB",
    "tr_textTBGB": "SSD [convertedSSD] TB + HDD&nbsp;[convertedHDD]&nbsp;GB",
    "tr_textTBTB": "SSD [convertedSSD] TB + HDD&nbsp;[convertedHDD]&nbsp;TB",
    "tr_textGBSSD": "[convertedSSD] GB SSD",
    "tr_textTBSSD": "[convertedSSD] TB SSD",
    "tr_textGBHDD": "[convertedHDD] GB HDD",
    "tr_textTBHDD": "[convertedHDD] TB HDD",
    "tr_textStorageWithOptaneGB": "หน่วยความจำ Intel®&nbsp;Optane™ [XX]&nbsp;GB + SSD [convertedSSD]&nbsp;GB",
    "tr_textStorageWithOptaneTB": "หน่วยความจำ Intel®&nbsp;Optane™ [XX]&nbsp;GB + SSD [convertedSSD]&nbsp;TB ",
    "tr_OSDescriptionMapping": {
      "tr_OS_A": "Windows* 7",
      "tr_OS_B": "Windows* 7 Home Basic",
      "tr_OS_C": "Windows* 7 Home Premium",
      "tr_OS_D": "Windows* 7 Professional",
      "tr_OS_E": "Windows* 7 Enterprise",
      "tr_OS_F": "Windows* 7 Ultimate",
      "tr_OS_G": "Windows* 8",
      "tr_OS_H": "Windows* 8 Pro",
      "tr_OS_I": "Windows* 8 Enterprise",
      "tr_OS_J": "Windows* 8.1",
      "tr_OS_K": "Windows* 8.1 Pro",
      "tr_OS_L": "Windows* 8.1 Enterprise",
      "tr_OS_M": "Windows* 8.1",
      "tr_OS_N": "Windows* 10 Home",
      "tr_OS_O": "Windows* 10 Pro",
      "tr_OS_P": "Windows* 10 Enterprise",
      "tr_OS_Q": "Windows* 11 Home",
      "tr_OS_R": "Windows* 11 Pro",
      "tr_OS_S": "Windows* 11 Enterprise",
      "tr_OS_T": "Windows* 10 Home ในโหมด S",
      "tr_OS_U": "Windows* 10 Pro ในโหมด S",
      "tr_OS_V": "Windows* 10 Enterprise ในโหมด S",
      "tr_OS_W": "Windows* 11 Home ในโหมด S",
      "tr_OS_X": "Windows* 11 Pro ในโหมด S",
      "tr_OS_Y": "Windows* 11 Enterprise ในโหมด&nbsp;S"
    },
    "tr_GraphicsDescriptionMapping": {
      "tr_GR1": "AMD* Mobility Radeon* 4100",
      "tr_GR2": "AMD* Mobility Radeon* HD 2400",
      "tr_GR3": "AMD* Mobility Radeon* HD 2400 XT",
      "tr_GR4": "AMD* Mobility Radeon* HD 2600",
      "tr_GR5": "AMD* Mobility Radeon* HD 2600 XT",
      "tr_GR6": "AMD* Mobility Radeon* HD 3400",
      "tr_GR7": "AMD* Mobility Radeon* HD 3430",
      "tr_GR8": "AMD* Mobility Radeon* HD 3650",
      "tr_GR9": "AMD* Mobility Radeon* HD 3670",
      "tr_GR10": "AMD* Mobility Radeon* HD 3850",
      "tr_GR11": "AMD* Mobility Radeon* HD 3850 X2",
      "tr_GR12": "AMD* Mobility Radeon* HD 3870",
      "tr_GR13": "AMD* Mobility Radeon* HD 3870 X2",
      "tr_GR14": "AMD* Mobility Radeon* HD 4200",
      "tr_GR15": "AMD* Mobility Radeon* HD 4300",
      "tr_GR16": "AMD* Mobility Radeon* HD 4330",
      "tr_GR17": "AMD* Mobility Radeon* HD 4500",
      "tr_GR18": "AMD* Mobility Radeon* HD 4650",
      "tr_GR19": "AMD* Mobility Radeon* HD 4670",
      "tr_GR20": "AMD* Mobility Radeon* HD 4830",
      "tr_GR21": "AMD* Mobility Radeon* HD 4850",
      "tr_GR22": "AMD* Mobility Radeon* HD 4860",
      "tr_GR23": "AMD* Mobility Radeon* HD 4870",
      "tr_GR24": "AMD* Mobility Radeon* HD 5000",
      "tr_GR25": "AMD* Mobility Radeon* HD 5570",
      "tr_GR26": "AMD* Mobility Radeon* HD 5800",
      "tr_GR27": "AMD* Mobility Radeon* HD 6000",
      "tr_GR28": "AMD* Radeon* HD 2350",
      "tr_GR29": "AMD* Radeon* HD 2400",
      "tr_GR30": "AMD* Radeon* HD 2400 Pro",
      "tr_GR31": "AMD* Radeon* HD 2400 XT",
      "tr_GR32": "AMD* Radeon* HD 2600",
      "tr_GR33": "AMD* Radeon* HD 2600 Pro",
      "tr_GR34": "AMD* Radeon* HD 2600 XT",
      "tr_GR35": "AMD* Radeon* HD 2900 GT",
      "tr_GR36": "AMD* Radeon* HD 2900 Pro",
      "tr_GR37": "AMD* Radeon* HD 2900 XT",
      "tr_GR38": "AMD* Radeon* HD 3200",
      "tr_GR39": "AMD* Radeon* HD 3300",
      "tr_GR40": "AMD* Radeon* HD 3450",
      "tr_GR41": "AMD* Radeon* HD 3470",
      "tr_GR42": "AMD* Radeon* HD 3600",
      "tr_GR43": "AMD* Radeon* HD 3650",
      "tr_GR44": "AMD* Radeon* HD 3830",
      "tr_GR45": "AMD* Radeon* HD 3850",
      "tr_GR46": "AMD* Radeon* HD 3850 X2",
      "tr_GR47": "AMD* Radeon* HD 3870",
      "tr_GR48": "AMD* Radeon* HD 3870 X2",
      "tr_GR49": "AMD* Radeon* HD 4200",
      "tr_GR50": "AMD* Radeon* HD 4250",
      "tr_GR51": "AMD* Radeon* HD 4290",
      "tr_GR52": "AMD* Radeon* HD 4300",
      "tr_GR53": "AMD* Radeon* HD 4550",
      "tr_GR54": "AMD* Radeon* HD 4600",
      "tr_GR55": "AMD* Radeon* HD 4700",
      "tr_GR56": "AMD* Radeon* HD 4770",
      "tr_GR57": "AMD* Radeon* HD 4800",
      "tr_GR58": "AMD* Radeon* HD 4850 X2",
      "tr_GR59": "AMD* Radeon* HD 4870 X2",
      "tr_GR60": "AMD* Radeon* HD 5000",
      "tr_GR61": "AMD* Radeon* HD 5400",
      "tr_GR62": "AMD* Radeon* HD 5450",
      "tr_GR63": "AMD* Radeon* HD 5470",
      "tr_GR64": "AMD* Radeon* HD 5490",
      "tr_GR65": "AMD* Radeon* HD 5500",
      "tr_GR66": "AMD* Radeon* HD 5530",
      "tr_GR67": "AMD* Radeon* HD 5570",
      "tr_GR68": "AMD* Radeon* HD 5600",
      "tr_GR69": "AMD* Radeon* HD 5630",
      "tr_GR70": "AMD* Mobility Radeon* 4100",
      "tr_GR71": "AMD* Radeon* HD 5690",
      "tr_GR72": "AMD* Radeon* HD 5700",
      "tr_GR73": "AMD* Radeon* HD 5730",
      "tr_GR74": "AMD* Radeon* HD 5800",
      "tr_GR75": "AMD* Radeon* HD 5850X2",
      "tr_GR76": "AMD* Radeon* HD 5900",
      "tr_GR77": "AMD* Radeon* HD 6230",
      "tr_GR78": "AMD* Radeon* HD 6250",
      "tr_GR79": "AMD* Radeon* HD 6290",
      "tr_GR80": "AMD* Radeon* HD 6300M",
      "tr_GR81": "AMD* Radeon* HD 6350",
      "tr_GR82": "AMD* Radeon* HD 6350A",
      "tr_GR83": "AMD* Radeon* HD 6390",
      "tr_GR84": "AMD* Radeon* HD 6400",
      "tr_GR85": "AMD* Radeon* HD 6430M",
      "tr_GR86": "AMD* Radeon* HD 6450",
      "tr_GR87": "AMD* Radeon* HD 6490",
      "tr_GR88": "AMD* Radeon* HD 6500",
      "tr_GR89": "AMD* Radeon* HD 6510",
      "tr_GR90": "AMD* Radeon* HD 6530",
      "tr_GR91": "AMD* Radeon* HD 6570",
      "tr_GR92": "AMD* Radeon* HD 6600A",
      "tr_GR93": "AMD* Radeon* HD 6610",
      "tr_GR94": "AMD* Radeon* HD 6670",
      "tr_GR95": "AMD* Radeon* HD 6700",
      "tr_GR96": "AMD* Radeon* HD 6700M",
      "tr_GR97": "AMD* Radeon* HD 6750",
      "tr_GR98": "AMD* Radeon* HD 6800",
      "tr_GR99": "AMD* Radeon* HD 6800M",
      "tr_GR100": "AMD* Radeon* HD 6850",
      "tr_GR101": "AMD* Radeon* HD 6850 X2",
      "tr_GR102": "AMD* Radeon* HD 6870",
      "tr_GR103": "AMD* Radeon* HD 6870 X2",
      "tr_GR104": "AMD* Radeon* HD 6900",
      "tr_GR105": "AMD* Radeon* HD 6900M",
      "tr_GR106": "AMD* Radeon* HD 7000",
      "tr_GR107": "AMD* Radeon* HD 7000M",
      "tr_GR108": "AMD* Radeon* HD 7300",
      "tr_GR109": "AMD* Radeon* HD 7350",
      "tr_GR110": "AMD* Radeon* HD 7400",
      "tr_GR111": "AMD* Radeon* HD 7400A",
      "tr_GR112": "AMD* Radeon* HD 7400G",
      "tr_GR113": "AMD* Radeon* HD 7400M",
      "tr_GR114": "AMD* Radeon* HD 7420G",
      "tr_GR115": "AMD* Radeon* HD 7450",
      "tr_GR116": "AMD* Radeon* HD 7450A",
      "tr_GR117": "AMD* Radeon* HD 7470",
      "tr_GR118": "AMD* Radeon* HD 7480D",
      "tr_GR119": "AMD* Radeon* HD 7500",
      "tr_GR120": "AMD* Radeon* HD 7500G",
      "tr_GR121": "AMD* Radeon* HD 7500M",
      "tr_GR122": "AMD* Radeon* HD 7510",
      "tr_GR123": "AMD* Radeon* HD 7520G",
      "tr_GR124": "AMD* Radeon* HD 7540D",
      "tr_GR125": "AMD* Radeon* HD 7560D",
      "tr_GR126": "AMD* Radeon* HD 7570",
      "tr_GR127": "AMD* Radeon* HD 7600",
      "tr_GR128": "AMD* Radeon* HD 7600A",
      "tr_GR129": "AMD* Radeon* HD 7600G",
      "tr_GR130": "AMD* Radeon* HD 7600M",
      "tr_GR131": "AMD* Radeon* HD 7620G",
      "tr_GR132": "AMD* Radeon* HD 7640G",
      "tr_GR133": "AMD* Radeon* HD 7660D",
      "tr_GR134": "AMD* Radeon* HD 7660G",
      "tr_GR135": "AMD* Radeon* HD 7670",
      "tr_GR136": "AMD* Radeon* HD 7670M",
      "tr_GR137": "AMD* Radeon* HD 7700",
      "tr_GR138": "AMD* Radeon* HD 7700M",
      "tr_GR139": "AMD* Radeon* HD 7720",
      "tr_GR140": "AMD* Radeon* HD 7800",
      "tr_GR141": "AMD* Radeon* HD 7800M",
      "tr_GR142": "AMD* Radeon* HD 7900",
      "tr_GR143": "AMD* Radeon* HD 7970M",
      "tr_GR144": "AMD* Radeon* HD 8180",
      "tr_GR145": "AMD* Radeon* HD 8200",
      "tr_GR146": "AMD* Radeon* HD 8210",
      "tr_GR147": "AMD* Radeon* HD 8210E",
      "tr_GR148": "AMD* Radeon* HD 8250",
      "tr_GR149": "AMD* Radeon* HD 8280E",
      "tr_GR150": "AMD* Radeon* HD 8310G",
      "tr_GR151": "AMD* Radeon* HD 8330",
      "tr_GR152": "AMD* Radeon* HD 8330E",
      "tr_GR153": "AMD* Radeon* HD 8350",
      "tr_GR154": "AMD* Radeon* HD 8350G",
      "tr_GR155": "AMD* Radeon* HD 8370D",
      "tr_GR156": "AMD* Radeon* HD 8400",
      "tr_GR157": "AMD* Radeon* HD 8400E",
      "tr_GR158": "AMD* Radeon* HD 8410G",
      "tr_GR159": "AMD* Radeon* HD 8450",
      "tr_GR160": "AMD* Radeon* HD 8450G",
      "tr_GR161": "AMD* Radeon* HD 8470",
      "tr_GR162": "AMD* Radeon* HD 8470D",
      "tr_GR163": "AMD* Radeon* HD 8490",
      "tr_GR164": "AMD* Radeon* HD 8500M",
      "tr_GR165": "AMD* Radeon* HD 8510",
      "tr_GR166": "AMD* Radeon* HD 8510G",
      "tr_GR167": "AMD* Radeon* HD 8550",
      "tr_GR168": "AMD* Radeon* HD 8550D",
      "tr_GR169": "AMD* Radeon* HD 8550G",
      "tr_GR170": "AMD* Radeon* HD 8570",
      "tr_GR171": "AMD* Radeon* HD 8570D",
      "tr_GR172": "AMD* Radeon* HD 8600",
      "tr_GR173": "AMD* Radeon* HD 8600M",
      "tr_GR174": "AMD* Radeon* HD 8610G",
      "tr_GR175": "AMD* Radeon* HD 8650D",
      "tr_GR176": "AMD* Radeon* HD 8650G",
      "tr_GR177": "AMD* Radeon* HD 8670D",
      "tr_GR178": "AMD* Radeon* HD 8730",
      "tr_GR179": "AMD* Radeon* HD 8760",
      "tr_GR180": "AMD* Radeon* HD 8770",
      "tr_GR181": "AMD* Radeon* HD 8790M",
      "tr_GR182": "AMD* Radeon* HD 8800M",
      "tr_GR183": "AMD* Radeon* HD 8870",
      "tr_GR184": "AMD* Radeon* HD 8950",
      "tr_GR185": "AMD* Radeon* HD 8970",
      "tr_GR186": "AMD* Radeon* HD 8970M",
      "tr_GR187": "AMD* Radeon* HD 8990",
      "tr_GR188": "AMD* Radeon* HD 9000",
      "tr_GR189": "AMD* Radeon* Pro 450",
      "tr_GR190": "AMD* Radeon* Pro 455",
      "tr_GR191": "AMD* Radeon* Pro 460",
      "tr_GR192": "AMD* Radeon* Pro 465",
      "tr_GR193": "AMD* Radeon* Pro Duo",
      "tr_GR194": "AMD* Radeon* Pro SSG",
      "tr_GR195": "AMD* Radeon* Pro V340",
      "tr_GR196": "AMD* Radeon* Pro V5300X",
      "tr_GR197": "AMD* Radeon* Pro V7300X",
      "tr_GR198": "AMD* Radeon* Pro V7350x2",
      "tr_GR199": "AMD* Radeon* Pro Vega 56",
      "tr_GR200": "AMD* Radeon* Pro VII",
      "tr_GR201": "AMD* Radeon* Pro W5500",
      "tr_GR202": "AMD* Radeon* Pro W5500M",
      "tr_GR203": "AMD* Radeon* Pro W5700",
      "tr_GR204": "AMD* Radeon* Pro W6300",
      "tr_GR205": "AMD* Radeon* Pro W6300M",
      "tr_GR206": "AMD* Radeon* Pro W6400",
      "tr_GR207": "AMD* Radeon* Pro W6500M",
      "tr_GR208": "AMD* Radeon* Pro W6600",
      "tr_GR209": "AMD* Radeon* Pro W6600M",
      "tr_GR210": "AMD* Radeon* Pro W6800",
      "tr_GR211": "AMD* Radeon* Pro W7500",
      "tr_GR212": "AMD* Radeon* Pro W7600",
      "tr_GR213": "AMD* Radeon* Pro W7700",
      "tr_GR214": "AMD* Radeon* Pro W7800",
      "tr_GR215": "AMD* Radeon* Pro W7900",
      "tr_GR216": "AMD* Radeon* Pro WX 2100",
      "tr_GR217": "AMD* Radeon* Pro WX 3100",
      "tr_GR218": "AMD* Radeon* Pro WX 3200",
      "tr_GR219": "AMD* Radeon* Pro WX 4100",
      "tr_GR220": "AMD* Radeon* Pro WX 4150",
      "tr_GR221": "AMD* Radeon* Pro WX 4170",
      "tr_GR222": "AMD* Radeon* Pro WX 5100",
      "tr_GR223": "AMD* Radeon* Pro WX 7100",
      "tr_GR224": "AMD* Radeon* Pro WX 8200",
      "tr_GR225": "AMD* Radeon* Pro WX 9100",
      "tr_GR226": "AMD* Radeon* R5 200",
      "tr_GR227": "AMD* Radeon* R5 220",
      "tr_GR228": "AMD* Radeon* R5 230",
      "tr_GR229": "AMD* Radeon* R5 235",
      "tr_GR230": "AMD* Radeon* R5 240",
      "tr_GR231": "AMD* Radeon* R5 340",
      "tr_GR232": "AMD* Radeon* R5 340X",
      "tr_GR233": "AMD* Radeon* R5 420",
      "tr_GR234": "AMD* Radeon* R5 430",
      "tr_GR235": "AMD* Radeon* R5 430M",
      "tr_GR236": "AMD* Radeon* R5 M200",
      "tr_GR237": "AMD* Radeon* R5 M230",
      "tr_GR238": "AMD* Radeon* R5 M240",
      "tr_GR239": "AMD* Radeon* R5 M255",
      "tr_GR240": "AMD* Radeon* R5 M315",
      "tr_GR241": "AMD* Radeon* R5 M320",
      "tr_GR242": "AMD* Radeon* R5 M330",
      "tr_GR243": "AMD* Radeon* R5 M335",
      "tr_GR244": "AMD* Radeon* R5 M430",
      "tr_GR245": "AMD* Radeon* R5 M435",
      "tr_GR246": "AMD* Radeon* R6 M255DX",
      "tr_GR247": "AMD* Radeon* R6 M335DX",
      "tr_GR248": "AMD* Radeon* R6 M340DX",
      "tr_GR249": "AMD* Radeon* R6 M435DX",
      "tr_GR250": "AMD* Radeon* R7 200",
      "tr_GR251": "AMD* Radeon* R7 240",
      "tr_GR252": "AMD* Radeon* R7 250",
      "tr_GR253": "AMD* Radeon* R7 250X",
      "tr_GR254": "AMD* Radeon* R7 265",
      "tr_GR255": "AMD* Radeon* R7 300",
      "tr_GR256": "AMD* Radeon* R7 340",
      "tr_GR257": "AMD* Radeon* R7 350",
      "tr_GR258": "AMD* Radeon* R7 350X",
      "tr_GR259": "AMD* Radeon* R7 360",
      "tr_GR260": "AMD* Radeon* R7 370",
      "tr_GR261": "AMD* Radeon* R7 430",
      "tr_GR262": "AMD* Radeon* R7 450",
      "tr_GR263": "AMD* Radeon* R7 M260",
      "tr_GR264": "AMD* Radeon* R7 M260DX",
      "tr_GR265": "AMD* Radeon* R7 M265",
      "tr_GR266": "AMD* Radeon* R7 M265DX",
      "tr_GR267": "AMD* Radeon* R7 M340",
      "tr_GR268": "AMD* Radeon* R7 M350",
      "tr_GR269": "AMD* Radeon* R7 M360",
      "tr_GR270": "AMD* Radeon* R7 M370",
      "tr_GR271": "AMD* Radeon* R7 M380",
      "tr_GR272": "AMD* Radeon* R7 M440",
      "tr_GR273": "AMD* Radeon* R7 M460",
      "tr_GR274": "AMD* Radeon* R7 M465",
      "tr_GR275": "AMD* Radeon* R7 M465X",
      "tr_GR276": "AMD* Radeon* R8 M350DX",
      "tr_GR277": "AMD* Radeon* R8 M435DX",
      "tr_GR278": "AMD* Radeon* R8 M535DX",
      "tr_GR279": "AMD* Radeon* R9 200",
      "tr_GR280": "AMD* Radeon* R9 255",
      "tr_GR281": "AMD* Radeon* R9 260",
      "tr_GR282": "AMD* Radeon* R9 270",
      "tr_GR283": "AMD* Radeon* R9 280",
      "tr_GR284": "AMD* Radeon* R9 290",
      "tr_GR285": "AMD* Radeon* R9 290X",
      "tr_GR286": "AMD* Radeon* R9 295X2",
      "tr_GR287": "AMD* Radeon* R9 360",
      "tr_GR288": "AMD* Radeon* R9 370",
      "tr_GR289": "AMD* Radeon* R9 370X",
      "tr_GR290": "AMD* Radeon* R9 380",
      "tr_GR291": "AMD* Radeon* R9 390",
      "tr_GR292": "AMD* Radeon* R9 390X",
      "tr_GR293": "AMD* Radeon* R9 Fury",
      "tr_GR294": "AMD* Radeon* R9 Fury X",
      "tr_GR295": "AMD* Radeon* R9 M200X",
      "tr_GR296": "AMD* Radeon* R9 M275X",
      "tr_GR297": "AMD* Radeon* R9 M280X",
      "tr_GR298": "AMD* Radeon* R9 M360",
      "tr_GR299": "AMD* Radeon* R9 M365X",
      "tr_GR300": "AMD* Radeon* R9 M370X",
      "tr_GR301": "AMD* Radeon* R9 M375",
      "tr_GR302": "AMD* Radeon* R9 M375X",
      "tr_GR303": "AMD* Radeon* R9 M380",
      "tr_GR304": "AMD* Radeon* R9 M385",
      "tr_GR305": "AMD* Radeon* R9 M385X",
      "tr_GR306": "AMD* Radeon* R9 M390X",
      "tr_GR307": "AMD* Radeon* R9 M395X",
      "tr_GR308": "AMD* Radeon* R9 M470X",
      "tr_GR309": "AMD* Radeon* RX 455",
      "tr_GR310": "AMD* Radeon* RX 460",
      "tr_GR311": "AMD* Radeon* RX 470",
      "tr_GR312": "AMD* Radeon* RX 480",
      "tr_GR313": "AMD* Radeon* RX 5300",
      "tr_GR314": "AMD* Radeon* RX 5300M",
      "tr_GR315": "AMD* Radeon* RX 540",
      "tr_GR316": "AMD* Radeon* RX 540X",
      "tr_GR317": "AMD* Radeon* RX 550",
      "tr_GR318": "AMD* Radeon* RX 5500",
      "tr_GR319": "AMD* Radeon* RX 5500 XT",
      "tr_GR320": "AMD* Radeon* RX 5500M",
      "tr_GR321": "AMD* Radeon* RX 550X",
      "tr_GR322": "AMD* Radeon* RX 560",
      "tr_GR323": "AMD* Radeon* RX 560 XT",
      "tr_GR324": "AMD* Radeon* RX 5600",
      "tr_GR325": "AMD* Radeon* RX 5600 OEM",
      "tr_GR326": "AMD* Radeon* RX 5600 XT",
      "tr_GR327": "AMD* Radeon* RX 5600M",
      "tr_GR328": "AMD* Radeon* RX 560X",
      "tr_GR329": "AMD* Radeon* RX 570",
      "tr_GR330": "AMD* Radeon* RX 5700",
      "tr_GR331": "AMD* Radeon* RX 5700 XT",
      "tr_GR332": "AMD* Radeon* RX 5700M",
      "tr_GR333": "AMD* Radeon* RX 570X",
      "tr_GR334": "AMD* Radeon* RX 580",
      "tr_GR335": "AMD* Radeon* RX 580X",
      "tr_GR336": "AMD* Radeon* RX 590",
      "tr_GR337": "AMD* Radeon* RX 590 GME",
      "tr_GR338": "AMD* Radeon* RX 6300",
      "tr_GR339": "AMD* Radeon* RX 6300M",
      "tr_GR340": "AMD* Radeon* RX 640",
      "tr_GR341": "AMD* Radeon* RX 6400",
      "tr_GR342": "AMD* Radeon* RX 6450M",
      "tr_GR343": "AMD* Radeon* RX 6500",
      "tr_GR344": "AMD* Radeon* RX 6500 XT",
      "tr_GR345": "AMD* Radeon* RX 6500M",
      "tr_GR346": "AMD* Radeon* RX 6550M",
      "tr_GR347": "AMD* Radeon* RX 6600",
      "tr_GR348": "AMD* Radeon* RX 6600 LE",
      "tr_GR349": "AMD* Radeon* RX 6600 XT",
      "tr_GR350": "AMD* Radeon* RX 6600M",
      "tr_GR351": "AMD* Radeon* RX 6600S",
      "tr_GR352": "AMD* Radeon* RX 6650 XT",
      "tr_GR353": "AMD* Radeon* RX 6650M",
      "tr_GR354": "AMD* Radeon* RX 6650M XT",
      "tr_GR355": "AMD* Radeon* RX 6700",
      "tr_GR356": "AMD* Radeon* RX 6700 XT",
      "tr_GR357": "AMD* Radeon* RX 6700M",
      "tr_GR358": "AMD* Radeon* RX 6700S",
      "tr_GR359": "AMD* Radeon* RX 6750 GRE",
      "tr_GR360": "AMD* Radeon* RX 6750 XT",
      "tr_GR361": "AMD* Radeon* RX 6800",
      "tr_GR362": "AMD* Radeon* RX 6800 XT",
      "tr_GR363": "AMD* Radeon* RX 6800M",
      "tr_GR364": "AMD* Radeon* RX 6800S",
      "tr_GR365": "AMD* Radeon* RX 6850M XT",
      "tr_GR366": "AMD* Radeon* RX 6900 XT",
      "tr_GR367": "AMD* Radeon* RX 6950 XT",
      "tr_GR368": "AMD* Radeon* RX 7600",
      "tr_GR369": "AMD* Radeon* RX 7600 XT",
      "tr_GR370": "AMD* Radeon* RX 7600M",
      "tr_GR371": "AMD* Radeon* RX 7600M XT",
      "tr_GR372": "AMD* Radeon* RX 7600S",
      "tr_GR373": "AMD* Radeon* RX 7700 XT",
      "tr_GR374": "AMD* Radeon* RX 7700S",
      "tr_GR375": "AMD* Radeon* RX 7800 XT",
      "tr_GR376": "AMD* Radeon* RX 7900 GRE",
      "tr_GR377": "AMD* Radeon* RX 7900 XT",
      "tr_GR378": "AMD* Radeon* RX 7900 XTX",
      "tr_GR379": "AMD* Radeon* RX 7900M",
      "tr_GR380": "AMD* Radeon* RX Vega",
      "tr_GR381": "AMD* Radeon* RX Vega 10",
      "tr_GR382": "AMD* Radeon* RX Vega 11",
      "tr_GR383": "AMD* Radeon* RX Vega 64",
      "tr_GR384": "AMD* Radeon* RX Vega M GH",
      "tr_GR385": "AMD* Radeon* RX Vega M GL",
      "tr_GR386": "กราฟิก Intel® Arc™ A310",
      "tr_GR387": "กราฟิก Intel® Arc™ A350M",
      "tr_GR388": "กราฟิก Intel® Arc™ A370M",
      "tr_GR389": "กราฟิก Intel® Arc™ A380",
      "tr_GR390": "กราฟิก Intel® Arc™ A530M",
      "tr_GR391": "กราฟิก Intel® Arc™ A550M",
      "tr_GR392": "กราฟิก Intel® Arc™ A570M",
      "tr_GR393": "กราฟิก Intel® Arc™ A580",
      "tr_GR394": "กราฟิก Intel® Arc™ A730M",
      "tr_GR395": "กราฟิก Intel® Arc™ A750",
      "tr_GR396": "กราฟิก Intel® Arc™ A770",
      "tr_GR397": "กราฟิก Intel® Arc™ A770M",
      "tr_GR398": "กราฟิก Intel® Arc™",
      "tr_GR399": "กราฟิก Intel® Arc™ Pro A30M",
      "tr_GR400": "กราฟิก Intel® Arc™ Pro A40/A50",
      "tr_GR401": "กราฟิก Intel® Arc™ Pro A60",
      "tr_GR402": "กราฟิก Intel® Arc™ Pro A60M",
      "tr_GR403": "กราฟิก Intel®",
      "tr_GR404": "กราฟิก HD Intel® 2000",
      "tr_GR405": "กราฟิก HD Intel® 2500",
      "tr_GR406": "กราฟิก HD Intel® 3000",
      "tr_GR407": "กราฟิก HD Intel® 400",
      "tr_GR408": "กราฟิก HD Intel® 4000",
      "tr_GR409": "กราฟิก HD Intel® 405",
      "tr_GR410": "กราฟิก HD Intel® 4200",
      "tr_GR411": "กราฟิก HD Intel® 4400",
      "tr_GR412": "กราฟิก HD Intel® 4600",
      "tr_GR413": "กราฟิก HD Intel® 500",
      "tr_GR414": "กราฟิก HD Intel® 5000",
      "tr_GR415": "กราฟิก HD Intel® 505",
      "tr_GR416": "กราฟิก HD Intel® 510",
      "tr_GR417": "กราฟิก HD Intel® 515",
      "tr_GR418": "กราฟิก HD Intel® 520",
      "tr_GR419": "กราฟิก HD Intel® 530",
      "tr_GR420": "กราฟิก HD Intel® 5300",
      "tr_GR421": "กราฟิก HD Intel® 5500",
      "tr_GR422": "กราฟิก HD Intel® 5600",
      "tr_GR423": "กราฟิก HD Intel® 6000",
      "tr_GR424": "กราฟิก HD Intel® 610",
      "tr_GR425": "กราฟิก HD Intel® 615",
      "tr_GR426": "กราฟิก HD Intel® 620",
      "tr_GR427": "กราฟิก HD Intel® 630",
      "tr_GR428": "กราฟิก HD Intel®",
      "tr_GR429": "กราฟิก Intel® Iris® 5100",
      "tr_GR430": "กราฟิก Intel® Iris® 540",
      "tr_GR431": "กราฟิก Intel® Iris® 550",
      "tr_GR432": "กราฟิก Intel® Iris® 6100",
      "tr_GR433": "กราฟิก Intel® Iris® Plus 640",
      "tr_GR434": "กราฟิก Intel® Iris® Plus 645",
      "tr_GR435": "กราฟิก Intel® Iris® Plus 650",
      "tr_GR436": "กราฟิก Intel® Iris® Plus 655",
      "tr_GR437": "กราฟิก Intel® Iris® Plus",
      "tr_GR438": "กราฟิก Intel® Iris® Pro 5200",
      "tr_GR439": "กราฟิก Intel® Iris® Pro 580",
      "tr_GR440": "กราฟิก Intel® Iris® Pro 6200",
      "tr_GR441": "กราฟิก Intel® Iris® X<sup>e</sup>",
      "tr_GR442": "กราฟิก Intel® Iris® X<sup>e</sup> MAX A220M",
      "tr_GR443": "กราฟิก Intel® Iris® X<sup>e</sup> MAX",
      "tr_GR444": "กราฟิก Intel® แบบรวม",
      "tr_GR445": "กราฟิก UHD Intel® 600",
      "tr_GR446": "กราฟิก UHD Intel® 605",
      "tr_GR447": "กราฟิก UHD Intel® 610",
      "tr_GR448": "กราฟิก UHD Intel® 615",
      "tr_GR449": "กราฟิก UHD Intel® 617",
      "tr_GR450": "กราฟิก UHD Intel® 620",
      "tr_GR451": "กราฟิก UHD Intel® 630",
      "tr_GR452": "กราฟิก UHD Intel® 710",
      "tr_GR453": "กราฟิก UHD Intel® 730",
      "tr_GR454": "กราฟิก UHD Intel® 770",
      "tr_GR455": "กราฟิก UHD Intel®",
      "tr_GR456": "กราฟิก UHD Intel®",
      "tr_GR457": "กราฟิก UHD Intel®",
      "tr_GR458": "NVIDIA* GeForce* MX110",
      "tr_GR459": "NVIDIA* GeForce* MX130",
      "tr_GR460": "NVIDIA* GeForce* MX150",
      "tr_GR461": "NVIDIA* GeForce* MX230",
      "tr_GR462": "NVIDIA* GeForce* MX250",
      "tr_GR463": "NVIDIA* GeForce* MX330",
      "tr_GR464": "NVIDIA* GeForce* MX350",
      "tr_GR465": "NVIDIA* GeForce* 410M",
      "tr_GR466": "NVIDIA* GeForce* MX450",
      "tr_GR467": "NVIDIA* GeForce* 510",
      "tr_GR468": "NVIDIA* GeForce* MX550",
      "tr_GR469": "NVIDIA* GeForce* MX570",
      "tr_GR470": "NVIDIA* GeForce* MX570 A",
      "tr_GR471": "NVIDIA* GeForce* 605",
      "tr_GR472": "NVIDIA* GeForce* 610",
      "tr_GR473": "NVIDIA* GeForce* 610M",
      "tr_GR474": "NVIDIA* GeForce* 615",
      "tr_GR475": "NVIDIA* GeForce* 620M",
      "tr_GR476": "NVIDIA* GeForce* 705A",
      "tr_GR477": "NVIDIA* GeForce* 705M",
      "tr_GR478": "NVIDIA* GeForce* 710A",
      "tr_GR479": "NVIDIA* GeForce* 710M",
      "tr_GR480": "NVIDIA* GeForce* 720A",
      "tr_GR481": "NVIDIA* GeForce* 720M",
      "tr_GR482": "NVIDIA* GeForce* 730A",
      "tr_GR483": "NVIDIA* GeForce* 800A",
      "tr_GR484": "NVIDIA* GeForce* 800M",
      "tr_GR485": "NVIDIA* GeForce* 805A",
      "tr_GR486": "NVIDIA* GeForce* 810A",
      "tr_GR487": "NVIDIA* GeForce* 810M",
      "tr_GR488": "NVIDIA* GeForce* 820A",
      "tr_GR489": "NVIDIA* GeForce* 820M",
      "tr_GR490": "NVIDIA* GeForce* 825M",
      "tr_GR491": "NVIDIA* GeForce* 830A",
      "tr_GR492": "NVIDIA* GeForce* 830M",
      "tr_GR493": "NVIDIA* GeForce* 840A",
      "tr_GR494": "NVIDIA* GeForce* 840M",
      "tr_GR495": "NVIDIA* GeForce* 845M",
      "tr_GR496": "NVIDIA* GeForce* 910M",
      "tr_GR497": "NVIDIA* GeForce* 920A",
      "tr_GR498": "NVIDIA* GeForce* 920M",
      "tr_GR499": "NVIDIA* GeForce* 920MX",
      "tr_GR500": "NVIDIA* GeForce* 930A",
      "tr_GR501": "NVIDIA* GeForce* 930M",
      "tr_GR502": "NVIDIA* GeForce* 930MX",
      "tr_GR503": "NVIDIA* GeForce* 940A",
      "tr_GR504": "NVIDIA* GeForce* 940M",
      "tr_GR505": "NVIDIA* GeForce* 940MX",
      "tr_GR506": "NVIDIA* GeForce* 945A",
      "tr_GR507": "NVIDIA* GeForce* 945M",
      "tr_GR508": "NVIDIA* GeForce* GT 1010",
      "tr_GR509": "NVIDIA* GeForce* GT 1030",
      "tr_GR510": "NVIDIA* GeForce* GT 415M",
      "tr_GR511": "NVIDIA* GeForce* GT 420",
      "tr_GR512": "NVIDIA* GeForce* GT 420M",
      "tr_GR513": "NVIDIA* GeForce* GT 425M",
      "tr_GR514": "NVIDIA* GeForce* GT 430",
      "tr_GR515": "NVIDIA* GeForce* GT 435M",
      "tr_GR516": "NVIDIA* GeForce* GT 440",
      "tr_GR517": "NVIDIA* GeForce* GT 445M",
      "tr_GR518": "NVIDIA* GeForce* GT 520",
      "tr_GR519": "NVIDIA* GeForce* GT 520M",
      "tr_GR520": "NVIDIA* GeForce* GT 520MX",
      "tr_GR521": "NVIDIA* GeForce* GT 525M",
      "tr_GR522": "NVIDIA* GeForce* GT 530",
      "tr_GR523": "NVIDIA* GeForce* GT 540M",
      "tr_GR524": "NVIDIA* GeForce* GT 545",
      "tr_GR525": "NVIDIA* GeForce* GT 550M",
      "tr_GR526": "NVIDIA* GeForce* GT 555M",
      "tr_GR527": "NVIDIA* GeForce* GT 610",
      "tr_GR528": "NVIDIA* GeForce* GT 620",
      "tr_GR529": "NVIDIA* GeForce* GT 620M",
      "tr_GR530": "NVIDIA* GeForce* GT 625",
      "tr_GR531": "NVIDIA* GeForce* GT 625M",
      "tr_GR532": "NVIDIA* GeForce* GT 630",
      "tr_GR533": "NVIDIA* GeForce* GT 630M",
      "tr_GR534": "NVIDIA* GeForce* GT 635",
      "tr_GR535": "NVIDIA* GeForce* GT 635M",
      "tr_GR536": "NVIDIA* GeForce* GT 640",
      "tr_GR537": "NVIDIA* GeForce* GT 640M",
      "tr_GR538": "NVIDIA* GeForce* GT 640M LE",
      "tr_GR539": "NVIDIA* GeForce* GT 645",
      "tr_GR540": "NVIDIA* GeForce* GT 645M",
      "tr_GR541": "NVIDIA* GeForce* GT 650M",
      "tr_GR542": "NVIDIA* GeForce* GT 705",
      "tr_GR543": "NVIDIA* GeForce* GT 710",
      "tr_GR544": "NVIDIA* GeForce* GT 710M",
      "tr_GR545": "NVIDIA* GeForce* GT 720",
      "tr_GR546": "NVIDIA* GeForce* GT 720A",
      "tr_GR547": "NVIDIA* GeForce* GT 720M",
      "tr_GR548": "NVIDIA* GeForce* GT 730",
      "tr_GR549": "NVIDIA* GeForce* GT 730M",
      "tr_GR550": "NVIDIA* GeForce* GT 735M",
      "tr_GR551": "NVIDIA* GeForce* GT 740",
      "tr_GR552": "NVIDIA* GeForce* GT 740A",
      "tr_GR553": "NVIDIA* GeForce* GT 740M",
      "tr_GR554": "NVIDIA* GeForce* GT 745A",
      "tr_GR555": "NVIDIA* GeForce* GT 745M",
      "tr_GR556": "NVIDIA* GeForce* GT 750M",
      "tr_GR557": "NVIDIA* GeForce* GT 755M",
      "tr_GR558": "NVIDIA* GeForce* GT 820M",
      "tr_GR559": "NVIDIA* GeForce* GTS 450",
      "tr_GR560": "NVIDIA* GeForce* GTX 1050",
      "tr_GR561": "NVIDIA* GeForce* GTX 1050 ที่มี Max-Q Design",
      "tr_GR562": "NVIDIA* GeForce* GTX 1050 Ti",
      "tr_GR563": "NVIDIA* GeForce* GTX 1050 Ti ที่มี Max-Q Design",
      "tr_GR564": "NVIDIA* GeForce* GTX 1060",
      "tr_GR565": "NVIDIA* GeForce* GTX 1060 ที่มี Max-Q Design",
      "tr_GR566": "NVIDIA* GeForce* GTX 1070",
      "tr_GR567": "NVIDIA* GeForce* GTX 1070 ที่มี Max-Q Design",
      "tr_GR568": "NVIDIA* GeForce* GTX 1070 Ti",
      "tr_GR569": "NVIDIA* GeForce* GTX 1080",
      "tr_GR570": "NVIDIA* GeForce* GTX 1080 ที่มี Max-Q Design",
      "tr_GR571": "NVIDIA* GeForce* GTX 1080 Ti",
      "tr_GR572": "NVIDIA* GeForce* GTX 1630",
      "tr_GR573": "NVIDIA* GeForce* GTX 1650",
      "tr_GR574": "NVIDIA* GeForce* GTX 1650 ที่มี Max-Q Design",
      "tr_GR575": "NVIDIA* GeForce* GTX 1650 SUPER",
      "tr_GR576": "NVIDIA* GeForce* GTX 1650 Ti",
      "tr_GR577": "NVIDIA* GeForce* GTX 1650 Ti ที่มี Max-Q Design",
      "tr_GR578": "NVIDIA* GeForce* GTX 1660",
      "tr_GR579": "NVIDIA* GeForce* GTX 1660 SUPER",
      "tr_GR580": "NVIDIA* GeForce* GTX 1660 Ti",
      "tr_GR581": "NVIDIA* GeForce* GTX 1660 Ti ที่มี Max-Q Design",
      "tr_GR582": "NVIDIA* GeForce* GTX 460",
      "tr_GR583": "NVIDIA* GeForce* GTX 460 SE",
      "tr_GR584": "NVIDIA* GeForce* GTX 460 v2",
      "tr_GR585": "NVIDIA* GeForce* GTX 460M",
      "tr_GR586": "NVIDIA* GeForce* GTX 465",
      "tr_GR587": "NVIDIA* GeForce* GTX 470",
      "tr_GR588": "NVIDIA* GeForce* GTX 470M",
      "tr_GR589": "NVIDIA* GeForce* GTX 480",
      "tr_GR590": "NVIDIA* GeForce* GTX 480M",
      "tr_GR591": "NVIDIA* GeForce* GTX 485M",
      "tr_GR592": "NVIDIA* GeForce* GTX 550 Ti",
      "tr_GR593": "NVIDIA* GeForce* GTX 555",
      "tr_GR594": "NVIDIA* GeForce* GTX 560",
      "tr_GR595": "NVIDIA* GeForce* GTX 560 SE",
      "tr_GR596": "NVIDIA* GeForce* GTX 560 Ti",
      "tr_GR597": "NVIDIA* GeForce* GTX 560M",
      "tr_GR598": "NVIDIA* GeForce* GTX 570",
      "tr_GR599": "NVIDIA* GeForce* GTX 570M",
      "tr_GR600": "NVIDIA* GeForce* GTX 580",
      "tr_GR601": "NVIDIA* GeForce* GTX 580M",
      "tr_GR602": "NVIDIA* GeForce* GTX 590",
      "tr_GR603": "NVIDIA* GeForce* GTX 645",
      "tr_GR604": "NVIDIA* GeForce* GTX 650",
      "tr_GR605": "NVIDIA* GeForce* GTX 650 Ti",
      "tr_GR606": "NVIDIA* GeForce* GTX 660",
      "tr_GR607": "NVIDIA* GeForce* GTX 660 Ti",
      "tr_GR608": "NVIDIA* GeForce* GTX 660M",
      "tr_GR609": "NVIDIA* GeForce* GTX 670",
      "tr_GR610": "NVIDIA* GeForce* GTX 670M",
      "tr_GR611": "NVIDIA* GeForce* GTX 670MX",
      "tr_GR612": "NVIDIA* GeForce* GTX 675M",
      "tr_GR613": "NVIDIA* GeForce* GTX 675MX",
      "tr_GR614": "NVIDIA* GeForce* GTX 680",
      "tr_GR615": "NVIDIA* GeForce* GTX 680M",
      "tr_GR616": "NVIDIA* GeForce* GTX 680MX",
      "tr_GR617": "NVIDIA* GeForce* GTX 690",
      "tr_GR618": "NVIDIA* GeForce* GTX 745",
      "tr_GR619": "NVIDIA* GeForce* GTX 750",
      "tr_GR620": "NVIDIA* GeForce* GTX 750 Ti",
      "tr_GR621": "NVIDIA* GeForce* GTX 760",
      "tr_GR622": "NVIDIA* GeForce* GTX 760 Ti",
      "tr_GR623": "NVIDIA* GeForce* GTX 760A",
      "tr_GR624": "NVIDIA* GeForce* GTX 760M",
      "tr_GR625": "NVIDIA* GeForce* GTX 765M",
      "tr_GR626": "NVIDIA* GeForce* GTX 770",
      "tr_GR627": "NVIDIA* GeForce* GTX 770M",
      "tr_GR628": "NVIDIA* GeForce* GTX 775M",
      "tr_GR629": "NVIDIA* GeForce* GTX 780",
      "tr_GR630": "NVIDIA* GeForce* GTX 780 Ti",
      "tr_GR631": "NVIDIA* GeForce* GTX 780M",
      "tr_GR632": "NVIDIA* GeForce* GTX 850A",
      "tr_GR633": "NVIDIA* GeForce* GTX 850M",
      "tr_GR634": "NVIDIA* GeForce* GTX 860M",
      "tr_GR635": "NVIDIA* GeForce* GTX 870M",
      "tr_GR636": "NVIDIA* GeForce* GTX 880M",
      "tr_GR637": "NVIDIA* GeForce* GTX 950",
      "tr_GR638": "NVIDIA* GeForce* GTX 950A",
      "tr_GR639": "NVIDIA* GeForce* GTX 950M",
      "tr_GR640": "NVIDIA* GeForce* GTX 960",
      "tr_GR641": "NVIDIA* GeForce* GTX 960A",
      "tr_GR642": "NVIDIA* GeForce* GTX 960M",
      "tr_GR643": "NVIDIA* GeForce* GTX 965M",
      "tr_GR644": "NVIDIA* GeForce* GTX 970",
      "tr_GR645": "NVIDIA* GeForce* GTX 970M",
      "tr_GR646": "NVIDIA* GeForce* GTX 980",
      "tr_GR647": "NVIDIA* GeForce* GTX 980 Ti",
      "tr_GR648": "NVIDIA* GeForce* GTX 980M",
      "tr_GR649": "NVIDIA* GeForce* GTX TITAN",
      "tr_GR650": "NVIDIA* GeForce* GTX TITAN Black",
      "tr_GR651": "NVIDIA* GeForce* GTX TITAN X",
      "tr_GR652": "NVIDIA* GeForce* GTX TITAN Z",
      "tr_GR653": "NVIDIA* GeForce* RTX 2050",
      "tr_GR654": "NVIDIA* GeForce* RTX 2060",
      "tr_GR655": "NVIDIA* GeForce* RTX 2060 ที่มี Max-Q Design",
      "tr_GR656": "NVIDIA* GeForce* RTX 2060 SUPER",
      "tr_GR657": "NVIDIA* GeForce* RTX 2070",
      "tr_GR658": "NVIDIA* GeForce* RTX 2070 ที่มี Max-Q Design",
      "tr_GR659": "NVIDIA* GeForce* RTX 2070 SUPER",
      "tr_GR660": "NVIDIA* GeForce* RTX 2070 Super ที่มี Max-Q Design",
      "tr_GR661": "NVIDIA* GeForce* RTX 2080",
      "tr_GR662": "NVIDIA* GeForce* RTX 2080 ที่มี Max-Q Design",
      "tr_GR663": "NVIDIA* GeForce* RTX 2080 SUPER",
      "tr_GR664": "NVIDIA* GeForce* RTX 2080 Super ที่มี Max-Q Design",
      "tr_GR665": "NVIDIA* GeForce* RTX 2080 Ti",
      "tr_GR666": "NVIDIA* GeForce* RTX 3050",
      "tr_GR667": "NVIDIA* GeForce* RTX 3050 Ti",
      "tr_GR668": "NVIDIA* GeForce* RTX 3060",
      "tr_GR669": "NVIDIA* GeForce* RTX 3060 Ti",
      "tr_GR670": "NVIDIA* GeForce* RTX 3070",
      "tr_GR671": "NVIDIA* GeForce* RTX 3070 Ti",
      "tr_GR672": "NVIDIA* GeForce* RTX 3080",
      "tr_GR673": "NVIDIA* GeForce* RTX 3080 Ti",
      "tr_GR674": "NVIDIA* GeForce* RTX 3090",
      "tr_GR675": "NVIDIA* GeForce* RTX 3090 Ti",
      "tr_GR676": "NVIDIA* GeForce* RTX 4050",
      "tr_GR677": "NVIDIA* GeForce* RTX 4060",
      "tr_GR678": "NVIDIA* GeForce* RTX 4060 Ti",
      "tr_GR679": "NVIDIA* GeForce* RTX 4070",
      "tr_GR680": "NVIDIA* GeForce* RTX 4070 SUPER",
      "tr_GR681": "NVIDIA* GeForce* RTX 4070 Ti",
      "tr_GR682": "NVIDIA* GeForce* RTX 4070 Ti SUPER",
      "tr_GR683": "NVIDIA* GeForce* RTX 4080",
      "tr_GR684": "NVIDIA* GeForce* RTX 4090",
      "tr_GR685": "NVIDIA* GeForce* RTX 4090 D",
      "tr_GR686": "NVIDIA* NVS* 310",
      "tr_GR687": "NVIDIA* NVS* 315",
      "tr_GR688": "NVIDIA* NVS* 4200M",
      "tr_GR689": "NVIDIA* NVS* 510",
      "tr_GR690": "NVIDIA* NVS* 5200M",
      "tr_GR691": "NVIDIA* NVS* 5400M",
      "tr_GR692": "NVIDIA* NVS* 810",
      "tr_GR693": "NVIDIA* Quadro* 410",
      "tr_GR694": "NVIDIA* Quadro* GP100",
      "tr_GR695": "NVIDIA* Quadro* GV100",
      "tr_GR696": "NVIDIA* Quadro* K1000M",
      "tr_GR697": "NVIDIA* Quadro* K1100M",
      "tr_GR698": "NVIDIA* Quadro* K1200",
      "tr_GR699": "NVIDIA* Quadro* K2000",
      "tr_GR700": "NVIDIA* Quadro* K2000D",
      "tr_GR701": "NVIDIA* Quadro* K2000M",
      "tr_GR702": "NVIDIA* Quadro* K2100M",
      "tr_GR703": "NVIDIA* Quadro* K2200",
      "tr_GR704": "NVIDIA* Quadro* K2200M",
      "tr_GR705": "NVIDIA* Quadro* K3000M",
      "tr_GR706": "NVIDIA* Quadro* K3100M",
      "tr_GR707": "NVIDIA* Quadro* K4000",
      "tr_GR708": "NVIDIA* Quadro* K4000M",
      "tr_GR709": "NVIDIA* Quadro* K4100M",
      "tr_GR710": "NVIDIA* Quadro* K420",
      "tr_GR711": "NVIDIA* Quadro* K4200",
      "tr_GR712": "NVIDIA* Quadro* K5000",
      "tr_GR713": "NVIDIA* Quadro* K5000M",
      "tr_GR714": "NVIDIA* Quadro* K500M",
      "tr_GR715": "NVIDIA* Quadro* K5100M",
      "tr_GR716": "NVIDIA* Quadro* K510M",
      "tr_GR717": "NVIDIA* Quadro* K5200",
      "tr_GR718": "NVIDIA* Quadro* K600",
      "tr_GR719": "NVIDIA* Quadro* K6000",
      "tr_GR720": "NVIDIA* Quadro* K610M",
      "tr_GR721": "NVIDIA* Quadro* K620",
      "tr_GR722": "NVIDIA* Quadro* K620M",
      "tr_GR723": "NVIDIA* Quadro* M1000M",
      "tr_GR724": "NVIDIA* Quadro* M1200",
      "tr_GR725": "NVIDIA* Quadro* M2000",
      "tr_GR726": "NVIDIA* Quadro* M2000M",
      "tr_GR727": "NVIDIA* Quadro* M2200",
      "tr_GR728": "NVIDIA* Quadro* M3000M",
      "tr_GR729": "NVIDIA* Quadro* M4000",
      "tr_GR730": "NVIDIA* Quadro* M4000M",
      "tr_GR731": "NVIDIA* Quadro* M5000",
      "tr_GR732": "NVIDIA* Quadro* M5000M",
      "tr_GR733": "NVIDIA* Quadro* M500M",
      "tr_GR734": "NVIDIA* Quadro* M520",
      "tr_GR735": "NVIDIA* Quadro* M5500",
      "tr_GR736": "NVIDIA* Quadro* M6000",
      "tr_GR737": "NVIDIA* Quadro* M600M",
      "tr_GR738": "NVIDIA* Quadro* M620",
      "tr_GR739": "NVIDIA* Quadro* P1000",
      "tr_GR740": "NVIDIA* Quadro* P2000",
      "tr_GR741": "NVIDIA* Quadro* P2000 ที่มี Max-Q Design",
      "tr_GR742": "NVIDIA* Quadro* P2200",
      "tr_GR743": "NVIDIA* Quadro* P3000",
      "tr_GR744": "NVIDIA* Quadro* P3200",
      "tr_GR745": "NVIDIA* Quadro* P3200 ที่มี Max-Q Design",
      "tr_GR746": "NVIDIA* Quadro* P400",
      "tr_GR747": "NVIDIA* Quadro* P4000",
      "tr_GR748": "NVIDIA* Quadro* P4000 ที่มี Max-Q Design",
      "tr_GR749": "NVIDIA* Quadro* P4200",
      "tr_GR750": "NVIDIA* Quadro* P4200 ที่มี Max-Q Design",
      "tr_GR751": "NVIDIA* Quadro* P500",
      "tr_GR752": "NVIDIA* Quadro* P5000",
      "tr_GR753": "NVIDIA* Quadro* P520",
      "tr_GR754": "NVIDIA* Quadro* P5200",
      "tr_GR755": "NVIDIA* Quadro* P5200 ที่มี Max-Q Design",
      "tr_GR756": "NVIDIA* Quadro* P600",
      "tr_GR757": "NVIDIA* Quadro* P6000",
      "tr_GR758": "NVIDIA* Quadro* P620",
      "tr_GR759": "NVIDIA* Quadro* RTX 3000",
      "tr_GR760": "NVIDIA* Quadro* RTX 3000 ที่มี Max-Q Design",
      "tr_GR761": "NVIDIA* Quadro* RTX 4000",
      "tr_GR762": "NVIDIA* Quadro* RTX 4000 ที่มี Max-Q Design",
      "tr_GR763": "NVIDIA* Quadro* RTX 5000",
      "tr_GR764": "NVIDIA* Quadro* RTX 5000 ที่มี Max-Q Design",
      "tr_GR765": "NVIDIA* Quadro* RTX 6000",
      "tr_GR766": "NVIDIA* Quadro* RTX 8000",
      "tr_GR767": "NVIDIA* Quadro* T1000",
      "tr_GR768": "NVIDIA* Quadro* T1000 ที่มี Max-Q Design",
      "tr_GR769": "NVIDIA* Quadro* T2000",
      "tr_GR770": "NVIDIA* Quadro* T2000 ที่มี Max-Q Design",
      "tr_GR771": "NVIDIA* T500",
      "tr_GR772": "NVIDIA* RTX 2000 Ada Generation",
      "tr_GR773": "NVIDIA* RTX 3000 Ada Generation",
      "tr_GR774": "NVIDIA* RTX 3500 Ada Generation",
      "tr_GR775": "NVIDIA* RTX 4000 Ada Generation",
      "tr_GR776": "NVIDIA* RTX 4000 SFF Ada Generation",
      "tr_GR777": "NVIDIA* RTX 4500 Ada Generation",
      "tr_GR778": "NVIDIA* RTX 5000 Ada Generation",
      "tr_GR779": "NVIDIA* RTX 5880 Ada Generation",
      "tr_GR780": "NVIDIA* Tesla* C2050 / C2070",
      "tr_GR781": "NVIDIA* Tesla* C2070",
      "tr_GR782": "NVIDIA* Tesla* C2075",
      "tr_GR783": "NVIDIA* Tesla* K10",
      "tr_GR784": "NVIDIA* Tesla* K20c",
      "tr_GR785": "NVIDIA* Tesla* K20m",
      "tr_GR786": "NVIDIA* Tesla* K20s",
      "tr_GR787": "NVIDIA* Tesla* K20Xm",
      "tr_GR788": "NVIDIA* Tesla* K40c",
      "tr_GR789": "NVIDIA* Tesla* K40m",
      "tr_GR790": "NVIDIA* Tesla* K40s",
      "tr_GR791": "NVIDIA* Tesla* K40st",
      "tr_GR792": "NVIDIA* Tesla* K40t",
      "tr_GR793": "NVIDIA* Tesla* K8",
      "tr_GR794": "NVIDIA* Tesla* K80",
      "tr_GR795": "NVIDIA* Tesla* M2050",
      "tr_GR796": "NVIDIA* Tesla* M2070",
      "tr_GR797": "NVIDIA* Tesla* M2070-Q",
      "tr_GR798": "NVIDIA* Tesla* M2075",
      "tr_GR799": "NVIDIA* Tesla* M2090",
      "tr_GR800": "NVIDIA* Tesla* S2050",
      "tr_GR801": "NVIDIA* Tesla* T20",
      "tr_GR802": "NVIDIA* Tesla* T4",
      "tr_GR803": "NVIDIA* Tesla* X2070",
      "tr_GR804": "NVIDIA* Tesla* X2090",
      "tr_GR805": "NVIDIA* TITAN RTX",
      "tr_GR806": "NVIDIA* TITAN V",
      "tr_GR807": "NVIDIA* TITAN X",
      "tr_GR808": "NVIDIA* TITAN Xp",
      "tr_GR809": "NVIDIA* GeForce* RTX 4080 SUPER",
      "tr_GR810": "NVIDIA* RTX 500 Ada Generation",
      "tr_GR811": "NVIDIA* RTX 1000 Ada Generation",
      "tr_GR812": "กราฟิก Intel® Arc™",
      "tr_GR813": "NVIDIA* GeForce* RTX 3050 A",
      "tr_GR814": "NVIDIA RTX* 2000E Ada Generation",
      "tr_GR815": "AMD Radeon* Pro W7900 Dual Slot",
      "tr_GR816": "AMD Radeon* RX 7800M",
      "tr_GR817": "กราฟิก Intel® Arc™ B570",
      "tr_GR818": "กราฟิก Intel® Arc™ B580",
      "tr_GR819": "กราฟิก Intel® Arc™ A310E",
      "tr_GR820": "กราฟิก Intel® Arc™ A350E",
      "tr_GR821": "กราฟิก Intel® Arc™ A370E",
      "tr_GR822": "กราฟิก Intel® Arc™ A380E",
      "tr_GR823": "กราฟิก Intel® Arc™ A580E",
      "tr_GR824": "กราฟิก Intel® Arc™ A750E",
      "tr_GR825": "กราฟิก Intel® Iris® X<sup>e</sup> MAX 101",
      "tr_GR826": "กราฟิก UHD Intel® 750",
      "tr_GR827": "NVIDIA* GeForce* RTX 5080",
      "tr_GR828": "NVIDIA* GeForce* RTX 5090",
      "tr_GR829": "NVIDIA* GeForce* RTX 5090 D",
      "tr_GR830": "AMD Radeon* RX 7650 GRE",
      "tr_GR831": "AMD Radeon* RX 9070",
      "tr_GR832": "AMD Radeon* RX 9070 XT",
      "tr_GR833": "NVIDIA* GeForce* RTX 5070",
      "tr_GR834": "NVIDIA* GeForce* RTX 5070 Ti",
      "tr_GR835": "กราฟิก Intel® Arc™ B390"
    },
    "tr_ProcessorDescriptionMapping": {
      "tr_Proc1": "โปรเซสเซอร์ Intel® Core™ Ultra 5 225",
      "tr_Proc2": "โปรเซสเซอร์ Intel® Core™ Ultra 5 225F",
      "tr_Proc3": "โปรเซสเซอร์ Intel® Core™ Ultra 5 225H",
      "tr_Proc4": "โปรเซสเซอร์ Intel® Core™ Ultra 5 225T",
      "tr_Proc5": "โปรเซสเซอร์ Intel® Core™ Ultra 5 225U",
      "tr_Proc6": "โปรเซสเซอร์ Intel® Core™ Ultra 5 235",
      "tr_Proc7": "โปรเซสเซอร์ Intel® Core™ Ultra 5 235H",
      "tr_Proc8": "โปรเซสเซอร์ Intel® Core™ Ultra 5 235HX",
      "tr_Proc9": "โปรเซสเซอร์ Intel® Core™ Ultra 5 235T",
      "tr_Proc10": "โปรเซสเซอร์ Intel® Core™ Ultra 5 235U",
      "tr_Proc11": "โปรเซสเซอร์ Intel® Core™ Ultra 5 245",
      "tr_Proc12": "โปรเซสเซอร์ Intel® Core™ Ultra 5 245HX",
      "tr_Proc13": "โปรเซสเซอร์ Intel® Core™ Ultra 5 245T",
      "tr_Proc14": "โปรเซสเซอร์ Intel® Core™ Ultra 7 255H",
      "tr_Proc15": "โปรเซสเซอร์ Intel® Core™ Ultra 7 255HX",
      "tr_Proc16": "โปรเซสเซอร์ Intel® Core™ Ultra 7 255U",
      "tr_Proc17": "โปรเซสเซอร์ Intel® Core™ Ultra 7 265",
      "tr_Proc18": "โปรเซสเซอร์ Intel® Core™ Ultra 7 265F",
      "tr_Proc19": "โปรเซสเซอร์ Intel® Core™ Ultra 7 265H",
      "tr_Proc20": "โปรเซสเซอร์ Intel® Core™ Ultra 7 265HX",
      "tr_Proc21": "โปรเซสเซอร์ Intel® Core™ Ultra 7 265T",
      "tr_Proc22": "โปรเซสเซอร์ Intel® Core™ Ultra 7 265U",
      "tr_Proc23": "โปรเซสเซอร์ Intel® Core™ Ultra 9 275HX",
      "tr_Proc24": "โปรเซสเซอร์ Intel® Core™ Ultra 9 285",
      "tr_Proc25": "โปรเซสเซอร์ Intel® Core™ Ultra 9 285H",
      "tr_Proc26": "โปรเซสเซอร์ Intel® Core™ Ultra 9 285HX",
      "tr_Proc27": "โปรเซสเซอร์ Intel® Core™ Ultra 9 285T",
      "tr_Proc28": "โปรเซสเซอร์ Intel® Core™ Ultra 5 245K",
      "tr_Proc29": "โปรเซสเซอร์ Intel® Core™ Ultra 5 245KF",
      "tr_Proc30": "โปรเซสเซอร์ Intel® Core™ Ultra 7 265K",
      "tr_Proc31": "โปรเซสเซอร์ Intel® Core™ Ultra 7 265KF",
      "tr_Proc32": "โปรเซสเซอร์ Intel® Core™ Ultra 9 285K",
      "tr_Proc33": "โปรเซสเซอร์ Intel® Core™ Ultra 5 226V",
      "tr_Proc34": "โปรเซสเซอร์ Intel® Core™ Ultra 5 228V",
      "tr_Proc35": "โปรเซสเซอร์ Intel® Core™ Ultra 5 236V",
      "tr_Proc36": "โปรเซสเซอร์ Intel® Core™ Ultra 5 238V",
      "tr_Proc37": "โปรเซสเซอร์ Intel® Core™ Ultra 7 256V",
      "tr_Proc38": "โปรเซสเซอร์ Intel® Core™ Ultra 7 258V",
      "tr_Proc39": "โปรเซสเซอร์ Intel® Core™ Ultra 7 266V",
      "tr_Proc40": "โปรเซสเซอร์ Intel® Core™ Ultra 7 268V",
      "tr_Proc41": "โปรเซสเซอร์ Intel® Core™ Ultra 9 288V",
      "tr_Proc42": "โปรเซสเซอร์ Intel® Core™ Ultra 7 105UL",
      "tr_Proc43": "โปรเซสเซอร์ Intel® Core™ Ultra 5 125HL",
      "tr_Proc44": "โปรเซสเซอร์ Intel® Core™ Ultra 5 125UL",
      "tr_Proc45": "โปรเซสเซอร์ Intel® Core™ Ultra 5 135HL",
      "tr_Proc46": "โปรเซสเซอร์ Intel® Core™ Ultra 5 135UL",
      "tr_Proc47": "โปรเซสเซอร์ Intel® Core™ Ultra 7 155HL",
      "tr_Proc48": "โปรเซสเซอร์ Intel® Core™ Ultra 7 155UL",
      "tr_Proc49": "โปรเซสเซอร์ Intel® Core™ Ultra 7 165HL",
      "tr_Proc50": "โปรเซสเซอร์ Intel® Core™ Ultra 7 165UL",
      "tr_Proc51": "โปรเซสเซอร์ Intel® Core™ Ultra 5 125H",
      "tr_Proc52": "โปรเซสเซอร์ Intel® Core™ Ultra 5 125U",
      "tr_Proc53": "โปรเซสเซอร์ Intel® Core™ Ultra 5 134U",
      "tr_Proc54": "โปรเซสเซอร์ Intel® Core™ Ultra 5 135H",
      "tr_Proc55": "โปรเซสเซอร์ Intel® Core™ Ultra 5 135U",
      "tr_Proc56": "โปรเซสเซอร์ Intel® Core™ Ultra 7 155H",
      "tr_Proc57": "โปรเซสเซอร์ Intel® Core™ Ultra 7 155U",
      "tr_Proc58": "โปรเซสเซอร์ Intel® Core™ Ultra 7 164U",
      "tr_Proc59": "โปรเซสเซอร์ Intel® Core™ Ultra 7 165H",
      "tr_Proc60": "โปรเซสเซอร์ Intel® Core™ Ultra 7 165U",
      "tr_Proc61": "โปรเซสเซอร์ Intel® Core™ Ultra 9 185H",
      "tr_Proc62": "โปรเซสเซอร์ Intel® Core™ Ultra 5 250K",
      "tr_Proc63": "โปรเซสเซอร์ Intel® Core™ Ultra 5 250KF",
      "tr_Proc64": "โปรเซสเซอร์ Intel® Core™ Ultra 7 270K",
      "tr_Proc65": "โปรเซสเซอร์ Intel® Core™ Ultra 9 290K",
      "tr_Proc66": "โปรเซสเซอร์ Intel® Core™ Ultra 5 322",
      "tr_Proc67": "โปรเซสเซอร์ Intel® Core™ Ultra 5 325",
      "tr_Proc68": "โปรเซสเซอร์ Intel® Core™ Ultra 5 332",
      "tr_Proc69": "โปรเซสเซอร์ Intel® Core™ Ultra 5 335",
      "tr_Proc70": "โปรเซสเซอร์ Intel® Core™ Ultra 5 336H",
      "tr_Proc71": "โปรเซสเซอร์ Intel® Core™ Ultra 5 338H",
      "tr_Proc72": "โปรเซสเซอร์ Intel® Core™ Ultra 7 355",
      "tr_Proc73": "โปรเซสเซอร์ Intel® Core™ Ultra 7 356H",
      "tr_Proc74": "โปรเซสเซอร์ Intel® Core™ Ultra 7 365",
      "tr_Proc75": "โปรเซสเซอร์ Intel® Core™ Ultra 7 366H",
      "tr_Proc76": "โปรเซสเซอร์ Intel® Core™ Ultra 9 386H",
      "tr_Proc77": "โปรเซสเซอร์ Intel® Core™ Ultra X7 358H",
      "tr_Proc78": "โปรเซสเซอร์ Intel® Core™ Ultra X7 368H",
      "tr_Proc79": "โปรเซสเซอร์ Intel® Core™ Ultra X9 388H"
    },
    "tr_WifiDescMapping": {
      "tr_Wifi1": "Intel® เซนทริโน® Advanced-N 6200 ABG",
      "tr_Wifi2": "Intel® เซนทริโน® Advanced-N 6200 AGN",
      "tr_Wifi3": "Intel® เซนทริโน® Advanced-N 6200 BG",
      "tr_Wifi4": "Intel® เซนทริโน® Advanced-N 6205",
      "tr_Wifi5": "Intel® เซนทริโน® Advanced-N 6230",
      "tr_Wifi6": "Intel® เซนทริโน® Advanced-N 6235",
      "tr_Wifi7": "Intel® เซนทริโน® Advanced-N 6250 ABG",
      "tr_Wifi8": "Intel® เซนทริโน® Advanced-N 6250 AGN",
      "tr_Wifi9": "Intel® เซนทริโน® Ultimate-N 6300 AGN",
      "tr_Wifi10": "Intel® เซนทริโน® Wireless-N 100",
      "tr_Wifi11": "Intel® เซนทริโน® Wireless-N 1000",
      "tr_Wifi12": "Intel® เซนทริโน® Wireless-N 1030",
      "tr_Wifi13": "Intel® เซนทริโน® Wireless-N 105",
      "tr_Wifi14": "Intel® เซนทริโน® Wireless-N 135",
      "tr_Wifi15": "Intel® เซนทริโน® Wireless-N 2200",
      "tr_Wifi16": "Intel® เซนทริโน® Wireless-N 2230",
      "tr_Wifi17": "Intel® เซนทริโน® Wireless-N WiMAX 6150",
      "tr_Wifi18": "Intel® Dual Band Wireless-AC 3160",
      "tr_Wifi19": "Intel® Dual Band Wireless-AC 3165",
      "tr_Wifi20": "Intel® Dual Band Wireless-AC 7260",
      "tr_Wifi21": "Intel® Dual Band Wireless-AC 7265",
      "tr_Wifi22": "Intel® Dual Band Wireless-N 3160",
      "tr_Wifi23": "Intel® Dual Band Wireless-N 7260",
      "tr_Wifi24": "Intel® Dual Band Wireless-N 7265",
      "tr_Wifi25": "Intel® Tri-Band Wireless-AC 17261",
      "tr_Wifi26": "Intel® Wi-Fi 6 AX101",
      "tr_Wifi27": "Intel® Wi-Fi 6 AX200",
      "tr_Wifi28": "Intel® Wi-Fi 6 AX201",
      "tr_Wifi29": "Intel® Wi-Fi 6 AX203",
      "tr_Wifi30": "Intel® Wi-Fi 6E AX210",
      "tr_Wifi31": "Intel® Wi-Fi 6E AX211",
      "tr_Wifi32": "Intel® Wi-Fi 6E AX411",
      "tr_Wifi33": "Intel® Wi-Fi 7 BE200",
      "tr_Wifi34": "Intel® Wi-Fi 7 BE202",
      "tr_Wifi35": "Intel® Wireless-AC 3165",
      "tr_Wifi36": "Intel® Wireless-AC 3168",
      "tr_Wifi37": "Intel® Wireless-AC 8265",
      "tr_Wifi38": "Intel® Wireless-AC 9260",
      "tr_Wifi39": "Intel® Wireless-AC 9461",
      "tr_Wifi40": "Intel® Wireless-AC 9462",
      "tr_Wifi41": "Intel® Wireless-AC 9560",
      "tr_Wifi42": "Intel® Wireless-N 3160",
      "tr_Wifi43": "Intel® Wireless-N 7260",
      "tr_Wifi44": "Intel® Wireless-N 7265",
      "tr_Wifi45": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi46": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi47": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi48": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi49": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi50": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi51": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi52": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi53": "Intel® Killer™ Wi-Fi 6E AX1690",
      "tr_Wifi54": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi55": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi56": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi57": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi58": "Intel® Wi-Fi 7 BE201",
      "tr_Wifi59": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi60": "Intel® Killer™ Wi-Fi 7 BE1750"
    },
    "tr_textBuyNow": "ซื้อเลย",
    "tr_textTryagain": "ลองอีกครั้ง",
    "tr_textBuynowErr": "ตัวเลือก “ซื้อเลย” ไม่พร้อมใช้งานเนื่องจากมีการขัดจังหวะการเชื่อมต่อ",
    "tr_chatbotPlaceholder_text": "ถามได้ทุกอย่างเกี่ยวกับอุปกรณ์",
    "tr_chatbotPlaceholder_gaming_text": "สอบถามเรื่องใดก็ได้เกี่ยวกับอุปกรณ์ด้วยความช่วยเหลือของ AI",
    "tr_deviceSpecs_text": "ข้อมูลจำเพาะของอุปกรณ์",
    "tr_laptop": "แล็ปท็อป",
    "tr_desktop": "เดสก์ท็อป",
    "tr_back": "กลับ",
    "tr_HomePageNavigation": {
      "tr_overview": "ภาพรวม",
      "tr_specs": "ข้อมูลจำเพาะ",
      "tr_virtualAssistant": "ผู้ช่วยเสมือน",
      "tr_promos": "โปรโมชั่น",
      "tr_compareDevices": "เปรียบเทียบอุปกรณ์"
    },
    "tr_compareText": "เปรียบเทียบอุปกรณ์นี้",
    "tr_PTLHomePageText": "ก้าวสำคัญครั้งต่อไปของคุณเริ่มต้นที่นี่",
    "tr_PTL12XEHomePageText": "ดีไซน์บางเฉียบ ประสิทธิภาพเต็มพลัง",
    "tr_OnboardingText": {
      "tr_welcome": "ยินดีต้อนรับ",
      "tr_start_text": "คุณต้องการเริ่มต้นที่ไหน?",
      "tr_tabs": [
        {
          "tr_tab_heading": "ภาพรวม",
          "tr_tab_subheading": "ค้นพบว่าอุปกรณ์นี้ทำอะไรได้บ้าง"
        },
        {
          "tr_tab_heading": "ข้อมูลจำเพาะ",
          "tr_tab_subheading": "สำรวจคุณสมบัติและฮาร์ดแวร์"
        },
        {
          "tr_tab_heading": "โปรโมชันตามฤดูกาล",
          "tr_tab_subheading": "ค้นหาข้อเสนอและดีลล่าสุด"
        },
        {
          "tr_tab_heading": "เปรียบเทียบ",
          "tr_tab_subheading": "เปรียบเทียบอุปกรณ์แบบเคียงข้างกัน"
        },
        {
          "tr_tab_heading": "ผู้ช่วยเสมือน",
          "tr_tab_subheading": "รับคำตอบด้วยความช่วยเหลือของ AI"
        }
      ],
      "ptl_right_arrow_icon": "assets/images/ptl_right_chevron.svg",
      "ptl_12xe_right_arrow_icon": "assets/images/ptl_12xe_right_chevron.svg",
      "ptl_intel_logo": "assets/images/ptl_intel_logo.svg",
      "ptl_12xe_intel_logo": "assets/images/ptl_12xe_intel_logo.svg"
    },
    "tr_VAHomepageText": {
      "tr_VAHeading": "ยินดีต้อนรับ!",
      "tr_VASubHeading": "แชทกับผู้ช่วย AI ของเรา",
      "tr_VAInputboxQuestion": "สอบถามเกี่ยวกับอุปกรณ์นี้",
      "ptl_VASearchSendIcon": "assets/images/ptl_va_search_send.png",
      "ptl12xe_VASearchSendIcon": "assets/images/ptl12xe_va_search_send.png",
      "ptl_homePage_icon": "assets/images/ptl_homepage_icon.gif",
      "ptl_12xe_homePage_icon": "assets/images/ptl12xe_homepage_icon.gif"
    }
  },
  "backgroundMedia": [
    {
      "uiType": "S11",
      "backgroundURL": "url(../assets/images/11th_gen_background.png)"
    },
    {
      "uiType": "G11",
      "backgroundURL": "url(../assets/images/gaming_background.png)"
    },
    {
      "uiType": "evo",
      "backgroundURL": "url(../assets/images/evo_background.png)"
    },
    {
      "uiType": "athena",
      "backgroundURL": "url(../assets/images/mobile-tiles-athena-background.jpg)"
    },
    {
      "uiType": "NI",
      "backgroundURL": "url(../assets/images/ni_background.png)"
    },
    {
      "uiType": "S10",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S8_9",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S7",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "G12",
      "backgroundURL": "url(../assets/images/12th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "default",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S12",
      "backgroundURL": "url(../assets/images/12th_gen_bg.svg)"
    },
    {
      "uiType": "G13",
      "backgroundURL": "url(../assets/images/13th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "INTEL_INSIDE",
      "backgroundURL": "url(../assets/images/intel_inside/intel_inside_bg.png)"
    },
    {
      "uiType": "G14",
      "backgroundURL": "url(../assets/images/13th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "S14_AI_IPOS",
      "backgroundURL": "url(../assets/images/standard/std_mtl_background.svg)"
    },
    {
      "uiType": "EVO_AI_IPOS",
      "backgroundURL": "url(../assets/images/evo/evo_mtl_background.svg)"
    },
    {
      "uiType": "GAMING_AI_IPOS",
      "backgroundURL": "url(../assets/images/gaming_ai_ipos_background.svg)"
    }
  ],
  "hybridDetails": [
    {
      "badgeTitle": "I3_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I3_HYBRID.svg",
      "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i3 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid"
    },
    {
      "badgeTitle": "I5_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I5_HYBRID.svg",
      "tr_gen_core_title": "โปรเซสเซอร์ Intel®&nbsp;Core™&nbsp;i5 พร้อมเทคโนโลยี Intel®&nbsp;Hybrid"
    },
    {
      "badgeTitle": "I7_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I7_HYBRID.svg"
    }
  ],
  "tiles": [
    {
      "tilesType": "GAMING",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Marvel's Avengers",
              "tileUrlName": "avengers",
              "tileBadgeUrl": "assets/images/gaming/avengers-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "เตรียมพร้อมด้วย Intel® เพื่อการเล่นเกมที่ทรงพลัง",
                "tr_subtitle": "เล่นเกม Marvel’s Avengers* แบบสมจริงด้วยการเสริมประสิทธิภาพพีซีในเกมที่ขับเคลื่อนด้วย Intel®",
                "videoUrl": "assets/lang/[XX]/gaming/videos/avengers_[XX].mp4",
                "videoPosterUrl": "assets/images/gaming/avengers-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "สัมผัส Intel® Extreme Masters",
              "tileUrlName": "esl",
              "tileBadgeUrl": "assets/images/gaming/esl-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "ที่ซึ่งนักเกมระดับโลกมาร่วมประลองฝีมือ",
                "tr_subtitle": "ทัวร์นาเมนต์ที่ยาวนานที่สุดในประวัติศาสตร์ของวิดีโอเกม Intel® Extreme Masters สร้างมาตรฐานใหม่ให้กับอีสปอร์ต",
                "videoUrl": "assets/videos/gaming/esl_video.mp4",
                "videoPosterUrl": "assets/images/gaming/esl-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "เล่นอย่างมือโปร",
              "tileUrlName": "influencer",
              "tileBadgeUrl": "assets/images/gaming/influencer-tile-new-content.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "เป็นแชมป์ได้ด้วย Intel",
                "tr_subtitle": "หลังจากคว้ารางวัลชนะเลิศจากรายการ 2021 Rainbow Six Siege* North American League Championship ทีม Soniqs บอกเล่าถึงรายการเกมที่ผ่านมาของพวกเขา อนาคตของอีสปอร์ต และการเข้าร่วมเป็นพันธมิตรกับ Intel",
                "tr_pretitle": "ร่วมกับ Soniqs",
                "videoUrl": "assets/videos/gaming/influencer-new-video.mp4",
                "videoPosterUrl": "assets/images/gaming/influencer-new-vdo-thumbnail.svg",
                "subtitleUrl": "assets/subtitles/gaming/intel_soniq_influencer/Intel_Soniq_Influencer_022822.[XX].vtt"
              }
            },
            {
              "tr_tileTitle": "พร้อมรองรับ VR",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "เมื่อ VR กลายเป็นจริง",
                "tr_subtitle": "ประสบการณ์ Virtual Reality ที่น่าทึ่ง สมจริง และน่าตื่นตาตื่นใจมากที่สุดบนคอมพิวเตอร์ ด้วยโปรเซสเซอร์ Intel® Core™ รุ่นล่าสุด คุณจะสามารถเป็นใครก็ได้ ไปไหนก็ได้ และสัมผัสมิติใหม่ของการเล่นเกม",
                "videoUrl": "assets/videos/gaming/vr_video.mp4",
                "videoPosterUrl": "assets/images/gaming/vr-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "Xbox* Game Pass Ultimate",
              "tileUrlName": "xboxcontent",
              "tileBadgeUrl": "assets/images/gaming/xboxTile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "xbox-content-tile-panel",
                "tr_title": "Xbox* Game Pass Ultimate",
                "tr_subtitle": "เล่นเกมคอนโซลคุณภาพสูงกว่า 100 เกม เช่น Sea&nbsp;of&nbsp;Thieves* และ Psychonauts* 2 บนพีซี Windows*, โทรศัพท์มือถือ และแท็บเล็ตของคุณด้วย Xbox* Game Pass Ultimate และคอนโทรลเลอร์ที่รองรับ",
                "titleArray": [
                  {
                    "tr_title": "เล่นเกมด้วยกันบนอุปกรณ์ต่างๆ",
                    "tr_subtitle": "เข้าถึงศูนย์รวมของ Xbox* สู่ชุมชนผู้เล่นนับล้านคนที่พร้อมและกำลังรอที่จะเล่นเกมไปด้วยกัน เชื่อมต่อและเล่นเกมกับผู้เล่นอื่นจากไลบรารีเกมที่ใช้ร่วมกัน ไม่ว่าจะเป็นผู้เล่นจากอีกซีกโลกหรือคนที่นั่งอ&#65279;&#65279;ยู่&#65279;ข้&#65279;า&#65279;ง&#65279;คุ&#65279;ณ"
                  },
                  {
                    "tr_title": "การเล่นเกมบนพีซี Windows*",
                    "tr_subtitle": "เล่นเกมคอนโซลมากมายจากระบบคลาวด์โดยใช้แอป Xbox* สำหรับ Windows* และคอนโทรลเลอร์ที่รองรับ"
                  },
                  {
                    "tr_title": "เล่นได้ทุกที่ทุกเวลา",
                    "tr_subtitle": "เพลิดเพลินกับเกม Xbox* ในหลากหลายสถานที่ยิ่งขึ้น เล่นมากกว่า 100 เกมบนพีซี โทรศัพท์มือถือ และแท็บเล็ต ไม่ว่าคุณจะอยู่ที่บ้านในเวลาที่คนอื่นกำลังชมโทรทัศน์อยู่ ที่ร้านกาแฟ หรือสถานที่ใดก็ได้ที่มีการเชื่อมต่ออินเทอร์เน็ตความเร็วสูง"
                  },
                  {
                    "tr_title": "ปลดปล่อยพลังความสร้างสรรค์ของคุณ",
                    "tr_subtitle": "การควบคุมเกมด้วยระบบสัมผัสของ Xbox* ปลดล็อกวิธีใหม่ๆ ในการเล่นเกมทันทีที่ต้องการและรองรับระดับการเล่นที่คุณคุ้นเคยจากการเล่นด้วยคอนโทรลเลอร์"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD",
      "tilesDeviceTypes": [
        {
          "deviceType": "MTL_STD_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "จุดเด่น",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/standard/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ประสบการณ์ AI มากกว่า 100 รายการ",
                    "preTitle": "",
                    "detailPageName": "aiexperience",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_experience-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_experience.mp4"
                  },
                  {
                    "tr_title": "ควบคุมได้มากขึ้น สัมผัสน้อยลง",
                    "preTitle": "",
                    "detailPageName": "controlmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/controlmore-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/controlmore.mp4"
                  },
                  {
                    "tr_title": "อยู่ในเฟรมได้ในทุกสภาพการณ์",
                    "preTitle": "",
                    "detailPageName": "stayinframe",
                    "tileBadgeUrl": "assets/images/standard/redesign/stayinframe-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/stayinframe.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การสร้างสรรค์",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/standard/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "การจัดแสงที่ถูกต้องเหมื&#xfeff;อ&#xfeff;นมื&#xfeff;อ&#xfeff;อ&#xfeff;า&#xfeff;ชี&#xfeff;พ",
                    "preTitle": "",
                    "detailPageName": "lighting",
                    "tileBadgeUrl": "assets/images/standard/redesign/lighting-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/lighting.mp4"
                  },
                  {
                    "tr_title": "เพิ่มเอฟเฟกต์แบบอลังการอย่างง่ายดาย",
                    "preTitle": "",
                    "detailPageName": "effects",
                    "tileBadgeUrl": "assets/images/standard/redesign/effects-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/effects.mp4"
                  },
                  {
                    "tr_title": "รีมิกซ์เพลงด้วยพลังของ AI",
                    "preTitle": "",
                    "detailPageName": "remix",
                    "tileBadgeUrl": "assets/images/standard/redesign/remix-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/remix.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การทำงาน",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "เพิ่มผลิตภาพการทำงานและความเป็นส่วนตัวของคุณ",
                    "preTitle": "",
                    "detailPageName": "boostyourproductivity",
                    "tileBadgeUrl": "assets/images/standard/redesign/boost-your-productivity-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/boost-your-productivity.mp4"
                  },
                  {
                    "tr_title": "ใช้เวลาอยู่ห่างจุดชาร์จไฟได้น&#xfeff;า&#xfeff;น&#xfeff;ขึ้&#xfeff;น",
                    "preTitle": "",
                    "detailPageName": "spentmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spentmore-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/spentmore.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ความบันเทิง",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "การสตรีมที่ราบรื่น แม้ไม่ได้เ&#xfeff;สี&#xfeff;ย&#xfeff;บ&#xfeff;ป&#xfeff;ลั๊&#xfeff;ก",
                    "preTitle": "",
                    "detailPageName": "smoothstreaming",
                    "tileBadgeUrl": "assets/images/standard/redesign/smooth-streaming-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/smooth-streaming.mp4"
                  },
                  {
                    "tr_title": "การเล่นเกมที่รวดเร็วสมจริง",
                    "preTitle": "",
                    "detailPageName": "fastimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastimmersive-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastimmersive.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "MTL_STD_REDESIGN_ULTRA_7_9",
          "tilesDetails": [
            {
              "tr_tileTitle": "จุดเด่น",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/standard/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ประสบการณ์ AI มากกว่า 100 รายการ",
                    "preTitle": "",
                    "detailPageName": "aiexperience",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_experience-tile7.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_experience7.mp4"
                  },
                  {
                    "tr_title": "ทำเพลงโปรดในแบบที่คุณชอบอย่างแท้จริง",
                    "preTitle": "",
                    "detailPageName": "favouritesongs",
                    "tileBadgeUrl": "assets/images/standard/redesign/remix-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/remix.mp4"
                  },
                  {
                    "tr_title": "เห็นภาพที่คุณต้องการแบบทันที",
                    "preTitle": "",
                    "detailPageName": "realtime",
                    "tileBadgeUrl": "assets/images/standard/redesign/real-time-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/realtime.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การสร้างสรรค์",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/standard/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "หนทางสู่การตัดต่อที่เร็วที่สุด",
                    "preTitle": "",
                    "detailPageName": "fastestway",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastestway-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastestway.mp4"
                  },
                  {
                    "tr_title": "ทำให้ภาพถ่ายสมบูรณ์แบบทุกภาพ",
                    "preTitle": "",
                    "detailPageName": "effects",
                    "tileBadgeUrl": "assets/images/standard/redesign/pictureperfect-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/pictureperfect.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การทำงาน",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "เพิ่มผลิตภาพการทำงานและความเป็นส่วนตัวของคุณ",
                    "preTitle": "",
                    "detailPageName": "boostyourproductivity",
                    "tileBadgeUrl": "assets/images/standard/redesign/boost-your-productivity-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/boost-your-productivity.mp4"
                  },
                  {
                    "tr_title": "ประสิทธิภาพมากขึ้น มีอิสระยิ่งขึ้น",
                    "preTitle": "",
                    "detailPageName": "morefreedom",
                    "tileBadgeUrl": "assets/images/standard/redesign/morefreedom-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/morefreedom.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ความบันเทิง",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "การสตรีมแบบ HD ที่ราบรื่น แม้ไม่ได้เสียบปลั๊ก",
                    "preTitle": "",
                    "detailPageName": "smoothHDstreaming",
                    "tileBadgeUrl": "assets/images/standard/redesign/smoothHDstreaming-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/smoothHDstreaming.mp4"
                  },
                  {
                    "tr_title": "การเล่นเกมแบบสมจริงในหลากหลายสถานที่ยิ่งขึ้น",
                    "preTitle": "",
                    "detailPageName": "fastimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastimmersive-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastimmersive.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "LNL_STD_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "สร้างสรรค์ได้มากขึ้น",
              "tileUrlName": "creative",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "แก้ไขภาพอย่างง่ายดาย",
                    "preTitle": "",
                    "detailPageName": "photoediting",
                    "tileBadgeUrl": "assets/images/standard/redesign/photo_editing_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/photo_editing.mp4"
                  },
                  {
                    "tr_title": "สร้างภาพสวยระดับโปร ในพริบตา",
                    "preTitle": "",
                    "detailPageName": "createframe",
                    "tileBadgeUrl": "assets/images/standard/redesign/create_frame_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/create_frame.mp4"
                  },
                  {
                    "tr_title": "เพียงคุณพิมพ์ AI บันดาลให้",
                    "preTitle": "",
                    "detailPageName": "youtypeit",
                    "tileBadgeUrl": "assets/images/standard/redesign/you_type_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/you_type.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ส&#xfeff;ม&#xfeff;ร&#xfeff;ร&#xfeff;ถ&#xfeff;น&#xfeff;ะ<wbr/>ม&#xfeff;า&#xfeff;ก&#xfeff;ขึ้&#xfeff;น",
              "tileUrlName": "performance",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "สูตรลัดเพื่อการเล่นเกมที่ลื่นไหลยิ่งกว่า",
                    "preTitle": "",
                    "detailPageName": "cheatcode",
                    "tileBadgeUrl": "assets/images/standard/redesign/cheat_code_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/cheat_code.mp4"
                  },
                  {
                    "tr_title": "ใช้เวลาอยู่ห่างจุดชาร์จไฟได้น&#xfeff;า&#xfeff;น&#xfeff;ขึ้&#xfeff;น",
                    "preTitle": "",
                    "detailPageName": "spendmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spend_more_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/spend_more.svg"
                  },
                  {
                    "tr_title": "สมจริงแบบ ULTRA",
                    "preTitle": "",
                    "detailPageName": "ultraimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/ultra_immersive_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/ultra_immersive.svg"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "มีประสิทธิภาพมากขึ้น",
              "tileUrlName": "productive",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ผู้ช่วย AI ที่รู้ใจในการทำงานทุ&#xfeff;ก&nbsp;ๆ&nbsp;วั&#xfeff;น",
                    "preTitle": "",
                    "detailPageName": "aicompanion",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_companion_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_companion.mp4"
                  },
                  {
                    "tr_title": "การโทรผ่านวิดีโออย่างสมบูรณ์แบบ",
                    "preTitle": "",
                    "detailPageName": "videocall",
                    "tileBadgeUrl": "assets/images/standard/redesign/video_call_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/video_call.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ปลอดภัยมากขึ้น",
              "tileUrlName": "secure",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ระบบป้องกันในตัวเพื่อช่วยให้ข้อมูลของคุณมีความปลอดภัยและความเป็นส่วนตัวมากขึ้น",
                    "preTitle": "",
                    "detailPageName": "builtinprotection",
                    "tileBadgeUrl": "assets/images/standard/redesign/protection_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/protection.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "LNL_STD_REDESIGN_ULTRA_7",
          "tilesDetails": [
            {
              "tr_tileTitle": "สร้างสรรค์ได้มากขึ้น",
              "tileUrlName": "creative",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "แก้ไขภาพอย่างง่ายดาย",
                    "preTitle": "",
                    "detailPageName": "photoediting",
                    "tileBadgeUrl": "assets/images/standard/redesign/photo_editing_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/photo_editing.mp4"
                  },
                  {
                    "tr_title": "AI ทางลัดสู่งานฉบับสมบูรณ์",
                    "preTitle": "",
                    "detailPageName": "aishortcut",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_shortcut_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_shortcut.mp4"
                  },
                  {
                    "tr_title": "ถอดเสียงเนื้อเพลงโปรดของคุณได้อย่างรวดเร็ว",
                    "preTitle": "",
                    "detailPageName": "favouritesong",
                    "tileBadgeUrl": "assets/images/standard/redesign/favourite_song_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/favourite_song.mp4"
                  },
                  {
                    "tr_title": "ประหยัดเวลาการตัดต่อด้วย AI",
                    "preTitle": "",
                    "detailPageName": "savehours",
                    "tileBadgeUrl": "assets/images/standard/redesign/save_hours_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/save_hours.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ส&#xfeff;ม&#xfeff;ร&#xfeff;ร&#xfeff;ถ&#xfeff;น&#xfeff;ะ<wbr/>ม&#xfeff;า&#xfeff;ก&#xfeff;ขึ้&#xfeff;น",
              "tileUrlName": "performance",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "สูตรลัดเพื่อการเล่นเกมที่ลื่นไหลยิ่งกว่า",
                    "preTitle": "",
                    "detailPageName": "cheatcode",
                    "tileBadgeUrl": "assets/images/standard/redesign/cheat_code_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/cheat_code.mp4"
                  },
                  {
                    "tr_title": "ใช้เวลาอยู่ห่างจุดชาร์จไฟได้น&#xfeff;า&#xfeff;น&#xfeff;ขึ้&#xfeff;น",
                    "preTitle": "",
                    "detailPageName": "spendmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spend_more_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/spend_more.svg"
                  },
                  {
                    "tr_title": "สมจริงแบบ ULTRA",
                    "preTitle": "",
                    "detailPageName": "ultraimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/ultra_immersive_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/ultra_immersive.svg"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "มีประสิทธิภาพมากขึ้น",
              "tileUrlName": "productive",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ผู้ช่วย AI ที่รู้ใจในการทำงานทุ&#xfeff;ก&nbsp;ๆ&nbsp;วั&#xfeff;น",
                    "preTitle": "",
                    "detailPageName": "aicompanion",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_companion_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_companion.mp4"
                  },
                  {
                    "tr_title": "การโทรผ่านวิดีโออย่างสมบูรณ์แบบ",
                    "preTitle": "",
                    "detailPageName": "videocall",
                    "tileBadgeUrl": "assets/images/standard/redesign/video_call_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/video_call.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ปลอดภัยมากขึ้น",
              "tileUrlName": "secure",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ระบบป้องกันในตัวเพื่อช่วยให้ข้อมูลของคุณมีความปลอดภัยและความเป็นส่วนตัวมากขึ้น",
                    "preTitle": "",
                    "detailPageName": "builtinprotection",
                    "tileBadgeUrl": "assets/images/standard/redesign/protection_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/protection.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "ความบันเทิงพร้อมสรรพ ใ&#65279;น&#65279;พี&#65279;ซี&#65279;เ&#65279;ค&#65279;รื่&#65279;อ&#65279;ง&#65279;เ&#65279;ดี&#65279;ย&#65279;ว",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "สำหรับพีซีที่ใช้เป็นศูนย์รวมความบันเทิงด้วย คุณต้องมีพื้นที่จัดเก็บข้อมูลที่เพียงพอสำหรับเพลง วิดีโอ และเกมโปรดทั้งหมดของคุณ รวมทั้งมีการผสานรวมโปรเซสเซอร์กับจอแสดงผลที่เหมาะสมเพื่อให้ได้ภาพที่คมชัดสมจริง พีซีเครื่องนี้มีครบทั้งสามองค์ประกอบ",
                "titleArray": [
                  {
                    "tr_title": "พร้อมสำหรับภาพเจนเนอเรชั่นใหม่",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "สร้างศูนย์รวมดิจิทัลของคุณ",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "ช่องทางสู่ความบันเทิงของคุณ",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "การเล่นเกมและการสตรีมที่ไหลลื่น",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "สร้างศูนย์รวมดิจิทัลของคุณ",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "ช่องทางสู่ความบันเทิงของคุณ",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "เพิ่มประสิทธิภาพทุกที่",
              "tr_tileTitle1": "ทำสิ่งต่างๆ ได้มากขึ้น เ&#65279;ร็&#65279;ว&#65279;ขึ้&#65279;น",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "พีซีเครื่องนี้มีความสมดุลที่ลงตัวทั้งขุมพลังและความสะดวกในการพกพา เริ่มต้นด้วยโปรเซสเซอร์ที่สร้างมาเพื่อดีไซน์ที่บางและเบา พีซีเครื่องนี้ยังมี Wi-Fi ที่จะทำให้คุณไม่พลาดทุกการเชื่อมต่อ และแบตเตอรี่ที่เหมาะสมสำหรับการทำงานที่ยาวนานโดยไม่ต้องเสียบปลั๊ก",
                "tr_subtitle1": "พีซีนี้ส่งมอบความลงตัวที่ดีเยี่ยมระหว่างพลังและประสิทธิภาพเพื่อช่วยให้คุณทำงานได้มากขึ้นในเวลาที่น้อยลง การผสมผสานกันของโปรเซสเซอร์อันแข็งแกร่งที่เร่งความเร็วด้วยหน่วยความจำอย่างเหลือเฟือและ Wi&#8209;Fi ที่&#65279;เ&#65279;ร็&#65279;ว&#65279;ฉั&#65279;บ&#65279;ไวจะช่วยให้งานในแต่ละวันของคุณเป็นเรื่องง่าย",
                "tr_subtitle2": "พีซีเครื่องนี้มีความสมดุลที่ลงตัวทั้งขุมพลังและความสะดวกในการพกพา เริ่มต้นด้วยโปรเซสเซอร์ที่สร้างมาเพื่อดีไซน์ที่บางและเบา พีซีเครื่องนี้ยังมี Wi‑Fi ที่จะทำให้คุณไม่พลาดทุกการเชื่อมต่อ และแบตเตอรี่ที่เหมาะกับการทำงานแบบมัลติทาสก์",
                "titleArray": [
                  {
                    "tr_title": "สร้างมาให้ทำงานได้มากขึ้น",
                    "tr_title1": "ความสามารถแบบอัจฉริยะที่สำคัญ",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่ดีที่สุดในระดับเดียวกัน",
                    "tr_title1": "เชื่อมต่อกับสิ่งที่สำคัญ",
                    "tr_title2": "การพัฒนาประสิทธิภาพด้าน Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "ทำงานได้ยาวนานกว่าโดยไม่ต้องเสียบปลั๊ก",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "ปรับโปรแกรมให้เหมาะสมราวกับมืออาชีพ",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "อิสรภาพในการ<br/>สร้างสรรค์",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/standard/content-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "การสร้างคอนเทนต์คือหนึ่งในงานที่ต้องการพลังประมวลผลสูงสุดสำหรับ พีซีของคุณโชคดีที่องค์ประกอบเหล่านี้มีพลังในการปรับปรุง ประสิทธิภาพกระบวนการสร้างสรรค์ของคุณ",
                "titleArray": [
                  {
                    "tr_title": "สร้างสรรค์เต็มศักยภาพ",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "เพิ่มความสมจริงให้กับภาพราวกับมีชีวิต",
                    "tr_title1": "มาสร้างสรรค์กัน",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "หน่วยความจำสำหรับก&#65279;า&#65279;ร&#65279;มั&#65279;ล&#65279;ติ&#65279;ท&#65279;า&#65279;ส&#65279;กิ้&#65279;ง",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ดูภายในพีซีเครื่องนี้",
              "tileUrlName": "lookinside",
              "tileBadgeUrl": "assets/images/standard/lookinside-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "นี่คือสามองค์ประกอบหลักๆ ที่คุณควรพิจารณาเมื่อเลือกพีซีเครื่องใหม่ และถ้าคุณทราบว่าจะใช้งานพีซีเครื่องใหม่อย่างไร คุณก็จะทราบได้ไม่ยากว่าคุณต้องใช้สามองค์ประกอบหลักๆ เหล่านี้มากน้อยเพียงใด",
                "titleArray": [
                  {
                    "tr_title": "ประสิทธิภาพสำหรับการเล่นเกมและการสตรีม",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "อุปกรณ์จัดเก็บข้อมูล",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "หน่วยความจำ",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "UWP",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/standard/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "ความบันเทิงพร้อมสรรพ ใ&#65279;น&#65279;พี&#65279;ซี&#65279;เ&#65279;ค&#65279;รื่&#65279;อ&#65279;ง&#65279;เ&#65279;ดี&#65279;ย&#65279;ว",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "สำหรับพีซีที่ใช้เป็นศูนย์รวมความบันเทิงด้วย คุณต้องมีพื้นที่จัดเก็บข้อมูลที่เพียงพอสำหรับเพลง วิดีโอ และเกมโปรดทั้งหมดของคุณ รวมทั้งมีการผสานรวมโปรเซสเซอร์กับจอแสดงผลที่เหมาะสมเพื่อให้ได้ภาพที่คมชัดสมจริง พีซีเครื่องนี้มีครบทั้งสามองค์ประกอบ",
                "titleArray": [
                  {
                    "tr_title": "พร้อมสำหรับภาพเจนเนอเรชั่นใหม่",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "สร้างศูนย์รวมดิจิทัลของคุณ",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "ช่องทางสู่ความบันเทิงของคุณ",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "การเล่นเกมและการสตรีมที่ไหลลื่น",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "สร้างศูนย์รวมดิจิทัลของคุณ",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "ช่องทางสู่ความบันเทิงของคุณ",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "หน่วยความจำ",
              "tileUrlName": "memory",
              "tileBadgeUrl": "assets/images/standard/memory-tile.svg"
            },
            {
              "tr_tileTitle": "การแสดงผล",
              "tileUrlName": "display",
              "tileBadgeUrl": "assets/images/standard/display-tile.svg"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I5",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "มัลติทาสกิ้งที่รวดเร็ว",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "มัลติทาสกิ้งที่รวดเร็ว",
                "tr_subtitle": "ทำงานได้มากขึ้นโดยไม่ล่าช้า",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่มัลติทาสกิ้งฉับไวได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่สลับไปมาระหว่างหลายโปรแกรมได้อย่างฉับไว"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่เร็ว แรง และเสถียร"
                  },
                  {
                    "tr_title": "หน่วยความจำที่สลับแอปพลิเคชันได้อย่างราบรื่น"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การสนทนาผ่านวิดีโอ",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การสนทนาผ่านวิดีโอ",
                "tr_subtitle": "การเชื่อมต่อที่ชัดเจน",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่แชทผ่านวิดีโอได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่สามารถบันทึกและแชร์ภาพได้พร้อมกัน"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่เร็ว แรง และเสถียร"
                  },
                  {
                    "tr_title": "เว็บแคมที่ช่วยให้คุณดูหล่อสวยสดใส"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "พร้อมรองรับ VR",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "เมื่อ VR กลายเป็นจริง",
                "tr_subtitle": "ต้องใช้อะไรบ้างจึงจะสามารถสร้างโลกเสมือนจริงโดยสมบูรณ์ได้ คุณจะต้องมีการประสานการทำงานระหว่างโปรเซสเซอร์ การ์ดกราฟิก และหน่วยความจำบนพีซี",
                "titleArray": [
                  {
                    "tr_title": "เพิ่มพลังให้กับโลกเสมือนจริง",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ความสมจริงทุกรายละเอียด",
                    "tr_title1": "ดื่มด่ำกับบรรยากาศ",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I7",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "การตัดต่อวิดีโอ",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การตัดต่อวิดีโอ",
                "tr_subtitle": "เปิดประสบการณ์การรับชมภาพยนตร์ที่น่ามหัศจรรย์",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่ตัดต่อวิดีโอได้อย่างย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่รับมือไฟล์ขนาดใหญ่ได้"
                  },
                  {
                    "tr_title": "หน่วยความจำที่ช่วยให้ซอฟต์แวร์ตัดต่อทำงานได้อย่างรวดเร็วและตอบสนองทันที"
                  },
                  {
                    "tr_title": "กราฟิกที่ลดเวลาเรนเดอร์ภาพให้เร็วยิ่งขึ้น"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "มัลติทาสกิ้งที่รวดเร็ว",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "มัลติทาสกิ้งที่รวดเร็ว",
                "tr_subtitle": "ทำงานได้มากขึ้นโดยไม่ล่าช้า",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่มัลติทาสกิ้งฉับไวได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่สลับไปมาระหว่างหลายโปรแกรมได้อย่างฉับไว"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่เร็ว แรง และเสถียร"
                  },
                  {
                    "tr_title": "หน่วยความจำที่สลับแอปพลิเคชันได้อย่างราบรื่น"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "พร้อมรองรับ VR",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "เมื่อ VR กลายเป็นจริง",
                "tr_subtitle": "ต้องใช้อะไรบ้างจึงจะสามารถสร้างโลกเสมือนจริงโดยสมบูรณ์ได้ คุณจะต้องมีการประสานการทำงานระหว่างโปรเซสเซอร์ การ์ดกราฟิก และหน่วยความจำบนพีซี",
                "titleArray": [
                  {
                    "tr_title": "เพิ่มพลังให้กับโลกเสมือนจริง",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ความสมจริงทุกรายละเอียด",
                    "tr_title1": "ดื่มด่ำกับบรรยากาศ",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I9",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "การสร้างแบบจำลอง 3 มิติ",
              "tileUrlName": "threedmodeling",
              "tileBadgeUrl": "assets/images/standard/rebuild/threedmodeling.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_threedmodeling.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การสร้างแบบจำลอง 3 มิติ",
                "tr_subtitle": "การสร้างสรรค์อีกระดับ",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่สร้างแบบจำลอง 3 มิติได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#00285A",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่จัดการซอฟต์แวร์งานสร้างสรรค์ขั้นสูง"
                  },
                  {
                    "tr_title": "หน่วยความจำที่เรียกไฟล์ขนาดใหญ่ได้อย่างรวดเร็ว"
                  },
                  {
                    "tr_title": "กราฟิกที่สร้างและแก้ไขภาพที่ทรงพลัง"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การทำงานร่วมกันแบบเรียลไทม์",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การทำงานร่วมกันแบบเรียลไทม์",
                "tr_subtitle": "ทำงานได้จากทุกที่",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่ใช้ทำงานร่วมกันออนไลน์ได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่รองรับซอฟต์แวร์สำนักงาน"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่คุณเชื่อถือได้"
                  },
                  {
                    "tr_title": "เว็บแคมที่บันทึกภาพในระดับ HD ที่สว่างสดใส"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "พร้อมรองรับ VR",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "เมื่อ VR กลายเป็นจริง",
                "tr_subtitle": "ต้องใช้อะไรบ้างจึงจะสามารถสร้างโลกเสมือนจริงโดยสมบูรณ์ได้ คุณจะต้องมีการประสานการทำงานระหว่างโปรเซสเซอร์ การ์ดกราฟิก และหน่วยความจำบนพีซี",
                "titleArray": [
                  {
                    "tr_title": "เพิ่มพลังให้กับโลกเสมือนจริง",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ความสมจริงทุกรายละเอียด",
                    "tr_title1": "ดื่มด่ำกับบรรยากาศ",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "EVO",
      "tilesDeviceTypes": [
        {
          "deviceType": "11GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "แล็ปท็อป Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "แล็ปท็อปที่บางและเบาไม่น่าจะทรงพลังได้ถึงขนาดนี้",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ ออกแบบมาเพื่อประสิทธิภาพแบบพกพา ทั้งยังมอบความเร็ว กราฟิก และระยะเวลาการใช้งานแบตเตอรี่ที่คุณต้องการ รวมกันมาในดีไซน์ที่บางและเบาอย่างน่าทึ่ง",
                "titleArray": [
                  {
                    "tr_title": "แล็ปท็อปที่เป็นมากกว่าที่เคย ดังนั้นเราจึงมั่นใจได้ว่าจะสามารถทำได้หลายสิ่งมากกว่าที่เคย",
                    "tr_subtitle": "ใช้หน้าจอสัมผัสของคุณในการสำรวจ หมุน และย่อ/ขยาย"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "พร้อมใช้งานในทันที",
                    "tr_subtitle": "ด้วยการตื่นทันที พีซีของคุณสามารถเปลี่ยนจากโหมดหลับเป็นพร้อมใช้งานได้ในเวลาไม่ถึงวินาที"
                  },
                  {
                    "tr_title": "การรับชมที่สมจริง",
                    "tr_subtitle": "จอแสดงผลที่สวยงามทำให้ภาพของคุณมีชีวิตชีวาด้วยความละเอียดที่คมชัดและสีสันสดใส"
                  },
                  {
                    "tr_title": "ทำงานเสร็จเร็วขึ้น",
                    "tr_subtitle": "เพลิดเพลินไปกับประสิทธิภาพที่ตอบสนองเร็วเป็นพิเศษจากโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                  },
                  {
                    "tr_title": "พึ่งพาปลั๊กไฟน้อยลง",
                    "tr_subtitle": "ไม่พลาดทุกกระแสด้วยพีซีที่ยืดอายุการใช้งานแบตเตอรี่ให้นานขึ้นและชาร์จเต็มได้ในพริบตา"
                  },
                  {
                    "tr_title": "การเชื่อมต่อด้วยสายอเนกประสงค์",
                    "tr_subtitle": "ทำให้การเสียบอุปกรณ์อื่นๆ เข้ากับพีซีของคุณเป็นเรื่องง่าย รวดเร็ว และปลอดภัยด้วยเทคโนโลยี Thunderbolt™ 4<sup>10</sup>"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่รวดเร็วและเ&#65279;ชื่&#65279;อ&#65279;ถื&#65279;อ&#65279;ไ&#65279;ด้",
                    "tr_subtitle": "วิดีโอแชทหรือแชร์ไฟล์ด้วยการ&#xfeff;เ&#xfeff;ชื่&#xfeff;อ&#xfeff;ม&#xfeff;ต่&#xfeff;อที่&#xfeff;คุ&#xfeff;ณ&#xfeff;ว&#xfeff;า&#xfeff;ง&#xfeff;ใ&#xfeff;จ&#xfeff;ไ&#xfeff;ด้&#xfeff;เ&#xfeff;มื่&#xfeff;อ&#xfeff;ใ&#xfeff;ช้ Intel&#xfeff;®&nbsp;Wi&#xfeff;Fi&nbsp;6&nbsp;(Gig+)<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "12GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "แล็ปท็อป Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "มอบทุกสิ่งที่คุณต้องการและอีกมากมายในแล็ปท็อปที่บางและเบา",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ ออกแบบมาเพื่อประสิทธิภาพแบบพกพา และมอบประสบการณ์ใช้งานที่ดีที่สุด<sup>2</sup> ต&#xfeff;อ&#xfeff;บ&#xfeff;โ&#xfeff;จ&#xfeff;ท&#xfeff;ย์ทุกการใช้งานของคุณ",
                "titleArray": [
                  {
                    "tr_title": "แล็ปท็อปที่เป็นมากกว่าที่เคย ดังนั้นเราจึงมั่นใจได้ว่าจะสามารถทำได้หลายสิ่งมากกว่าที่เคย",
                    "tr_subtitle": "ใช้หน้าจอสัมผัสของคุณในการสำรวจ หมุน และย่อ/ขยาย"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "พร้อมใช้งานในทันที",
                    "tr_subtitle": "ด้วยการตื่นทันที พีซีของคุณสามารถเปลี่ยนจากโหมดหลับเป็นพร้อมใช้งานได้ในเวลาไม่ถึงวินาที"
                  },
                  {
                    "tr_title": "การรับชมที่สมจริง",
                    "tr_subtitle": "จอแสดงผลที่สวยงามทำให้ภาพของคุณมีชีวิตชีวาด้วยความละเอียดที่คมชัดและสีสันสดใส"
                  },
                  {
                    "tr_title": "ประสิทธิภาพที่ล้ำสมัย",
                    "tr_subtitle": "รับประสิทธิภาพที่เพิ่มขึ้นในส่วนที่คุณต้องการมากที่สุดด้วยความสามารถแบบอัจฉริยะจากโปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 12"
                  },
                  {
                    "tr_title": "พึ่งพาปลั๊กไฟน้อยลง",
                    "tr_subtitle": "ไม่พลาดทุกกระแสด้วยพีซีที่ยืดอายุการใช้งานแบตเตอรี่ให้นานขึ้นและชาร์จเต็มได้ในพริบตา"
                  },
                  {
                    "tr_title": "การเชื่อมต่อด้วยสายอเนกประสงค์",
                    "tr_subtitle": "ทำให้การเสียบอุปกรณ์อื่นๆ เข้ากับพีซีของคุณเป็นเรื่องง่าย รวดเร็ว และปลอดภัยด้วยเทคโนโลยี Thunderbolt™ 4<sup>10</sup>"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่รวดเร็วและเ&#65279;ชื่&#65279;อ&#65279;ถื&#65279;อ&#65279;ไ&#65279;ด้",
                    "tr_subtitle": "วิดีโอแชทหรือแชร์ไฟล์ด้วยการ&#xfeff;เ&#xfeff;ชื่&#xfeff;อ&#xfeff;ม&#xfeff;ต่&#xfeff;อที่&#xfeff;คุ&#xfeff;ณ&#xfeff;ว&#xfeff;า&#xfeff;ง&#xfeff;ใ&#xfeff;จ&#xfeff;ไ&#xfeff;ด้&#xfeff;เ&#xfeff;มื่&#xfeff;อ&#xfeff;ใ&#xfeff;ช้ Intel&#xfeff;®&nbsp;Wi&#xfeff;Fi&nbsp;6E&nbsp;(Gig+)<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "11GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "แล็ปท็อป Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "แล็ปท็อปที่บางและเบาไม่น่าจะทรงพลังได้ถึงขนาดนี้",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ ออกแบบมาเพื่อประสิทธิภาพแบบพกพา ทั้งยังมอบความเร็ว กราฟิก และระยะเวลาการใช้งานแบตเตอรี่ที่คุณต้องการ รวมกันมาในดีไซน์ที่บางและเบาอย่างน่าทึ่ง",
                "titleArray": [
                  {
                    "tr_title": "แล็ปท็อปที่เป็นมากกว่าที่เคย ดังนั้นเราจึงมั่นใจได้ว่าจะสามารถทำได้หลายสิ่งมากกว่าที่เคย",
                    "tr_subtitle": "ใช้หน้าจอสัมผัสของคุณในการสำรวจ หมุน และย่อ/ขยาย"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "พร้อมใช้งานในทันที",
                    "tr_subtitle": "ด้วยการตื่นทันที พีซีของคุณสามารถเปลี่ยนจากโหมดหลับเป็นพร้อมใช้งานได้ในเวลาไม่ถึงวินาที"
                  },
                  {
                    "tr_title": "การรับชมที่สมจริง",
                    "tr_subtitle": "จอแสดงผลที่สวยงามทำให้ภาพของคุณมีชีวิตชีวาด้วยความละเอียดที่คมชัดและสีสันสดใส"
                  },
                  {
                    "tr_title": "ทำงานเสร็จเร็วขึ้น",
                    "tr_subtitle": "เพลิดเพลินไปกับประสิทธิภาพที่ตอบสนองเร็วเป็นพิเศษจากโปรเซสเซอร์ Intel® Core™ เ&#65279;จ&#65279;น&#65279;เ&#65279;น&#65279;อ&#65279;เ&#65279;ร&#65279;ชั่&#65279;น&nbsp;11"
                  },
                  {
                    "tr_title": "พึ่งพาปลั๊กไฟน้อยลง",
                    "tr_subtitle": "ไม่พลาดทุกกระแสด้วยพีซีที่ยืดอายุการใช้งานแบตเตอรี่ให้นานขึ้นและชาร์จเต็มได้ในพริบตา"
                  },
                  {
                    "tr_title": "การเชื่อมต่อด้วยสายอเนกประสงค์",
                    "tr_subtitle": "ทำให้การเสียบอุปกรณ์อื่นๆ เข้ากับพีซีของคุณเป็นเรื่องง่าย รวดเร็ว และปลอดภัยด้วยเทคโนโลยี Thunderbolt™ 4<sup>10</sup>"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่รวดเร็วและเ&#65279;ชื่&#65279;อ&#65279;ถื&#65279;อ&#65279;ไ&#65279;ด้",
                    "tr_subtitle": "วิดีโอแชทหรือแชร์ไฟล์ด้วยการ&#xfeff;เ&#xfeff;ชื่&#xfeff;อ&#xfeff;ม&#xfeff;ต่&#xfeff;อที่&#xfeff;คุ&#xfeff;ณ&#xfeff;ว&#xfeff;า&#xfeff;ง&#xfeff;ใ&#xfeff;จ&#xfeff;ไ&#xfeff;ด้&#xfeff;เ&#xfeff;มื่&#xfeff;อ&#xfeff;ใ&#xfeff;ช้ Intel&#xfeff;®&nbsp;Wi&#xfeff;Fi&nbsp;6&nbsp;(Gig+)<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "12GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "แล็ปท็อป Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "มอบทุกสิ่งที่คุณต้องการและอีกมากมายในแล็ปท็อปที่บางและเบา",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ ออกแบบมาเพื่อประสิทธิภาพแบบพกพา และมอบประสบการณ์ใช้งานที่ดีที่สุด<sup>2</sup> ต&#xfeff;อ&#xfeff;บ&#xfeff;โ&#xfeff;จ&#xfeff;ท&#xfeff;ย์ทุกการใช้งานของคุณ",
                "titleArray": [
                  {
                    "tr_title": "แล็ปท็อปที่เป็นมากกว่าที่เคย ดังนั้นเราจึงมั่นใจได้ว่าจะสามารถทำได้หลายสิ่งมากกว่าที่เคย",
                    "tr_subtitle": "ใช้หน้าจอสัมผัสของคุณในการสำรวจ หมุน และย่อ/ขยาย"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "พร้อมใช้งานในทันที",
                    "tr_subtitle": "ด้วยการตื่นทันที พีซีของคุณสามารถเปลี่ยนจากโหมดหลับเป็นพร้อมใช้งานได้ในเวลาไม่ถึงวินาที"
                  },
                  {
                    "tr_title": "การรับชมที่สมจริง",
                    "tr_subtitle": "จอแสดงผลที่สวยงามทำให้ภาพของคุณมีชีวิตชีวาด้วยความละเอียดที่คมชัดและสีสันสดใส"
                  },
                  {
                    "tr_title": "ประสิทธิภาพที่ล้ำสมัย",
                    "tr_subtitle": "รับประสิทธิภาพที่เพิ่มขึ้นในส่วนที่คุณต้องการมากที่สุดด้วยความสามารถแบบอัจฉริยะจากโปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 12"
                  },
                  {
                    "tr_title": "พึ่งพาปลั๊กไฟน้อยลง",
                    "tr_subtitle": "ไม่พลาดทุกกระแสด้วยพีซีที่ยืดอายุการใช้งานแบตเตอรี่ให้นานขึ้นและชาร์จเต็มได้ในพริบตา"
                  },
                  {
                    "tr_title": "การเชื่อมต่อด้วยสายอเนกประสงค์",
                    "tr_subtitle": "ทำให้การเสียบอุปกรณ์อื่นๆ เข้ากับพีซีของคุณเป็นเรื่องง่าย รวดเร็ว และปลอดภัยด้วยเทคโนโลยี Thunderbolt™ 4<sup>10</sup>"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่รวดเร็วและเ&#65279;ชื่&#65279;อ&#65279;ถื&#65279;อ&#65279;ไ&#65279;ด้",
                    "tr_subtitle": "วิดีโอแชทหรือแชร์ไฟล์ด้วยการ&#xfeff;เ&#xfeff;ชื่&#xfeff;อ&#xfeff;ม&#xfeff;ต่&#xfeff;อที่&#xfeff;คุ&#xfeff;ณ&#xfeff;ว&#xfeff;า&#xfeff;ง&#xfeff;ใ&#xfeff;จ&#xfeff;ไ&#xfeff;ด้&#xfeff;เ&#xfeff;มื่&#xfeff;อ&#xfeff;ใ&#xfeff;ช้ Intel&#xfeff;®&nbsp;Wi&#xfeff;Fi&nbsp;6E&nbsp;(Gig+)<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "13GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "แล็ปท็อป Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "มอบทุกสิ่งที่คุณต้องการและอีกมากมายในแล็ปท็อปที่บางและเบา",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ ออกแบบมาเพื่อประสิทธิภาพแบบพกพา และมอบประสบการณ์ใช้งานที่ดีที่สุด<sup>2</sup> ต&#xfeff;อ&#xfeff;บ&#xfeff;โ&#xfeff;จ&#xfeff;ท&#xfeff;ย์ทุกการใช้งานของคุณ",
                "titleArray": [
                  {
                    "tr_title": "แล็ปท็อปที่เป็นมากกว่าที่เคย ดังนั้นเราจึงมั่นใจได้ว่าจะสามารถทำได้หลายสิ่งมากกว่าที่เคย",
                    "tr_subtitle": "ใช้หน้าจอสัมผัสของคุณในการสำรวจ หมุน และย่อ/ขยาย"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "พร้อมใช้งานในทันที",
                    "tr_subtitle": "ด้วยการตื่นทันที พีซีของคุณสามารถเปลี่ยนจากโหมดหลับเป็นพร้อมใช้งานได้ในเวลาไม่ถึงวินาที"
                  },
                  {
                    "tr_title": "การรับชมที่สมจริง",
                    "tr_subtitle": "จอแสดงผลที่สวยงามทำให้ภาพของคุณมีชีวิตชีวาด้วยความละเอียดที่คมชัดและสีสันสดใส"
                  },
                  {
                    "tr_title": "ประสิทธิภาพที่ล้ำสมัย",
                    "tr_subtitle": "รับประสิทธิภาพที่เพิ่มขึ้นในส่วนที่คุณต้องการมากที่สุดด้วยความสามารถแบบอัจฉริยะจากโปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 13"
                  },
                  {
                    "tr_title": "พึ่งพาปลั๊กไฟน้อยลง",
                    "tr_subtitle": "ไม่พลาดทุกกระแสด้วยพีซีที่ยืดอายุการใช้งานแบตเตอรี่ให้นานขึ้นและชาร์จเต็มได้ในพริบตา"
                  },
                  {
                    "tr_title": "การเชื่อมต่อด้วยสายอเนกประสงค์",
                    "tr_subtitle": "ทำให้การเสียบอุปกรณ์อื่นๆ เข้ากับพีซีของคุณเป็นเรื่องง่าย รวดเร็ว และปลอดภัยด้วยเทคโนโลยี Thunderbolt™ 4<sup>10</sup>"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่รวดเร็วและเ&#65279;ชื่&#65279;อ&#65279;ถื&#65279;อ&#65279;ไ&#65279;ด้",
                    "tr_subtitle": "วิดีโอแชทหรือแชร์ไฟล์ด้วยการ&#xfeff;เ&#xfeff;ชื่&#xfeff;อ&#xfeff;ม&#xfeff;ต่&#xfeff;อที่&#xfeff;คุ&#xfeff;ณ&#xfeff;ว&#xfeff;า&#xfeff;ง&#xfeff;ใ&#xfeff;จ&#xfeff;ไ&#xfeff;ด้&#xfeff;เ&#xfeff;มื่&#xfeff;อ&#xfeff;ใ&#xfeff;ช้ Intel&#xfeff;®&nbsp;Wi&#xfeff;Fi&nbsp;6E&nbsp;(Gig+)<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "13GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "แล็ปท็อป Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "มอบทุกสิ่งที่คุณต้องการและอีกมากมายในแล็ปท็อปที่บางและเบา",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ ออกแบบมาเพื่อประสิทธิภาพแบบพกพา และมอบประสบการณ์ใช้งานที่ดีที่สุด<sup>2</sup> ต&#xfeff;อ&#xfeff;บ&#xfeff;โ&#xfeff;จ&#xfeff;ท&#xfeff;ย์ทุกการใช้งานของคุณ",
                "titleArray": [
                  {
                    "tr_title": "แล็ปท็อปที่เป็นมากกว่าที่เคย ดังนั้นเราจึงมั่นใจได้ว่าจะสามารถทำได้หลายสิ่งมากกว่าที่เคย",
                    "tr_subtitle": "ใช้หน้าจอสัมผัสของคุณในการสำรวจ หมุน และย่อ/ขยาย"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "พร้อมใช้งานในทันที",
                    "tr_subtitle": "ด้วยการตื่นทันที พีซีของคุณสามารถเปลี่ยนจากโหมดหลับเป็นพร้อมใช้งานได้ในเวลาไม่ถึงวินาที"
                  },
                  {
                    "tr_title": "การรับชมที่สมจริง",
                    "tr_subtitle": "จอแสดงผลที่สวยงามทำให้ภาพของคุณมีชีวิตชีวาด้วยความละเอียดที่คมชัดและสีสันสดใส"
                  },
                  {
                    "tr_title": "ประสิทธิภาพที่ล้ำสมัย",
                    "tr_subtitle": "รับประสิทธิภาพที่เพิ่มขึ้นในส่วนที่คุณต้องการมากที่สุดด้วยความสามารถแบบอัจฉริยะจากโปรเซสเซอร์ Intel® Core™ เจนเนอเรชั่น 13"
                  },
                  {
                    "tr_title": "พึ่งพาปลั๊กไฟน้อยลง",
                    "tr_subtitle": "ไม่พลาดทุกกระแสด้วยพีซีที่ยืดอายุการใช้งานแบตเตอรี่ให้นานขึ้นและชาร์จเต็มได้ในพริบตา"
                  },
                  {
                    "tr_title": "การเชื่อมต่อด้วยสายอเนกประสงค์",
                    "tr_subtitle": "ทำให้การเสียบอุปกรณ์อื่นๆ เข้ากับพีซีของคุณเป็นเรื่องง่าย รวดเร็ว และปลอดภัยด้วยเทคโนโลยี Thunderbolt™ 4<sup>10</sup>"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่รวดเร็วและเ&#65279;ชื่&#65279;อ&#65279;ถื&#65279;อ&#65279;ไ&#65279;ด้",
                    "tr_subtitle": "วิดีโอแชทหรือแชร์ไฟล์ด้วยการ&#xfeff;เ&#xfeff;ชื่&#xfeff;อ&#xfeff;ม&#xfeff;ต่&#xfeff;อที่&#xfeff;คุ&#xfeff;ณ&#xfeff;ว&#xfeff;า&#xfeff;ง&#xfeff;ใ&#xfeff;จ&#xfeff;ไ&#xfeff;ด้&#xfeff;เ&#xfeff;มื่&#xfeff;อ&#xfeff;ใ&#xfeff;ช้ Intel&#xfeff;®&nbsp;Wi&#xfeff;Fi&nbsp;6E&nbsp;(Gig+)<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "EVO_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "จุดเด่น",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/evo/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "รุ่น Intel® Evo™ คืออะไร",
                    "preTitle": "",
                    "detailPageName": "whatIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whatIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whatIntelEvo.mp4"
                  },
                  {
                    "tr_title": "ทำไมต้องใช้รุ่น Intel® Evo™",
                    "preTitle": "",
                    "detailPageName": "whyIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whyIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whyIntelEvo.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การสร้างสรรค์",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/evo/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "สร้างสรรค์ได้มากขึ้นในห&#xfeff;ล&#xfeff;า&#xfeff;ก&#xfeff;ห&#xfeff;ล&#xfeff;า&#xfeff;ยสถานที่ยิ่งขึ้น",
                    "preTitle": "",
                    "detailPageName": "morecreative",
                    "tileBadgeUrl": "assets/images/evo/redesign/morecreative-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/morecreative.mp4"
                  },
                  {
                    "tr_title": "การแก้ไขภาพถ่ายอย่างรวดเร็ว",
                    "preTitle": "",
                    "detailPageName": "photoeditng",
                    "tileBadgeUrl": "assets/images/evo/redesign/photoeditng-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/photoeditng.mp4"
                  },
                  {
                    "tr_title": "สร้างผลงานศิลปะในทันที",
                    "preTitle": "",
                    "detailPageName": "originalArt",
                    "tileBadgeUrl": "assets/images/evo/redesign/originalArt-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/originalArt.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การทำงาน",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/evo/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "เพิ่มผลลัพธ์งานอย่างเต็มประสิทธิภาพ ด้วย Rewind AI ",
                    "preTitle": "",
                    "detailPageName": "rewind-ai",
                    "tileBadgeUrl": "assets/images/evo/redesign/rewind-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/rewind-ai.mp4"
                  },
                  {
                    "tr_title": "ตรวจจับ Deepfake ก่อนที่คุณจะแชร์ด้วย AI",
                    "preTitle": "",
                    "detailPageName": "deepfakes",
                    "tileBadgeUrl": "assets/images/evo/redesign/deepfakes-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/deepfakes.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ความคล่องตัว",
              "tileUrlName": "mobility",
              "tileBadgeUrl": "assets/images/evo/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "โบกมือทักทายการควบคุมด้วยท่าทาง",
                    "preTitle": "gesturecontrol",
                    "detailPageName": "virtuallyanywhere",
                    "tileBadgeUrl": "assets/images/evo/redesign/gesturecontrol-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/gesturecontrol.mp4"
                  },
                  {
                    "tr_title": "แบตเตอรี่ทนทาน ใช้งานต่อเนื่องได้ไม่สะดุด",
                    "preTitle": "",
                    "detailPageName": "batteryLife-entertainment",
                    "tileBadgeUrl": "assets/images/evo/redesign/batteryLife-entertainment-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/batteryLife-entertainment.mp4"
                  },
                  {
                    "tr_title": "ให้คุณคอยเชื่อมต่อได้โดยอัตโนมัติ",
                    "preTitle": "",
                    "detailPageName": "automaticallyConnected",
                    "tileBadgeUrl": "assets/images/evo/redesign/automaticallyConnected-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/automaticallyConnected.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "EVO_REDESIGN_ULTRA_7",
          "tilesDetails": [
            {
              "tr_tileTitle": "จุดเด่น",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/evo/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "รุ่น Intel® Evo™ คืออะไร",
                    "preTitle": "",
                    "detailPageName": "whatIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whatIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whatIntelEvo.mp4"
                  },
                  {
                    "tr_title": "ทำไมต้องใช้รุ่น Intel® Evo™",
                    "preTitle": "",
                    "detailPageName": "whyIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whyIntelEvo7-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whyIntelEvo7.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การสร้างสรรค์",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/evo/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "การเล่นวิดีโอที่รวดเร็วแ&#xfeff;ล&#xfeff;ะร&#xfeff;า&#xfeff;บ&#xfeff;รื่&#xfeff;น",
                    "preTitle": "",
                    "detailPageName": "videoplayback",
                    "tileBadgeUrl": "assets/images/evo/redesign/videoplayback-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/videoplayback.mp4"
                  },
                  {
                    "tr_title": "สร้างผลงานสุดฮิตด้วยพลังของ AI",
                    "preTitle": "",
                    "detailPageName": "powerAI",
                    "tileBadgeUrl": "assets/images/evo/redesign/power-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/power-ai.mp4"
                  },
                  {
                    "tr_title": "เสร็จงานเร็ว ด้วยทางลัดที่ชาญฉลาด",
                    "preTitle": "",
                    "detailPageName": "fastestway",
                    "tileBadgeUrl": "assets/images/evo/redesign/fastestway-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/fastestway.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การทำงาน",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/evo/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "เพิ่มผลลัพธ์งานอย่างเต็มประสิทธิภาพ ด้วย Rewind AI ",
                    "preTitle": "",
                    "detailPageName": "rewind-ai",
                    "tileBadgeUrl": "assets/images/evo/redesign/rewind-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/rewind-ai.mp4"
                  },
                  {
                    "tr_title": "ตรวจจับ Deepfake ก่อนที่คุณจะแชร์ด้วย AI",
                    "preTitle": "",
                    "detailPageName": "deepfakes",
                    "tileBadgeUrl": "assets/images/evo/redesign/deepfakes-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/deepfakes.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ความคล่องตัว",
              "tileUrlName": "mobility",
              "tileBadgeUrl": "assets/images/evo/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ทำงานร่วมกันแบบเสมือนจริงได้จากแทบทุกที่",
                    "preTitle": "",
                    "detailPageName": "virtuallyanywhere",
                    "tileBadgeUrl": "assets/images/evo/redesign/virtuallyanywhere7-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/virtuallyanywhere7.mp4"
                  },
                  {
                    "tr_title": "แบตเตอรี่ทนทาน ใช้งานต่อเนื่องได้ไม่สะดุด",
                    "preTitle": "",
                    "detailPageName": "batteryLife-entertainment",
                    "tileBadgeUrl": "assets/images/evo/redesign/batteryLife-entertainment-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/batteryLife-entertainment.mp4"
                  },
                  {
                    "tr_title": "ให้คุณคอยเชื่อมต่อได้โดยอัตโนมัติ",
                    "preTitle": "",
                    "detailPageName": "automaticallyConnected",
                    "tileBadgeUrl": "assets/images/evo/redesign/automaticallyConnected-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/automaticallyConnected.mp4"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_11",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "ความบันเทิงพร้อมสรรพ ใ&#65279;น&#65279;พี&#65279;ซี&#65279;เ&#65279;ค&#65279;รื่&#65279;อ&#65279;ง&#65279;เ&#65279;ดี&#65279;ย&#65279;ว",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "สำหรับพีซีที่ใช้เป็นศูนย์รวมความบันเทิงด้วย คุณต้องมีพื้นที่จัดเก็บข้อมูลที่เพียงพอสำหรับเพลง วิดีโอ และเกมโปรดทั้งหมดของคุณ รวมทั้งมีการผสานรวมโปรเซสเซอร์กับจอแสดงผลที่เหมาะสมเพื่อให้ได้ภาพที่คมชัดสมจริง พีซีเครื่องนี้มีครบทั้งสามองค์ประกอบ",
                "titleArray": [
                  {
                    "tr_title": "การเล่นเกมและการสตรีมสุ&#xfeff;ด&#xfeff;ป&#xfeff;ร&#xfeff;ะ&#xfeff;ทั&#xfeff;บ&#xfeff;ใ&#xfeff;จ",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "สร้างศูนย์รวมดิจิทัลของคุณ",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "ช่องทางสู่ความบันเทิงของคุณ",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "การเล่นเกมและการสตรีมที่ไหลลื่น",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "สร้างศูนย์รวมดิจิทัลของคุณ",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "ช่องทางสู่ความบันเทิงของคุณ",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "เพิ่มประสิทธิภาพทุกที่",
              "tr_tileTitle1": "ทำสิ่งต่างๆ ได้มากขึ้น เ&#65279;ร็&#65279;ว&#65279;ขึ้&#65279;น",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "พีซีเครื่องนี้มีความสมดุลที่ลงตัวทั้งขุมพลังและความสะดวกในการพกพา เริ่มต้นด้วยโปรเซสเซอร์ที่สร้างมาเพื่อดีไซน์ที่บางและเบา พีซีเครื่องนี้ยังมี Wi-Fi ที่จะทำให้คุณไม่พลาดทุกการเชื่อมต่อ และแบตเตอรี่ที่เหมาะสมสำหรับการทำงานที่ยาวนานโดยไม่ต้องเสียบปลั๊ก",
                "tr_subtitle1": "พีซีนี้ส่งมอบความลงตัวที่ดีเยี่ยมระหว่างพลังและประสิทธิภาพเพื่อช่วยให้คุณทำงานได้มากขึ้นในเวลาที่น้อยลง การผสมผสานกันของโปรเซสเซอร์อันแข็งแกร่งที่เร่งความเร็วด้วยหน่วยความจำอย่างเหลือเฟือและ Wi&#8209;Fi ที่&#65279;เ&#65279;ร็&#65279;ว&#65279;ฉั&#65279;บ&#65279;ไวจะช่วยให้งานในแต่ละวันของคุณเป็นเรื่องง่าย",
                "tr_subtitle2": "พีซีเครื่องนี้มีความสมดุลที่ลงตัวทั้งขุมพลังและความสะดวกในการพกพา เริ่มต้นด้วยโปรเซสเซอร์ที่สร้างมาเพื่อดีไซน์ที่บางและเบา พีซีเครื่องนี้ยังมี Wi‑Fi ที่จะทำให้คุณไม่พลาดทุกการเชื่อมต่อ และแบตเตอรี่ที่เหมาะกับการทำงานแบบมัลติทาสก์",
                "titleArray": [
                  {
                    "tr_title": "ความสามารถแบบอัจฉริยะที่สำคัญ",
                    "tr_title1": "เร่งความเร็วด้วยความสามารถแบบอัจฉริยะ",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่ดีที่สุดในระดับเดียวกัน",
                    "tr_title1": "เชื่อมต่อกับสิ่งที่สำคัญ",
                    "tr_title2": "การพัฒนาประสิทธิภาพด้าน Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "ทำงานได้ยาวนานกว่าโดยไม่ต้องเสียบปลั๊ก",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "ปรับโปรแกรมให้เหมาะสมราวกับมืออาชีพ",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "อิสรภาพในการ<br/>สร้างสรรค์",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/standard/content-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "การสร้างคอนเทนต์คือหนึ่งในงานที่ต้องการพลังประมวลผลสูงสุดสำหรับ พีซีของคุณโชคดีที่องค์ประกอบเหล่านี้มีพลังในการปรับปรุง ประสิทธิภาพกระบวนการสร้างสรรค์ของคุณ",
                "titleArray": [
                  {
                    "tr_title": "กระตุ้นพลังความคิดสร้างสรรค์",
                    "tr_title1": "ลื่นไหลไปกับโปรเจคครีเอทีฟ",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ยกระดับการสร้างสรรค์",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "หน่วยความจำสำหรับก&#65279;า&#65279;ร&#65279;มั&#65279;ล&#65279;ติ&#65279;ท&#65279;า&#65279;ส&#65279;กิ้&#65279;ง",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ดูภายในพีซีเครื่องนี้",
              "tileUrlName": "lookinside",
              "tileBadgeUrl": "assets/images/standard/lookinside-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "นี่คือสามองค์ประกอบหลักๆ ที่คุณควรพิจารณาเมื่อเลือกพีซีเครื่องใหม่ และถ้าคุณทราบว่าจะใช้งานพีซีเครื่องใหม่อย่างไร คุณก็จะทราบได้ไม่ยากว่าคุณต้องใช้สามองค์ประกอบหลักๆ เหล่านี้มากน้อยเพียงใด",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "อุปกรณ์จัดเก็บข้อมูล",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "หน่วยความจำ",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_12",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "อิสรภาพในการ<br/>สร้างสรรค์",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/creator/freedom_new.png",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "การสร้างคอนเทนต์คือหนึ่งในงานที่ต้องการพลังประมวลผลสูงสุดสำหรับ พีซีของคุณโชคดีที่องค์ประกอบเหล่านี้มีพลังในการปรับปรุง ประสิทธิภาพกระบวนการสร้างสรรค์ของคุณ",
                "titleArray": [
                  {
                    "tr_title": "สร้างสรรค์เต็มศักยภาพ",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "เพิ่มความสมจริงให้กับภาพราวกับมีชีวิต",
                    "tr_title1": "มาสร้างสรรค์กัน",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "หน่วยความจำสำหรับก&#65279;า&#65279;ร&#65279;มั&#65279;ล&#65279;ติ&#65279;ท&#65279;า&#65279;ส&#65279;กิ้&#65279;ง",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "เพิ่มประสิทธิภาพทุกที่",
              "tr_tileTitle1": "ทำสิ่งต่างๆ ได้มากขึ้น เ&#65279;ร็&#65279;ว&#65279;ขึ้&#65279;น",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "พีซีเครื่องนี้มีความสมดุลที่ลงตัวทั้งขุมพลังและความสะดวกในการพกพา เริ่มต้นด้วยโปรเซสเซอร์ที่สร้างมาเพื่อดีไซน์ที่บางและเบา พีซีเครื่องนี้ยังมี Wi-Fi ที่จะทำให้คุณไม่พลาดทุกการเชื่อมต่อ และแบตเตอรี่ที่เหมาะสมสำหรับการทำงานที่ยาวนานโดยไม่ต้องเสียบปลั๊ก",
                "tr_subtitle1": "พีซีนี้ส่งมอบความลงตัวที่ดีเยี่ยมระหว่างพลังและประสิทธิภาพเพื่อช่วยให้คุณทำงานได้มากขึ้นในเวลาที่น้อยลง การผสมผสานกันของโปรเซสเซอร์อันแข็งแกร่งที่เร่งความเร็วด้วยหน่วยความจำอย่างเหลือเฟือและ Wi&#8209;Fi ที่&#65279;เ&#65279;ร็&#65279;ว&#65279;ฉั&#65279;บ&#65279;ไวจะช่วยให้งานในแต่ละวันของคุณเป็นเรื่องง่าย",
                "tr_subtitle2": "พีซีเครื่องนี้มีความสมดุลที่ลงตัวทั้งขุมพลังและความสะดวกในการพกพา เริ่มต้นด้วยโปรเซสเซอร์ที่สร้างมาเพื่อดีไซน์ที่บางและเบา พีซีเครื่องนี้ยังมี Wi‑Fi ที่จะทำให้คุณไม่พลาดทุกการเชื่อมต่อ และแบตเตอรี่ที่เหมาะกับการทำงานแบบมัลติทาสก์",
                "titleArray": [
                  {
                    "tr_title": "สร้างมาให้ทำงานได้มากขึ้น",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "การเชื่อมต่อที่ดีที่สุดในระดับเดียวกัน",
                    "tr_title1": "เชื่อมต่อกับสิ่งที่สำคัญ",
                    "tr_title2": "การพัฒนาประสิทธิภาพด้าน Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "ทำงานได้ยาวนานกว่าโดยไม่ต้องเสียบปลั๊ก",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "ปรับโปรแกรมให้เหมาะสมราวกับมืออาชีพ",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "พร้อมรองรับ VR",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/creator/new_vr_gen12_creator.png",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "เมื่อ VR กลายเป็นจริง",
                "tr_subtitle": "ต้องใช้อะไรบ้างจึงจะสามารถสร้างโลกเสมือนจริงโดยสมบูรณ์ได้ คุณจะต้องมีการประสานการทำงานระหว่างโปรเซสเซอร์ การ์ดกราฟิก และหน่วยความจำบนพีซี",
                "titleArray": [
                  {
                    "tr_title": "เพิ่มพลังให้กับโลกเสมือนจริง",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ความสมจริงทุกรายละเอียด",
                    "tr_title1": "ดื่มด่ำกับบรรยากาศ",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "แบตเตอรี่ที่แรงพอกับพลังในตัวคุณ",
              "tileUrlName": "ptl-battery",
              "tileBadgeUrl": "assets/images/battery_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ทำงาน เล่น และจบทุกการ<br>สร้างสรรค์ด้วยการชาร์จ<br>เพียงครั้งเดียว",
                "tr_subtitle": "เมื่องานคุณยังไม่จบ ก็ลุยให้สุดกับพีซีที่พร้อมทำงานได้ต่อเนื่องโดยไม่ต้องเสียบปลั๊ก ความเร็วไม่ตก และไม่ต้องกังวลเรื่องการชาร์จไฟ",
                "detailBGUrl": "assets/images/battery_ptl_bg.png",
                "titleArray": [
                  {
                    "tr_title": "ทำงานได้อย่างมีประสิทธิภาพ โดยไม่ต้องเสียบปลั๊ก"
                  },
                  {
                    "tr_title": "สัมผัสประสิทธิภาพที่คล่องตัวไปกับคุณได้ทุกที่"
                  },
                  {
                    "tr_title": "รันแอปและเกมที่เครื่องอื่นๆ ทำไม่ได้"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ประสิทธิภาพที่สร้างขึ้นเพื่อตอบสนองความต้องการของคุณ",
              "tileUrlName": "ptl-performance",
              "tileBadgeUrl": "assets/images/performance_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ประสิทธิภาพที่สร้างขึ้นเพื่อตอบสนองความต้องการของคุณ",
                "tr_subtitle": "เปิดแท็บ 47 หน้า 3 แอปกำลังเรนเดอร์ และการประชุมจะเริ่มในอีก 30 วินาที สำหรับสถานการณ์เช่นนี้ คุณต้องการประสิทธิภาพที่เร็วขึ้น เย็น และสามารถควบคุมได้อย่างสมบูรณ์",
                "detailBGUrl": "assets/images/performance_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "เล่นเกมได้ภาพค&#xfeff;ม&#xfeff;ชั&#xfeff;ด<br/>มี&#xfeff;ประสิทธิภาพสู&#xfeff;ง&#xfeff;เ&#xfeff;ยี่&#xfeff;ย&#xfeff;ม",
              "tileUrlName": "ptl-gaming",
              "tileBadgeUrl": "assets/images/gaming_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "เล่นเกมได้ภาพค&#xfeff;ม&#xfeff;ชั&#xfeff;ด<br/>มี&#xfeff;ประสิทธิภาพสู&#xfeff;ง&#xfeff;เ&#xfeff;ยี่&#xfeff;ย&#xfeff;ม",
                "tr_subtitle": "เล่นเกม AAA และเกมอินดี้หลายพันเกมด้วยแล็ปท็อปที่รวดเร็ว ตอบสนองได้ดี และสร้างขึ้นเพื่อการเล่นเกมของคุณ ไร้อาการหน่วง ไร้สะดุด ไร้ข้อจำกัด",
                "detailBGUrl": "assets/images/gaming_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "AI ที่สร้างมาเพื่อช่วยคุณ",
              "tileUrlName": "ptl-aiexperience",
              "tileBadgeUrl": "assets/images/ai_experience_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "assets/images/aiExperience_ptl_bg.png",
                "tr_title": "AI ที่สร้างมาเพื่อช่วยคุณ",
                "tr_subtitle": "ตั้งแต่การสรุปเอกสารไปจนถึงการจัดระเบียบตารางเวลา และการยกระดับคุณภาพวิดีโอคอลแบบเรียลไทม์ คุณจะได้รับเครื่องมือ AI ที่มุ่งเน้นการเปลี่ยนงานยากให้เป็นเรื่องง่ายและช่วยประหยัดเวลาของคุณ",
                "titleArray": [
                  {
                    "tr_title": "สัมผัสประสบการณ์ Copilot+"
                  },
                  {
                    "tr_title": "ใช้งานร่วมกับเครื่องมือและแอป AI ชั้นนำได้เต็มที่"
                  },
                  {
                    "tr_title": "พร้อมสำหรับประสบการณ์ AI ในอนาคต"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "กราฟิกที่ปลุกทุกจินตนาการให้มีชีวิต",
              "tileUrlName": "ptl-graphics",
              "tileBadgeUrl": "assets/images/graphics_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "กราฟิกที่ปลุกทุกจินตนาการให้มีชีวิต",
                "tr_subtitle": "สร้างสรรค์ แก้ไข และเรนเดอร์ภาพความละเอียดสูงได้อย่างรวดเร็วด้วยกราฟิกในตัวที่ทำให้ทุกรายละเอียดโดดเด่น เส้นที่คมชัด สีสันเข้มสด และประสิทธิภาพที่ลื่นไหล ทำให้ทุกงานสร้างสรรค์สวยงามตามที่จินตนาการ",
                "detailBGUrl": "assets/images/graphics_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "รันแอปและเกมที่เครื่องอื่นๆ ทำ&#xfeff;ไ&#xfeff;ม่&#xfeff;ไ&#xfeff;ด้",
              "tileUrlName": "ptl-compatibility",
              "tileBadgeUrl": "assets/images/compatibility_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "รันแอปและเกมที่เครื่องอื่นๆ ทำ&#xfeff;ไ&#xfeff;ม่&#xfeff;ไ&#xfeff;ด้",
                "tr_subtitle": "แอปที่คุณใช้เป็นประจำใช้งานได้อย่างราบรื่นเสมอ เกมโปรดของคุณลื่นไหล พร้อมเล่นได้ทันที เราร่วมมือกับนักพัฒนาชั้นนำเพื่อให้โลกดิจิทัลของคุณทำงานได้ดีขึ้น เร็วขึ้น และฉลาดขึ้น ตั้งแต่เริ่มใช้งาน <br/><span class='ptl_compatibility_subtitle_text'>ไม่ว่าคุณจะออกแบบ แก้ไขงาน หรือกำลังเล่นเกมใหม่ ๆ คุณจะได้รับประสิทธิภาพที่ลื่นไหลไร้รอยต่อกับทุกเครื่องมือที่คุณใช้งาน ไม่มีอาการหน่วง ไม่สะดุด และไม่ต้องคาดเดาให้ยุ่งยาก</span>",
                "detailBGUrl": "assets/images/compatibility_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "งานออกแบบที่สะท้อนสไตล์ของคุณ",
              "tileUrlName": "ptl-design",
              "tileBadgeUrl": "assets/images/design_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "งานออกแบบที่สะท้อนสไตล์ของคุณ",
                "tr_subtitle": "พีซีของคุณควรมีทั้งรูปลักษณ์และสามารถทำงานได้ตามที่ต้องการ ด้วยตัวเลือกที่หลากหลาย ทั้งสีสัน ขนาด รวมถึงงานออกแบบแบบหน้าจอสัมผัส หรือแบบ 2 in 1 พีซีของคุณจะรู้สึกเป็นของคุณอย่างแท้จริงตั้งแต่วันแรกที่ใช้งาน",
                "detailBGUrl": "assets/images/design_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "ประสบการณ์แล็ปท็อปโดยรวมที่ดีที่สุด<sup>1</sup>",
              "tileUrlName": "ptl-evo",
              "tileBadgeUrl": "assets/images/evo_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ประสบการณ์แล็ปท็อปโดยรวมที่ดีที่สุด<sup>1</sup>",
                "tr_subtitle": "แล็ปท็อป Intel® Evo™ Edition ทุกเครื่องที่บางและเบา ได้ผ่านการตรวจสอบเพื่อมอบประสบการณ์ระดับพรีเมียมที่พร้อมใช้งานเสมอ เร็วเสมอ และสร้างมาเพื่อตอบทุกโจทย์ที่คุณต้องการ",
                "detailBGUrl": "assets/images/evo_ptl_bg.svg",
                "titleArray": [
                  {
                    "tr_title": "ประสิทธิภาพที่พร้อมไปกับคุณทุกที่"
                  },
                  {
                    "tr_title": "ระยะเวลาการใช้งานแบตเตอรี่ที่ตอบโจทย์ในชีวิตจริง"
                  },
                  {
                    "tr_title": "การชาร์จไฟที่รวดเร็ว"
                  },
                  {
                    "tr_title": "ปลุกการทำงานได้ทันที"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ให้คุณทำงานได้เร็วขึ้น ทรงพลังขึ้น",
              "tileUrlName": "ptl-processor",
              "tileBadgeUrl": "assets/images/processor_ptl_tile.png"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE_12XE",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "ไอเดียที่ยิ่งใหญ่ ไม่จำเป็นต้องใช้พีซีเครื่องใหญ่",
              "tileUrlName": "ptl-performance",
              "tileBadgeUrl": "assets/images/performance_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ประสิทธิภาพกราฟิกที่ต้องเห็นด้วยตาคุณเอง",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/performance_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "กราฟิกระดับสตูดิโอ ในดีไซน์บางเฉียบสุดพรีเมียม"
                  },
                  {
                    "tr_title": "เร็วกว่า เงียบกว่า พร้อมทำงานทันทีเมื่อมีไอเดีย"
                  },
                  {
                    "tr_title": "ระยะเวลาการใช้งานแบตเตอรี่ที่ทรงพลังไม่แพ้ความคิดสร้างสรรค์ของคุณ"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ในที่สุด แบตเตอรี่ก็<br/>ไม่อาจหยุดยั้งพลังแห่งความคิดสร้างสรรค์ของคุณแล้ว",
              "tileUrlName": "ptl-battery",
              "tileBadgeUrl": "assets/images/battery_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ในที่สุด แบตเตอรี่ก็<br/>ไม่อาจหยุดยั้งพลังแห่งความคิดสร้างสรรค์ของคุณแล้ว",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/battery_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "กราฟิกคุณภาพระดับสตูดิโอที่สามารถพกพาไปได้ทุกที่"
                  },
                  {
                    "tr_title": "ออกแบบมาเพื่อการสร้างสรรค์และเล่นเกมได้ตลอดทั้งวัน"
                  },
                  {
                    "tr_title": "ดีไซน์บางเบา แต่คงไว้ซึ่งประสิทธิภาพ"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "รับสิทธิ์เข้าถึง Battlefield* 6 และ Everwind* และอีกมากมาย",
              "tileUrlName": "ptl-softwarebundle",
              "tileBadgeUrl": "assets/images/software_bundle_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "ptl-tile1-panel",
                "tr_title": "กลางวันสร้างสรรค์<br/>กลางคืนเล่นเกม",
                "tr_title1": "<span class='processor_bold'>โปรเซสเซอร์ Intel® Core™ Ultra [XX] </span>ที่มีกราฟิก Intel® <span class='processor_bold'>Arc™ ในตัว</span>",
                "tr_subtitle": "รับสิทธิ์เล่นเกม Battlefield* 6 และ Everwind* พร้อมรับข้อเสนอจาก Adobe* เมื่อซื้ออุปกรณ์ที่ขับเคลื่อนด้วยโปรเซสเซอร์ Intel® Core™ Ultra [XX] รุ่นที่ร่วมรายการ",
                "detailBGUrl": "assets/images/software_bundle_ptl12xe_bg.png",
                "badgeUrl1": "assets/images/arc-badge.svg",
                "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                "tr_subtitle1": "เลือกการสมัครใช้งานนาน 6 เดือนได้ 1 รายการ:",
                "titleArray": [
                  {
                    "tr_title": "แพ็กเกจโปรแกรมแต่งรูป Adobe Creative Cloud",
                    "imgUrl": "assets/images/ptl_adobe_cloud.svg"
                  },
                  {
                    "tr_title": "Adobe Premiere Pro",
                    "imgUrl": "assets/images/ptl_adobe_premiere.svg"
                  }
                ],
                "tr_subtitle2": "สนามรบ© 2025 Electronic Arts Inc. เป็นเครื่องหมายการค้าของ Electronic Arts Inc. © 2025 BOHEMIA INTERACTIVE a.s. © 2025 Adobe. สงวนลิขสิทธิ์"
              }
            },
            {
              "tr_tileTitle": "กลางวันสร้างสรรค์ ก&#xfeff;ล&#xfeff;า&#xfeff;ง&#xfeff;คื&#xfeff;นเล่นเกม",
              "tileUrlName": "ptl-gaming",
              "tileBadgeUrl": "assets/images/gaming_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "กลางวันสร้างสรรค์ ก&#xfeff;ล&#xfeff;า&#xfeff;ง&#xfeff;คื&#xfeff;นเล่นเกม",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/gaming_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "กราฟิกที่พร้อมสำหรับเล่นเกมในดีไซน์ที่เพรียวบาง"
                  },
                  {
                    "tr_title": "รันแอปและเกมเกมโปรดของคุณ"
                  },
                  {
                    "tr_title": "เล่นได้ทุกที่ที่คุณต้องการ"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "AI ที่สร้างมาเพื่อช่วยคุณ",
              "tileUrlName": "ptl-aiexperience",
              "tileBadgeUrl": "assets/images/ai_experience_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "AI ที่สร้างมาเพื่อช่วยคุณ",
                "tr_subtitle": "ตั้งแต่การสรุปเอกสารไปจนถึงการจัดระเบียบตารางเวลา และการยกระดับคุณภาพวิดีโอคอลแบบเรียลไทม์ คุณจะได้รับเครื่องมือ AI ที่มุ่งเน้นการเปลี่ยนงานยากให้เป็นเรื่องง่ายและช่วยประหยัดเวลาของคุณ",
                "detailBGUrl": "assets/images/aiExperience_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "ระบบที่คุณวางใจได้"
                  },
                  {
                    "tr_title": "ทุกอย่างพร้อมทำงานได้ทันทีเมื่อแกะกล่อง"
                  },
                  {
                    "tr_title": "ระบบป้องกันที่ช่วยให้คุณไร้กังวล"
                  },
                  {
                    "tr_title": "การรักษาความปลอดภัยที่ล้ำหน้าภัยคุกคาม"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "กราฟิกที่ถ่ายทอดจินตนาการของคุณออกมาอย่างสมจริง",
              "tileUrlName": "ptl-graphics",
              "tileBadgeUrl": "assets/images/graphics_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "กราฟิกที่ถ่ายทอดจินตนาการของคุณออกมาอย่างสมจริง",
                "tr_subtitle": "อย่าประเมินกราฟิกในตัวต่ำไป เพราะด้วยคอร์ Intel® Arc™ X<sup>e</sup> ที่เพิ่มขึ้นถึง 50% คุณจะได้รับความเร็วสำหรับการเล่นเกม ตัดต่อ เรนเดอร์ และสตรีม โดยไม่ต้องใช้การ์ดจอแยก ที่จะเพิ่มต้นทุน น้ำหนัก และภาระแบตเตอรี่ เพราะนี่คือพลังกราฟิกที่ต้องการสำหรับผู้สร้างคอนเทนต์และเกมเมอร์ทั้งหลาย ที่มีมาให้ในเครื่อง",
                "detailBGUrl": "assets/images/graphics_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "รันแอปและเกมที่เครื่องอื่นๆ ทำ&#xfeff;ไ&#xfeff;ม่&#xfeff;ไ&#xfeff;ด้",
              "tileUrlName": "ptl-compatibility",
              "tileBadgeUrl": "assets/images/compatibility_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "รันแอปและเกมที่เครื่องอื่นๆ ทำ&#xfeff;ไ&#xfeff;ม่&#xfeff;ไ&#xfeff;ด้",
                "tr_subtitle": "แอปที่คุณใช้เป็นประจำใช้งานได้อย่างราบรื่นเสมอ เกมโปรดของคุณลื่นไหล พร้อมเล่นได้ทันที เราร่วมมือกับนักพัฒนาชั้นนำเพื่อให้โลกดิจิทัลของคุณทำงานได้ดีขึ้น เร็วขึ้น และฉลาดขึ้น ตั้งแต่เริ่มใช้งาน <br/><span class='ptl_compatibility_subtitle_text'>ไม่ว่าคุณจะออกแบบ แก้ไขงาน หรือกำลังเล่นเกมใหม่ ๆ คุณจะได้รับประสิทธิภาพที่ลื่นไหลไร้รอยต่อกับทุกเครื่องมือที่คุณใช้งาน ไม่มีอาการหน่วง ไม่สะดุด และไม่ต้องคาดเดาให้ยุ่งยาก</span>",
                "detailBGUrl": "assets/images/compatibility_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "งานออกแบบที่สะท้อนสไตล์ของคุณ",
              "tileUrlName": "ptl-design",
              "tileBadgeUrl": "assets/images/design_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "งานออกแบบที่สะท้อนสไตล์ของคุณ",
                "tr_subtitle": "พีซีของคุณควรมีทั้งรูปลักษณ์และสามารถทำงานได้ตามที่ต้องการ ด้วยตัวเลือกที่หลากหลาย ทั้งสีสัน ขนาด รวมถึงงานออกแบบแบบหน้าจอสัมผัส หรือแบบ 2 in 1 พีซีของคุณจะรู้สึกเป็นของคุณอย่างแท้จริงตั้งแต่วันแรกที่ใช้งาน",
                "detailBGUrl": "assets/images/design_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "ไอเดียที่ยิ่งใหญ่ ไม่จำเป็นต้องใช้พีซีเครื่องใหญ่",
              "tileUrlName": "ptl-processor",
              "tileBadgeUrl": "assets/images/processor_ptl12xe_tile.png"
            }
          ]
        }
      ]
    }
  ],
  "samsungOled": [
    {
      "panelType": "oled_first_panel",
      "badgeUrl": "assets/images/oled/OLED_logo.svg"
    },
    {
      "panelType": "oled_second_panel",
      "tr_header": "Samsung OLED:<br/>ให้ภาพสวยที่ถนอมสายตา",
      "tr_sub_header": "แสงสีฟ้าอาจทำให้รู้สึกไม่สบายตาและรบกวนการนอนหลับ จอ OLED ที่ผ่านการทดสอบจอถนอมสายตา SGS Eye Care จาก Samsung ไม่ได้ช่วยถนอมสายตาด้วยการปรับสีสัน แต่ใช้วิธีลดความยาวคลื่นแสงสีฟ้าที่อาจเป็นอันตราย เพิ่มความสบายตา และลดความล้าของลูกตา",
      "badgeUrl": "assets/images/oled/oled-graph.svg",
      "tr_title1": "ลดแสงสีฟ้าที่เป็นอันตราย"
    },
    {
      "panelType": "oled_third_panel",
      "tr_header": "มีความพิเศษในทุกมิติ",
      "tr_sub_header": "การออกแบบที่บางและเบาเป็นพิเศษของ OLED เพิ่มคุณภาพของภาพระดับสูงสุด พร้อมทั้งลดน้ำหนักจอให้เหลือน้อยที่สุด"
    },
    {
      "panelType": "oled_fourth_panel",
      "tr_header": "ดำสนิทอย่างแท้จริง",
      "tr_sub_header": "0.0005 นิต"
    },
    {
      "panelType": "oled_fifth_panel",
      "tr_header": "74%<br/><span class='conventional_text'>แบบเก่า</span>",
      "tr_sub_header": "120%<br/><span class='samsungoled_text'>Samsung OLED</span>"
    }
  ],
  "rebuildUsageModel": [
    {
      "tilesType": "STANDARD_REBUILD_I3",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "การสตรีม",
              "tileUrlName": "streaming",
              "tileBadgeUrl": "assets/images/standard/rebuild/streaming.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_streaming.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การสตรีม",
                "tr_subtitle": "ความบันเทิง<br>ที่ไม่มีที่สิ้นสุด",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่สตรีมมิ่งได้อย่างย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#794584",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่สตรีมได้ในระดับ HD"
                  },
                  {
                    "tr_title": "จอที่ให้ภาพที่สว่างสวยงาม"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่ลดบัฟเฟอร์และระยะเวลาโหลด"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การท่องเว็บ",
              "tileUrlName": "webbrowsing",
              "tileBadgeUrl": "assets/images/standard/rebuild/webbrowsing.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_webbrowsing.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การท่องเว็บ",
                "tr_subtitle": "ท่องอินเทอร์เน็ตได้ง่ายดาย",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่ท่องเว็บได้อย่างย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#87A944",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ซึ่งโหลดหน้าที่เต็มไปด้วยสื่อต่างๆ ได้อย่างรวดเร็ว"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่รวดเร็วและเชื่อถือได้"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การสนทนาผ่านวิดีโอ",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การสนทนาผ่านวิดีโอ",
                "tr_subtitle": "การเชื่อมต่อที่ชัดเจน",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่แชทผ่านวิดีโอได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่สามารถบันทึกและแชร์ภาพได้พร้อมกัน"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่เร็ว แรง และเสถียร"
                  },
                  {
                    "tr_title": "เว็บแคมที่ช่วยให้คุณดูหล่อสวยสดใส"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I5",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "มัลติทาสกิ้งที่รวดเร็ว",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "มัลติทาสกิ้งที่รวดเร็ว",
                "tr_subtitle": "ทำงานได้มากขึ้นโดยไม่ล่าช้า",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่มัลติทาสกิ้งฉับไวได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่สลับไปมาระหว่างหลายโปรแกรมได้อย่างฉับไว"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่เร็ว แรง และเสถียร"
                  },
                  {
                    "tr_title": "หน่วยความจำที่สลับแอปพลิเคชันได้อย่างราบรื่น"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การสนทนาผ่านวิดีโอ",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การสนทนาผ่านวิดีโอ",
                "tr_subtitle": "การเชื่อมต่อที่ชัดเจน",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่แชทผ่านวิดีโอได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่สามารถบันทึกและแชร์ภาพได้พร้อมกัน"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่เร็ว แรง และเสถียร"
                  },
                  {
                    "tr_title": "เว็บแคมที่ช่วยให้คุณดูหล่อสวยสดใส"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การเล่นเกมทั่วไป",
              "tileUrlName": "casualgaming",
              "tileBadgeUrl": "assets/images/standard/rebuild/casualgaming.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_casualgaming.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การเล่นเกมทั่วไป",
                "tr_subtitle": "ได้เวลาเล่นเกมแล้ว",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่เล่นเกมเบาๆ ได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#000000",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่เล่นเกมได้อย่างราบรื่น"
                  },
                  {
                    "tr_title": "หน่วยความจำที่สามารถแชทด้วยเสียงและสตรีมได้พร้อมกัน"
                  },
                  {
                    "tr_title": "กราฟิกที่ให้ภาพที่น่าทึ่ง"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การแก้ไขภาพถ่าย",
              "tileUrlName": "photoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/photoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_photoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การแก้ไขภาพถ่าย",
                "tr_subtitle": "ภาพที่เก็บทุก<wbr>ร&#65279;า&#65279;ย&#65279;ล&#65279;ะเ&#65279;อี&#65279;ยดพิกเซล",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่แก้ไขภาพถ่ายได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#659FBA",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่รองรับการแก้ไขภาพจำนวนมาก"
                  },
                  {
                    "tr_title": "หน่วยความจำที่รองรับซอฟต์แวร์การแก้ไขที่รวดเร็ว"
                  },
                  {
                    "tr_title": "เทคโนโลยี Thunderbolt™ 4 ให้คุณถ่&#65279;า&#65279;ยโ&#65279;อ&#65279;นไฟล์ได้อย่างรวดเร็ว"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I7",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "มัลติทาสกิ้งที่รวดเร็ว",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "มัลติทาสกิ้งที่รวดเร็ว",
                "tr_subtitle": "ทำงานได้มากขึ้นโดยไม่ล่าช้า",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่มัลติทาสกิ้งฉับไวได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่สลับไปมาระหว่างหลายโปรแกรมได้อย่างฉับไว"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่เร็ว แรง และเสถียร"
                  },
                  {
                    "tr_title": "หน่วยความจำที่สลับแอปพลิเคชันได้อย่างราบรื่น"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การทำงานร่วมกันแบบเรียลไทม์",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การทำงานร่วมกันแบบเรียลไทม์",
                "tr_subtitle": "ทำงานได้จากทุกที่",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่ใช้ทำงานร่วมกันออนไลน์ได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่รองรับซอฟต์แวร์สำนักงาน"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่คุณเชื่อถือได้"
                  },
                  {
                    "tr_title": "เว็บแคมที่บันทึกภาพในระดับ HD ที่สว่างสดใส"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การตัดต่อวิดีโอ",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การตัดต่อวิดีโอ",
                "tr_subtitle": "เปิดประสบการณ์การรับชมภาพยนตร์ที่น่ามหัศจรรย์",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่ตัดต่อวิดีโอได้อย่างย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่รับมือไฟล์ขนาดใหญ่ได้"
                  },
                  {
                    "tr_title": "หน่วยความจำที่ช่วยให้ซอฟต์แวร์ตัดต่อทำงานได้อย่างรวดเร็วและตอบสนองทันที"
                  },
                  {
                    "tr_title": "กราฟิกที่ลดเวลาเรนเดอร์ภาพให้เร็วยิ่งขึ้น"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การแก้ไขภาพถ่าย",
              "tileUrlName": "photoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/photoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_photoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การแก้ไขภาพถ่าย",
                "tr_subtitle": "ภาพที่เก็บทุก<wbr>ร&#65279;า&#65279;ย&#65279;ล&#65279;ะเ&#65279;อี&#65279;ยดพิกเซล",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่แก้ไขภาพถ่ายได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#659FBA",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่รองรับการแก้ไขภาพจำนวนมาก"
                  },
                  {
                    "tr_title": "หน่วยความจำที่รองรับซอฟต์แวร์การแก้ไขที่รวดเร็ว"
                  },
                  {
                    "tr_title": "เทคโนโลยี Thunderbolt™ 4 ให้คุณถ่&#65279;า&#65279;ยโ&#65279;อ&#65279;นไฟล์ได้อย่างรวดเร็ว"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I9",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "การตัดต่อวิดีโอ",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การตัดต่อวิดีโอ",
                "tr_subtitle": "เปิดประสบการณ์การรับชมภาพยนตร์ที่น่ามหัศจรรย์",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่ตัดต่อวิดีโอได้อย่างย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่รับมือไฟล์ขนาดใหญ่ได้"
                  },
                  {
                    "tr_title": "หน่วยความจำที่ช่วยให้ซอฟต์แวร์ตัดต่อทำงานได้อย่างรวดเร็วและตอบสนองทันที"
                  },
                  {
                    "tr_title": "กราฟิกที่ลดเวลาเรนเดอร์ภาพให้เร็วยิ่งขึ้น"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การสร้างแบบจำลอง 3 มิติ",
              "tileUrlName": "threedmodeling",
              "tileBadgeUrl": "assets/images/standard/rebuild/threedmodeling.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_threedmodeling.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การสร้างแบบจำลอง 3 มิติ",
                "tr_subtitle": "การสร้างสรรค์อีกระดับ",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่สร้างแบบจำลอง 3 มิติได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#00285A",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่จัดการซอฟต์แวร์งานสร้างสรรค์ขั้นสูง"
                  },
                  {
                    "tr_title": "หน่วยความจำที่เรียกไฟล์ขนาดใหญ่ได้อย่างรวดเร็ว"
                  },
                  {
                    "tr_title": "กราฟิกที่สร้างและแก้ไขภาพที่ทรงพลัง"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "การทำงานร่วมกันแบบเรียลไทม์",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "การทำงานร่วมกันแบบเรียลไทม์",
                "tr_subtitle": "ทำงานได้จากทุกที่",
                "tr_subtitle1": "นี่คือสิ่งที่เราพบในพีซีนี้ที่ใช้ทำงานร่วมกันออนไลน์ได้อย่าง<wbr>ย&#65279;อ&#65279;ด&#65279;เ&#65279;ยี่&#65279;ย&#65279;ม",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "โปรเซสเซอร์ที่รองรับซอฟต์แวร์สำนักงาน"
                  },
                  {
                    "tr_title": "Wi‑Fi ที่คุณเชื่อถือได้"
                  },
                  {
                    "tr_title": "เว็บแคมที่บันทึกภาพในระดับ HD ที่สว่างสดใส"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "unison": {
    "panelType1": "gaming-tile-panel",
    "panelType2": "unison-panel",
    "tr_tileTitle": "แอป Intel® Unison™",
    "tr_title": "ปลดล็อกโลกแห่งการเชื่อมต่อ",
    "tr_subtitle": "ถ่ายโอนไฟล์และภาพถ่ายได้อย่างราบรื่น ขณะที่จัดการข้อความแจ้งบอกของโทรศัพท์ สายโทรเรียกและข้อความจากพีซีของคุณ<sup>18</sup>",
    "detailBGUrl": "assets/images/unison/unison_panel1_img.png",
    "tileBG": "assets/images/unison/unison_hometile_img.png",
    "titleArray": [
      {
        "tr_title": "ถ่ายโอนไฟล์และภาพถ่าย",
        "imgUrl": "assets/images/unison/unison_img1.png"
      },
      {
        "tr_title": "โทรออกและรั&#xfeff;บ&#xfeff;ส&#xfeff;า&#xfeff;ย",
        "imgUrl": "assets/images/unison/unison_img2.png"
      },
      {
        "tr_title": "รับและส่งข้อความ",
        "imgUrl": "assets/images/unison/unison_img3.png"
      },
      {
        "tr_title": "จัดการการแจ้งเตือนของโทรศัพท์",
        "imgUrl": "assets/images/unison/unison_img4.png"
      },
      {
        "tr_title": "ปลดล็อกโลกแห่งการเชื่อมต่อ",
        "imgUrl": "assets/images/unison/unison_img5.png"
      }
    ]
  },
  "copilot": {
    "panelType1": "gaming-tile-panel",
    "panelType2": "copilot-panel",
    "tr_tileTitle": "ทำสิ่งต่าง ๆ ได้มากขึ้นด้วย Copilot+",
    "tr_title": "<strong><span class ='copilot_highlight'>ใช้ประสิทธิภาพ</span>จากพีซี Copilot+ ได้มากขึ้น</strong>ด้วยโปรเซสเซอร์ [cpu_display] [cpuModel]",
    "badgeUrl": "assets/images/copilot_badge.png",
    "tileBG": "assets/images/copilot_hometile_img.png",
    "videoUrl": "assets/lang/[XX]/redesign/copilot_panel4.mp4",
    "detailBGUrl": "",
    "tr_pretitle": "Copilot+",
    "badgeIcons": [
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
        "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;5 (ซีรีส์&nbsp;2)",
        "tr_badgeSubTitle": ""
      },
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
        "tr_badgeIconTile": "โปรเซสเซอร์ Intel®&nbsp;Core™ Ultra&nbsp;7 (ซีรีส์&nbsp;2)",
        "tr_badgeSubTitle": ""
      },
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
        "tr_badgeIconTile": "โปรเซสเซอร์ Intel® Core™ Ultra 9 (ซีรีส์ 2)",
        "tr_badgeSubTitle": ""
      }
    ],
    "titleArray": [
      {
        "tr_title": "คำบรรยายสด",
        "tr_subtitle": "แปล 44 ภาษาเป็นอังกฤษ <span class ='copilot_subhighlight'>ง่ายขึ้น</span>",
        "imgUrl": "assets/images/copilot_panel1.png"
      },
      {
        "tr_title": "Cocreator",
        "tr_subtitle": "คุณสร้างโครงร่าง AI ช่วยจัดการให้เสร็จสมบูรณ์ <span class ='copilot_subhighlight'>เร็วกว่า</span>",
        "imgUrl": "assets/images/copilot_panel2.png"
      },
      {
        "tr_title": "Windows* Studio Effects",
        "tr_subtitle": "นำเสนอตัวคุณให้ดีที่สุด <span class ='copilot_subhighlight'>อย่างง่ายดาย</span>",
        "imgUrl": "assets/images/copilot_panel3.png"
      }
    ]
  },
  "deviceReview": {
    "panelType1": "evo-mtl-video-panel",
    "tr_tileTitle": "รับชมรีวิว [XX]",
    "tileBG": "assets/images/device_review_hometile.svg",
    "videoUrl": "assets/lang/[XX]/redesign/device_review_video.mp4"
  }
}